import { defineComponent as V, createBlock as F, openBlock as x, unref as S, withCtx as D, renderSlot as H, computed as oe, watch as Pi, h as vr, inject as me, resolveDynamicComponent as be, createVNode as U, normalizeClass as X, createElementVNode as k, provide as Le, createElementBlock as N, createCommentVNode as J, normalizeStyle as Ai, toDisplayString as _, Fragment as xe, createStaticVNode as Jr, useId as Oi, mergeModels as sr, useModel as or, renderList as Qe, createTextVNode as le, Transition as At, withDirectives as dt, mergeProps as _e, defineAsyncComponent as Im, ref as de, vModelDynamic as Td, resolveComponent as jd, version as Lm, withModifiers as Ds, normalizeProps as kd, guardReactiveProps as Md, createSlots as zd, vModelText as ja, vModelSelect as Ed, readonly as fr, onMounted as Kr, onUnmounted as Rm, reactive as Nm, shallowRef as Dm, vModelRadio as Hm, useSlots as jl, useAttrs as Wm } from "vue";
import { Disclosure as Cd, DisclosureButton as Id, DisclosurePanel as Ld, Combobox as Fm, ComboboxInput as Vm, ComboboxButton as Gm, ComboboxLabel as Zm, ComboboxOption as Xm, ComboboxOptions as Bm, TransitionRoot as zo, Dialog as Eo, TransitionChild as Vr, DialogPanel as Co, DialogDescription as Rd, DialogTitle as Nd, Menu as Dd, MenuButton as Hs, MenuItems as Hd, MenuItem as Wd, Popover as ka, PopoverButton as Ti, PopoverPanel as Ma, RadioGroup as Io, RadioGroupDescription as Lo, RadioGroupLabel as Ro, RadioGroupOption as No, Listbox as Um, ListboxButton as Ym, ListboxLabel as qm, ListboxOption as Qm, ListboxOptions as Jm, PopoverGroup as Fd, Switch as Km, SwitchGroup as _m, SwitchLabel as $m, Tab as eh, TabGroup as th, TabList as rh, TabPanel as nh, TabPanels as ih } from "@headlessui/vue";
import { Link as Lt } from "@inertiajs/vue3";
import { useClipboard as Vd, useToggle as jn, onClickOutside as ah, useDebounceFn as kl, whenever as sh, useFileDialog as Gd, useDropZone as oh, useObjectUrl as lh, promiseTimeout as ch, useTimeoutFn as Ml } from "@vueuse/core";
import { useTippy as uh } from "vue-tippy";
import { Float as Zd } from "@headlessui-float/vue";
import { instantMeiliSearch as dh } from "@meilisearch/instant-meilisearch";
import { vInfiniteScroll as Xd } from "@vueuse/components";
import { z as _a } from "zod";
import Bd from "axios";
import fh from "@tailwindcss/forms";
import { isString as zl } from "lodash-es";
import ph from "pusher-js";
import mh from "laravel-echo";
const uj = /* @__PURE__ */ V({
  __name: "Accordion",
  props: {
    defaultOpen: { type: Boolean }
  },
  setup(t) {
    return (e, r) => (x(), F(S(Cd), {
      as: "div",
      "default-open": e.defaultOpen
    }, {
      default: D(({ open: n, close: i }) => [
        H(e.$slots, "default", {
          open: n,
          close: i
        })
      ]),
      _: 3
    }, 8, ["default-open"]));
  }
});
function El(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ee(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? El(Object(r), !0).forEach(function(n) {
      Re(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : El(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ha(t) {
  "@babel/helpers - typeof";
  return ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ha(t);
}
function hh(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gh(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function vh(t, e, r) {
  return e && gh(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Re(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Do(t, e) {
  return yh(t) || Sh(t, e) || Ud(t, e) || Ph();
}
function ji(t) {
  return bh(t) || wh(t) || Ud(t) || xh();
}
function bh(t) {
  if (Array.isArray(t)) return Ws(t);
}
function yh(t) {
  if (Array.isArray(t)) return t;
}
function wh(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Sh(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, s, o;
    try {
      for (r = r.call(t); !(i = (s = r.next()).done) && (n.push(s.value), !(e && n.length === e)); i = !0)
        ;
    } catch (l) {
      a = !0, o = l;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a) throw o;
      }
    }
    return n;
  }
}
function Ud(t, e) {
  if (t) {
    if (typeof t == "string") return Ws(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ws(t, e);
  }
}
function Ws(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function xh() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ph() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Cl = function() {
}, Ho = {}, Yd = {}, qd = null, Qd = {
  mark: Cl,
  measure: Cl
};
try {
  typeof window < "u" && (Ho = window), typeof document < "u" && (Yd = document), typeof MutationObserver < "u" && (qd = MutationObserver), typeof performance < "u" && (Qd = performance);
} catch {
}
var Ah = Ho.navigator || {}, Il = Ah.userAgent, Ll = Il === void 0 ? "" : Il, rr = Ho, Te = Yd, Rl = qd, Ni = Qd;
rr.document;
var Xt = !!Te.documentElement && !!Te.head && typeof Te.addEventListener == "function" && typeof Te.createElement == "function", Jd = ~Ll.indexOf("MSIE") || ~Ll.indexOf("Trident/"), Di, Hi, Wi, Fi, Vi, Wt = "___FONT_AWESOME___", Fs = 16, Kd = "fa", _d = "svg-inline--fa", yr = "data-fa-i2svg", Vs = "data-fa-pseudo-element", Oh = "data-fa-pseudo-element-pending", Wo = "data-prefix", Fo = "data-icon", Nl = "fontawesome-i2svg", Th = "async", jh = ["HTML", "HEAD", "STYLE", "SCRIPT"], $d = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Oe = "classic", Ce = "sharp", Vo = [Oe, Ce];
function ki(t) {
  return new Proxy(t, {
    get: function(r, n) {
      return n in r ? r[n] : r[Oe];
    }
  });
}
var kn = ki((Di = {}, Re(Di, Oe, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), Re(Di, Ce, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), Di)), Mn = ki((Hi = {}, Re(Hi, Oe, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Re(Hi, Ce, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), Hi)), zn = ki((Wi = {}, Re(Wi, Oe, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Re(Wi, Ce, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), Wi)), kh = ki((Fi = {}, Re(Fi, Oe, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Re(Fi, Ce, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), Fi)), Mh = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, ef = "fa-layers-text", zh = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, Eh = ki((Vi = {}, Re(Vi, Oe, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Re(Vi, Ce, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), Vi)), tf = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ch = tf.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Ih = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], mr = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, En = /* @__PURE__ */ new Set();
Object.keys(Mn[Oe]).map(En.add.bind(En));
Object.keys(Mn[Ce]).map(En.add.bind(En));
var Lh = [].concat(Vo, ji(En), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", mr.GROUP, mr.SWAP_OPACITY, mr.PRIMARY, mr.SECONDARY]).concat(tf.map(function(t) {
  return "".concat(t, "x");
})).concat(Ch.map(function(t) {
  return "w-".concat(t);
})), yn = rr.FontAwesomeConfig || {};
function Rh(t) {
  var e = Te.querySelector("script[" + t + "]");
  if (e)
    return e.getAttribute(t);
}
function Nh(t) {
  return t === "" ? !0 : t === "false" ? !1 : t === "true" ? !0 : t;
}
if (Te && typeof Te.querySelector == "function") {
  var Dh = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Dh.forEach(function(t) {
    var e = Do(t, 2), r = e[0], n = e[1], i = Nh(Rh(r));
    i != null && (yn[n] = i);
  });
}
var rf = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: Kd,
  replacementClass: _d,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
yn.familyPrefix && (yn.cssPrefix = yn.familyPrefix);
var Gr = ee(ee({}, rf), yn);
Gr.autoReplaceSvg || (Gr.observeMutations = !1);
var re = {};
Object.keys(rf).forEach(function(t) {
  Object.defineProperty(re, t, {
    enumerable: !0,
    set: function(r) {
      Gr[t] = r, wn.forEach(function(n) {
        return n(re);
      });
    },
    get: function() {
      return Gr[t];
    }
  });
});
Object.defineProperty(re, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Gr.cssPrefix = e, wn.forEach(function(r) {
      return r(re);
    });
  },
  get: function() {
    return Gr.cssPrefix;
  }
});
rr.FontAwesomeConfig = re;
var wn = [];
function Hh(t) {
  return wn.push(t), function() {
    wn.splice(wn.indexOf(t), 1);
  };
}
var kr = Fs, Et = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Wh(t) {
  if (!(!t || !Xt)) {
    var e = Te.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = t;
    for (var r = Te.head.childNodes, n = null, i = r.length - 1; i > -1; i--) {
      var a = r[i], s = (a.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(s) > -1 && (n = a);
    }
    return Te.head.insertBefore(e, n), t;
  }
}
var Fh = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Cn() {
  for (var t = 12, e = ""; t-- > 0; )
    e += Fh[Math.random() * 62 | 0];
  return e;
}
function _r(t) {
  for (var e = [], r = (t || []).length >>> 0; r--; )
    e[r] = t[r];
  return e;
}
function Go(t) {
  return t.classList ? _r(t.classList) : (t.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function nf(t) {
  return "".concat(t).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Vh(t) {
  return Object.keys(t || {}).reduce(function(e, r) {
    return e + "".concat(r, '="').concat(nf(t[r]), '" ');
  }, "").trim();
}
function za(t) {
  return Object.keys(t || {}).reduce(function(e, r) {
    return e + "".concat(r, ": ").concat(t[r].trim(), ";");
  }, "");
}
function Zo(t) {
  return t.size !== Et.size || t.x !== Et.x || t.y !== Et.y || t.rotate !== Et.rotate || t.flipX || t.flipY;
}
function Gh(t) {
  var e = t.transform, r = t.containerWidth, n = t.iconWidth, i = {
    transform: "translate(".concat(r / 2, " 256)")
  }, a = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), s = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), o = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(a, " ").concat(s, " ").concat(o)
  }, c = {
    transform: "translate(".concat(n / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: c
  };
}
function Zh(t) {
  var e = t.transform, r = t.width, n = r === void 0 ? Fs : r, i = t.height, a = i === void 0 ? Fs : i, s = "";
  return Jd ? s += "translate(".concat(e.x / kr - n / 2, "em, ").concat(e.y / kr - a / 2, "em) ") : s += "translate(calc(-50% + ".concat(e.x / kr, "em), calc(-50% + ").concat(e.y / kr, "em)) "), s += "scale(".concat(e.size / kr * (e.flipX ? -1 : 1), ", ").concat(e.size / kr * (e.flipY ? -1 : 1), ") "), s += "rotate(".concat(e.rotate, "deg) "), s;
}
var Xh = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function af() {
  var t = Kd, e = _d, r = re.cssPrefix, n = re.replacementClass, i = Xh;
  if (r !== t || n !== e) {
    var a = new RegExp("\\.".concat(t, "\\-"), "g"), s = new RegExp("\\--".concat(t, "\\-"), "g"), o = new RegExp("\\.".concat(e), "g");
    i = i.replace(a, ".".concat(r, "-")).replace(s, "--".concat(r, "-")).replace(o, ".".concat(n));
  }
  return i;
}
var Dl = !1;
function $a() {
  re.autoAddCss && !Dl && (Wh(af()), Dl = !0);
}
var Bh = {
  mixout: function() {
    return {
      dom: {
        css: af,
        insertCss: $a
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        $a();
      },
      beforeI2svg: function() {
        $a();
      }
    };
  }
}, Ft = rr || {};
Ft[Wt] || (Ft[Wt] = {});
Ft[Wt].styles || (Ft[Wt].styles = {});
Ft[Wt].hooks || (Ft[Wt].hooks = {});
Ft[Wt].shims || (Ft[Wt].shims = []);
var St = Ft[Wt], sf = [], Uh = function t() {
  Te.removeEventListener("DOMContentLoaded", t), ga = 1, sf.map(function(e) {
    return e();
  });
}, ga = !1;
Xt && (ga = (Te.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Te.readyState), ga || Te.addEventListener("DOMContentLoaded", Uh));
function Yh(t) {
  Xt && (ga ? setTimeout(t, 0) : sf.push(t));
}
function Mi(t) {
  var e = t.tag, r = t.attributes, n = r === void 0 ? {} : r, i = t.children, a = i === void 0 ? [] : i;
  return typeof t == "string" ? nf(t) : "<".concat(e, " ").concat(Vh(n), ">").concat(a.map(Mi).join(""), "</").concat(e, ">");
}
function Hl(t, e, r) {
  if (t && t[e] && t[e][r])
    return {
      prefix: e,
      iconName: r,
      icon: t[e][r]
    };
}
var es = function(e, r, n, i) {
  var a = Object.keys(e), s = a.length, o = r, l, c, u;
  for (n === void 0 ? (l = 1, u = e[a[0]]) : (l = 0, u = n); l < s; l++)
    c = a[l], u = o(u, e[c], c, e);
  return u;
};
function qh(t) {
  for (var e = [], r = 0, n = t.length; r < n; ) {
    var i = t.charCodeAt(r++);
    if (i >= 55296 && i <= 56319 && r < n) {
      var a = t.charCodeAt(r++);
      (a & 64512) == 56320 ? e.push(((i & 1023) << 10) + (a & 1023) + 65536) : (e.push(i), r--);
    } else
      e.push(i);
  }
  return e;
}
function Gs(t) {
  var e = qh(t);
  return e.length === 1 ? e[0].toString(16) : null;
}
function Qh(t, e) {
  var r = t.length, n = t.charCodeAt(e), i;
  return n >= 55296 && n <= 56319 && r > e + 1 && (i = t.charCodeAt(e + 1), i >= 56320 && i <= 57343) ? (n - 55296) * 1024 + i - 56320 + 65536 : n;
}
function Wl(t) {
  return Object.keys(t).reduce(function(e, r) {
    var n = t[r], i = !!n.icon;
    return i ? e[n.iconName] = n.icon : e[r] = n, e;
  }, {});
}
function Zs(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = r.skipHooks, i = n === void 0 ? !1 : n, a = Wl(e);
  typeof St.hooks.addPack == "function" && !i ? St.hooks.addPack(t, Wl(e)) : St.styles[t] = ee(ee({}, St.styles[t] || {}), a), t === "fas" && Zs("fa", e);
}
var Gi, Zi, Xi, Rr = St.styles, Jh = St.shims, Kh = (Gi = {}, Re(Gi, Oe, Object.values(zn[Oe])), Re(Gi, Ce, Object.values(zn[Ce])), Gi), Xo = null, of = {}, lf = {}, cf = {}, uf = {}, df = {}, _h = (Zi = {}, Re(Zi, Oe, Object.keys(kn[Oe])), Re(Zi, Ce, Object.keys(kn[Ce])), Zi);
function $h(t) {
  return ~Lh.indexOf(t);
}
function eg(t, e) {
  var r = e.split("-"), n = r[0], i = r.slice(1).join("-");
  return n === t && i !== "" && !$h(i) ? i : null;
}
var ff = function() {
  var e = function(a) {
    return es(Rr, function(s, o, l) {
      return s[l] = es(o, a, {}), s;
    }, {});
  };
  of = e(function(i, a, s) {
    if (a[3] && (i[a[3]] = s), a[2]) {
      var o = a[2].filter(function(l) {
        return typeof l == "number";
      });
      o.forEach(function(l) {
        i[l.toString(16)] = s;
      });
    }
    return i;
  }), lf = e(function(i, a, s) {
    if (i[s] = s, a[2]) {
      var o = a[2].filter(function(l) {
        return typeof l == "string";
      });
      o.forEach(function(l) {
        i[l] = s;
      });
    }
    return i;
  }), df = e(function(i, a, s) {
    var o = a[2];
    return i[s] = s, o.forEach(function(l) {
      i[l] = s;
    }), i;
  });
  var r = "far" in Rr || re.autoFetchSvg, n = es(Jh, function(i, a) {
    var s = a[0], o = a[1], l = a[2];
    return o === "far" && !r && (o = "fas"), typeof s == "string" && (i.names[s] = {
      prefix: o,
      iconName: l
    }), typeof s == "number" && (i.unicodes[s.toString(16)] = {
      prefix: o,
      iconName: l
    }), i;
  }, {
    names: {},
    unicodes: {}
  });
  cf = n.names, uf = n.unicodes, Xo = Ea(re.styleDefault, {
    family: re.familyDefault
  });
};
Hh(function(t) {
  Xo = Ea(t.styleDefault, {
    family: re.familyDefault
  });
});
ff();
function Bo(t, e) {
  return (of[t] || {})[e];
}
function tg(t, e) {
  return (lf[t] || {})[e];
}
function hr(t, e) {
  return (df[t] || {})[e];
}
function pf(t) {
  return cf[t] || {
    prefix: null,
    iconName: null
  };
}
function rg(t) {
  var e = uf[t], r = Bo("fas", t);
  return e || (r ? {
    prefix: "fas",
    iconName: r
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function nr() {
  return Xo;
}
var Uo = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function Ea(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.family, n = r === void 0 ? Oe : r, i = kn[n][t], a = Mn[n][t] || Mn[n][i], s = t in St.styles ? t : null;
  return a || s || null;
}
var Fl = (Xi = {}, Re(Xi, Oe, Object.keys(zn[Oe])), Re(Xi, Ce, Object.keys(zn[Ce])), Xi);
function Ca(t) {
  var e, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.skipLookups, i = n === void 0 ? !1 : n, a = (e = {}, Re(e, Oe, "".concat(re.cssPrefix, "-").concat(Oe)), Re(e, Ce, "".concat(re.cssPrefix, "-").concat(Ce)), e), s = null, o = Oe;
  (t.includes(a[Oe]) || t.some(function(c) {
    return Fl[Oe].includes(c);
  })) && (o = Oe), (t.includes(a[Ce]) || t.some(function(c) {
    return Fl[Ce].includes(c);
  })) && (o = Ce);
  var l = t.reduce(function(c, u) {
    var f = eg(re.cssPrefix, u);
    if (Rr[u] ? (u = Kh[o].includes(u) ? kh[o][u] : u, s = u, c.prefix = u) : _h[o].indexOf(u) > -1 ? (s = u, c.prefix = Ea(u, {
      family: o
    })) : f ? c.iconName = f : u !== re.replacementClass && u !== a[Oe] && u !== a[Ce] && c.rest.push(u), !i && c.prefix && c.iconName) {
      var m = s === "fa" ? pf(c.iconName) : {}, h = hr(c.prefix, c.iconName);
      m.prefix && (s = null), c.iconName = m.iconName || h || c.iconName, c.prefix = m.prefix || c.prefix, c.prefix === "far" && !Rr.far && Rr.fas && !re.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, Uo());
  return (t.includes("fa-brands") || t.includes("fab")) && (l.prefix = "fab"), (t.includes("fa-duotone") || t.includes("fad")) && (l.prefix = "fad"), !l.prefix && o === Ce && (Rr.fass || re.autoFetchSvg) && (l.prefix = "fass", l.iconName = hr(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || s === "fa") && (l.prefix = nr() || "fas"), l;
}
var ng = /* @__PURE__ */ function() {
  function t() {
    hh(this, t), this.definitions = {};
  }
  return vh(t, [{
    key: "add",
    value: function() {
      for (var r = this, n = arguments.length, i = new Array(n), a = 0; a < n; a++)
        i[a] = arguments[a];
      var s = i.reduce(this._pullDefinitions, {});
      Object.keys(s).forEach(function(o) {
        r.definitions[o] = ee(ee({}, r.definitions[o] || {}), s[o]), Zs(o, s[o]);
        var l = zn[Oe][o];
        l && Zs(l, s[o]), ff();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(r, n) {
      var i = n.prefix && n.iconName && n.icon ? {
        0: n
      } : n;
      return Object.keys(i).map(function(a) {
        var s = i[a], o = s.prefix, l = s.iconName, c = s.icon, u = c[2];
        r[o] || (r[o] = {}), u.length > 0 && u.forEach(function(f) {
          typeof f == "string" && (r[o][f] = c);
        }), r[o][l] = c;
      }), r;
    }
  }]), t;
}(), Vl = [], Nr = {}, Wr = {}, ig = Object.keys(Wr);
function ag(t, e) {
  var r = e.mixoutsTo;
  return Vl = t, Nr = {}, Object.keys(Wr).forEach(function(n) {
    ig.indexOf(n) === -1 && delete Wr[n];
  }), Vl.forEach(function(n) {
    var i = n.mixout ? n.mixout() : {};
    if (Object.keys(i).forEach(function(s) {
      typeof i[s] == "function" && (r[s] = i[s]), ha(i[s]) === "object" && Object.keys(i[s]).forEach(function(o) {
        r[s] || (r[s] = {}), r[s][o] = i[s][o];
      });
    }), n.hooks) {
      var a = n.hooks();
      Object.keys(a).forEach(function(s) {
        Nr[s] || (Nr[s] = []), Nr[s].push(a[s]);
      });
    }
    n.provides && n.provides(Wr);
  }), r;
}
function Xs(t, e) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  var a = Nr[t] || [];
  return a.forEach(function(s) {
    e = s.apply(null, [e].concat(n));
  }), e;
}
function wr(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  var i = Nr[t] || [];
  i.forEach(function(a) {
    a.apply(null, r);
  });
}
function Vt() {
  var t = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return Wr[t] ? Wr[t].apply(null, e) : void 0;
}
function Bs(t) {
  t.prefix === "fa" && (t.prefix = "fas");
  var e = t.iconName, r = t.prefix || nr();
  if (e)
    return e = hr(r, e) || e, Hl(mf.definitions, r, e) || Hl(St.styles, r, e);
}
var mf = new ng(), sg = function() {
  re.autoReplaceSvg = !1, re.observeMutations = !1, wr("noAuto");
}, og = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Xt ? (wr("beforeI2svg", e), Vt("pseudoElements2svg", e), Vt("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot;
    re.autoReplaceSvg === !1 && (re.autoReplaceSvg = !0), re.observeMutations = !0, Yh(function() {
      cg({
        autoReplaceSvgRoot: r
      }), wr("watch", e);
    });
  }
}, lg = {
  icon: function(e) {
    if (e === null)
      return null;
    if (ha(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: hr(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var r = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Ea(e[0]);
      return {
        prefix: n,
        iconName: hr(n, r) || r
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(re.cssPrefix, "-")) > -1 || e.match(Mh))) {
      var i = Ca(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: i.prefix || nr(),
        iconName: hr(i.prefix, i.iconName) || i.iconName
      };
    }
    if (typeof e == "string") {
      var a = nr();
      return {
        prefix: a,
        iconName: hr(a, e) || e
      };
    }
  }
}, ft = {
  noAuto: sg,
  config: re,
  dom: og,
  parse: lg,
  library: mf,
  findIconDefinition: Bs,
  toHtml: Mi
}, cg = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot, n = r === void 0 ? Te : r;
  (Object.keys(St.styles).length > 0 || re.autoFetchSvg) && Xt && re.autoReplaceSvg && ft.dom.i2svg({
    node: n
  });
};
function Ia(t, e) {
  return Object.defineProperty(t, "abstract", {
    get: e
  }), Object.defineProperty(t, "html", {
    get: function() {
      return t.abstract.map(function(n) {
        return Mi(n);
      });
    }
  }), Object.defineProperty(t, "node", {
    get: function() {
      if (Xt) {
        var n = Te.createElement("div");
        return n.innerHTML = t.html, n.children;
      }
    }
  }), t;
}
function ug(t) {
  var e = t.children, r = t.main, n = t.mask, i = t.attributes, a = t.styles, s = t.transform;
  if (Zo(s) && r.found && !n.found) {
    var o = r.width, l = r.height, c = {
      x: o / l / 2,
      y: 0.5
    };
    i.style = za(ee(ee({}, a), {}, {
      "transform-origin": "".concat(c.x + s.x / 16, "em ").concat(c.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: e
  }];
}
function dg(t) {
  var e = t.prefix, r = t.iconName, n = t.children, i = t.attributes, a = t.symbol, s = a === !0 ? "".concat(e, "-").concat(re.cssPrefix, "-").concat(r) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: ee(ee({}, i), {}, {
        id: s
      }),
      children: n
    }]
  }];
}
function Yo(t) {
  var e = t.icons, r = e.main, n = e.mask, i = t.prefix, a = t.iconName, s = t.transform, o = t.symbol, l = t.title, c = t.maskId, u = t.titleId, f = t.extra, m = t.watchable, h = m === void 0 ? !1 : m, p = n.found ? n : r, d = p.width, v = p.height, b = i === "fak", g = [re.replacementClass, a ? "".concat(re.cssPrefix, "-").concat(a) : ""].filter(function(O) {
    return f.classes.indexOf(O) === -1;
  }).filter(function(O) {
    return O !== "" || !!O;
  }).concat(f.classes).join(" "), y = {
    children: [],
    attributes: ee(ee({}, f.attributes), {}, {
      "data-prefix": i,
      "data-icon": a,
      class: g,
      role: f.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(v)
    })
  }, w = b && !~f.classes.indexOf("fa-fw") ? {
    width: "".concat(d / v * 16 * 0.0625, "em")
  } : {};
  h && (y.attributes[yr] = ""), l && (y.children.push({
    tag: "title",
    attributes: {
      id: y.attributes["aria-labelledby"] || "title-".concat(u || Cn())
    },
    children: [l]
  }), delete y.attributes.title);
  var P = ee(ee({}, y), {}, {
    prefix: i,
    iconName: a,
    main: r,
    mask: n,
    maskId: c,
    transform: s,
    symbol: o,
    styles: ee(ee({}, w), f.styles)
  }), T = n.found && r.found ? Vt("generateAbstractMask", P) || {
    children: [],
    attributes: {}
  } : Vt("generateAbstractIcon", P) || {
    children: [],
    attributes: {}
  }, A = T.children, j = T.attributes;
  return P.children = A, P.attributes = j, o ? dg(P) : ug(P);
}
function Gl(t) {
  var e = t.content, r = t.width, n = t.height, i = t.transform, a = t.title, s = t.extra, o = t.watchable, l = o === void 0 ? !1 : o, c = ee(ee(ee({}, s.attributes), a ? {
    title: a
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  l && (c[yr] = "");
  var u = ee({}, s.styles);
  Zo(i) && (u.transform = Zh({
    transform: i,
    width: r,
    height: n
  }), u["-webkit-transform"] = u.transform);
  var f = za(u);
  f.length > 0 && (c.style = f);
  var m = [];
  return m.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), a && m.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [a]
  }), m;
}
function fg(t) {
  var e = t.content, r = t.title, n = t.extra, i = ee(ee(ee({}, n.attributes), r ? {
    title: r
  } : {}), {}, {
    class: n.classes.join(" ")
  }), a = za(n.styles);
  a.length > 0 && (i.style = a);
  var s = [];
  return s.push({
    tag: "span",
    attributes: i,
    children: [e]
  }), r && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), s;
}
var ts = St.styles;
function Us(t) {
  var e = t[0], r = t[1], n = t.slice(4), i = Do(n, 1), a = i[0], s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(re.cssPrefix, "-").concat(mr.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(re.cssPrefix, "-").concat(mr.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(re.cssPrefix, "-").concat(mr.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: e,
    height: r,
    icon: s
  };
}
var pg = {
  found: !1,
  width: 512,
  height: 512
};
function mg(t, e) {
  !$d && !re.showMissingIcons && t && console.error('Icon with name "'.concat(t, '" and prefix "').concat(e, '" is missing.'));
}
function Ys(t, e) {
  var r = e;
  return e === "fa" && re.styleDefault !== null && (e = nr()), new Promise(function(n, i) {
    if (Vt("missingIconAbstract"), r === "fa") {
      var a = pf(t) || {};
      t = a.iconName || t, e = a.prefix || e;
    }
    if (t && e && ts[e] && ts[e][t]) {
      var s = ts[e][t];
      return n(Us(s));
    }
    mg(t, e), n(ee(ee({}, pg), {}, {
      icon: re.showMissingIcons && t ? Vt("missingIconAbstract") || {} : {}
    }));
  });
}
var Zl = function() {
}, qs = re.measurePerformance && Ni && Ni.mark && Ni.measure ? Ni : {
  mark: Zl,
  measure: Zl
}, dn = 'FA "6.5.1"', hg = function(e) {
  return qs.mark("".concat(dn, " ").concat(e, " begins")), function() {
    return hf(e);
  };
}, hf = function(e) {
  qs.mark("".concat(dn, " ").concat(e, " ends")), qs.measure("".concat(dn, " ").concat(e), "".concat(dn, " ").concat(e, " begins"), "".concat(dn, " ").concat(e, " ends"));
}, qo = {
  begin: hg,
  end: hf
}, aa = function() {
};
function Xl(t) {
  var e = t.getAttribute ? t.getAttribute(yr) : null;
  return typeof e == "string";
}
function gg(t) {
  var e = t.getAttribute ? t.getAttribute(Wo) : null, r = t.getAttribute ? t.getAttribute(Fo) : null;
  return e && r;
}
function vg(t) {
  return t && t.classList && t.classList.contains && t.classList.contains(re.replacementClass);
}
function bg() {
  if (re.autoReplaceSvg === !0)
    return sa.replace;
  var t = sa[re.autoReplaceSvg];
  return t || sa.replace;
}
function yg(t) {
  return Te.createElementNS("http://www.w3.org/2000/svg", t);
}
function wg(t) {
  return Te.createElement(t);
}
function gf(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.ceFn, n = r === void 0 ? t.tag === "svg" ? yg : wg : r;
  if (typeof t == "string")
    return Te.createTextNode(t);
  var i = n(t.tag);
  Object.keys(t.attributes || []).forEach(function(s) {
    i.setAttribute(s, t.attributes[s]);
  });
  var a = t.children || [];
  return a.forEach(function(s) {
    i.appendChild(gf(s, {
      ceFn: n
    }));
  }), i;
}
function Sg(t) {
  var e = " ".concat(t.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var sa = {
  replace: function(e) {
    var r = e[0];
    if (r.parentNode)
      if (e[1].forEach(function(i) {
        r.parentNode.insertBefore(gf(i), r);
      }), r.getAttribute(yr) === null && re.keepOriginalSource) {
        var n = Te.createComment(Sg(r));
        r.parentNode.replaceChild(n, r);
      } else
        r.remove();
  },
  nest: function(e) {
    var r = e[0], n = e[1];
    if (~Go(r).indexOf(re.replacementClass))
      return sa.replace(e);
    var i = new RegExp("".concat(re.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      var a = n[0].attributes.class.split(" ").reduce(function(o, l) {
        return l === re.replacementClass || l.match(i) ? o.toSvg.push(l) : o.toNode.push(l), o;
      }, {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? r.removeAttribute("class") : r.setAttribute("class", a.toNode.join(" "));
    }
    var s = n.map(function(o) {
      return Mi(o);
    }).join(`
`);
    r.setAttribute(yr, ""), r.innerHTML = s;
  }
};
function Bl(t) {
  t();
}
function vf(t, e) {
  var r = typeof e == "function" ? e : aa;
  if (t.length === 0)
    r();
  else {
    var n = Bl;
    re.mutateApproach === Th && (n = rr.requestAnimationFrame || Bl), n(function() {
      var i = bg(), a = qo.begin("mutate");
      t.map(i), a(), r();
    });
  }
}
var Qo = !1;
function bf() {
  Qo = !0;
}
function Qs() {
  Qo = !1;
}
var va = null;
function Ul(t) {
  if (Rl && re.observeMutations) {
    var e = t.treeCallback, r = e === void 0 ? aa : e, n = t.nodeCallback, i = n === void 0 ? aa : n, a = t.pseudoElementsCallback, s = a === void 0 ? aa : a, o = t.observeMutationsRoot, l = o === void 0 ? Te : o;
    va = new Rl(function(c) {
      if (!Qo) {
        var u = nr();
        _r(c).forEach(function(f) {
          if (f.type === "childList" && f.addedNodes.length > 0 && !Xl(f.addedNodes[0]) && (re.searchPseudoElements && s(f.target), r(f.target)), f.type === "attributes" && f.target.parentNode && re.searchPseudoElements && s(f.target.parentNode), f.type === "attributes" && Xl(f.target) && ~Ih.indexOf(f.attributeName))
            if (f.attributeName === "class" && gg(f.target)) {
              var m = Ca(Go(f.target)), h = m.prefix, p = m.iconName;
              f.target.setAttribute(Wo, h || u), p && f.target.setAttribute(Fo, p);
            } else vg(f.target) && i(f.target);
        });
      }
    }), Xt && va.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function xg() {
  va && va.disconnect();
}
function Pg(t) {
  var e = t.getAttribute("style"), r = [];
  return e && (r = e.split(";").reduce(function(n, i) {
    var a = i.split(":"), s = a[0], o = a.slice(1);
    return s && o.length > 0 && (n[s] = o.join(":").trim()), n;
  }, {})), r;
}
function Ag(t) {
  var e = t.getAttribute("data-prefix"), r = t.getAttribute("data-icon"), n = t.innerText !== void 0 ? t.innerText.trim() : "", i = Ca(Go(t));
  return i.prefix || (i.prefix = nr()), e && r && (i.prefix = e, i.iconName = r), i.iconName && i.prefix || (i.prefix && n.length > 0 && (i.iconName = tg(i.prefix, t.innerText) || Bo(i.prefix, Gs(t.innerText))), !i.iconName && re.autoFetchSvg && t.firstChild && t.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = t.firstChild.data)), i;
}
function Og(t) {
  var e = _r(t.attributes).reduce(function(i, a) {
    return i.name !== "class" && i.name !== "style" && (i[a.name] = a.value), i;
  }, {}), r = t.getAttribute("title"), n = t.getAttribute("data-fa-title-id");
  return re.autoA11y && (r ? e["aria-labelledby"] = "".concat(re.replacementClass, "-title-").concat(n || Cn()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function Tg() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Et,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Yl(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, r = Ag(t), n = r.iconName, i = r.prefix, a = r.rest, s = Og(t), o = Xs("parseNodeAttributes", {}, t), l = e.styleParser ? Pg(t) : [];
  return ee({
    iconName: n,
    title: t.getAttribute("title"),
    titleId: t.getAttribute("data-fa-title-id"),
    prefix: i,
    transform: Et,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: s
    }
  }, o);
}
var jg = St.styles;
function yf(t) {
  var e = re.autoReplaceSvg === "nest" ? Yl(t, {
    styleParser: !1
  }) : Yl(t);
  return ~e.extra.classes.indexOf(ef) ? Vt("generateLayersText", t, e) : Vt("generateSvgReplacementMutation", t, e);
}
var ir = /* @__PURE__ */ new Set();
Vo.map(function(t) {
  ir.add("fa-".concat(t));
});
Object.keys(kn[Oe]).map(ir.add.bind(ir));
Object.keys(kn[Ce]).map(ir.add.bind(ir));
ir = ji(ir);
function ql(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Xt) return Promise.resolve();
  var r = Te.documentElement.classList, n = function(f) {
    return r.add("".concat(Nl, "-").concat(f));
  }, i = function(f) {
    return r.remove("".concat(Nl, "-").concat(f));
  }, a = re.autoFetchSvg ? ir : Vo.map(function(u) {
    return "fa-".concat(u);
  }).concat(Object.keys(jg));
  a.includes("fa") || a.push("fa");
  var s = [".".concat(ef, ":not([").concat(yr, "])")].concat(a.map(function(u) {
    return ".".concat(u, ":not([").concat(yr, "])");
  })).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  var o = [];
  try {
    o = _r(t.querySelectorAll(s));
  } catch {
  }
  if (o.length > 0)
    n("pending"), i("complete");
  else
    return Promise.resolve();
  var l = qo.begin("onTree"), c = o.reduce(function(u, f) {
    try {
      var m = yf(f);
      m && u.push(m);
    } catch (h) {
      $d || h.name === "MissingIcon" && console.error(h);
    }
    return u;
  }, []);
  return new Promise(function(u, f) {
    Promise.all(c).then(function(m) {
      vf(m, function() {
        n("active"), n("complete"), i("pending"), typeof e == "function" && e(), l(), u();
      });
    }).catch(function(m) {
      l(), f(m);
    });
  });
}
function kg(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  yf(t).then(function(r) {
    r && vf([r], e);
  });
}
function Mg(t) {
  return function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = (e || {}).icon ? e : Bs(e || {}), i = r.mask;
    return i && (i = (i || {}).icon ? i : Bs(i || {})), t(n, ee(ee({}, r), {}, {
      mask: i
    }));
  };
}
var zg = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.transform, i = n === void 0 ? Et : n, a = r.symbol, s = a === void 0 ? !1 : a, o = r.mask, l = o === void 0 ? null : o, c = r.maskId, u = c === void 0 ? null : c, f = r.title, m = f === void 0 ? null : f, h = r.titleId, p = h === void 0 ? null : h, d = r.classes, v = d === void 0 ? [] : d, b = r.attributes, g = b === void 0 ? {} : b, y = r.styles, w = y === void 0 ? {} : y;
  if (e) {
    var P = e.prefix, T = e.iconName, A = e.icon;
    return Ia(ee({
      type: "icon"
    }, e), function() {
      return wr("beforeDOMElementCreation", {
        iconDefinition: e,
        params: r
      }), re.autoA11y && (m ? g["aria-labelledby"] = "".concat(re.replacementClass, "-title-").concat(p || Cn()) : (g["aria-hidden"] = "true", g.focusable = "false")), Yo({
        icons: {
          main: Us(A),
          mask: l ? Us(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: P,
        iconName: T,
        transform: ee(ee({}, Et), i),
        symbol: s,
        title: m,
        maskId: u,
        titleId: p,
        extra: {
          attributes: g,
          styles: w,
          classes: v
        }
      });
    });
  }
}, Eg = {
  mixout: function() {
    return {
      icon: Mg(zg)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.treeCallback = ql, r.nodeCallback = kg, r;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(r) {
      var n = r.node, i = n === void 0 ? Te : n, a = r.callback, s = a === void 0 ? function() {
      } : a;
      return ql(i, s);
    }, e.generateSvgReplacementMutation = function(r, n) {
      var i = n.iconName, a = n.title, s = n.titleId, o = n.prefix, l = n.transform, c = n.symbol, u = n.mask, f = n.maskId, m = n.extra;
      return new Promise(function(h, p) {
        Promise.all([Ys(i, o), u.iconName ? Ys(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(d) {
          var v = Do(d, 2), b = v[0], g = v[1];
          h([r, Yo({
            icons: {
              main: b,
              mask: g
            },
            prefix: o,
            iconName: i,
            transform: l,
            symbol: c,
            maskId: f,
            title: a,
            titleId: s,
            extra: m,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(r) {
      var n = r.children, i = r.attributes, a = r.main, s = r.transform, o = r.styles, l = za(o);
      l.length > 0 && (i.style = l);
      var c;
      return Zo(s) && (c = Vt("generateAbstractTransformGrouping", {
        main: a,
        transform: s,
        containerWidth: a.width,
        iconWidth: a.width
      })), n.push(c || a.icon), {
        children: n,
        attributes: i
      };
    };
  }
}, Cg = {
  mixout: function() {
    return {
      layer: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.classes, a = i === void 0 ? [] : i;
        return Ia({
          type: "layer"
        }, function() {
          wr("beforeDOMElementCreation", {
            assembler: r,
            params: n
          });
          var s = [];
          return r(function(o) {
            Array.isArray(o) ? o.map(function(l) {
              s = s.concat(l.abstract);
            }) : s = s.concat(o.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(re.cssPrefix, "-layers")].concat(ji(a)).join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, Ig = {
  mixout: function() {
    return {
      counter: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.title, a = i === void 0 ? null : i, s = n.classes, o = s === void 0 ? [] : s, l = n.attributes, c = l === void 0 ? {} : l, u = n.styles, f = u === void 0 ? {} : u;
        return Ia({
          type: "counter",
          content: r
        }, function() {
          return wr("beforeDOMElementCreation", {
            content: r,
            params: n
          }), fg({
            content: r.toString(),
            title: a,
            extra: {
              attributes: c,
              styles: f,
              classes: ["".concat(re.cssPrefix, "-layers-counter")].concat(ji(o))
            }
          });
        });
      }
    };
  }
}, Lg = {
  mixout: function() {
    return {
      text: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.transform, a = i === void 0 ? Et : i, s = n.title, o = s === void 0 ? null : s, l = n.classes, c = l === void 0 ? [] : l, u = n.attributes, f = u === void 0 ? {} : u, m = n.styles, h = m === void 0 ? {} : m;
        return Ia({
          type: "text",
          content: r
        }, function() {
          return wr("beforeDOMElementCreation", {
            content: r,
            params: n
          }), Gl({
            content: r,
            transform: ee(ee({}, Et), a),
            title: o,
            extra: {
              attributes: f,
              styles: h,
              classes: ["".concat(re.cssPrefix, "-layers-text")].concat(ji(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(r, n) {
      var i = n.title, a = n.transform, s = n.extra, o = null, l = null;
      if (Jd) {
        var c = parseInt(getComputedStyle(r).fontSize, 10), u = r.getBoundingClientRect();
        o = u.width / c, l = u.height / c;
      }
      return re.autoA11y && !i && (s.attributes["aria-hidden"] = "true"), Promise.resolve([r, Gl({
        content: r.innerHTML,
        width: o,
        height: l,
        transform: a,
        title: i,
        extra: s,
        watchable: !0
      })]);
    };
  }
}, Rg = new RegExp('"', "ug"), Ql = [1105920, 1112319];
function Ng(t) {
  var e = t.replace(Rg, ""), r = Qh(e, 0), n = r >= Ql[0] && r <= Ql[1], i = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: Gs(i ? e[0] : e),
    isSecondary: n || i
  };
}
function Jl(t, e) {
  var r = "".concat(Oh).concat(e.replace(":", "-"));
  return new Promise(function(n, i) {
    if (t.getAttribute(r) !== null)
      return n();
    var a = _r(t.children), s = a.filter(function(A) {
      return A.getAttribute(Vs) === e;
    })[0], o = rr.getComputedStyle(t, e), l = o.getPropertyValue("font-family").match(zh), c = o.getPropertyValue("font-weight"), u = o.getPropertyValue("content");
    if (s && !l)
      return t.removeChild(s), n();
    if (l && u !== "none" && u !== "") {
      var f = o.getPropertyValue("content"), m = ~["Sharp"].indexOf(l[2]) ? Ce : Oe, h = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? Mn[m][l[2].toLowerCase()] : Eh[m][c], p = Ng(f), d = p.value, v = p.isSecondary, b = l[0].startsWith("FontAwesome"), g = Bo(h, d), y = g;
      if (b) {
        var w = rg(d);
        w.iconName && w.prefix && (g = w.iconName, h = w.prefix);
      }
      if (g && !v && (!s || s.getAttribute(Wo) !== h || s.getAttribute(Fo) !== y)) {
        t.setAttribute(r, y), s && t.removeChild(s);
        var P = Tg(), T = P.extra;
        T.attributes[Vs] = e, Ys(g, h).then(function(A) {
          var j = Yo(ee(ee({}, P), {}, {
            icons: {
              main: A,
              mask: Uo()
            },
            prefix: h,
            iconName: y,
            extra: T,
            watchable: !0
          })), O = Te.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? t.insertBefore(O, t.firstChild) : t.appendChild(O), O.outerHTML = j.map(function(M) {
            return Mi(M);
          }).join(`
`), t.removeAttribute(r), n();
        }).catch(i);
      } else
        n();
    } else
      n();
  });
}
function Dg(t) {
  return Promise.all([Jl(t, "::before"), Jl(t, "::after")]);
}
function Hg(t) {
  return t.parentNode !== document.head && !~jh.indexOf(t.tagName.toUpperCase()) && !t.getAttribute(Vs) && (!t.parentNode || t.parentNode.tagName !== "svg");
}
function Kl(t) {
  if (Xt)
    return new Promise(function(e, r) {
      var n = _r(t.querySelectorAll("*")).filter(Hg).map(Dg), i = qo.begin("searchPseudoElements");
      bf(), Promise.all(n).then(function() {
        i(), Qs(), e();
      }).catch(function() {
        i(), Qs(), r();
      });
    });
}
var Wg = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.pseudoElementsCallback = Kl, r;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(r) {
      var n = r.node, i = n === void 0 ? Te : n;
      re.searchPseudoElements && Kl(i);
    };
  }
}, _l = !1, Fg = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          bf(), _l = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        Ul(Xs("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        xg();
      },
      watch: function(r) {
        var n = r.observeMutationsRoot;
        _l ? Qs() : Ul(Xs("mutationObserverCallbacks", {
          observeMutationsRoot: n
        }));
      }
    };
  }
}, $l = function(e) {
  var r = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(n, i) {
    var a = i.toLowerCase().split("-"), s = a[0], o = a.slice(1).join("-");
    if (s && o === "h")
      return n.flipX = !0, n;
    if (s && o === "v")
      return n.flipY = !0, n;
    if (o = parseFloat(o), isNaN(o))
      return n;
    switch (s) {
      case "grow":
        n.size = n.size + o;
        break;
      case "shrink":
        n.size = n.size - o;
        break;
      case "left":
        n.x = n.x - o;
        break;
      case "right":
        n.x = n.x + o;
        break;
      case "up":
        n.y = n.y - o;
        break;
      case "down":
        n.y = n.y + o;
        break;
      case "rotate":
        n.rotate = n.rotate + o;
        break;
    }
    return n;
  }, r);
}, Vg = {
  mixout: function() {
    return {
      parse: {
        transform: function(r) {
          return $l(r);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var i = n.getAttribute("data-fa-transform");
        return i && (r.transform = $l(i)), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(r) {
      var n = r.main, i = r.transform, a = r.containerWidth, s = r.iconWidth, o = {
        transform: "translate(".concat(a / 2, " 256)")
      }, l = "translate(".concat(i.x * 32, ", ").concat(i.y * 32, ") "), c = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), u = "rotate(".concat(i.rotate, " 0 0)"), f = {
        transform: "".concat(l, " ").concat(c, " ").concat(u)
      }, m = {
        transform: "translate(".concat(s / 2 * -1, " -256)")
      }, h = {
        outer: o,
        inner: f,
        path: m
      };
      return {
        tag: "g",
        attributes: ee({}, h.outer),
        children: [{
          tag: "g",
          attributes: ee({}, h.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: ee(ee({}, n.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
}, rs = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function ec(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return t.attributes && (t.attributes.fill || e) && (t.attributes.fill = "black"), t;
}
function Gg(t) {
  return t.tag === "g" ? t.children : [t];
}
var Zg = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var i = n.getAttribute("data-fa-mask"), a = i ? Ca(i.split(" ").map(function(s) {
          return s.trim();
        })) : Uo();
        return a.prefix || (a.prefix = nr()), r.mask = a, r.maskId = n.getAttribute("data-fa-mask-id"), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(r) {
      var n = r.children, i = r.attributes, a = r.main, s = r.mask, o = r.maskId, l = r.transform, c = a.width, u = a.icon, f = s.width, m = s.icon, h = Gh({
        transform: l,
        containerWidth: f,
        iconWidth: c
      }), p = {
        tag: "rect",
        attributes: ee(ee({}, rs), {}, {
          fill: "white"
        })
      }, d = u.children ? {
        children: u.children.map(ec)
      } : {}, v = {
        tag: "g",
        attributes: ee({}, h.inner),
        children: [ec(ee({
          tag: u.tag,
          attributes: ee(ee({}, u.attributes), h.path)
        }, d))]
      }, b = {
        tag: "g",
        attributes: ee({}, h.outer),
        children: [v]
      }, g = "mask-".concat(o || Cn()), y = "clip-".concat(o || Cn()), w = {
        tag: "mask",
        attributes: ee(ee({}, rs), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, b]
      }, P = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: y
          },
          children: Gg(m)
        }, w]
      };
      return n.push(P, {
        tag: "rect",
        attributes: ee({
          fill: "currentColor",
          "clip-path": "url(#".concat(y, ")"),
          mask: "url(#".concat(g, ")")
        }, rs)
      }), {
        children: n,
        attributes: i
      };
    };
  }
}, Xg = {
  provides: function(e) {
    var r = !1;
    rr.matchMedia && (r = rr.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var n = [], i = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: ee(ee({}, i), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var s = ee(ee({}, a), {}, {
        attributeName: "opacity"
      }), o = {
        tag: "circle",
        attributes: ee(ee({}, i), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return r || o.children.push({
        tag: "animate",
        attributes: ee(ee({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: ee(ee({}, s), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(o), n.push({
        tag: "path",
        attributes: ee(ee({}, i), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: r ? [] : [{
          tag: "animate",
          attributes: ee(ee({}, s), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), r || n.push({
        tag: "path",
        attributes: ee(ee({}, i), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: ee(ee({}, s), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, Bg = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var i = n.getAttribute("data-fa-symbol"), a = i === null ? !1 : i === "" ? !0 : i;
        return r.symbol = a, r;
      }
    };
  }
}, Ug = [Bh, Eg, Cg, Ig, Lg, Wg, Fg, Vg, Zg, Xg, Bg];
ag(Ug, {
  mixoutsTo: ft
});
ft.noAuto;
var wf = ft.config;
ft.library;
ft.dom;
var ba = ft.parse;
ft.findIconDefinition;
ft.toHtml;
var Yg = ft.icon;
ft.layer;
var qg = ft.text;
ft.counter;
function tc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tc(Object(r), !0).forEach(function(n) {
      it(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ya(t) {
  "@babel/helpers - typeof";
  return ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ya(t);
}
function it(t, e, r) {
  return e = rv(e), e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Qg(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function Jg(t, e) {
  if (t == null) return {};
  var r = Qg(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Js(t) {
  return Kg(t) || _g(t) || $g(t) || ev();
}
function Kg(t) {
  if (Array.isArray(t)) return Ks(t);
}
function _g(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function $g(t, e) {
  if (t) {
    if (typeof t == "string") return Ks(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ks(t, e);
  }
}
function Ks(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function ev() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tv(t, e) {
  if (typeof t != "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function rv(t) {
  var e = tv(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var nv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Sf = { exports: {} };
(function(t) {
  (function(e) {
    var r = function(b, g, y) {
      if (!c(g) || f(g) || m(g) || h(g) || l(g))
        return g;
      var w, P = 0, T = 0;
      if (u(g))
        for (w = [], T = g.length; P < T; P++)
          w.push(r(b, g[P], y));
      else {
        w = {};
        for (var A in g)
          Object.prototype.hasOwnProperty.call(g, A) && (w[b(A, y)] = r(b, g[A], y));
      }
      return w;
    }, n = function(b, g) {
      g = g || {};
      var y = g.separator || "_", w = g.split || /(?=[A-Z])/;
      return b.split(w).join(y);
    }, i = function(b) {
      return p(b) ? b : (b = b.replace(/[\-_\s]+(.)?/g, function(g, y) {
        return y ? y.toUpperCase() : "";
      }), b.substr(0, 1).toLowerCase() + b.substr(1));
    }, a = function(b) {
      var g = i(b);
      return g.substr(0, 1).toUpperCase() + g.substr(1);
    }, s = function(b, g) {
      return n(b, g).toLowerCase();
    }, o = Object.prototype.toString, l = function(b) {
      return typeof b == "function";
    }, c = function(b) {
      return b === Object(b);
    }, u = function(b) {
      return o.call(b) == "[object Array]";
    }, f = function(b) {
      return o.call(b) == "[object Date]";
    }, m = function(b) {
      return o.call(b) == "[object RegExp]";
    }, h = function(b) {
      return o.call(b) == "[object Boolean]";
    }, p = function(b) {
      return b = b - 0, b === b;
    }, d = function(b, g) {
      var y = g && "process" in g ? g.process : g;
      return typeof y != "function" ? b : function(w, P) {
        return y(w, b, P);
      };
    }, v = {
      camelize: i,
      decamelize: s,
      pascalize: a,
      depascalize: s,
      camelizeKeys: function(b, g) {
        return r(d(i, g), b);
      },
      decamelizeKeys: function(b, g) {
        return r(d(s, g), b, g);
      },
      pascalizeKeys: function(b, g) {
        return r(d(a, g), b);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    t.exports ? t.exports = v : e.humps = v;
  })(nv);
})(Sf);
var iv = Sf.exports, av = ["class", "style"];
function sv(t) {
  return t.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, r) {
    var n = r.indexOf(":"), i = iv.camelize(r.slice(0, n)), a = r.slice(n + 1).trim();
    return e[i] = a, e;
  }, {});
}
function ov(t) {
  return t.split(/\s+/).reduce(function(e, r) {
    return e[r] = !0, e;
  }, {});
}
function Jo(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var n = (t.children || []).map(function(l) {
    return Jo(l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, c) {
    var u = t.attributes[c];
    switch (c) {
      case "class":
        l.class = ov(u);
        break;
      case "style":
        l.style = sv(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  r.class;
  var a = r.style, s = a === void 0 ? {} : a, o = Jg(r, av);
  return vr(t.tag, wt(wt(wt({}, e), {}, {
    class: i.class,
    style: wt(wt({}, i.style), s)
  }, i.attrs), o), n);
}
var xf = !1;
try {
  xf = process.env.NODE_ENV === "production";
} catch {
}
function lv() {
  if (!xf && console && typeof console.error == "function") {
    var t;
    (t = console).error.apply(t, arguments);
  }
}
function Sn(t, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? it({}, t, e) : {};
}
function cv(t) {
  var e, r = (e = {
    "fa-spin": t.spin,
    "fa-pulse": t.pulse,
    "fa-fw": t.fixedWidth,
    "fa-border": t.border,
    "fa-li": t.listItem,
    "fa-inverse": t.inverse,
    "fa-flip": t.flip === !0,
    "fa-flip-horizontal": t.flip === "horizontal" || t.flip === "both",
    "fa-flip-vertical": t.flip === "vertical" || t.flip === "both"
  }, it(e, "fa-".concat(t.size), t.size !== null), it(e, "fa-rotate-".concat(t.rotation), t.rotation !== null), it(e, "fa-pull-".concat(t.pull), t.pull !== null), it(e, "fa-swap-opacity", t.swapOpacity), it(e, "fa-bounce", t.bounce), it(e, "fa-shake", t.shake), it(e, "fa-beat", t.beat), it(e, "fa-fade", t.fade), it(e, "fa-beat-fade", t.beatFade), it(e, "fa-flash", t.flash), it(e, "fa-spin-pulse", t.spinPulse), it(e, "fa-spin-reverse", t.spinReverse), e);
  return Object.keys(r).map(function(n) {
    return r[n] ? n : null;
  }).filter(function(n) {
    return n;
  });
}
function rc(t) {
  if (t && ya(t) === "object" && t.prefix && t.iconName && t.icon)
    return t;
  if (ba.icon)
    return ba.icon(t);
  if (t === null)
    return null;
  if (ya(t) === "object" && t.prefix && t.iconName)
    return t;
  if (Array.isArray(t) && t.length === 2)
    return {
      prefix: t[0],
      iconName: t[1]
    };
  if (typeof t == "string")
    return {
      prefix: "fas",
      iconName: t
    };
}
var ae = V({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var n = r.attrs, i = oe(function() {
      return rc(e.icon);
    }), a = oe(function() {
      return Sn("classes", cv(e));
    }), s = oe(function() {
      return Sn("transform", typeof e.transform == "string" ? ba.transform(e.transform) : e.transform);
    }), o = oe(function() {
      return Sn("mask", rc(e.mask));
    }), l = oe(function() {
      return Yg(i.value, wt(wt(wt(wt({}, a.value), s.value), o.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    Pi(l, function(u) {
      if (!u)
        return lv("Could not find one or more icon(s)", i.value, o.value);
    }, {
      immediate: !0
    });
    var c = oe(function() {
      return l.value ? Jo(l.value.abstract[0], {}, n) : null;
    });
    return function() {
      return c.value;
    };
  }
});
V({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var n = r.slots, i = wf.familyPrefix, a = oe(function() {
      return ["".concat(i, "-layers")].concat(Js(e.fixedWidth ? ["".concat(i, "-fw")] : []));
    });
    return function() {
      return vr("div", {
        class: a.value
      }, n.default ? n.default() : []);
    };
  }
});
V({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(e) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(e) > -1;
      }
    }
  },
  setup: function(e, r) {
    var n = r.attrs, i = wf.familyPrefix, a = oe(function() {
      return Sn("classes", [].concat(Js(e.counter ? ["".concat(i, "-layers-counter")] : []), Js(e.position ? ["".concat(i, "-layers-").concat(e.position)] : [])));
    }), s = oe(function() {
      return Sn("transform", typeof e.transform == "string" ? ba.transform(e.transform) : e.transform);
    }), o = oe(function() {
      var c = qg(e.value.toString(), wt(wt({}, s.value), a.value)), u = c.abstract;
      return e.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = oe(function() {
      return Jo(o.value, {}, n);
    });
    return function() {
      return l.value;
    };
  }
});
var La = {
  prefix: "far",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
  ]
}, uv = {
  prefix: "far",
  iconName: "face-smile",
  icon: [
    512,
    512,
    [128578, "smile"],
    "f118",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, dv = uv, Pf = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
  ]
}, fv = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
  ]
}, Ko = {
  prefix: "far",
  iconName: "xmark",
  icon: [
    384,
    512,
    [215, 10005, 10006, 10060, 128473, "close", "multiply", "remove", "times"],
    "f00d",
    "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
  ]
}, pv = {
  prefix: "far",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"
  ]
}, _o = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"
  ]
}, mv = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"
  ]
}, hv = mv, gv = {
  prefix: "far",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"
  ]
}, vv = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [
    448,
    512,
    [8592],
    "f060",
    "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"
  ]
}, nc = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [
    448,
    512,
    [8594],
    "f061",
    "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"
  ]
}, bv = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"
  ]
}, yv = {
  prefix: "far",
  iconName: "bars",
  icon: [
    448,
    512,
    ["navicon"],
    "f0c9",
    "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"
  ]
};
const wv = { class: "flex-1 text-left" }, dj = /* @__PURE__ */ V({
  __name: "AccordionButton",
  setup(t) {
    const e = me("multiple", !1);
    return (r, n) => (x(), F(be(S(e) ? "dt" : "div"), null, {
      default: D(() => [
        U(S(Id), {
          class: X([
            "w-full text-sm flex justify-between items-center gap-2 text-default-600",
            "hover:text-default-700"
          ])
        }, {
          default: D(({ open: i }) => [
            k("span", wv, [
              H(r.$slots, "default", { open: i })
            ]),
            U(S(ae), {
              icon: i ? S(gv) : S(pv),
              class: "size-5 flex-none",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Sv = {
  class: /* @__PURE__ */ X([
    "divide-y divide-gray-900/10",
    "[&>div]:py-6 [&>div:first-child]:pt-0 [&>div:last-child]:pb-0"
  ])
}, fj = /* @__PURE__ */ V({
  __name: "AccordionGroup",
  setup(t) {
    return Le("multiple", !0), (e, r) => (x(), N("dl", Sv, [
      H(e.$slots, "default")
    ]));
  }
}), pj = /* @__PURE__ */ V({
  __name: "AccordionPanel",
  setup(t) {
    const e = me("multiple", !1);
    return (r, n) => (x(), F(S(Ld), {
      class: "pt-6 text-sm",
      as: S(e) ? "dd" : void 0
    }, {
      default: D(({ open: i, close: a }) => [
        H(r.$slots, "default", {
          open: i,
          close: a
        })
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), xv = {
  class: /* @__PURE__ */ X([
    "shadow rounded-2xl bg-primary-100 p-6 flex items-center",
    "md:space-x-base"
  ])
}, Pv = {
  key: 0,
  class: /* @__PURE__ */ X([
    "hidden size-10 rounded-full bg-primary-600 items-center justify-center",
    "md:inline-flex"
  ])
}, Av = {
  class: /* @__PURE__ */ X([
    "flex-1 grid-cols-12 grid-rows-[repeat(2,minmax(0,auto))]",
    "md:grid"
  ])
}, mj = /* @__PURE__ */ V({
  __name: "ActionBanner",
  props: {
    icon: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", xv, [
      e.icon ? (x(), N("span", Pv, [
        U(S(ae), {
          icon: e.icon,
          class: "size-4 text-white",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : J("", !0),
      k("div", Av, [
        H(e.$slots, "default")
      ])
    ]));
  }
}), se = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [n, i] of e)
    r[n] = i;
  return r;
}, Ov = {}, Tv = {
  class: /* @__PURE__ */ X([
    "col-start-9 col-end-13 row-start-1 row-end-3 pt-4",
    "md:pt-0 md:self-center md:justify-self-end"
  ])
};
function jv(t, e) {
  return x(), N("div", Tv, [
    H(t.$slots, "default")
  ]);
}
const hj = /* @__PURE__ */ se(Ov, [["render", jv]]), kv = {}, Mv = { class: "mt-1 text-sm font-medium text-default-700 col-start-1 col-end-9 row-start-2 row-end-3" };
function zv(t, e) {
  return x(), N("div", Mv, [
    k("p", null, [
      H(t.$slots, "default")
    ])
  ]);
}
const gj = /* @__PURE__ */ se(kv, [["render", zv]]), vj = /* @__PURE__ */ V({
  __name: "ActionBannerTitle",
  props: {
    as: { default: "h3" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "font-gilmer font-bold text-2xl text-default-700 col-start-1 col-end-9 row-start-1 row-end-2" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Ev = {}, Cv = {
  class: /* @__PURE__ */ X([
    "mx-auto max-w-3xl bg-white shadow",
    "sm:rounded-lg"
  ])
}, Iv = {
  class: /* @__PURE__ */ X([
    "px-4 py-5",
    "sm:p-6"
  ])
};
function Lv(t, e) {
  return x(), N("div", Cv, [
    k("div", Iv, [
      H(t.$slots, "default")
    ])
  ]);
}
const bj = /* @__PURE__ */ se(Ev, [["render", Lv]]), Rv = {}, Nv = { class: "pt-5" };
function Dv(t, e) {
  return x(), N("div", Nv, [
    H(t.$slots, "default")
  ]);
}
const yj = /* @__PURE__ */ se(Rv, [["render", Dv]]), Hv = {}, Wv = { class: "mt-2 max-w-xl text-sm text-default-500" };
function Fv(t, e) {
  return x(), N("div", Wv, [
    k("p", null, [
      H(t.$slots, "default")
    ])
  ]);
}
const wj = /* @__PURE__ */ se(Hv, [["render", Fv]]), Sj = /* @__PURE__ */ V({
  __name: "ActionPanelTitle",
  props: {
    as: { default: "h3" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "text-base font-semibold text-default-900" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
var Vv = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [
    512,
    512,
    [61532, "times-circle", "xmark-circle"],
    "f057",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
  ]
}, Gv = Vv, Zv = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [
    512,
    512,
    [9888, "exclamation-triangle", "warning"],
    "f071",
    "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
  ]
}, Xv = {
  prefix: "fas",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
  ]
}, Bv = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
  ]
}, Uv = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, Af = Uv, Yv = {
  prefix: "fas",
  iconName: "face-hand-over-mouth",
  icon: [
    512,
    512,
    [129762],
    "e378",
    "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
  ]
}, qv = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Of = qv, Qv = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
};
const Jv = { class: "flex" }, Kv = { class: "shrink-0" }, xj = /* @__PURE__ */ V({
  __name: "Alert",
  props: {
    icon: { default: void 0 },
    link: { default: void 0 },
    type: { default: "info" }
  },
  setup(t) {
    const e = t;
    Le("type", e.type);
    const r = /* @__PURE__ */ new Map([
      ["info", "bg-blue-50"],
      ["success", "bg-green-50"],
      ["error", "bg-red-50"],
      ["warning", "bg-yellow-50"]
    ]), n = /* @__PURE__ */ new Map([
      ["info", "text-blue-400"],
      ["success", "text-green-400"],
      ["error", "text-red-400"],
      ["warning", "text-yellow-400"]
    ]), i = oe(() => e.icon ? e.icon : {
      info: Af,
      error: Yv,
      warning: Qv,
      success: Of
    }[e.type]);
    return (a, s) => (x(), N("div", {
      class: X(["rounded-md p-4", S(r).get(a.type)])
    }, [
      k("div", Jv, [
        k("div", Kv, [
          U(S(ae), {
            icon: i.value,
            class: X(["size-4", S(n).get(a.type)]),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])
        ]),
        k("div", {
          class: X([["ml-3 flex-1 grid grid-cols-1 gap-2", "md:grid-cols-12"], "[&:has([data-slot='description'])_[data-slot='title']]:font-medium"])
        }, [
          H(a.$slots, "default")
        ])
      ])
    ], 2));
  }
}), Pj = /* @__PURE__ */ V({
  __name: "AlertDescription",
  props: {
    as: { default: "p" }
  },
  setup(t) {
    const e = me("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700"],
      ["success", "text-green-700"],
      ["error", "text-red-700"],
      ["warning", "text-yellow-700"]
    ]);
    return (n, i) => (x(), F(be(n.as), {
      class: X([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-2 md:row-end-3",
        S(r).get(S(e))
      ]),
      "data-slot": "description"
    }, {
      default: D(() => [
        H(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Aj = /* @__PURE__ */ V({
  __name: "AlertLink",
  props: {
    as: { default: Lt }
  },
  setup(t) {
    const e = me("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700 hover:text-blue-600"],
      ["success", "text-green-700 hover:text-green-600"],
      ["error", "text-red-700 hover:text-red-600"],
      ["warning", "text-yellow-700 hover:text-yellow-600"]
    ]);
    return (n, i) => (x(), F(be(n.as), {
      class: X([
        "pt-3 text-sm whitespace-nowrap font-medium",
        "md:pt-0 md:text-right md:col-start-11 md:col-end-13",
        S(r).get(S(e))
      ])
    }, {
      default: D(() => [
        H(n.$slots, "default"),
        i[0] || (i[0] = k("span", { "aria-hidden": "true" }, " →", -1))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Oj = /* @__PURE__ */ V({
  __name: "AlertTitle",
  props: {
    as: { default: "h3" }
  },
  setup(t) {
    const e = me("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-800"],
      ["success", "text-green-800"],
      ["error", "text-red-800"],
      ["warning", "text-yellow-800"]
    ]);
    return (n, i) => (x(), F(be(n.as), {
      class: X([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-1 md:row-end-2",
        S(r).get(S(e))
      ]),
      "data-slot": "title"
    }, {
      default: D(() => [
        H(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Tf = /* @__PURE__ */ V({
  __name: "Badge",
  props: {
    color: { default: "gray" }
  },
  setup(t) {
    Le("badge-color", t.color);
    const r = /* @__PURE__ */ new Map([
      ["gray", "bg-default-50 text-default-600 ring-default-500/10"],
      ["red", "bg-red-50 text-red-700 ring-red-600/10"],
      ["yellow", "bg-yellow-50 text-yellow-800 ring-yellow-600/20"],
      ["green", "bg-green-50 text-green-700 ring-green-600/20"],
      ["blue", "bg-blue-50 text-blue-700 ring-blue-700/10"],
      ["primary", "bg-primary-50 text-primary-700 ring-primary-700/10"],
      ["purple", "bg-purple-50 text-purple-700 ring-purple-700/10"],
      ["pink", "bg-pink-50 text-pink-700 ring-pink-700/10"]
    ]);
    return (n, i) => (x(), N("span", {
      class: X([
        "inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",
        S(r).get(n.color)
      ])
    }, [
      H(n.$slots, "default")
    ], 2));
  }
}), _v = { class: "w-full rounded-md bg-white p-base" }, $v = { class: "mt-5 text-gray-500 text-sm leading-normal" }, ic = /* @__PURE__ */ V({
  __name: "TextPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    fontSize: {},
    textColour: {}
  },
  setup(t) {
    const e = t;
    return (r, n) => (x(), N("div", _v, [
      k("h2", {
        style: Ai({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          fontSize: `${e.fontSize}px`,
          color: e.textColour
        })
      }, " The Quick Brown Fox Jumps Over The Lazy Dogf ", 4),
      k("p", $v, _(r.fontFamily) + ", " + _(r.fontWeight) + ", " + _(r.fontSize) + "px, " + _(r.textColour), 1)
    ]));
  }
}), e1 = ["src"], ac = /* @__PURE__ */ V({
  __name: "ImagePreview",
  props: {
    src: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", {
      class: X(["flex size-full items-center justify-center rounded-md bg-white p-base", {
        "bg-checkerboard": !e.src
      }])
    }, [
      e.src ? (x(), N("img", {
        key: 0,
        src: e.src,
        alt: "Image Preview",
        class: "max-h-full max-w-full"
      }, null, 8, e1)) : J("", !0)
    ], 2));
  }
}), t1 = { class: "flex size-full items-center justify-center rounded-md bg-white p-base" }, sc = /* @__PURE__ */ V({
  __name: "ButtonPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    textColour: {},
    textHoverColour: {},
    backgroundColour: {},
    backgroundHoverColour: {},
    text: {}
  },
  setup(t) {
    const e = t;
    return (r, n) => (x(), N("div", t1, [
      k("button", {
        class: "inline-flex items-center rounded-md px-3 py-2 text-sm transition duration-150 ease-in-out",
        style: Ai({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          color: e.textColour,
          backgroundColor: e.backgroundColour
        })
      }, _(r.text ?? "Example button"), 5)
    ]));
  }
}), r1 = { class: "mx-2 items-center justify-center text-center" }, n1 = { class: "text-xs text-gray-700" }, oc = /* @__PURE__ */ V({
  __name: "ColourPreview",
  props: {
    colour: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", r1, [
      k("div", {
        class: "mx-auto flex size-14 shrink-0 items-center justify-center rounded-md",
        style: Ai(`background-color: ${e.colour}`)
      }, null, 4),
      k("span", n1, _(e.colour), 1)
    ]));
  }
}), i1 = {}, a1 = { class: "flex flex-col rounded-md bg-gray-200 p-base" }, s1 = { class: "grow" };
function o1(t, e) {
  return x(), N("div", a1, [
    e[0] || (e[0] = k("div", { class: "mb-3 flex justify-end" }, [
      k("span", { class: "rounded-full bg-blue-100 px-3 py-0.5 text-xs font-semibold text-blue-800" }, " Preview ")
    ], -1)),
    k("div", s1, [
      H(t.$slots, "default")
    ])
  ]);
}
const l1 = /* @__PURE__ */ se(i1, [["render", o1]]), c1 = { class: "max-w-2xl" }, u1 = { class: "flex flex-row gap-base" }, d1 = { class: "w-1/2" }, f1 = { class: "w-1/2" }, p1 = { class: "mt-base flex flex-row gap-base" }, m1 = { class: "w-2/12" }, h1 = { class: "w-5/12" }, g1 = { class: "flex h-full items-center rounded-md bg-white" }, v1 = { class: "w-5/12" }, b1 = { class: "flex justify-center rounded-md bg-white p-base" }, Tj = /* @__PURE__ */ V({
  __name: "BrandPreview",
  props: {
    rectangleLogoSrc: {},
    squareLogoSrc: {},
    headingFontFamily: {},
    headingFontWeight: {},
    headingFontSize: {},
    headingTextColour: {},
    bodyFontFamily: {},
    bodyFontWeight: {},
    bodyFontSize: {},
    bodyTextColour: {},
    primaryColour: {},
    secondaryColour: {},
    primaryButtonFontFamily: {},
    primaryButtonFontWeight: {},
    primaryButtonTextColour: {},
    primaryButtonTextHoverColour: {},
    primaryButtonBackgroundColour: {},
    primaryButtonBackgroundHoverColour: {},
    secondaryButtonFontFamily: {},
    secondaryButtonFontWeight: {},
    secondaryButtonTextColour: {},
    secondaryButtonTextHoverColour: {},
    secondaryButtonBackgroundColour: {},
    secondaryButtonBackgroundHoverColour: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", c1, [
      U(l1, null, {
        default: D(() => [
          k("div", u1, [
            k("div", d1, [
              U(ac, {
                src: e.rectangleLogoSrc,
                class: "h-full"
              }, null, 8, ["src"])
            ]),
            k("div", f1, [
              U(ic, {
                "font-family": e.headingFontFamily,
                "font-weight": e.headingFontWeight,
                "font-size": e.headingFontSize,
                "text-colour": e.headingTextColour
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"]),
              U(ic, {
                "font-family": e.bodyFontFamily,
                "font-weight": e.bodyFontWeight,
                "font-size": e.bodyFontSize,
                "text-colour": e.bodyTextColour,
                class: "mt-base"
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"])
            ])
          ]),
          k("div", p1, [
            k("div", m1, [
              U(ac, {
                src: e.squareLogoSrc,
                class: "h-full"
              }, null, 8, ["src"])
            ]),
            k("div", h1, [
              k("div", g1, [
                U(sc, {
                  "font-family": e.primaryButtonFontFamily,
                  "font-weight": e.primaryButtonFontWeight,
                  "text-colour": e.primaryButtonTextColour,
                  "text-hover-colour": e.primaryButtonTextHoverColour,
                  "background-colour": e.primaryButtonBackgroundColour,
                  "background-hover-colour": e.primaryButtonBackgroundHoverColour,
                  text: "Primary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"]),
                U(sc, {
                  "font-family": e.secondaryButtonFontFamily,
                  "font-weight": e.secondaryButtonFontWeight,
                  "text-colour": e.secondaryButtonTextColour,
                  "text-hover-colour": e.secondaryButtonTextHoverColour,
                  "background-colour": e.secondaryButtonBackgroundColour,
                  "background-hover-colour": e.secondaryButtonBackgroundHoverColour,
                  text: "Secondary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"])
              ])
            ]),
            k("div", v1, [
              k("div", b1, [
                U(oc, { colour: e.primaryColour }, null, 8, ["colour"]),
                U(oc, { colour: e.secondaryColour }, null, 8, ["colour"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]));
  }
}), y1 = { class: "flex items-center" }, jj = /* @__PURE__ */ V({
  __name: "Breadcrumb",
  props: {
    current: { type: Boolean, default: !1 },
    href: {}
  },
  setup(t) {
    const e = me("as");
    return (r, n) => (x(), N("li", null, [
      k("div", y1, [
        U(S(ae), {
          icon: S(Bv),
          class: "size-3 shrink-0 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        (x(), F(be(S(e)), {
          href: r.href,
          class: X([
            "ml-3 text-sm font-medium",
            r.current ? "text-primary-600" : "text-default-600 hover:text-default-700"
          ]),
          "aria-current": r.current ? "page" : void 0
        }, {
          default: D(() => [
            H(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["href", "class", "aria-current"]))
      ])
    ]));
  }
});
var w1 = {
  prefix: "fal",
  iconName: "calendar-day",
  icon: [
    448,
    512,
    [],
    "f783",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"
  ]
}, S1 = {
  prefix: "fal",
  iconName: "scale-balanced",
  icon: [
    640,
    512,
    [9878, "balance-scale"],
    "f24e",
    "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
  ]
}, lc = {
  prefix: "fal",
  iconName: "circle-plus",
  icon: [
    512,
    512,
    ["plus-circle"],
    "f055",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
  ]
}, x1 = {
  prefix: "fal",
  iconName: "gears",
  icon: [
    640,
    512,
    ["cogs"],
    "f085",
    "M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3 0 0 2.9 5.1 .2 .3 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3 0 0-3 5.1-.2 .3 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2 0 0-2.6-4.5-.1-.2 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2 0 0 2.6-4.5 .1-.2 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 0 0 5.1-2.9 .3-.2 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2 0 0 5.1 3 .3 .2 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1 0 0-4.5 2.6-.2 .1 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1 0 0-4.5-2.6-.2-.1 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, P1 = {
  prefix: "fal",
  iconName: "building-magnifying-glass",
  icon: [
    603,
    512,
    [],
    "e61c",
    "M60.6 30.1H301.5c16.6 0 30.1 13.5 30.1 30.1V180.7c9.3-7 19.4-12.9 30.1-17.6V60.2C361.7 27 334.8 0 301.5 0H60.6C27.3 0 .3 27 .3 60.2V421.6c0 33.3 27 60.2 60.2 60.2h60.2 30.1 60.2 30.1 60.2c27.5 0 50.7-18.5 57.9-43.7c-9.9-4.5-19.2-10.1-27.8-16.5c0 16.6-13.5 30.1-30.1 30.1H241.3V391.5c0-33.3-27-60.2-60.2-60.2s-60.2 27-60.2 60.2v60.2H60.6c-16.6 0-30.1-13.5-30.1-30.1V60.2c0-16.6 13.5-30.1 30.1-30.1zM278.9 210.8H233.7c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h37.6c0-30.5 9.1-58.8 24.6-82.5c-4.1-4.8-10.3-7.8-17.1-7.8zM211.1 391.5v60.2H150.9V391.5c0-16.6 13.5-30.1 30.1-30.1s30.1 13.5 30.1 30.1zM60.6 112.9v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V120.5zM233.7 90.4c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H233.7zm7.5 60.2V120.5h30.1v30.1H241.3zM60.6 233.4v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V233.4c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V240.9zm150.6 30.1V240.9h30.1v30.1H241.3zM422 211a90.4 90.4 0 1 1 0 180.7A90.4 90.4 0 1 1 422 211zm0 210.8c27.8 0 53.5-9.4 73.9-25.3L577 477.6c5.9 5.9 15.4 5.9 21.3 0s5.9-15.4 0-21.3l-81.1-81.1c15.9-20.4 25.3-46 25.3-73.9c0-66.5-53.9-120.5-120.5-120.5s-120.5 53.9-120.5 120.5s53.9 120.5 120.5 120.5z"
  ]
}, A1 = {
  prefix: "fal",
  iconName: "xmark",
  icon: [
    384,
    512,
    [215, 10005, 10006, 10060, 128473, "close", "multiply", "remove", "times"],
    "f00d",
    "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"
  ]
}, O1 = {
  prefix: "fal",
  iconName: "bolt",
  icon: [
    448,
    512,
    [9889, "zap"],
    "f0e7",
    "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"
  ]
}, T1 = {
  prefix: "fal",
  iconName: "pipe",
  icon: [
    64,
    512,
    [],
    "7c",
    "M32 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0z"
  ]
}, jf = {
  prefix: "fal",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"
  ]
}, j1 = {
  prefix: "fal",
  iconName: "gear",
  icon: [
    512,
    512,
    [9881, "cog"],
    "f013",
    "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"
  ]
}, k1 = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, M1 = k1, z1 = {
  prefix: "fal",
  iconName: "image-user",
  icon: [
    512,
    512,
    [],
    "e1b8",
    "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320H212.6c-18.6 0-34 14-36.3 32H335.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H256h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z"
  ]
}, E1 = {
  prefix: "fal",
  iconName: "badge-check",
  icon: [
    512,
    512,
    [],
    "f336",
    "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, C1 = {
  prefix: "fal",
  iconName: "screwdriver-wrench",
  icon: [
    512,
    512,
    ["tools"],
    "f7d9",
    "M64.7 34.6L160 107.9V160H107.9L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h64c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"
  ]
}, I1 = {
  prefix: "fal",
  iconName: "chart-line",
  icon: [
    512,
    512,
    ["line-chart"],
    "f201",
    "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"
  ]
}, L1 = {
  prefix: "fal",
  iconName: "memo-circle-check",
  icon: [
    576,
    512,
    [],
    "e1d9",
    "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z"
  ]
}, R1 = {
  prefix: "fal",
  iconName: "comments-dollar",
  icon: [
    640,
    512,
    [],
    "f653",
    "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, N1 = {
  prefix: "fal",
  iconName: "layer-group",
  icon: [
    576,
    512,
    [],
    "f5fd",
    "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"
  ]
}, D1 = {
  prefix: "fal",
  iconName: "person-shelter",
  icon: [
    512,
    512,
    [],
    "e54f",
    "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160V496c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7 480 169.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zM232 400h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232H243.8c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"
  ]
}, kf = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, Mf = {
  prefix: "fal",
  iconName: "clipboard",
  icon: [
    384,
    512,
    [128203],
    "f328",
    "M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12H112c-8.8 0-16 7.2-16 16v32h96 96V96c0-8.8-7.2-16-16-16H254c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7C73.3 61.4 91.1 48 112 48h6.7zM320 128c0 17.7-14.3 32-32 32H192 96c-17.7 0-32-14.3-32-32V112c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
  ]
}, H1 = {
  prefix: "fal",
  iconName: "paper-plane-top",
  icon: [
    512,
    512,
    ["paper-plane-alt", "send"],
    "e20a",
    "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272H120zm322.7-32L32 64l88 176H442.7z"
  ]
}, W1 = {
  prefix: "fal",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM245.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L224 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"
  ]
}, F1 = {
  prefix: "fal",
  iconName: "file-chart-column",
  icon: [
    384,
    512,
    ["file-chart-line"],
    "f659",
    "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V368z"
  ]
}, V1 = F1, G1 = {
  prefix: "fal",
  iconName: "key",
  icon: [
    512,
    512,
    [128273],
    "f084",
    "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48H144c-8.8 0-16 7.2-16 16v48H32V398.6L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V384h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, zf = {
  prefix: "fal",
  iconName: "eye-slash",
  icon: [
    640,
    512,
    [],
    "f070",
    "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
  ]
}, Z1 = {
  prefix: "fal",
  iconName: "users",
  icon: [
    640,
    512,
    [],
    "f0c0",
    "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"
  ]
}, X1 = {
  prefix: "fal",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"
  ]
}, B1 = {
  prefix: "fal",
  iconName: "arrow-progress",
  icon: [
    512,
    512,
    [],
    "e5df",
    "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112H400c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80H288L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432H126zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, U1 = {
  prefix: "fal",
  iconName: "browsers",
  icon: [
    576,
    512,
    [],
    "e0cb",
    "M512 32c17.7 0 32 14.3 32 32V96H256V32H512zM160 32h64V96H128V64c0-17.7 14.3-32 32-32zM128 352V128H240 544V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
  ]
};
const Y1 = {
  class: "flex text-sm",
  "aria-label": "Breadcrumb"
}, q1 = {
  role: "list",
  class: "flex items-center space-x-3"
}, kj = /* @__PURE__ */ V({
  __name: "BreadcrumbGroup",
  props: {
    as: { default: Lt },
    homeUrl: {}
  },
  setup(t) {
    return Le("as", t.as), (r, n) => (x(), N("nav", Y1, [
      k("ol", q1, [
        k("li", null, [
          k("div", null, [
            (x(), F(be(r.as), {
              href: r.homeUrl,
              class: X([
                "text-default-600 hover:text-default-700"
              ])
            }, {
              default: D(() => [
                U(S(ae), {
                  icon: S(jf),
                  class: "size-4",
                  "aria-hidden": "true"
                }, null, 8, ["icon"]),
                n[0] || (n[0] = k("span", { class: "sr-only" }, " Home ", -1))
              ]),
              _: 1
            }, 8, ["href"]))
          ])
        ]),
        H(r.$slots, "default")
      ])
    ]));
  }
}), $o = /* @__PURE__ */ V({
  __name: "Spinner",
  props: {
    as: { default: "span" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), {
      role: "status",
      class: "inline-flex"
    }, {
      default: D(() => r[0] || (r[0] = [
        k("svg", {
          class: "animate-spin",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "aria-hidden": "true"
        }, [
          k("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }),
          k("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })
        ], -1),
        k("span", { class: "sr-only" }, " Loading... ", -1)
      ])),
      _: 1
    }));
  }
}), xt = /* @__PURE__ */ V({
  __name: "Button",
  props: {
    as: { default: void 0 },
    block: { type: Boolean },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    id: { default: void 0 },
    leadingIcon: { default: void 0 },
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    trailingIcon: { default: void 0 },
    type: { default: void 0 }
  },
  setup(t) {
    const e = t, r = {
      sm: "px-2.5 py-2 text-sm rounded gap-x-1.5",
      base: "px-3.5 py-2.5 text-sm rounded-md gap-x-2",
      lg: "px-4 py-3 text-base rounded-md gap-x-2",
      xl: "px-7 py-4 text-lg rounded-md gap-x-4"
    }, n = {
      primary: "shadow-sm border-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm border-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900",
      tertiary: "border-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm border-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm border-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm border-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, i = oe(() => r[e.size]), a = oe(() => n[e.color]), s = oe(() => e.disabled || e.loading);
    return (o, l) => (x(), F(be(o.as ?? (o.href ? S(Lt) : "button")), {
      id: o.id,
      class: X([
        "inline-flex justify-center items-center font-medium border border-px",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        i.value,
        a.value,
        o.block && "w-full",
        s.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400"
      ]),
      href: o.href,
      type: o.type,
      method: o.method,
      disabled: s.value,
      "aria-disabled": s.value,
      "aria-busy": o.loading,
      tabindex: s.value ? "-1" : 0
    }, {
      default: D(() => [
        o.leadingIcon && !o.loading ? (x(), F(S(ae), {
          key: 0,
          icon: o.leadingIcon,
          "aria-hidden": "true",
          class: "size-4"
        }, null, 8, ["icon"])) : J("", !0),
        o.loading ? (x(), F($o, {
          key: 1,
          class: "size-4"
        })) : J("", !0),
        H(o.$slots, "default"),
        o.trailingIcon ? (x(), F(S(ae), {
          key: 2,
          icon: o.trailingIcon,
          "aria-hidden": "true",
          class: "size-4"
        }, null, 8, ["icon"])) : J("", !0)
      ]),
      _: 3
    }, 8, ["id", "class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex"]));
  }
}), Q1 = {}, J1 = {
  class: /* @__PURE__ */ X([
    "isolate inline-flex rounded-md",
    "[&>*]:rounded-none [&>*:not(:first-child)]:-ml-px [&>*:first-child]:rounded-l-md [&>*:last-child]:rounded-r-md [&>*]:relative [&>*:focus]:z-10"
  ])
};
function K1(t, e) {
  return x(), N("span", J1, [
    H(t.$slots, "default")
  ]);
}
const Mj = /* @__PURE__ */ se(Q1, [["render", K1]]), _1 = {}, $1 = { class: "isolate mt-2 grid grid-cols-7 gap-px bg-default-200 text-sm shadow ring-1 ring-default-200 rounded-lg overflow-hidden" };
function e0(t, e) {
  return x(), N(xe, null, [
    e[0] || (e[0] = Jr('<div class="grid grid-cols-7 text-center text-xs/6 text-default-900 font-medium"><span><abbr title="Monday">M</abbr></span><span><abbr title="Tuesday">T</abbr></span><span><abbr title="Wednesday">W</abbr></span><span><abbr title="Thursday">T</abbr></span><span><abbr title="Friday">F</abbr></span><span><abbr title="Saturday">S</abbr></span><span><abbr title="Sunday">S</abbr></span></div>', 1)),
    k("div", $1, [
      H(t.$slots, "default")
    ])
  ], 64);
}
const zj = /* @__PURE__ */ se(_1, [["render", e0]]), t0 = ["datetime", "aria-current"], Ej = /* @__PURE__ */ V({
  __name: "CalendarMonthViewDay",
  props: {
    as: { default: "span" },
    day: {},
    disabled: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(t) {
    const e = t, r = oe(() => e.as === "button");
    return (n, i) => (x(), F(be(n.as), {
      type: r.value ? "button" : void 0,
      class: X([
        "py-1.5 font-medium",
        n.disabled && "cursor-not-allowed",
        r.value && !n.selected && !n.disabled && "hover:bg-default-100",
        r.value && n.selected && !n.disabled && "hover:bg-primary-700",
        r.value && "focus:z-10",
        n.day.isCurrentMonth && !n.selected ? "bg-white" : "bg-default-100",
        n.selected && "text-white bg-primary-600",
        !n.selected && n.day.isCurrentMonth && !n.day.isToday && "text-default-900",
        !n.selected && !n.day.isCurrentMonth && !n.day.isToday && "text-default-400",
        n.day.isToday && !n.selected && "text-primary-600"
      ]),
      disabled: r.value ? n.disabled : void 0,
      "aria-disabled": r.value ? n.disabled : void 0,
      tabindex: r.value ? n.disabled ? "-1" : 0 : void 0
    }, {
      default: D(() => {
        var a;
        return [
          k("time", {
            datetime: n.day.date,
            class: "mx-auto flex size-7 items-center justify-center",
            "aria-current": n.day.isToday ? "date" : void 0
          }, _((a = n.day.date.split("-").pop()) == null ? void 0 : a.replace(/^0/, "")), 9, t0)
        ];
      }),
      _: 1
    }, 8, ["type", "class", "disabled", "aria-disabled", "tabindex"]));
  }
}), r0 = {}, n0 = { class: "flex items-center gap-x-base" };
function i0(t, e) {
  return x(), N("div", n0, [
    H(t.$slots, "default")
  ]);
}
const Cj = /* @__PURE__ */ se(r0, [["render", i0]]), Ij = /* @__PURE__ */ V({
  __name: "CalendarNavigationTitle",
  props: {
    as: { default: "h2" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "flex-1 text-sm font-semibold text-default-900 text-center" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), a0 = {}, s0 = { class: "rounded-lg bg-white shadow" };
function o0(t, e) {
  return x(), N("div", s0, [
    H(t.$slots, "default")
  ]);
}
const Ef = /* @__PURE__ */ se(a0, [["render", o0]]), l0 = {}, c0 = { class: "px-4 py-5 sm:p-6" };
function u0(t, e) {
  return x(), N("div", c0, [
    H(t.$slots, "default")
  ]);
}
const Cf = /* @__PURE__ */ se(l0, [["render", u0]]), d0 = {}, f0 = { class: "bg-default-50 px-4 py-4 sm:px-6" };
function p0(t, e) {
  return x(), N("div", f0, [
    H(t.$slots, "default")
  ]);
}
const m0 = /* @__PURE__ */ se(d0, [["render", p0]]), h0 = {}, g0 = { class: "px-4 py-5 sm:px-6" };
function v0(t, e) {
  return x(), N("div", g0, [
    H(t.$slots, "default")
  ]);
}
const b0 = /* @__PURE__ */ se(h0, [["render", v0]]), y0 = ["id", "value", "indeterminate", "checked", "disabled", "tabindex", "aria-disabled"], Lj = /* @__PURE__ */ V({
  __name: "Checkbox",
  props: {
    checked: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    indeterminate: { type: Boolean },
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = e, n = t, i = oe(() => n.checked ? !0 : Array.isArray(n.modelValue) && n.value ? n.modelValue.includes(n.value) : n.modelValue), a = (o) => {
      if (Array.isArray(n.modelValue) && n.value) {
        const l = n.modelValue.indexOf(n.value), { modelValue: c } = n;
        l === -1 ? c.push(n.value) : c.splice(l, 1), r("update:modelValue", c);
        return;
      }
      r("update:modelValue", o.target.checked);
    }, s = me("field-id");
    return (o, l) => (x(), N("input", {
      id: S(s),
      type: "checkbox",
      class: X([
        "h-4 w-4 rounded border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: o.value,
      indeterminate: o.indeterminate,
      checked: i.value,
      disabled: o.disabled,
      tabindex: o.disabled ? "-1" : 0,
      "aria-disabled": o.disabled,
      onChange: a
    }, null, 40, y0));
  }
}), w0 = {}, S0 = { class: "space-y-3" };
function x0(t, e) {
  return x(), N("div", S0, [
    H(t.$slots, "default")
  ]);
}
const Rj = /* @__PURE__ */ se(w0, [["render", x0]]), P0 = ["for"], Nj = /* @__PURE__ */ V({
  __name: "CheckboxGroupField",
  setup(t) {
    const e = Oi();
    return Le("field-id", e), (r, n) => (x(), N("label", {
      for: S(e),
      class: X([
        "bg-white flex items-center justify-between space-x-3 rounded-xl p-base border border-default-200 cursor-pointer",
        "[&>*]:cursor-pointer"
      ])
    }, [
      H(r.$slots, "default")
    ], 8, P0));
  }
}), Ra = /* @__PURE__ */ V({
  __name: "Label",
  props: {
    as: { default: "label" }
  },
  setup(t) {
    const r = t.as === "label" ? me("field-id") : void 0;
    return (n, i) => (x(), F(be(n.as), {
      for: n.as === "label" ? S(r) : void 0,
      class: "block text-sm font-medium text-default-900"
    }, {
      default: D(() => [
        H(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["for"]));
  }
}), Dj = /* @__PURE__ */ V({
  __name: "CheckboxGroupFieldLabel",
  setup(t) {
    return (e, r) => (x(), F(Ra, { as: "span" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Hj = /* @__PURE__ */ V({
  __name: "Combobox",
  props: /* @__PURE__ */ sr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, r = or(t, "modelValue");
    return Le("disabled", e.disabled), Le("modelValue", r), (n, i) => (x(), F(S(Fm), {
      modelValue: r.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => r.value = a),
      disabled: n.disabled,
      multiple: n.multiple,
      by: "id"
    }, {
      default: D(({ open: a, disabled: s }) => [
        H(n.$slots, "default", {
          open: a,
          disabled: s
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), A0 = { class: "flex flex-wrap gap-2 pt-2" }, Wj = /* @__PURE__ */ V({
  __name: "ComboboxBadges",
  emits: ["remove"],
  setup(t, { emit: e }) {
    const r = me("modelValue"), n = e;
    return (i, a) => (x(), N("ul", A0, [
      (x(!0), N(xe, null, Qe(S(r), (s) => (x(), N("li", {
        key: s.id
      }, [
        U(Tf, {
          color: "blue",
          remove: "",
          onRemove: (o) => n("remove", s)
        }, {
          default: D(() => [
            le(_(s.label), 1)
          ]),
          _: 2
        }, 1032, ["onRemove"])
      ]))), 128))
    ]));
  }
}), Fj = /* @__PURE__ */ V({
  __name: "ComboboxControl",
  props: {
    query: {},
    value: {}
  },
  emits: ["change"],
  setup(t, { emit: e }) {
    const r = e, n = me("disabled");
    return (i, a) => (x(), N("div", {
      class: X([
        "relative",
        S(n) && "opacity-50 pointer-events-none"
      ])
    }, [
      U(S(Vm), {
        class: X([
          "border-none block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "placeholder:text-default-400",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6"
        ]),
        "display-value": (s) => {
          if (i.value)
            return i.value;
          const o = s;
          return Array.isArray(o) ? o.map((l) => l.label).join(", ") : o == null ? void 0 : o.label;
        },
        onChange: a[0] || (a[0] = (s) => r("change", s.target.value))
      }, null, 8, ["display-value"]),
      U(S(Gm), {
        class: X([
          "absolute inset-y-0 right-0 flex items-center rounded-r-md px-3",
          "focus:outline-none"
        ])
      }, {
        default: D(() => [
          U(S(ae), {
            icon: S(_o),
            class: X([
              "text-default-500 size-4",
              "sm:size-3"
            ]),
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      H(i.$slots, "default")
    ], 2));
  }
}), Vj = /* @__PURE__ */ V({
  __name: "ComboboxLabel",
  setup(t) {
    return (e, r) => (x(), F(Ra, { as: S(Zm) }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Gj = /* @__PURE__ */ V({
  __name: "ComboboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(t) {
    return (e, r) => (x(), F(S(Xm), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: D(({ active: n, selected: i }) => [
        k("li", {
          class: X([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            n ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          k("span", {
            class: X([
              i ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            H(e.$slots, "default")
          ], 2),
          i ? (x(), N("span", {
            key: 0,
            class: X([
              n ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            U(S(ae), {
              icon: S(La),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : J("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), Zj = /* @__PURE__ */ V({
  __name: "ComboboxOptions",
  setup(t) {
    return (e, r) => (x(), F(At, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: D(() => [
        U(S(Bm), {
          class: X([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: D(() => [
            H(e.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), O0 = /* @__PURE__ */ V({
  __name: "Container",
  props: {
    as: { default: "main" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "w-full max-w-[1920px] mx-auto" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), If = {
  mounted(t, e) {
    const { tippy: r } = uh(t, {
      content: e.value,
      theme: "spectre",
      maxWidth: 160
    });
    t._tippy = r.value;
  },
  updated(t, e) {
    var r;
    (r = t._tippy) == null || r.setContent(e.value);
  },
  unmounted(t) {
    var e;
    (e = t._tippy) == null || e.destroy();
  }
}, Xj = /* @__PURE__ */ V({
  __name: "CopyToClipboard",
  props: {
    tooltip: {},
    value: {}
  },
  setup(t) {
    const e = t, { copy: r, copied: n } = Vd({
      legacy: !0,
      source: e.value.toString()
    });
    return (i, a) => dt((x(), N("button", {
      class: "relative",
      type: "button",
      onClick: a[0] || (a[0] = (s) => S(r)(i.value.toString()))
    }, [
      a[2] || (a[2] = k("span", { class: "absolute -inset-1" }, null, -1)),
      S(n) ? (x(), F(S(ae), {
        key: 1,
        icon: S(kf),
        class: "size-4 text-emerald-800",
        "aria-hidden": "true"
      }, null, 8, ["icon"])) : (x(), N(xe, { key: 0 }, [
        U(S(ae), {
          icon: S(Mf),
          class: "size-4",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        a[1] || (a[1] = k("span", { class: "sr-only" }, " Copy to clipboard ", -1))
      ], 64))
    ])), [
      [S(If), i.tooltip]
    ]);
  }
}), Bj = /* @__PURE__ */ V({
  __name: "Description",
  props: {
    as: { default: "p" }
  },
  setup(t) {
    const e = me("field-id", "");
    return (r, n) => (x(), F(be(r.as), {
      id: S(e) ? `${S(e)}-description` : void 0,
      class: "text-sm text-default-600"
    }, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), T0 = {}, j0 = { class: "flex items-center justify-center" }, k0 = {
  key: 0,
  class: "px-4 text-sm text-default-500"
};
function M0(t, e) {
  return x(), N("div", j0, [
    e[0] || (e[0] = k("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1)),
    t.$slots.default ? (x(), N("span", k0, [
      H(t.$slots, "default")
    ])) : J("", !0),
    e[1] || (e[1] = k("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1))
  ]);
}
const Uj = /* @__PURE__ */ se(T0, [["render", M0]]), z0 = { class: "fixed inset-0 overflow-hidden" }, E0 = { class: "absolute inset-0 overflow-hidden" }, C0 = { class: "relative h-full overflow-y-scroll bg-default-50 py-6 shadow-xl" }, Yj = /* @__PURE__ */ V({
  __name: "Drawer",
  props: {
    direction: { default: "right" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => (x(), F(S(zo), {
      as: "template",
      show: n.open
    }, {
      default: D(() => [
        U(S(Eo), {
          class: "relative z-[60]",
          onClose: i[1] || (i[1] = (a) => r("close"))
        }, {
          default: D(() => [
            U(S(Vr), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: D(() => i[2] || (i[2] = [
                k("div", { class: "fixed inset-0 bg-black/25 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            k("div", z0, [
              k("div", E0, [
                k("div", {
                  class: X(["pointer-events-none fixed inset-y-0 flex max-w-full", n.direction === "right" ? "pl-10 right-0" : "pr-10 left-0"])
                }, [
                  U(S(Vr), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": n.direction === "right" ? "translate-x-full" : "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": n.direction === "right" ? "translate-x-full" : "-translate-x-full"
                  }, {
                    default: D(() => [
                      U(S(Co), { class: "pointer-events-auto w-screen max-w-lg" }, {
                        default: D(() => [
                          k("div", C0, [
                            k("div", _e({ class: ["px-4", "sm:px-6"] }, n.$attrs), [
                              H(n.$slots, "default"),
                              k("button", {
                                class: X(["absolute right-4 top-4 inline-flex rounded-md", "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"]),
                                onClick: i[0] || (i[0] = (a) => r("close"))
                              }, [
                                U(S(ae), {
                                  icon: S(Ko),
                                  class: "size-5 text-default-400",
                                  "aria-hidden": "true"
                                }, null, 8, ["icon"]),
                                i[3] || (i[3] = k("span", { class: "sr-only" }, " Close ", -1))
                              ])
                            ], 16)
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }, 8, ["enter-from", "leave-to"])
                ], 2)
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), qj = /* @__PURE__ */ V({
  __name: "DrawerDescription",
  setup(t) {
    return (e, r) => (x(), F(S(Rd), { class: "pt-2 text-sm text-default-500" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Qj = /* @__PURE__ */ V({
  __name: "DrawerTitle",
  setup(t) {
    return (e, r) => (x(), F(S(Nd), { class: "text-base font-semibold text-default-900" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Lf = /* @__PURE__ */ V({
  __name: "IconButton",
  props: {
    as: { default: void 0 },
    ariaLabel: {},
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    icon: {},
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    type: { default: void 0 }
  },
  setup(t) {
    const e = t, r = {
      sm: "px-2.5 py-2 text-sm rounded gap-x-1.5",
      base: "px-3.5 py-2.5 text-sm rounded-md gap-x-2",
      lg: "px-4 py-3 text-base rounded-md gap-x-2",
      xl: "px-7 py-4 text-lg rounded-md gap-x-4"
    }, n = {
      primary: "shadow-sm border-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm border-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900 disabled:border-transparent",
      tertiary: "border-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm border-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm border-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm border-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, i = oe(() => r[e.size]), a = oe(() => n[e.color]), s = oe(() => e.disabled || e.loading);
    return (o, l) => (x(), F(be(o.as ?? (o.href ? S(Lt) : "button")), {
      class: X([
        "inline-flex justify-center items-center font-medium border border-px",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        i.value,
        a.value,
        s.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400"
      ]),
      href: o.href,
      type: o.type,
      method: o.method,
      disabled: s.value,
      "aria-disabled": s.value,
      "aria-busy": o.loading,
      tabindex: s.value ? "-1" : 0,
      "aria-label": o.ariaLabel
    }, {
      default: D(() => [
        o.loading ? (x(), F($o, {
          key: 0,
          class: "size-4"
        })) : (x(), F(S(ae), {
          key: 1,
          icon: o.icon,
          "aria-hidden": "true",
          class: "size-4"
        }, null, 8, ["icon"]))
      ]),
      _: 1
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex", "aria-label"]));
  }
}), Jj = /* @__PURE__ */ V({
  __name: "Dropdown",
  props: {
    disabled: { type: Boolean },
    trigger: { default: void 0 },
    placement: { default: void 0 },
    variant: { default: "default" }
  },
  setup(t) {
    return (e, r) => (x(), F(S(Dd), {
      as: "div",
      class: "inline-block text-left"
    }, {
      default: D(({ open: n }) => [
        U(S(Zd), {
          placement: e.placement,
          offset: 4
        }, {
          default: D(() => [
            e.variant === "default" ? (x(), N(xe, { key: 0 }, [
              e.$slots.trigger ? H(e.$slots, "trigger", {
                key: 0,
                open: n,
                disabled: e.disabled
              }) : (x(), F(S(Hs), {
                key: 1,
                as: xt,
                "trailing-icon": n ? S(bv) : S(_o),
                disabled: e.disabled,
                color: "secondary"
              }, {
                default: D(() => [
                  le(_(e.trigger), 1)
                ]),
                _: 2
              }, 1032, ["trailing-icon", "disabled"]))
            ], 64)) : (x(), F(S(Hs), {
              key: 1,
              as: Lf,
              icon: S(hv),
              disabled: e.disabled,
              color: "tertiary",
              "aria-label": e.trigger
            }, null, 8, ["icon", "disabled", "aria-label"])),
            U(At, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: D(() => [
                U(S(Hd), {
                  class: X(["z-10 p-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black/5", "focus:outline-none"])
                }, {
                  default: D(() => [
                    H(e.$slots, "default")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 2
        }, 1032, ["placement"])
      ]),
      _: 3
    }));
  }
}), Kj = /* @__PURE__ */ V({
  __name: "DropdownItem",
  props: {
    as: { default: Lt },
    disabled: { type: Boolean },
    href: { default: void 0 },
    leadingIcon: { default: void 0 }
  },
  setup(t) {
    return (e, r) => (x(), F(S(Wd), { disabled: e.disabled }, {
      default: D(({ active: n, close: i }) => [
        (x(), F(be(e.as), _e({
          href: e.href,
          class: [
            e.disabled && "opacity-50 pointer-events-none",
            n && "bg-primary-50",
            "block w-full text-left rounded-lg font-medium text-default-500 px-3 py-2 leading-6 text-sm"
          ]
        }, e.$attrs, { onClick: i }), {
          default: D(() => [
            e.leadingIcon ? (x(), F(S(ae), {
              key: 0,
              icon: e.leadingIcon,
              class: X([
                n ? "text-default-500" : "text-default-400",
                "mr-3 size-4"
              ]),
              "aria-hidden": "true"
            }, null, 8, ["icon", "class"])) : J("", !0),
            H(e.$slots, "default")
          ]),
          _: 2
        }, 1040, ["href", "class", "onClick"]))
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
}), _j = /* @__PURE__ */ V({
  __name: "EmojiPicker",
  props: {
    disabled: { type: Boolean },
    placement: { default: void 0 }
  },
  emits: ["change"],
  setup(t, { emit: e }) {
    const r = Im(async () => await import("vue3-emoji-picker").then((i) => i)), n = e;
    return (i, a) => (x(), F(S(ka), { class: "relative" }, {
      default: D(() => [
        U(S(Zd), {
          placement: i.placement,
          offset: 8
        }, {
          default: D(() => [
            U(S(Ti), {
              as: Lf,
              icon: S(dv),
              color: "tertiary",
              size: "sm",
              "aria-label": "Open emoji picker",
              disabled: i.disabled
            }, null, 8, ["icon", "disabled"]),
            U(At, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: D(() => [
                U(S(Ma), { class: "z-10" }, {
                  default: D(({ close: s }) => [
                    U(S(r), {
                      native: "",
                      "hide-group-icons": "",
                      "disable-skin-tones": "",
                      onSelect: (o) => {
                        s(), n("change", o);
                      }
                    }, null, 8, ["onSelect"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["placement"])
      ]),
      _: 1
    }));
  }
}), $j = /* @__PURE__ */ V({
  __name: "ErrorMessage",
  props: {
    as: { default: "p" }
  },
  setup(t) {
    const e = me("field-id", "");
    return (r, n) => (x(), F(be(r.as), {
      id: S(e) ? `${S(e)}-error` : void 0,
      class: "text-sm text-red-600"
    }, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), I0 = /* @__PURE__ */ V({
  __name: "Field",
  props: {
    as: { default: "div" }
  },
  setup(t) {
    const e = Oi();
    return Le("field-id", e), (r, n) => (x(), F(be(r.as), null, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }));
  }
}), L0 = ["aria-labelledby"], R0 = /* @__PURE__ */ V({
  __name: "Fieldset",
  setup(t) {
    const e = Oi();
    return Le("fieldset-id", e), (r, n) => (x(), N("fieldset", { "aria-labelledby": S(e) }, [
      H(r.$slots, "default")
    ], 8, L0));
  }
}), ek = /* @__PURE__ */ V({
  __name: "GridCheckboxGroup",
  setup(t) {
    const e = Oi();
    return Le("grid-checkbox-group-id", e), (r, n) => (x(), F(R0, {
      class: "[&:has([data-slot='legend'])_[data-slot='options']]:mt-8 [&:has([data-slot='description'])_[data-slot='options']]:mt-8",
      "aria-describedby": S(e)
    }, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-describedby"]));
  }
}), tk = /* @__PURE__ */ V({
  __name: "GridCheckboxGroupDescription",
  props: {
    as: { default: "p" }
  },
  setup(t) {
    const e = me("grid-checkbox-group-id");
    return (r, n) => (x(), F(be(r.as), {
      id: S(e),
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), N0 = ["id"], D0 = /* @__PURE__ */ V({
  __name: "Legend",
  setup(t) {
    const e = me("fieldset-id");
    return (r, n) => (x(), N("div", {
      id: S(e),
      class: "text-sm font-medium text-default-900"
    }, [
      H(r.$slots, "default")
    ], 8, N0));
  }
}), rk = /* @__PURE__ */ V({
  __name: "GridCheckboxGroupLegend",
  setup(t) {
    return (e, r) => (x(), F(D0, {
      class: "block text-sm font-medium text-default-900",
      "data-slot": "legend"
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), H0 = ["id", "disabled", "tabindex", "aria-disabled", "checked", "value"], W0 = ["for"], F0 = { class: "sr-only" }, V0 = {
  key: 0,
  class: "absolute top-2 right-2 inline-flex items-center justify-center p-2 rounded-full bg-primary-500"
}, nk = /* @__PURE__ */ V({
  __name: "GridCheckboxGroupOption",
  props: {
    label: {},
    disabled: { type: Boolean },
    modelValue: {},
    value: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, n = e, i = oe(() => r.modelValue.includes(r.value)), a = () => {
      const o = r.modelValue.indexOf(r.value), { modelValue: l } = r;
      o === -1 ? l.push(r.value) : l.splice(o, 1), n("update:modelValue", l);
    }, s = Oi();
    return (o, l) => (x(), N("div", null, [
      k("input", {
        id: S(s),
        type: "checkbox",
        disabled: o.disabled,
        tabindex: o.disabled ? "-1" : 0,
        "aria-disabled": o.disabled,
        checked: i.value,
        class: X([
          "sr-only",
          "[&:focus-visible+label]:ring-2 [&:focus-visible+label]:ring-primary-500"
        ]),
        value: o.value,
        onChange: a
      }, null, 40, H0),
      k("label", _e({
        for: S(s),
        class: [
          "flex bg-white min-h-12 relative ring-2 ring-default-300 w-full shadow-md cursor-pointer outline-none rounded-md overflow-hidden",
          "hover:ring-primary-500",
          i.value && "ring-primary-500",
          o.disabled && "opacity-50 pointer-events-none"
        ]
      }, o.$attrs), [
        k("span", F0, _(o.label), 1),
        i.value ? (x(), N("span", V0, [
          U(S(ae), {
            icon: S(La),
            class: "size-4 text-white",
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ])) : J("", !0),
        H(o.$slots, "default", { checked: i.value })
      ], 16, W0)
    ]));
  }
}), G0 = {}, Z0 = {
  class: "grid gap-base",
  "data-slot": "options"
};
function X0(t, e) {
  return x(), N("div", Z0, [
    H(t.$slots, "default")
  ]);
}
const ik = /* @__PURE__ */ se(G0, [["render", X0]]), ak = /* @__PURE__ */ V({
  __name: "GridRadioGroup",
  setup(t) {
    return (e, r) => (x(), F(S(Io), { class: "[&:has([data-slot='label'])_[data-slot='options']]:mt-8 [&:has([data-slot='description'])_[data-slot='options']]:mt-8" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), sk = /* @__PURE__ */ V({
  __name: "GridRadioGroupDescription",
  setup(t) {
    return (e, r) => (x(), F(S(Lo), {
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ok = /* @__PURE__ */ V({
  __name: "GridRadioGroupLabel",
  setup(t) {
    return (e, r) => (x(), F(S(Ro), {
      class: "block text-sm font-medium text-default-900",
      "data-slot": "label"
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), B0 = {
  key: 0,
  class: "absolute top-2 right-2 inline-flex items-center justify-center p-2 rounded-full bg-primary-500"
}, lk = /* @__PURE__ */ V({
  __name: "GridRadioGroupOption",
  setup(t) {
    return (e, r) => (x(), F(S(No), { as: "template" }, {
      default: D(({ checked: n, disabled: i }) => [
        k("button", {
          class: X([
            "bg-white min-h-12 relative ring-2 ring-default-300 w-full shadow-md cursor-pointer outline-none rounded-md overflow-hidden",
            "hover:ring-primary-500",
            "focus-visible:ring-2 focus-visible:ring-primary-500",
            n && "ring-primary-500",
            i && "opacity-50 pointer-events-none"
          ]),
          type: "button"
        }, [
          n ? (x(), N("span", B0, [
            U(S(ae), {
              icon: S(La),
              class: "size-4 text-white",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ])) : J("", !0),
          H(e.$slots, "default", { checked: n })
        ], 2)
      ]),
      _: 3
    }));
  }
}), U0 = {}, Y0 = {
  class: "grid gap-base",
  "data-slot": "options"
};
function q0(t, e) {
  return x(), N("div", Y0, [
    H(t.$slots, "default")
  ]);
}
const ck = /* @__PURE__ */ se(U0, [["render", q0]]);
function cc(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function el(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : cc(e[n]) && cc(t[n]) && Object.keys(e[n]).length > 0 && el(t[n], e[n]);
  });
}
const Rf = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Fe() {
  const t = typeof document < "u" ? document : {};
  return el(t, Rf), t;
}
const Q0 = {
  document: Rf,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function Me() {
  const t = typeof window < "u" ? window : {};
  return el(t, Q0), t;
}
function Jt(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function J0(t) {
  const e = t;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function Sr(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function vt() {
  return Date.now();
}
function K0(t) {
  const e = Me();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r || (r = t.style), r;
}
function _s(t, e) {
  e === void 0 && (e = "x");
  const r = Me();
  let n, i, a;
  const s = K0(t);
  return r.WebKitCSSMatrix ? (i = s.transform || s.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((o) => o.replace(",", ".")).join(", ")), a = new r.WebKitCSSMatrix(i === "none" ? "" : i)) : (a = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = a.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? i = a.m41 : n.length === 16 ? i = parseFloat(n[12]) : i = parseFloat(n[4])), e === "y" && (r.WebKitCSSMatrix ? i = a.m42 : n.length === 16 ? i = parseFloat(n[13]) : i = parseFloat(n[5])), i || 0;
}
function fn(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function _0(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function ct() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < arguments.length; r += 1) {
    const n = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (n != null && !_0(n)) {
      const i = Object.keys(Object(n)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, s = i.length; a < s; a += 1) {
        const o = i[a], l = Object.getOwnPropertyDescriptor(n, o);
        l !== void 0 && l.enumerable && (fn(t[o]) && fn(n[o]) ? n[o].__swiper__ ? t[o] = n[o] : ct(t[o], n[o]) : !fn(t[o]) && fn(n[o]) ? (t[o] = {}, n[o].__swiper__ ? t[o] = n[o] : ct(t[o], n[o])) : t[o] = n[o]);
      }
    }
  }
  return t;
}
function pn(t, e, r) {
  t.style.setProperty(e, r);
}
function Nf(t) {
  let {
    swiper: e,
    targetPosition: r,
    side: n
  } = t;
  const i = Me(), a = -e.translate;
  let s = null, o;
  const l = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(e.cssModeFrameID);
  const c = r > a ? "next" : "prev", u = (m, h) => c === "next" && m >= h || c === "prev" && m <= h, f = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = o);
    const m = Math.max(Math.min((o - s) / l, 1), 0), h = 0.5 - Math.cos(m * Math.PI) / 2;
    let p = a + h * (r - a);
    if (u(p, r) && (p = r), e.wrapperEl.scrollTo({
      [n]: p
    }), u(p, r)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [n]: p
        });
      }), i.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = i.requestAnimationFrame(f);
  };
  f();
}
function xr(t) {
  return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
}
function Ze(t, e) {
  e === void 0 && (e = "");
  const r = Me(), n = [...t.children];
  return r.HTMLSlotElement && t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter((i) => i.matches(e)) : n;
}
function $0(t, e) {
  const r = [e];
  for (; r.length > 0; ) {
    const n = r.shift();
    if (t === n)
      return !0;
    r.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
  }
}
function eb(t, e) {
  const r = Me();
  let n = e.contains(t);
  return !n && r.HTMLSlotElement && e instanceof HTMLSlotElement && (n = [...e.assignedElements()].includes(t), n || (n = $0(t, e))), n;
}
function wa(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function ut(t, e) {
  e === void 0 && (e = []);
  const r = document.createElement(t);
  return r.classList.add(...Array.isArray(e) ? e : Jt(e)), r;
}
function Sa(t) {
  const e = Me(), r = Fe(), n = t.getBoundingClientRect(), i = r.body, a = t.clientTop || i.clientTop || 0, s = t.clientLeft || i.clientLeft || 0, o = t === e ? e.scrollY : t.scrollTop, l = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: n.top + o - a,
    left: n.left + l - s
  };
}
function tb(t, e) {
  const r = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function rb(t, e) {
  const r = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function er(t, e) {
  return Me().getComputedStyle(t, null).getPropertyValue(e);
}
function In(t) {
  let e = t, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function br(t, e) {
  const r = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && r.push(n) : r.push(n), n = n.parentElement;
  return r;
}
function xn(t, e) {
  function r(n) {
    n.target === t && (e.call(t, n), t.removeEventListener("transitionend", r));
  }
  e && t.addEventListener("transitionend", r);
}
function $s(t, e, r) {
  const n = Me();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function pe(t) {
  return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
}
function Na(t) {
  return (e) => Math.abs(e) > 0 && t.browser && t.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
let ns;
function nb() {
  const t = Me(), e = Fe();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Df() {
  return ns || (ns = nb()), ns;
}
let is;
function ib(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const r = Df(), n = Me(), i = n.navigator.platform, a = e || n.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, o = n.screen.width, l = n.screen.height, c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = a.match(/(iPad).*OS\s([\d_]+)/);
  const f = a.match(/(iPod)(.*OS\s([\d_]+))?/), m = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = i === "Win32";
  let p = i === "MacIntel";
  const d = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && r.touch && d.indexOf(`${o}x${l}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), c && !h && (s.os = "android", s.android = !0), (u || m || f) && (s.os = "ios", s.ios = !0), s;
}
function Hf(t) {
  return t === void 0 && (t = {}), is || (is = ib(t)), is;
}
let as;
function ab() {
  const t = Me(), e = Hf();
  let r = !1;
  function n() {
    const o = t.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (n()) {
    const o = String(t.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, c] = o.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      r = l < 16 || l === 16 && c < 2;
    }
  }
  const i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), a = n(), s = a || i && e.ios;
  return {
    isSafari: r || a,
    needPerspectiveFix: r,
    need3dFix: s,
    isWebView: i
  };
}
function Wf() {
  return as || (as = ab()), as;
}
function sb(t) {
  let {
    swiper: e,
    on: r,
    emit: n
  } = t;
  const i = Me();
  let a = null, s = null;
  const o = () => {
    !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
  }, l = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((f) => {
      s = i.requestAnimationFrame(() => {
        const {
          width: m,
          height: h
        } = e;
        let p = m, d = h;
        f.forEach((v) => {
          let {
            contentBoxSize: b,
            contentRect: g,
            target: y
          } = v;
          y && y !== e.el || (p = g ? g.width : (b[0] || b).inlineSize, d = g ? g.height : (b[0] || b).blockSize);
        }), (p !== m || d !== h) && o();
      });
    }), a.observe(e.el));
  }, c = () => {
    s && i.cancelAnimationFrame(s), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || n("orientationchange");
  };
  r("init", () => {
    if (e.params.resizeObserver && typeof i.ResizeObserver < "u") {
      l();
      return;
    }
    i.addEventListener("resize", o), i.addEventListener("orientationchange", u);
  }), r("destroy", () => {
    c(), i.removeEventListener("resize", o), i.removeEventListener("orientationchange", u);
  });
}
function ob(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = [], s = Me(), o = function(u, f) {
    f === void 0 && (f = {});
    const m = s.MutationObserver || s.WebkitMutationObserver, h = new m((p) => {
      if (e.__preventObserver__) return;
      if (p.length === 1) {
        i("observerUpdate", p[0]);
        return;
      }
      const d = function() {
        i("observerUpdate", p[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(d) : s.setTimeout(d, 0);
    });
    h.observe(u, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: e.isElement || (typeof f.childList > "u" ? !0 : f).childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), a.push(h);
  }, l = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = br(e.hostEl);
        for (let f = 0; f < u.length; f += 1)
          o(u[f]);
      }
      o(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), o(e.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    a.forEach((u) => {
      u.disconnect();
    }), a.splice(0, a.length);
  };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", l), n("destroy", c);
}
var lb = {
  on(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const i = r ? "unshift" : "push";
    return t.split(" ").forEach((a) => {
      n.eventsListeners[a] || (n.eventsListeners[a] = []), n.eventsListeners[a][i](e);
    }), n;
  },
  once(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    function i() {
      n.off(t, i), i.__emitterProxy && delete i.__emitterProxy;
      for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
        s[o] = arguments[o];
      e.apply(n, s);
    }
    return i.__emitterProxy = e, n.on(t, i, r);
  },
  onAny(t, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
    const n = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[n](t), r;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const r = e.eventsAnyListeners.indexOf(t);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(t, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((i, a) => {
        (i === e || i.__emitterProxy && i.__emitterProxy === e) && r.eventsListeners[n].splice(a, 1);
      });
    }), r;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, r, n;
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], r = a.slice(1, a.length), n = t) : (e = a[0].events, r = a[0].data, n = a[0].context || t), r.unshift(n), (Array.isArray(e) ? e : e.split(" ")).forEach((l) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((c) => {
        c.apply(n, [l, ...r]);
      }), t.eventsListeners && t.eventsListeners[l] && t.eventsListeners[l].forEach((c) => {
        c.apply(n, r);
      });
    }), t;
  }
};
function cb() {
  const t = this;
  let e, r;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? r = t.params.height : r = n.clientHeight, !(e === 0 && t.isHorizontal() || r === 0 && t.isVertical()) && (e = e - parseInt(er(n, "padding-left") || 0, 10) - parseInt(er(n, "padding-right") || 0, 10), r = r - parseInt(er(n, "padding-top") || 0, 10) - parseInt(er(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(t, {
    width: e,
    height: r,
    size: t.isHorizontal() ? e : r
  }));
}
function ub() {
  const t = this;
  function e(M, z) {
    return parseFloat(M.getPropertyValue(t.getDirectionLabel(z)) || 0);
  }
  const r = t.params, {
    wrapperEl: n,
    slidesEl: i,
    size: a,
    rtlTranslate: s,
    wrongRTL: o
  } = t, l = t.virtual && r.virtual.enabled, c = l ? t.virtual.slides.length : t.slides.length, u = Ze(i, `.${t.params.slideClass}, swiper-slide`), f = l ? t.virtual.slides.length : u.length;
  let m = [];
  const h = [], p = [];
  let d = r.slidesOffsetBefore;
  typeof d == "function" && (d = r.slidesOffsetBefore.call(t));
  let v = r.slidesOffsetAfter;
  typeof v == "function" && (v = r.slidesOffsetAfter.call(t));
  const b = t.snapGrid.length, g = t.slidesGrid.length;
  let y = r.spaceBetween, w = -d, P = 0, T = 0;
  if (typeof a > "u")
    return;
  typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * a : typeof y == "string" && (y = parseFloat(y)), t.virtualSize = -y, u.forEach((M) => {
    s ? M.style.marginLeft = "" : M.style.marginRight = "", M.style.marginBottom = "", M.style.marginTop = "";
  }), r.centeredSlides && r.cssMode && (pn(n, "--swiper-centered-offset-before", ""), pn(n, "--swiper-centered-offset-after", ""));
  const A = r.grid && r.grid.rows > 1 && t.grid;
  A ? t.grid.initSlides(u) : t.grid && t.grid.unsetSlides();
  let j;
  const O = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((M) => typeof r.breakpoints[M].slidesPerView < "u").length > 0;
  for (let M = 0; M < f; M += 1) {
    j = 0;
    let z;
    if (u[M] && (z = u[M]), A && t.grid.updateSlide(M, z, u), !(u[M] && er(z, "display") === "none")) {
      if (r.slidesPerView === "auto") {
        O && (u[M].style[t.getDirectionLabel("width")] = "");
        const R = getComputedStyle(z), I = z.style.transform, L = z.style.webkitTransform;
        if (I && (z.style.transform = "none"), L && (z.style.webkitTransform = "none"), r.roundLengths)
          j = t.isHorizontal() ? $s(z, "width") : $s(z, "height");
        else {
          const W = e(R, "width"), q = e(R, "padding-left"), C = e(R, "padding-right"), E = e(R, "margin-left"), B = e(R, "margin-right"), Q = R.getPropertyValue("box-sizing");
          if (Q && Q === "border-box")
            j = W + E + B;
          else {
            const {
              clientWidth: $,
              offsetWidth: ne
            } = z;
            j = W + q + C + E + B + (ne - $);
          }
        }
        I && (z.style.transform = I), L && (z.style.webkitTransform = L), r.roundLengths && (j = Math.floor(j));
      } else
        j = (a - (r.slidesPerView - 1) * y) / r.slidesPerView, r.roundLengths && (j = Math.floor(j)), u[M] && (u[M].style[t.getDirectionLabel("width")] = `${j}px`);
      u[M] && (u[M].swiperSlideSize = j), p.push(j), r.centeredSlides ? (w = w + j / 2 + P / 2 + y, P === 0 && M !== 0 && (w = w - a / 2 - y), M === 0 && (w = w - a / 2 - y), Math.abs(w) < 1 / 1e3 && (w = 0), r.roundLengths && (w = Math.floor(w)), T % r.slidesPerGroup === 0 && m.push(w), h.push(w)) : (r.roundLengths && (w = Math.floor(w)), (T - Math.min(t.params.slidesPerGroupSkip, T)) % t.params.slidesPerGroup === 0 && m.push(w), h.push(w), w = w + j + y), t.virtualSize += j + y, P = j, T += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, a) + v, s && o && (r.effect === "slide" || r.effect === "coverflow") && (n.style.width = `${t.virtualSize + y}px`), r.setWrapperSize && (n.style[t.getDirectionLabel("width")] = `${t.virtualSize + y}px`), A && t.grid.updateWrapperSize(j, m), !r.centeredSlides) {
    const M = [];
    for (let z = 0; z < m.length; z += 1) {
      let R = m[z];
      r.roundLengths && (R = Math.floor(R)), m[z] <= t.virtualSize - a && M.push(R);
    }
    m = M, Math.floor(t.virtualSize - a) - Math.floor(m[m.length - 1]) > 1 && m.push(t.virtualSize - a);
  }
  if (l && r.loop) {
    const M = p[0] + y;
    if (r.slidesPerGroup > 1) {
      const z = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / r.slidesPerGroup), R = M * r.slidesPerGroup;
      for (let I = 0; I < z; I += 1)
        m.push(m[m.length - 1] + R);
    }
    for (let z = 0; z < t.virtual.slidesBefore + t.virtual.slidesAfter; z += 1)
      r.slidesPerGroup === 1 && m.push(m[m.length - 1] + M), h.push(h[h.length - 1] + M), t.virtualSize += M;
  }
  if (m.length === 0 && (m = [0]), y !== 0) {
    const M = t.isHorizontal() && s ? "marginLeft" : t.getDirectionLabel("marginRight");
    u.filter((z, R) => !r.cssMode || r.loop ? !0 : R !== u.length - 1).forEach((z) => {
      z.style[M] = `${y}px`;
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let M = 0;
    p.forEach((R) => {
      M += R + (y || 0);
    }), M -= y;
    const z = M > a ? M - a : 0;
    m = m.map((R) => R <= 0 ? -d : R > z ? z + v : R);
  }
  if (r.centerInsufficientSlides) {
    let M = 0;
    p.forEach((R) => {
      M += R + (y || 0);
    }), M -= y;
    const z = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
    if (M + z < a) {
      const R = (a - M - z) / 2;
      m.forEach((I, L) => {
        m[L] = I - R;
      }), h.forEach((I, L) => {
        h[L] = I + R;
      });
    }
  }
  if (Object.assign(t, {
    slides: u,
    snapGrid: m,
    slidesGrid: h,
    slidesSizesGrid: p
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    pn(n, "--swiper-centered-offset-before", `${-m[0]}px`), pn(n, "--swiper-centered-offset-after", `${t.size / 2 - p[p.length - 1] / 2}px`);
    const M = -t.snapGrid[0], z = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((R) => R + M), t.slidesGrid = t.slidesGrid.map((R) => R + z);
  }
  if (f !== c && t.emit("slidesLengthChange"), m.length !== b && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), h.length !== g && t.emit("slidesGridLengthChange"), r.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const M = `${r.containerModifierClass}backface-hidden`, z = t.el.classList.contains(M);
    f <= r.maxBackfaceHiddenSlides ? z || t.el.classList.add(M) : z && t.el.classList.remove(M);
  }
}
function db(t) {
  const e = this, r = [], n = e.virtual && e.params.virtual.enabled;
  let i = 0, a;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const s = (o) => n ? e.slides[e.getSlideIndexByData(o)] : e.slides[o];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((o) => {
        r.push(o);
      });
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const o = e.activeIndex + a;
        if (o > e.slides.length && !n) break;
        r.push(s(o));
      }
  else
    r.push(s(e.activeIndex));
  for (a = 0; a < r.length; a += 1)
    if (typeof r[a] < "u") {
      const o = r[a].offsetHeight;
      i = o > i ? o : i;
    }
  (i || i === 0) && (e.wrapperEl.style.height = `${i}px`);
}
function fb() {
  const t = this, e = t.slides, r = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - r - t.cssOverflowAdjustment();
}
const uc = (t, e, r) => {
  e && !t.classList.contains(r) ? t.classList.add(r) : !e && t.classList.contains(r) && t.classList.remove(r);
};
function pb(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, r = e.params, {
    slides: n,
    rtlTranslate: i,
    snapGrid: a
  } = e;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let s = -t;
  i && (s = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let o = r.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * e.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < n.length; l += 1) {
    const c = n[l];
    let u = c.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (u -= n[0].swiperSlideOffset);
    const f = (s + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + o), m = (s - a[0] + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + o), h = -(s - u), p = h + e.slidesSizesGrid[l], d = h >= 0 && h <= e.size - e.slidesSizesGrid[l], v = h >= 0 && h < e.size - 1 || p > 1 && p <= e.size || h <= 0 && p >= e.size;
    v && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(l)), uc(c, v, r.slideVisibleClass), uc(c, d, r.slideFullyVisibleClass), c.progress = i ? -f : f, c.originalProgress = i ? -m : m;
  }
}
function mb(t) {
  const e = this;
  if (typeof t > "u") {
    const u = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * u || 0;
  }
  const r = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: i,
    isBeginning: a,
    isEnd: s,
    progressLoop: o
  } = e;
  const l = a, c = s;
  if (n === 0)
    i = 0, a = !0, s = !0;
  else {
    i = (t - e.minTranslate()) / n;
    const u = Math.abs(t - e.minTranslate()) < 1, f = Math.abs(t - e.maxTranslate()) < 1;
    a = u || i <= 0, s = f || i >= 1, u && (i = 0), f && (i = 1);
  }
  if (r.loop) {
    const u = e.getSlideIndexByData(0), f = e.getSlideIndexByData(e.slides.length - 1), m = e.slidesGrid[u], h = e.slidesGrid[f], p = e.slidesGrid[e.slidesGrid.length - 1], d = Math.abs(t);
    d >= m ? o = (d - m) / p : o = (d + p - h) / p, o > 1 && (o -= 1);
  }
  Object.assign(e, {
    progress: i,
    progressLoop: o,
    isBeginning: a,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(t), a && !l && e.emit("reachBeginning toEdge"), s && !c && e.emit("reachEnd toEdge"), (l && !a || c && !s) && e.emit("fromEdge"), e.emit("progress", i);
}
const ss = (t, e, r) => {
  e && !t.classList.contains(r) ? t.classList.add(r) : !e && t.classList.contains(r) && t.classList.remove(r);
};
function hb() {
  const t = this, {
    slides: e,
    params: r,
    slidesEl: n,
    activeIndex: i
  } = t, a = t.virtual && r.virtual.enabled, s = t.grid && r.grid && r.grid.rows > 1, o = (f) => Ze(n, `.${r.slideClass}${f}, swiper-slide${f}`)[0];
  let l, c, u;
  if (a)
    if (r.loop) {
      let f = i - t.virtual.slidesBefore;
      f < 0 && (f = t.virtual.slides.length + f), f >= t.virtual.slides.length && (f -= t.virtual.slides.length), l = o(`[data-swiper-slide-index="${f}"]`);
    } else
      l = o(`[data-swiper-slide-index="${i}"]`);
  else
    s ? (l = e.find((f) => f.column === i), u = e.find((f) => f.column === i + 1), c = e.find((f) => f.column === i - 1)) : l = e[i];
  l && (s || (u = rb(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !u && (u = e[0]), c = tb(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !c === 0 && (c = e[e.length - 1]))), e.forEach((f) => {
    ss(f, f === l, r.slideActiveClass), ss(f, f === u, r.slideNextClass), ss(f, f === c, r.slidePrevClass);
  }), t.emitSlidesClasses();
}
const oa = (t, e) => {
  if (!t || t.destroyed || !t.params) return;
  const r = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(r());
  if (n) {
    let i = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    !i && t.isElement && (n.shadowRoot ? i = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (i = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), i && i.remove());
    })), i && i.remove();
  }
}, os = (t, e) => {
  if (!t.slides[e]) return;
  const r = t.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, eo = (t) => {
  if (!t || t.destroyed || !t.params) return;
  let e = t.params.lazyPreloadPrevNext;
  const r = t.slides.length;
  if (!r || !e || e < 0) return;
  e = Math.min(e, r);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), i = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const s = i, o = [s - e];
    o.push(...Array.from({
      length: e
    }).map((l, c) => s + n + c)), t.slides.forEach((l, c) => {
      o.includes(l.column) && os(t, c);
    });
    return;
  }
  const a = i + n - 1;
  if (t.params.rewind || t.params.loop)
    for (let s = i - e; s <= a + e; s += 1) {
      const o = (s % r + r) % r;
      (o < i || o > a) && os(t, o);
    }
  else
    for (let s = Math.max(i - e, 0); s <= Math.min(a + e, r - 1); s += 1)
      s !== i && (s > a || s < i) && os(t, s);
};
function gb(t) {
  const {
    slidesGrid: e,
    params: r
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let i;
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < "u" ? n >= e[a] && n < e[a + 1] - (e[a + 1] - e[a]) / 2 ? i = a : n >= e[a] && n < e[a + 1] && (i = a + 1) : n >= e[a] && (i = a);
  return r.normalizeSlideIndex && (i < 0 || typeof i > "u") && (i = 0), i;
}
function vb(t) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: i,
    activeIndex: a,
    realIndex: s,
    snapIndex: o
  } = e;
  let l = t, c;
  const u = (h) => {
    let p = h - e.virtual.slidesBefore;
    return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = gb(e)), n.indexOf(r) >= 0)
    c = n.indexOf(r);
  else {
    const h = Math.min(i.slidesPerGroupSkip, l);
    c = h + Math.floor((l - h) / i.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), l === a && !e.params.loop) {
    c !== o && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  if (l === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = u(l);
    return;
  }
  const f = e.grid && i.grid && i.grid.rows > 1;
  let m;
  if (e.virtual && i.virtual.enabled && i.loop)
    m = u(l);
  else if (f) {
    const h = e.slides.find((d) => d.column === l);
    let p = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(e.slides.indexOf(h), 0)), m = Math.floor(p / i.grid.rows);
  } else if (e.slides[l]) {
    const h = e.slides[l].getAttribute("data-swiper-slide-index");
    h ? m = parseInt(h, 10) : m = l;
  } else
    m = l;
  Object.assign(e, {
    previousSnapIndex: o,
    snapIndex: c,
    previousRealIndex: s,
    realIndex: m,
    previousIndex: a,
    activeIndex: l
  }), e.initialized && eo(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (s !== m && e.emit("realIndexChange"), e.emit("slideChange"));
}
function bb(t, e) {
  const r = this, n = r.params;
  let i = t.closest(`.${n.slideClass}, swiper-slide`);
  !i && r.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((o) => {
    !i && o.matches && o.matches(`.${n.slideClass}, swiper-slide`) && (i = o);
  });
  let a = !1, s;
  if (i) {
    for (let o = 0; o < r.slides.length; o += 1)
      if (r.slides[o] === i) {
        a = !0, s = o;
        break;
      }
  }
  if (i && a)
    r.clickedSlide = i, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = s;
  else {
    r.clickedSlide = void 0, r.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
}
var yb = {
  updateSize: cb,
  updateSlides: ub,
  updateAutoHeight: db,
  updateSlidesOffset: fb,
  updateSlidesProgress: pb,
  updateProgress: mb,
  updateSlidesClasses: hb,
  updateActiveIndex: vb,
  updateClickedSlide: bb
};
function wb(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: r,
    rtlTranslate: n,
    translate: i,
    wrapperEl: a
  } = e;
  if (r.virtualTranslate)
    return n ? -i : i;
  if (r.cssMode)
    return i;
  let s = _s(a, t);
  return s += e.cssOverflowAdjustment(), n && (s = -s), s || 0;
}
function Sb(t, e) {
  const r = this, {
    rtlTranslate: n,
    params: i,
    wrapperEl: a,
    progress: s
  } = r;
  let o = 0, l = 0;
  const c = 0;
  r.isHorizontal() ? o = n ? -t : t : l = t, i.roundLengths && (o = Math.floor(o), l = Math.floor(l)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? o : l, i.cssMode ? a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -o : -l : i.virtualTranslate || (r.isHorizontal() ? o -= r.cssOverflowAdjustment() : l -= r.cssOverflowAdjustment(), a.style.transform = `translate3d(${o}px, ${l}px, ${c}px)`);
  let u;
  const f = r.maxTranslate() - r.minTranslate();
  f === 0 ? u = 0 : u = (t - r.minTranslate()) / f, u !== s && r.updateProgress(t), r.emit("setTranslate", r.translate, e);
}
function xb() {
  return -this.snapGrid[0];
}
function Pb() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Ab(t, e, r, n, i) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), n === void 0 && (n = !0);
  const a = this, {
    params: s,
    wrapperEl: o
  } = a;
  if (a.animating && s.preventInteractionOnTransition)
    return !1;
  const l = a.minTranslate(), c = a.maxTranslate();
  let u;
  if (n && t > l ? u = l : n && t < c ? u = c : u = t, a.updateProgress(u), s.cssMode) {
    const f = a.isHorizontal();
    if (e === 0)
      o[f ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!a.support.smoothScroll)
        return Nf({
          swiper: a,
          targetPosition: -u,
          side: f ? "left" : "top"
        }), !0;
      o.scrollTo({
        [f ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (a.setTransition(0), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, i), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, i), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(m) {
    !a || a.destroyed || m.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, r && a.emit("transitionEnd"));
  }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
var Ob = {
  getTranslate: wb,
  setTranslate: Sb,
  minTranslate: xb,
  maxTranslate: Pb,
  translateTo: Ab
};
function Tb(t, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${t}ms`, r.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), r.emit("setTransition", t, e);
}
function Ff(t) {
  let {
    swiper: e,
    runCallbacks: r,
    direction: n,
    step: i
  } = t;
  const {
    activeIndex: a,
    previousIndex: s
  } = e;
  let o = n;
  if (o || (a > s ? o = "next" : a < s ? o = "prev" : o = "reset"), e.emit(`transition${i}`), r && a !== s) {
    if (o === "reset") {
      e.emit(`slideResetTransition${i}`);
      return;
    }
    e.emit(`slideChangeTransition${i}`), o === "next" ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
  }
}
function jb(t, e) {
  t === void 0 && (t = !0);
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), Ff({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function kb(t, e) {
  t === void 0 && (t = !0);
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), Ff({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var Mb = {
  setTransition: Tb,
  transitionStart: jb,
  transitionEnd: kb
};
function zb(t, e, r, n, i) {
  t === void 0 && (t = 0), r === void 0 && (r = !0), typeof t == "string" && (t = parseInt(t, 10));
  const a = this;
  let s = t;
  s < 0 && (s = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: u,
    activeIndex: f,
    rtlTranslate: m,
    wrapperEl: h,
    enabled: p
  } = a;
  if (!p && !n && !i || a.destroyed || a.animating && o.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = a.params.speed);
  const d = Math.min(a.params.slidesPerGroupSkip, s);
  let v = d + Math.floor((s - d) / a.params.slidesPerGroup);
  v >= l.length && (v = l.length - 1);
  const b = -l[v];
  if (o.normalizeSlideIndex)
    for (let A = 0; A < c.length; A += 1) {
      const j = -Math.floor(b * 100), O = Math.floor(c[A] * 100), M = Math.floor(c[A + 1] * 100);
      typeof c[A + 1] < "u" ? j >= O && j < M - (M - O) / 2 ? s = A : j >= O && j < M && (s = A + 1) : j >= O && (s = A);
    }
  if (a.initialized && s !== f && (!a.allowSlideNext && (m ? b > a.translate && b > a.minTranslate() : b < a.translate && b < a.minTranslate()) || !a.allowSlidePrev && b > a.translate && b > a.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (u || 0) && r && a.emit("beforeSlideChangeStart"), a.updateProgress(b);
  let g;
  s > f ? g = "next" : s < f ? g = "prev" : g = "reset";
  const y = a.virtual && a.params.virtual.enabled;
  if (!(y && i) && (m && -b === a.translate || !m && b === a.translate))
    return a.updateActiveIndex(s), o.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), o.effect !== "slide" && a.setTranslate(b), g !== "reset" && (a.transitionStart(r, g), a.transitionEnd(r, g)), !1;
  if (o.cssMode) {
    const A = a.isHorizontal(), j = m ? b : -b;
    if (e === 0)
      y && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), y && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        h[A ? "scrollLeft" : "scrollTop"] = j;
      })) : h[A ? "scrollLeft" : "scrollTop"] = j, y && requestAnimationFrame(() => {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });
    else {
      if (!a.support.smoothScroll)
        return Nf({
          swiper: a,
          targetPosition: j,
          side: A ? "left" : "top"
        }), !0;
      h.scrollTo({
        [A ? "left" : "top"]: j,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const T = Wf().isSafari;
  return y && !i && T && a.isElement && a.virtual.update(!1, !1, s), a.setTransition(e), a.setTranslate(b), a.updateActiveIndex(s), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, n), a.transitionStart(r, g), e === 0 ? a.transitionEnd(r, g) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(j) {
    !a || a.destroyed || j.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(r, g));
  }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function Eb(t, e, r, n) {
  t === void 0 && (t = 0), r === void 0 && (r = !0), typeof t == "string" && (t = parseInt(t, 10));
  const i = this;
  if (i.destroyed) return;
  typeof e > "u" && (e = i.params.speed);
  const a = i.grid && i.params.grid && i.params.grid.rows > 1;
  let s = t;
  if (i.params.loop)
    if (i.virtual && i.params.virtual.enabled)
      s = s + i.virtual.slidesBefore;
    else {
      let o;
      if (a) {
        const m = s * i.params.grid.rows;
        o = i.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === m).column;
      } else
        o = i.getSlideIndexByData(s);
      const l = a ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length, {
        centeredSlides: c
      } = i.params;
      let u = i.params.slidesPerView;
      u === "auto" ? u = i.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(i.params.slidesPerView, 10)), c && u % 2 === 0 && (u = u + 1));
      let f = l - o < u;
      if (c && (f = f || o < Math.ceil(u / 2)), n && c && i.params.slidesPerView !== "auto" && !a && (f = !1), f) {
        const m = c ? o < i.activeIndex ? "prev" : "next" : o - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
        i.loopFix({
          direction: m,
          slideTo: !0,
          activeSlideIndex: m === "next" ? o + 1 : o - l + 1,
          slideRealIndex: m === "next" ? i.realIndex : void 0
        });
      }
      if (a) {
        const m = s * i.params.grid.rows;
        s = i.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === m).column;
      } else
        s = i.getSlideIndexByData(s);
    }
  return requestAnimationFrame(() => {
    i.slideTo(s, e, r, n);
  }), i;
}
function Cb(t, e, r) {
  e === void 0 && (e = !0);
  const n = this, {
    enabled: i,
    params: a,
    animating: s
  } = n;
  if (!i || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  let o = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const l = n.activeIndex < a.slidesPerGroupSkip ? 1 : o, c = n.virtual && a.virtual.enabled;
  if (a.loop) {
    if (s && !c && a.loopPreventsSliding) return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && a.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + l, t, e, r);
      }), !0;
  }
  return a.rewind && n.isEnd ? n.slideTo(0, t, e, r) : n.slideTo(n.activeIndex + l, t, e, r);
}
function Ib(t, e, r) {
  e === void 0 && (e = !0);
  const n = this, {
    params: i,
    snapGrid: a,
    slidesGrid: s,
    rtlTranslate: o,
    enabled: l,
    animating: c
  } = n;
  if (!l || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  const u = n.virtual && i.virtual.enabled;
  if (i.loop) {
    if (c && !u && i.loopPreventsSliding) return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const f = o ? n.translate : -n.translate;
  function m(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const h = m(f), p = a.map((g) => m(g)), d = i.freeMode && i.freeMode.enabled;
  let v = a[p.indexOf(h) - 1];
  if (typeof v > "u" && (i.cssMode || d)) {
    let g;
    a.forEach((y, w) => {
      h >= y && (g = w);
    }), typeof g < "u" && (v = d ? a[g] : a[g > 0 ? g - 1 : g]);
  }
  let b = 0;
  if (typeof v < "u" && (b = s.indexOf(v), b < 0 && (b = n.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (b = b - n.slidesPerViewDynamic("previous", !0) + 1, b = Math.max(b, 0))), i.rewind && n.isBeginning) {
    const g = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(g, t, e, r);
  } else if (i.loop && n.activeIndex === 0 && i.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(b, t, e, r);
    }), !0;
  return n.slideTo(b, t, e, r);
}
function Lb(t, e, r) {
  e === void 0 && (e = !0);
  const n = this;
  if (!n.destroyed)
    return typeof t > "u" && (t = n.params.speed), n.slideTo(n.activeIndex, t, e, r);
}
function Rb(t, e, r, n) {
  e === void 0 && (e = !0), n === void 0 && (n = 0.5);
  const i = this;
  if (i.destroyed) return;
  typeof t > "u" && (t = i.params.speed);
  let a = i.activeIndex;
  const s = Math.min(i.params.slidesPerGroupSkip, a), o = s + Math.floor((a - s) / i.params.slidesPerGroup), l = i.rtlTranslate ? i.translate : -i.translate;
  if (l >= i.snapGrid[o]) {
    const c = i.snapGrid[o], u = i.snapGrid[o + 1];
    l - c > (u - c) * n && (a += i.params.slidesPerGroup);
  } else {
    const c = i.snapGrid[o - 1], u = i.snapGrid[o];
    l - c <= (u - c) * n && (a -= i.params.slidesPerGroup);
  }
  return a = Math.max(a, 0), a = Math.min(a, i.slidesGrid.length - 1), i.slideTo(a, t, e, r);
}
function Nb() {
  const t = this;
  if (t.destroyed) return;
  const {
    params: e,
    slidesEl: r
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let i = t.clickedIndex, a;
  const s = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating) return;
    a = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? i < t.loopedSlides - n / 2 || i > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), i = t.getSlideIndex(Ze(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), Sr(() => {
      t.slideTo(i);
    })) : t.slideTo(i) : i > t.slides.length - n ? (t.loopFix(), i = t.getSlideIndex(Ze(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), Sr(() => {
      t.slideTo(i);
    })) : t.slideTo(i);
  } else
    t.slideTo(i);
}
var Db = {
  slideTo: zb,
  slideToLoop: Eb,
  slideNext: Cb,
  slidePrev: Ib,
  slideReset: Lb,
  slideToClosest: Rb,
  slideToClickedSlide: Nb
};
function Hb(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled) return;
  const i = () => {
    Ze(n, `.${r.slideClass}, swiper-slide`).forEach((f, m) => {
      f.setAttribute("data-swiper-slide-index", m);
    });
  }, a = e.grid && r.grid && r.grid.rows > 1, s = r.slidesPerGroup * (a ? r.grid.rows : 1), o = e.slides.length % s !== 0, l = a && e.slides.length % r.grid.rows !== 0, c = (u) => {
    for (let f = 0; f < u; f += 1) {
      const m = e.isElement ? ut("swiper-slide", [r.slideBlankClass]) : ut("div", [r.slideClass, r.slideBlankClass]);
      e.slidesEl.append(m);
    }
  };
  if (o) {
    if (r.loopAddBlankSlides) {
      const u = s - e.slides.length % s;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      wa("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    i();
  } else if (l) {
    if (r.loopAddBlankSlides) {
      const u = r.grid.rows - e.slides.length % r.grid.rows;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      wa("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    i();
  } else
    i();
  e.loopFix({
    slideRealIndex: t,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function Wb(t) {
  let {
    slideRealIndex: e,
    slideTo: r = !0,
    direction: n,
    setTranslate: i,
    activeSlideIndex: a,
    byController: s,
    byMousewheel: o
  } = t === void 0 ? {} : t;
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: c,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: m,
    params: h
  } = l, {
    centeredSlides: p
  } = h;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && h.virtual.enabled) {
    r && (!h.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : h.centeredSlides && l.snapIndex < h.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = u, l.allowSlideNext = f, l.emit("loopFix");
    return;
  }
  let d = h.slidesPerView;
  d === "auto" ? d = l.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(h.slidesPerView, 10)), p && d % 2 === 0 && (d = d + 1));
  const v = h.slidesPerGroupAuto ? d : h.slidesPerGroup;
  let b = v;
  b % v !== 0 && (b += v - b % v), b += h.loopAdditionalSlides, l.loopedSlides = b;
  const g = l.grid && h.grid && h.grid.rows > 1;
  c.length < d + b ? wa("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : g && h.grid.fill === "row" && wa("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const y = [], w = [];
  let P = l.activeIndex;
  typeof a > "u" ? a = l.getSlideIndex(c.find((I) => I.classList.contains(h.slideActiveClass))) : P = a;
  const T = n === "next" || !n, A = n === "prev" || !n;
  let j = 0, O = 0;
  const M = g ? Math.ceil(c.length / h.grid.rows) : c.length, R = (g ? c[a].column : a) + (p && typeof i > "u" ? -d / 2 + 0.5 : 0);
  if (R < b) {
    j = Math.max(b - R, v);
    for (let I = 0; I < b - R; I += 1) {
      const L = I - Math.floor(I / M) * M;
      if (g) {
        const W = M - L - 1;
        for (let q = c.length - 1; q >= 0; q -= 1)
          c[q].column === W && y.push(q);
      } else
        y.push(M - L - 1);
    }
  } else if (R + d > M - b) {
    O = Math.max(R - (M - b * 2), v);
    for (let I = 0; I < O; I += 1) {
      const L = I - Math.floor(I / M) * M;
      g ? c.forEach((W, q) => {
        W.column === L && w.push(q);
      }) : w.push(L);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), A && y.forEach((I) => {
    c[I].swiperLoopMoveDOM = !0, m.prepend(c[I]), c[I].swiperLoopMoveDOM = !1;
  }), T && w.forEach((I) => {
    c[I].swiperLoopMoveDOM = !0, m.append(c[I]), c[I].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), h.slidesPerView === "auto" ? l.updateSlides() : g && (y.length > 0 && A || w.length > 0 && T) && l.slides.forEach((I, L) => {
    l.grid.updateSlide(L, I, l.slides);
  }), h.watchSlidesProgress && l.updateSlidesOffset(), r) {
    if (y.length > 0 && A) {
      if (typeof e > "u") {
        const I = l.slidesGrid[P], W = l.slidesGrid[P + j] - I;
        o ? l.setTranslate(l.translate - W) : (l.slideTo(P + Math.ceil(j), 0, !1, !0), i && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - W, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - W));
      } else if (i) {
        const I = g ? y.length / h.grid.rows : y.length;
        l.slideTo(l.activeIndex + I, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (w.length > 0 && T)
      if (typeof e > "u") {
        const I = l.slidesGrid[P], W = l.slidesGrid[P - O] - I;
        o ? l.setTranslate(l.translate - W) : (l.slideTo(P - O, 0, !1, !0), i && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - W, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - W));
      } else {
        const I = g ? w.length / h.grid.rows : w.length;
        l.slideTo(l.activeIndex - I, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = u, l.allowSlideNext = f, l.controller && l.controller.control && !s) {
    const I = {
      slideRealIndex: e,
      direction: n,
      setTranslate: i,
      activeSlideIndex: a,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((L) => {
      !L.destroyed && L.params.loop && L.loopFix({
        ...I,
        slideTo: L.params.slidesPerView === h.slidesPerView ? r : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...I,
      slideTo: l.controller.control.params.slidesPerView === h.slidesPerView ? r : !1
    });
  }
  l.emit("loopFix");
}
function Fb() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t;
  if (!e.loop || !r || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((i) => {
    const a = typeof i.swiperSlideIndex > "u" ? i.getAttribute("data-swiper-slide-index") * 1 : i.swiperSlideIndex;
    n[a] = i;
  }), t.slides.forEach((i) => {
    i.removeAttribute("data-swiper-slide-index");
  }), n.forEach((i) => {
    r.append(i);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var Vb = {
  loopCreate: Hb,
  loopFix: Wb,
  loopDestroy: Fb
};
function Gb(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function Zb() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var Xb = {
  setGrabCursor: Gb,
  unsetGrabCursor: Zb
};
function Bb(t, e) {
  e === void 0 && (e = this);
  function r(n) {
    if (!n || n === Fe() || n === Me()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const i = n.closest(t);
    return !i && !n.getRootNode ? null : i || r(n.getRootNode().host);
  }
  return r(e);
}
function dc(t, e, r) {
  const n = Me(), {
    params: i
  } = t, a = i.edgeSwipeDetection, s = i.edgeSwipeThreshold;
  return a && (r <= s || r >= n.innerWidth - s) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function Ub(t) {
  const e = this, r = Fe();
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  const i = e.touchEventsData;
  if (n.type === "pointerdown") {
    if (i.pointerId !== null && i.pointerId !== n.pointerId)
      return;
    i.pointerId = n.pointerId;
  } else n.type === "touchstart" && n.targetTouches.length === 1 && (i.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    dc(e, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: a,
    touches: s,
    enabled: o
  } = e;
  if (!o || !a.simulateTouch && n.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition)
    return;
  !e.animating && a.cssMode && a.loop && e.loopFix();
  let l = n.target;
  if (a.touchEventsTarget === "wrapper" && !eb(l, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || i.isTouched && i.isMoved) return;
  const c = !!a.noSwipingClass && a.noSwipingClass !== "", u = n.composedPath ? n.composedPath() : n.path;
  c && n.target && n.target.shadowRoot && u && (l = u[0]);
  const f = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, m = !!(n.target && n.target.shadowRoot);
  if (a.noSwiping && (m ? Bb(f, l) : l.closest(f))) {
    e.allowClick = !0;
    return;
  }
  if (a.swipeHandler && !l.closest(a.swipeHandler))
    return;
  s.currentX = n.pageX, s.currentY = n.pageY;
  const h = s.currentX, p = s.currentY;
  if (!dc(e, n, h))
    return;
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = h, s.startY = p, i.touchStartTime = vt(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (i.allowThresholdMove = !1);
  let d = !0;
  l.matches(i.focusableElements) && (d = !1, l.nodeName === "SELECT" && (i.isTouched = !1)), r.activeElement && r.activeElement.matches(i.focusableElements) && r.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(i.focusableElements)) && r.activeElement.blur();
  const v = d && e.allowTouchMove && a.touchStartPreventDefault;
  (a.touchStartForcePreventDefault || v) && !l.isContentEditable && n.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
}
function Yb(t) {
  const e = Fe(), r = this, n = r.touchEventsData, {
    params: i,
    touches: a,
    rtlTranslate: s,
    enabled: o
  } = r;
  if (!o || !i.simulateTouch && t.pointerType === "mouse") return;
  let l = t;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((P) => P.identifier === n.touchId), !c || c.identifier !== n.touchId) return;
  } else
    c = l;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", l);
    return;
  }
  const u = c.pageX, f = c.pageY;
  if (l.preventedByNestedSwiper) {
    a.startX = u, a.startY = f;
    return;
  }
  if (!r.allowTouchMove) {
    l.target.matches(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(a, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f
    }), n.touchStartTime = vt());
    return;
  }
  if (i.touchReleaseOnEdges && !i.loop) {
    if (r.isVertical()) {
      if (f < a.startY && r.translate <= r.maxTranslate() || f > a.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else if (u < a.startX && r.translate <= r.maxTranslate() || u > a.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && r.emit("touchMove", l), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = u, a.currentY = f;
  const m = a.currentX - a.startX, h = a.currentY - a.startY;
  if (r.params.threshold && Math.sqrt(m ** 2 + h ** 2) < r.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let P;
    r.isHorizontal() && a.currentY === a.startY || r.isVertical() && a.currentX === a.startX ? n.isScrolling = !1 : m * m + h * h >= 25 && (P = Math.atan2(Math.abs(h), Math.abs(m)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? P > i.touchAngle : 90 - P > i.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", l), typeof n.startMoving > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (n.startMoving = !0), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !i.cssMode && l.cancelable && l.preventDefault(), i.touchMoveStopPropagation && !i.nested && l.stopPropagation();
  let p = r.isHorizontal() ? m : h, d = r.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  i.oneWayMovement && (p = Math.abs(p) * (s ? 1 : -1), d = Math.abs(d) * (s ? 1 : -1)), a.diff = p, p *= i.touchRatio, s && (p = -p, d = -d);
  const v = r.touchesDirection;
  r.swipeDirection = p > 0 ? "prev" : "next", r.touchesDirection = d > 0 ? "prev" : "next";
  const b = r.params.loop && !i.cssMode, g = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
  if (!n.isMoved) {
    if (b && g && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const P = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      r.wrapperEl.dispatchEvent(P);
    }
    n.allowMomentumBounce = !1, i.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), i._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && v !== r.touchesDirection && b && g && Math.abs(p) >= 1) {
    Object.assign(a, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  r.emit("sliderMove", l), n.isMoved = !0, n.currentTranslate = p + n.startTranslate;
  let y = !0, w = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (w = 0), p > 0 ? (b && g && n.allowThresholdMove && n.currentTranslate > (i.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (i.slidesPerView !== "auto" && r.slides.length - i.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (y = !1, i.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + p) ** w))) : p < 0 && (b && g && n.allowThresholdMove && n.currentTranslate < (i.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (i.slidesPerView !== "auto" && r.slides.length - i.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (i.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (y = !1, i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - p) ** w))), y && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), i.threshold > 0)
    if (Math.abs(p) > i.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, n.currentTranslate = n.startTranslate, a.diff = r.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && r.freeMode || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function qb(t) {
  const e = this, r = e.touchEventsData;
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  let i;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (i = [...n.changedTouches].find((P) => P.identifier === r.touchId), !i || i.identifier !== r.touchId) return;
  } else {
    if (r.touchId !== null || n.pointerId !== r.pointerId) return;
    i = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  r.pointerId = null, r.touchId = null;
  const {
    params: s,
    touches: o,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: u
  } = e;
  if (!u || !s.simulateTouch && n.pointerType === "mouse") return;
  if (r.allowTouchCallbacks && e.emit("touchEnd", n), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && s.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  s.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const f = vt(), m = f - r.touchStartTime;
  if (e.allowClick) {
    const P = n.path || n.composedPath && n.composedPath();
    e.updateClickedSlide(P && P[0] || n.target, P), e.emit("tap click", n), m < 300 && f - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
  }
  if (r.lastClickTime = vt(), Sr(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || o.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let h;
  if (s.followFinger ? h = l ? e.translate : -e.translate : h = -r.currentTranslate, s.cssMode)
    return;
  if (s.freeMode && s.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  const p = h >= -e.maxTranslate() && !e.params.loop;
  let d = 0, v = e.slidesSizesGrid[0];
  for (let P = 0; P < c.length; P += P < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const T = P < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof c[P + T] < "u" ? (p || h >= c[P] && h < c[P + T]) && (d = P, v = c[P + T] - c[P]) : (p || h >= c[P]) && (d = P, v = c[c.length - 1] - c[c.length - 2]);
  }
  let b = null, g = null;
  s.rewind && (e.isBeginning ? g = s.virtual && s.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (b = 0));
  const y = (h - c[d]) / v, w = d < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (m > s.longSwipesMs) {
    if (!s.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (y >= s.longSwipesRatio ? e.slideTo(s.rewind && e.isEnd ? b : d + w) : e.slideTo(d)), e.swipeDirection === "prev" && (y > 1 - s.longSwipesRatio ? e.slideTo(d + w) : g !== null && y < 0 && Math.abs(y) > s.longSwipesRatio ? e.slideTo(g) : e.slideTo(d));
  } else {
    if (!s.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(d + w) : e.slideTo(d) : (e.swipeDirection === "next" && e.slideTo(b !== null ? b : d + w), e.swipeDirection === "prev" && e.slideTo(g !== null ? g : d));
  }
}
function fc() {
  const t = this, {
    params: e,
    el: r
  } = t;
  if (r && r.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: i,
    snapGrid: a
  } = t, s = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const o = s && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !o ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !s ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = i, t.allowSlideNext = n, t.params.watchOverflow && a !== t.snapGrid && t.checkOverflow();
}
function Qb(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Jb() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: n
  } = t;
  if (!n) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let i;
  const a = t.maxTranslate() - t.minTranslate();
  a === 0 ? i = 0 : i = (t.translate - t.minTranslate()) / a, i !== t.progress && t.updateProgress(r ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function Kb(t) {
  const e = this;
  oa(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function _b() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const Vf = (t, e) => {
  const r = Fe(), {
    params: n,
    el: i,
    wrapperEl: a,
    device: s
  } = t, o = !!n.nested, l = e === "on" ? "addEventListener" : "removeEventListener", c = e;
  !i || typeof i == "string" || (r[l]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), i[l]("touchstart", t.onTouchStart, {
    passive: !1
  }), i[l]("pointerdown", t.onTouchStart, {
    passive: !1
  }), r[l]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("touchend", t.onTouchEnd, {
    passive: !0
  }), r[l]("pointerup", t.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), r[l]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", t.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), r[l]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && i[l]("click", t.onClick, !0), n.cssMode && a[l]("scroll", t.onScroll), n.updateOnWindowResize ? t[c](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", fc, !0) : t[c]("observerUpdate", fc, !0), i[l]("load", t.onLoad, {
    capture: !0
  }));
};
function $b() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = Ub.bind(t), t.onTouchMove = Yb.bind(t), t.onTouchEnd = qb.bind(t), t.onDocumentTouchStart = _b.bind(t), e.cssMode && (t.onScroll = Jb.bind(t)), t.onClick = Qb.bind(t), t.onLoad = Kb.bind(t), Vf(t, "on");
}
function ey() {
  Vf(this, "off");
}
var ty = {
  attachEvents: $b,
  detachEvents: ey
};
const pc = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function ry() {
  const t = this, {
    realIndex: e,
    initialized: r,
    params: n,
    el: i
  } = t, a = n.breakpoints;
  if (!a || a && Object.keys(a).length === 0) return;
  const s = Fe(), o = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? t.el : s.querySelector(n.breakpointsBase), c = t.getBreakpoint(a, o, l);
  if (!c || t.currentBreakpoint === c) return;
  const f = (c in a ? a[c] : void 0) || t.originalParams, m = pc(t, n), h = pc(t, f), p = t.params.grabCursor, d = f.grabCursor, v = n.enabled;
  m && !h ? (i.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !m && h && (i.classList.add(`${n.containerModifierClass}grid`), (f.grid.fill && f.grid.fill === "column" || !f.grid.fill && n.grid.fill === "column") && i.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), p && !d ? t.unsetGrabCursor() : !p && d && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((T) => {
    if (typeof f[T] > "u") return;
    const A = n[T] && n[T].enabled, j = f[T] && f[T].enabled;
    A && !j && t[T].disable(), !A && j && t[T].enable();
  });
  const b = f.direction && f.direction !== n.direction, g = n.loop && (f.slidesPerView !== n.slidesPerView || b), y = n.loop;
  b && r && t.changeDirection(), ct(t.params, f);
  const w = t.params.enabled, P = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), v && !w ? t.disable() : !v && w && t.enable(), t.currentBreakpoint = c, t.emit("_beforeBreakpoint", f), r && (g ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !y && P ? (t.loopCreate(e), t.updateSlides()) : y && !P && t.loopDestroy()), t.emit("breakpoint", f);
}
function ny(t, e, r) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !r) return;
  let n = !1;
  const i = Me(), a = e === "window" ? i.innerHeight : r.clientHeight, s = Object.keys(t).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: a * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  s.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < s.length; o += 1) {
    const {
      point: l,
      value: c
    } = s[o];
    e === "window" ? i.matchMedia(`(min-width: ${c}px)`).matches && (n = l) : c <= r.clientWidth && (n = l);
  }
  return n || "max";
}
var iy = {
  setBreakpoint: ry,
  getBreakpoint: ny
};
function ay(t, e) {
  const r = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((i) => {
      n[i] && r.push(e + i);
    }) : typeof n == "string" && r.push(e + n);
  }), r;
}
function sy() {
  const t = this, {
    classNames: e,
    params: r,
    rtl: n,
    el: i,
    device: a
  } = t, s = ay(["initialized", r.direction, {
    "free-mode": t.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: a.android
  }, {
    ios: a.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...s), i.classList.add(...e), t.emitContainerClasses();
}
function oy() {
  const t = this, {
    el: e,
    classNames: r
  } = t;
  !e || typeof e == "string" || (e.classList.remove(...r), t.emitContainerClasses());
}
var ly = {
  addClasses: sy,
  removeClasses: oy
};
function cy() {
  const t = this, {
    isLocked: e,
    params: r
  } = t, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const i = t.slides.length - 1, a = t.slidesGrid[i] + t.slidesSizesGrid[i] + n * 2;
    t.isLocked = t.size > a;
  } else
    t.isLocked = t.snapGrid.length === 1;
  r.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), r.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var uy = {
  checkOverflow: cy
}, to = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function dy(t, e) {
  return function(n) {
    n === void 0 && (n = {});
    const i = Object.keys(n)[0], a = n[i];
    if (typeof a != "object" || a === null) {
      ct(e, n);
      return;
    }
    if (t[i] === !0 && (t[i] = {
      enabled: !0
    }), i === "navigation" && t[i] && t[i].enabled && !t[i].prevEl && !t[i].nextEl && (t[i].auto = !0), ["pagination", "scrollbar"].indexOf(i) >= 0 && t[i] && t[i].enabled && !t[i].el && (t[i].auto = !0), !(i in t && "enabled" in a)) {
      ct(e, n);
      return;
    }
    typeof t[i] == "object" && !("enabled" in t[i]) && (t[i].enabled = !0), t[i] || (t[i] = {
      enabled: !1
    }), ct(e, n);
  };
}
const ls = {
  eventsEmitter: lb,
  update: yb,
  translate: Ob,
  transition: Mb,
  slide: Db,
  loop: Vb,
  grabCursor: Xb,
  events: ty,
  breakpoints: iy,
  checkOverflow: uy,
  classes: ly
}, cs = {};
class lt {
  constructor() {
    let e, r;
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    i.length === 1 && i[0].constructor && Object.prototype.toString.call(i[0]).slice(8, -1) === "Object" ? r = i[0] : [e, r] = i, r || (r = {}), r = ct({}, r), e && !r.el && (r.el = e);
    const s = Fe();
    if (r.el && typeof r.el == "string" && s.querySelectorAll(r.el).length > 1) {
      const u = [];
      return s.querySelectorAll(r.el).forEach((f) => {
        const m = ct({}, r, {
          el: f
        });
        u.push(new lt(m));
      }), u;
    }
    const o = this;
    o.__swiper__ = !0, o.support = Df(), o.device = Hf({
      userAgent: r.userAgent
    }), o.browser = Wf(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], r.modules && Array.isArray(r.modules) && o.modules.push(...r.modules);
    const l = {};
    o.modules.forEach((u) => {
      u({
        params: r,
        swiper: o,
        extendParams: dy(r, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const c = ct({}, to, l);
    return o.params = ct({}, c, cs, r), o.originalParams = ct({}, o.params), o.passedParams = ct({}, r), o.params && o.params.on && Object.keys(o.params.on).forEach((u) => {
      o.on(u, o.params.on[u]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: n
    } = this, i = Ze(r, `.${n.slideClass}, swiper-slide`), a = In(i[0]);
    return In(e) - a;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((r) => r.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: n
    } = e;
    e.slides = Ze(r, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = n.minTranslate(), s = (n.maxTranslate() - i) * e + i;
    n.translateTo(s, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = [];
    e.slides.forEach((n) => {
      const i = e.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: i
      }), e.emit("_slideClass", n, i);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e, r) {
    e === void 0 && (e = "current"), r === void 0 && (r = !1);
    const n = this, {
      params: i,
      slides: a,
      slidesGrid: s,
      slidesSizesGrid: o,
      size: l,
      activeIndex: c
    } = n;
    let u = 1;
    if (typeof i.slidesPerView == "number") return i.slidesPerView;
    if (i.centeredSlides) {
      let f = a[c] ? Math.ceil(a[c].swiperSlideSize) : 0, m;
      for (let h = c + 1; h < a.length; h += 1)
        a[h] && !m && (f += Math.ceil(a[h].swiperSlideSize), u += 1, f > l && (m = !0));
      for (let h = c - 1; h >= 0; h -= 1)
        a[h] && !m && (f += a[h].swiperSlideSize, u += 1, f > l && (m = !0));
    } else if (e === "current")
      for (let f = c + 1; f < a.length; f += 1)
        (r ? s[f] + o[f] - s[c] < l : s[f] - s[c] < l) && (u += 1);
    else
      for (let f = c - 1; f >= 0; f -= 1)
        s[c] - s[f] < l && (u += 1);
    return u;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: r,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && oa(e, s);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function i() {
      const s = e.rtlTranslate ? e.translate * -1 : e.translate, o = Math.min(Math.max(s, e.maxTranslate()), e.minTranslate());
      e.setTranslate(o), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let a;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      i(), n.autoHeight && e.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const s = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        a = e.slideTo(s.length - 1, 0, !1, !0);
      } else
        a = e.slideTo(e.activeIndex, 0, !1, !0);
      a || i();
    }
    n.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r) {
    r === void 0 && (r = !0);
    const n = this, i = n.params.direction;
    return e || (e = i === "horizontal" ? "vertical" : "horizontal"), e === i || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${i}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((a) => {
      e === "vertical" ? a.style.width = "" : a.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted) return !0;
    let n = e || r.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = r, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
    const i = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(i()) : Ze(n, i())[0];
    return !s && r.params.createElements && (s = ut("div", r.params.wrapperClass), n.append(s), Ze(n, `.${r.params.slideClass}`).forEach((o) => {
      s.append(o);
    })), Object.assign(r, {
      el: n,
      wrapperEl: s,
      slidesEl: r.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : s,
      hostEl: r.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || er(n, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || er(n, "direction") === "rtl"),
      wrongRTL: er(s, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    if (r.initialized || r.mount(e) === !1) return r;
    r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents();
    const i = [...r.el.querySelectorAll('[loading="lazy"]')];
    return r.isElement && i.push(...r.hostEl.querySelectorAll('[loading="lazy"]')), i.forEach((a) => {
      a.complete ? oa(r, a) : a.addEventListener("load", (s) => {
        oa(r, s.target);
      });
    }), eo(r), r.initialized = !0, eo(r), r.emit("init"), r.emit("afterInit"), r;
  }
  destroy(e, r) {
    e === void 0 && (e = !0), r === void 0 && (r = !0);
    const n = this, {
      params: i,
      el: a,
      wrapperEl: s,
      slides: o
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), i.loop && n.loopDestroy(), r && (n.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), s && s.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((l) => {
      n.off(l);
    }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), J0(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    ct(cs, e);
  }
  static get extendedDefaults() {
    return cs;
  }
  static get defaults() {
    return to;
  }
  static installModule(e) {
    lt.prototype.__modules__ || (lt.prototype.__modules__ = []);
    const r = lt.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => lt.installModule(r)), lt) : (lt.installModule(e), lt);
  }
}
Object.keys(ls).forEach((t) => {
  Object.keys(ls[t]).forEach((e) => {
    lt.prototype[e] = ls[t][e];
  });
});
lt.use([sb, ob]);
function fy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  r({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let a;
  const s = Fe();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const o = s.createElement("div");
  function l(p, d) {
    const v = e.params.virtual;
    if (v.cache && e.virtual.cache[d])
      return e.virtual.cache[d];
    let b;
    return v.renderSlide ? (b = v.renderSlide.call(e, p, d), typeof b == "string" && (o.innerHTML = b, b = o.children[0])) : e.isElement ? b = ut("swiper-slide") : b = ut("div", e.params.slideClass), b.setAttribute("data-swiper-slide-index", d), v.renderSlide || (b.innerHTML = p), v.cache && (e.virtual.cache[d] = b), b;
  }
  function c(p, d, v) {
    const {
      slidesPerView: b,
      slidesPerGroup: g,
      centeredSlides: y,
      loop: w,
      initialSlide: P
    } = e.params;
    if (d && !w && P > 0)
      return;
    const {
      addSlidesBefore: T,
      addSlidesAfter: A
    } = e.params.virtual, {
      from: j,
      to: O,
      slides: M,
      slidesGrid: z,
      offset: R
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const I = typeof v > "u" ? e.activeIndex || 0 : v;
    let L;
    e.rtlTranslate ? L = "right" : L = e.isHorizontal() ? "left" : "top";
    let W, q;
    y ? (W = Math.floor(b / 2) + g + A, q = Math.floor(b / 2) + g + T) : (W = b + (g - 1) + A, q = (w ? b : g) + T);
    let C = I - q, E = I + W;
    w || (C = Math.max(C, 0), E = Math.min(E, M.length - 1));
    let B = (e.slidesGrid[C] || 0) - (e.slidesGrid[0] || 0);
    w && I >= q ? (C -= q, y || (B += e.slidesGrid[0])) : w && I < q && (C = -q, y && (B += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: C,
      to: E,
      offset: B,
      slidesGrid: e.slidesGrid,
      slidesBefore: q,
      slidesAfter: W
    });
    function Q() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), i("virtualUpdate");
    }
    if (j === C && O === E && !p) {
      e.slidesGrid !== z && B !== R && e.slides.forEach((Z) => {
        Z.style[L] = `${B - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), i("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: B,
        from: C,
        to: E,
        slides: function() {
          const Y = [];
          for (let te = C; te <= E; te += 1)
            Y.push(M[te]);
          return Y;
        }()
      }), e.params.virtual.renderExternalUpdate ? Q() : i("virtualUpdate");
      return;
    }
    const $ = [], ne = [], ce = (Z) => {
      let Y = Z;
      return Z < 0 ? Y = M.length + Z : Y >= M.length && (Y = Y - M.length), Y;
    };
    if (p)
      e.slides.filter((Z) => Z.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((Z) => {
        Z.remove();
      });
    else
      for (let Z = j; Z <= O; Z += 1)
        if (Z < C || Z > E) {
          const Y = ce(Z);
          e.slides.filter((te) => te.matches(`.${e.params.slideClass}[data-swiper-slide-index="${Y}"], swiper-slide[data-swiper-slide-index="${Y}"]`)).forEach((te) => {
            te.remove();
          });
        }
    const ge = w ? -M.length : 0, G = w ? M.length * 2 : M.length;
    for (let Z = ge; Z < G; Z += 1)
      if (Z >= C && Z <= E) {
        const Y = ce(Z);
        typeof O > "u" || p ? ne.push(Y) : (Z > O && ne.push(Y), Z < j && $.push(Y));
      }
    if (ne.forEach((Z) => {
      e.slidesEl.append(l(M[Z], Z));
    }), w)
      for (let Z = $.length - 1; Z >= 0; Z -= 1) {
        const Y = $[Z];
        e.slidesEl.prepend(l(M[Y], Y));
      }
    else
      $.sort((Z, Y) => Y - Z), $.forEach((Z) => {
        e.slidesEl.prepend(l(M[Z], Z));
      });
    Ze(e.slidesEl, ".swiper-slide, swiper-slide").forEach((Z) => {
      Z.style[L] = `${B - Math.abs(e.cssOverflowAdjustment())}px`;
    }), Q();
  }
  function u(p) {
    if (typeof p == "object" && "length" in p)
      for (let d = 0; d < p.length; d += 1)
        p[d] && e.virtual.slides.push(p[d]);
    else
      e.virtual.slides.push(p);
    c(!0);
  }
  function f(p) {
    const d = e.activeIndex;
    let v = d + 1, b = 1;
    if (Array.isArray(p)) {
      for (let g = 0; g < p.length; g += 1)
        p[g] && e.virtual.slides.unshift(p[g]);
      v = d + p.length, b = p.length;
    } else
      e.virtual.slides.unshift(p);
    if (e.params.virtual.cache) {
      const g = e.virtual.cache, y = {};
      Object.keys(g).forEach((w) => {
        const P = g[w], T = P.getAttribute("data-swiper-slide-index");
        T && P.setAttribute("data-swiper-slide-index", parseInt(T, 10) + b), y[parseInt(w, 10) + b] = P;
      }), e.virtual.cache = y;
    }
    c(!0), e.slideTo(v, 0);
  }
  function m(p) {
    if (typeof p > "u" || p === null) return;
    let d = e.activeIndex;
    if (Array.isArray(p))
      for (let v = p.length - 1; v >= 0; v -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[p[v]], Object.keys(e.virtual.cache).forEach((b) => {
          b > p && (e.virtual.cache[b - 1] = e.virtual.cache[b], e.virtual.cache[b - 1].setAttribute("data-swiper-slide-index", b - 1), delete e.virtual.cache[b]);
        })), e.virtual.slides.splice(p[v], 1), p[v] < d && (d -= 1), d = Math.max(d, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach((v) => {
        v > p && (e.virtual.cache[v - 1] = e.virtual.cache[v], e.virtual.cache[v - 1].setAttribute("data-swiper-slide-index", v - 1), delete e.virtual.cache[v]);
      })), e.virtual.slides.splice(p, 1), p < d && (d -= 1), d = Math.max(d, 0);
    c(!0), e.slideTo(d, 0);
  }
  function h() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), c(!0), e.slideTo(0, 0);
  }
  n("beforeInit", () => {
    if (!e.params.virtual.enabled) return;
    let p;
    if (typeof e.passedParams.virtual.slides > "u") {
      const d = [...e.slidesEl.children].filter((v) => v.matches(`.${e.params.slideClass}, swiper-slide`));
      d && d.length && (e.virtual.slides = [...d], p = !0, d.forEach((v, b) => {
        v.setAttribute("data-swiper-slide-index", b), e.virtual.cache[b] = v, v.remove();
      }));
    }
    p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, c(!1, !0);
  }), n("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(() => {
      c();
    }, 100)) : c());
  }), n("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && pn(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: u,
    prependSlide: f,
    removeSlide: m,
    removeAllSlides: h,
    update: c
  });
}
function py(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = Fe(), s = Me();
  e.keyboard = {
    enabled: !1
  }, r({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function o(u) {
    if (!e.enabled) return;
    const {
      rtlTranslate: f
    } = e;
    let m = u;
    m.originalEvent && (m = m.originalEvent);
    const h = m.keyCode || m.charCode, p = e.params.keyboard.pageUpDown, d = p && h === 33, v = p && h === 34, b = h === 37, g = h === 39, y = h === 38, w = h === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && g || e.isVertical() && w || v) || !e.allowSlidePrev && (e.isHorizontal() && b || e.isVertical() && y || d))
      return !1;
    if (!(m.shiftKey || m.altKey || m.ctrlKey || m.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (d || v || b || g || y || w)) {
        let P = !1;
        if (br(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && br(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const T = e.el, A = T.clientWidth, j = T.clientHeight, O = s.innerWidth, M = s.innerHeight, z = Sa(T);
        f && (z.left -= T.scrollLeft);
        const R = [[z.left, z.top], [z.left + A, z.top], [z.left, z.top + j], [z.left + A, z.top + j]];
        for (let I = 0; I < R.length; I += 1) {
          const L = R[I];
          if (L[0] >= 0 && L[0] <= O && L[1] >= 0 && L[1] <= M) {
            if (L[0] === 0 && L[1] === 0) continue;
            P = !0;
          }
        }
        if (!P) return;
      }
      e.isHorizontal() ? ((d || v || b || g) && (m.preventDefault ? m.preventDefault() : m.returnValue = !1), ((v || g) && !f || (d || b) && f) && e.slideNext(), ((d || b) && !f || (v || g) && f) && e.slidePrev()) : ((d || v || y || w) && (m.preventDefault ? m.preventDefault() : m.returnValue = !1), (v || w) && e.slideNext(), (d || y) && e.slidePrev()), i("keyPress", h);
    }
  }
  function l() {
    e.keyboard.enabled || (a.addEventListener("keydown", o), e.keyboard.enabled = !0);
  }
  function c() {
    e.keyboard.enabled && (a.removeEventListener("keydown", o), e.keyboard.enabled = !1);
  }
  n("init", () => {
    e.params.keyboard.enabled && l();
  }), n("destroy", () => {
    e.keyboard.enabled && c();
  }), Object.assign(e.keyboard, {
    enable: l,
    disable: c
  });
}
function my(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = Me();
  r({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let s, o = vt(), l;
  const c = [];
  function u(y) {
    let A = 0, j = 0, O = 0, M = 0;
    return "detail" in y && (j = y.detail), "wheelDelta" in y && (j = -y.wheelDelta / 120), "wheelDeltaY" in y && (j = -y.wheelDeltaY / 120), "wheelDeltaX" in y && (A = -y.wheelDeltaX / 120), "axis" in y && y.axis === y.HORIZONTAL_AXIS && (A = j, j = 0), O = A * 10, M = j * 10, "deltaY" in y && (M = y.deltaY), "deltaX" in y && (O = y.deltaX), y.shiftKey && !O && (O = M, M = 0), (O || M) && y.deltaMode && (y.deltaMode === 1 ? (O *= 40, M *= 40) : (O *= 800, M *= 800)), O && !A && (A = O < 1 ? -1 : 1), M && !j && (j = M < 1 ? -1 : 1), {
      spinX: A,
      spinY: j,
      pixelX: O,
      pixelY: M
    };
  }
  function f() {
    e.enabled && (e.mouseEntered = !0);
  }
  function m() {
    e.enabled && (e.mouseEntered = !1);
  }
  function h(y) {
    return e.params.mousewheel.thresholdDelta && y.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && vt() - o < e.params.mousewheel.thresholdTime ? !1 : y.delta >= 6 && vt() - o < 60 ? !0 : (y.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), i("scroll", y.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), i("scroll", y.raw)), o = new a.Date().getTime(), !1);
  }
  function p(y) {
    const w = e.params.mousewheel;
    if (y.direction < 0) {
      if (e.isEnd && !e.params.loop && w.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && w.releaseOnEdges)
      return !0;
    return !1;
  }
  function d(y) {
    let w = y, P = !0;
    if (!e.enabled || y.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const T = e.params.mousewheel;
    e.params.cssMode && w.preventDefault();
    let A = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (A = document.querySelector(e.params.mousewheel.eventsTarget));
    const j = A && A.contains(w.target);
    if (!e.mouseEntered && !j && !T.releaseOnEdges) return !0;
    w.originalEvent && (w = w.originalEvent);
    let O = 0;
    const M = e.rtlTranslate ? -1 : 1, z = u(w);
    if (T.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(z.pixelX) > Math.abs(z.pixelY)) O = -z.pixelX * M;
        else return !0;
      else if (Math.abs(z.pixelY) > Math.abs(z.pixelX)) O = -z.pixelY;
      else return !0;
    else
      O = Math.abs(z.pixelX) > Math.abs(z.pixelY) ? -z.pixelX * M : -z.pixelY;
    if (O === 0) return !0;
    T.invert && (O = -O);
    let R = e.getTranslate() + O * T.sensitivity;
    if (R >= e.minTranslate() && (R = e.minTranslate()), R <= e.maxTranslate() && (R = e.maxTranslate()), P = e.params.loop ? !0 : !(R === e.minTranslate() || R === e.maxTranslate()), P && e.params.nested && w.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const I = {
        time: vt(),
        delta: Math.abs(O),
        direction: Math.sign(O),
        raw: y
      };
      c.length >= 2 && c.shift();
      const L = c.length ? c[c.length - 1] : void 0;
      if (c.push(I), L ? (I.direction !== L.direction || I.delta > L.delta || I.time > L.time + 150) && h(I) : h(I), p(I))
        return !0;
    } else {
      const I = {
        time: vt(),
        delta: Math.abs(O),
        direction: Math.sign(O)
      }, L = l && I.time < l.time + 500 && I.delta <= l.delta && I.direction === l.direction;
      if (!L) {
        l = void 0;
        let W = e.getTranslate() + O * T.sensitivity;
        const q = e.isBeginning, C = e.isEnd;
        if (W >= e.minTranslate() && (W = e.minTranslate()), W <= e.maxTranslate() && (W = e.maxTranslate()), e.setTransition(0), e.setTranslate(W), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!q && e.isBeginning || !C && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: I.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(s), s = void 0, c.length >= 15 && c.shift();
          const E = c.length ? c[c.length - 1] : void 0, B = c[0];
          if (c.push(I), E && (I.delta > E.delta || I.direction !== E.direction))
            c.splice(0);
          else if (c.length >= 15 && I.time - B.time < 500 && B.delta - I.delta >= 1 && I.delta <= 6) {
            const Q = O > 0 ? 0.8 : 0.2;
            l = I, c.splice(0), s = Sr(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, Q);
            }, 0);
          }
          s || (s = Sr(() => {
            if (e.destroyed || !e.params) return;
            const Q = 0.5;
            l = I, c.splice(0), e.slideToClosest(e.params.speed, !0, void 0, Q);
          }, 500));
        }
        if (L || i("scroll", w), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), T.releaseOnEdges && (W === e.minTranslate() || W === e.maxTranslate()))
          return !0;
      }
    }
    return w.preventDefault ? w.preventDefault() : w.returnValue = !1, !1;
  }
  function v(y) {
    let w = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (w = document.querySelector(e.params.mousewheel.eventsTarget)), w[y]("mouseenter", f), w[y]("mouseleave", m), w[y]("wheel", d);
  }
  function b() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", d), !0) : e.mousewheel.enabled ? !1 : (v("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function g() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, d), !0) : e.mousewheel.enabled ? (v("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  n("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && g(), e.params.mousewheel.enabled && b();
  }), n("destroy", () => {
    e.params.cssMode && b(), e.mousewheel.enabled && g();
  }), Object.assign(e.mousewheel, {
    enable: b,
    disable: g
  });
}
function tl(t, e, r, n) {
  return t.params.createElements && Object.keys(n).forEach((i) => {
    if (!r[i] && r.auto === !0) {
      let a = Ze(t.el, `.${n[i]}`)[0];
      a || (a = ut("div", n[i]), a.className = n[i], t.el.append(a)), r[i] = a, e[i] = a;
    }
  }), r;
}
function hy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  r({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(p) {
    let d;
    return p && typeof p == "string" && e.isElement && (d = e.el.querySelector(p) || e.hostEl.querySelector(p), d) ? d : (p && (typeof p == "string" && (d = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && d && d.length > 1 && e.el.querySelectorAll(p).length === 1 ? d = e.el.querySelector(p) : d && d.length === 1 && (d = d[0])), p && !d ? p : d);
  }
  function s(p, d) {
    const v = e.params.navigation;
    p = pe(p), p.forEach((b) => {
      b && (b.classList[d ? "add" : "remove"](...v.disabledClass.split(" ")), b.tagName === "BUTTON" && (b.disabled = d), e.params.watchOverflow && e.enabled && b.classList[e.isLocked ? "add" : "remove"](v.lockClass));
    });
  }
  function o() {
    const {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    if (e.params.loop) {
      s(d, !1), s(p, !1);
      return;
    }
    s(d, e.isBeginning && !e.params.rewind), s(p, e.isEnd && !e.params.rewind);
  }
  function l(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), i("navigationPrev"));
  }
  function c(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), i("navigationNext"));
  }
  function u() {
    const p = e.params.navigation;
    if (e.params.navigation = tl(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    let d = a(p.nextEl), v = a(p.prevEl);
    Object.assign(e.navigation, {
      nextEl: d,
      prevEl: v
    }), d = pe(d), v = pe(v);
    const b = (g, y) => {
      g && g.addEventListener("click", y === "next" ? c : l), !e.enabled && g && g.classList.add(...p.lockClass.split(" "));
    };
    d.forEach((g) => b(g, "next")), v.forEach((g) => b(g, "prev"));
  }
  function f() {
    let {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    p = pe(p), d = pe(d);
    const v = (b, g) => {
      b.removeEventListener("click", g === "next" ? c : l), b.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    p.forEach((b) => v(b, "next")), d.forEach((b) => v(b, "prev"));
  }
  n("init", () => {
    e.params.navigation.enabled === !1 ? h() : (u(), o());
  }), n("toEdge fromEdge lock unlock", () => {
    o();
  }), n("destroy", () => {
    f();
  }), n("enable disable", () => {
    let {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    if (p = pe(p), d = pe(d), e.enabled) {
      o();
      return;
    }
    [...p, ...d].filter((v) => !!v).forEach((v) => v.classList.add(e.params.navigation.lockClass));
  }), n("click", (p, d) => {
    let {
      nextEl: v,
      prevEl: b
    } = e.navigation;
    v = pe(v), b = pe(b);
    const g = d.target;
    let y = b.includes(g) || v.includes(g);
    if (e.isElement && !y) {
      const w = d.path || d.composedPath && d.composedPath();
      w && (y = w.find((P) => v.includes(P) || b.includes(P)));
    }
    if (e.params.navigation.hideOnClick && !y) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === g || e.pagination.el.contains(g))) return;
      let w;
      v.length ? w = v[0].classList.contains(e.params.navigation.hiddenClass) : b.length && (w = b[0].classList.contains(e.params.navigation.hiddenClass)), i(w === !0 ? "navigationShow" : "navigationHide"), [...v, ...b].filter((P) => !!P).forEach((P) => P.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const m = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), u(), o();
  }, h = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), f();
  };
  Object.assign(e.navigation, {
    enable: m,
    disable: h,
    update: o,
    init: u,
    destroy: f
  });
}
function Ht(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function gy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = "swiper-pagination";
  r({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (g) => g,
      formatFractionTotal: (g) => g,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let s, o = 0;
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function c(g, y) {
    const {
      bulletActiveClass: w
    } = e.params.pagination;
    g && (g = g[`${y === "prev" ? "previous" : "next"}ElementSibling`], g && (g.classList.add(`${w}-${y}`), g = g[`${y === "prev" ? "previous" : "next"}ElementSibling`], g && g.classList.add(`${w}-${y}-${y}`)));
  }
  function u(g, y, w) {
    if (g = g % w, y = y % w, y === g + 1)
      return "next";
    if (y === g - 1)
      return "previous";
  }
  function f(g) {
    const y = g.target.closest(Ht(e.params.pagination.bulletClass));
    if (!y)
      return;
    g.preventDefault();
    const w = In(y) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === w) return;
      const P = u(e.realIndex, w, e.slides.length);
      P === "next" ? e.slideNext() : P === "previous" ? e.slidePrev() : e.slideToLoop(w);
    } else
      e.slideTo(w);
  }
  function m() {
    const g = e.rtl, y = e.params.pagination;
    if (l()) return;
    let w = e.pagination.el;
    w = pe(w);
    let P, T;
    const A = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, j = e.params.loop ? Math.ceil(A / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (T = e.previousRealIndex || 0, P = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (P = e.snapIndex, T = e.previousSnapIndex) : (T = e.previousIndex || 0, P = e.activeIndex || 0), y.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const O = e.pagination.bullets;
      let M, z, R;
      if (y.dynamicBullets && (s = $s(O[0], e.isHorizontal() ? "width" : "height"), w.forEach((I) => {
        I.style[e.isHorizontal() ? "width" : "height"] = `${s * (y.dynamicMainBullets + 4)}px`;
      }), y.dynamicMainBullets > 1 && T !== void 0 && (o += P - (T || 0), o > y.dynamicMainBullets - 1 ? o = y.dynamicMainBullets - 1 : o < 0 && (o = 0)), M = Math.max(P - o, 0), z = M + (Math.min(O.length, y.dynamicMainBullets) - 1), R = (z + M) / 2), O.forEach((I) => {
        const L = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((W) => `${y.bulletActiveClass}${W}`)].map((W) => typeof W == "string" && W.includes(" ") ? W.split(" ") : W).flat();
        I.classList.remove(...L);
      }), w.length > 1)
        O.forEach((I) => {
          const L = In(I);
          L === P ? I.classList.add(...y.bulletActiveClass.split(" ")) : e.isElement && I.setAttribute("part", "bullet"), y.dynamicBullets && (L >= M && L <= z && I.classList.add(...`${y.bulletActiveClass}-main`.split(" ")), L === M && c(I, "prev"), L === z && c(I, "next"));
        });
      else {
        const I = O[P];
        if (I && I.classList.add(...y.bulletActiveClass.split(" ")), e.isElement && O.forEach((L, W) => {
          L.setAttribute("part", W === P ? "bullet-active" : "bullet");
        }), y.dynamicBullets) {
          const L = O[M], W = O[z];
          for (let q = M; q <= z; q += 1)
            O[q] && O[q].classList.add(...`${y.bulletActiveClass}-main`.split(" "));
          c(L, "prev"), c(W, "next");
        }
      }
      if (y.dynamicBullets) {
        const I = Math.min(O.length, y.dynamicMainBullets + 4), L = (s * I - s) / 2 - R * s, W = g ? "right" : "left";
        O.forEach((q) => {
          q.style[e.isHorizontal() ? W : "top"] = `${L}px`;
        });
      }
    }
    w.forEach((O, M) => {
      if (y.type === "fraction" && (O.querySelectorAll(Ht(y.currentClass)).forEach((z) => {
        z.textContent = y.formatFractionCurrent(P + 1);
      }), O.querySelectorAll(Ht(y.totalClass)).forEach((z) => {
        z.textContent = y.formatFractionTotal(j);
      })), y.type === "progressbar") {
        let z;
        y.progressbarOpposite ? z = e.isHorizontal() ? "vertical" : "horizontal" : z = e.isHorizontal() ? "horizontal" : "vertical";
        const R = (P + 1) / j;
        let I = 1, L = 1;
        z === "horizontal" ? I = R : L = R, O.querySelectorAll(Ht(y.progressbarFillClass)).forEach((W) => {
          W.style.transform = `translate3d(0,0,0) scaleX(${I}) scaleY(${L})`, W.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      y.type === "custom" && y.renderCustom ? (O.innerHTML = y.renderCustom(e, P + 1, j), M === 0 && i("paginationRender", O)) : (M === 0 && i("paginationRender", O), i("paginationUpdate", O)), e.params.watchOverflow && e.enabled && O.classList[e.isLocked ? "add" : "remove"](y.lockClass);
    });
  }
  function h() {
    const g = e.params.pagination;
    if (l()) return;
    const y = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let w = e.pagination.el;
    w = pe(w);
    let P = "";
    if (g.type === "bullets") {
      let T = e.params.loop ? Math.ceil(y / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && T > y && (T = y);
      for (let A = 0; A < T; A += 1)
        g.renderBullet ? P += g.renderBullet.call(e, A, g.bulletClass) : P += `<${g.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${g.bulletClass}"></${g.bulletElement}>`;
    }
    g.type === "fraction" && (g.renderFraction ? P = g.renderFraction.call(e, g.currentClass, g.totalClass) : P = `<span class="${g.currentClass}"></span> / <span class="${g.totalClass}"></span>`), g.type === "progressbar" && (g.renderProgressbar ? P = g.renderProgressbar.call(e, g.progressbarFillClass) : P = `<span class="${g.progressbarFillClass}"></span>`), e.pagination.bullets = [], w.forEach((T) => {
      g.type !== "custom" && (T.innerHTML = P || ""), g.type === "bullets" && e.pagination.bullets.push(...T.querySelectorAll(Ht(g.bulletClass)));
    }), g.type !== "custom" && i("paginationRender", w[0]);
  }
  function p() {
    e.params.pagination = tl(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const g = e.params.pagination;
    if (!g.el) return;
    let y;
    typeof g.el == "string" && e.isElement && (y = e.el.querySelector(g.el)), !y && typeof g.el == "string" && (y = [...document.querySelectorAll(g.el)]), y || (y = g.el), !(!y || y.length === 0) && (e.params.uniqueNavElements && typeof g.el == "string" && Array.isArray(y) && y.length > 1 && (y = [...e.el.querySelectorAll(g.el)], y.length > 1 && (y = y.find((w) => br(w, ".swiper")[0] === e.el))), Array.isArray(y) && y.length === 1 && (y = y[0]), Object.assign(e.pagination, {
      el: y
    }), y = pe(y), y.forEach((w) => {
      g.type === "bullets" && g.clickable && w.classList.add(...(g.clickableClass || "").split(" ")), w.classList.add(g.modifierClass + g.type), w.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.type === "bullets" && g.dynamicBullets && (w.classList.add(`${g.modifierClass}${g.type}-dynamic`), o = 0, g.dynamicMainBullets < 1 && (g.dynamicMainBullets = 1)), g.type === "progressbar" && g.progressbarOpposite && w.classList.add(g.progressbarOppositeClass), g.clickable && w.addEventListener("click", f), e.enabled || w.classList.add(g.lockClass);
    }));
  }
  function d() {
    const g = e.params.pagination;
    if (l()) return;
    let y = e.pagination.el;
    y && (y = pe(y), y.forEach((w) => {
      w.classList.remove(g.hiddenClass), w.classList.remove(g.modifierClass + g.type), w.classList.remove(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.clickable && (w.classList.remove(...(g.clickableClass || "").split(" ")), w.removeEventListener("click", f));
    })), e.pagination.bullets && e.pagination.bullets.forEach((w) => w.classList.remove(...g.bulletActiveClass.split(" ")));
  }
  n("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const g = e.params.pagination;
    let {
      el: y
    } = e.pagination;
    y = pe(y), y.forEach((w) => {
      w.classList.remove(g.horizontalClass, g.verticalClass), w.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass);
    });
  }), n("init", () => {
    e.params.pagination.enabled === !1 ? b() : (p(), h(), m());
  }), n("activeIndexChange", () => {
    typeof e.snapIndex > "u" && m();
  }), n("snapIndexChange", () => {
    m();
  }), n("snapGridLengthChange", () => {
    h(), m();
  }), n("destroy", () => {
    d();
  }), n("enable disable", () => {
    let {
      el: g
    } = e.pagination;
    g && (g = pe(g), g.forEach((y) => y.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), n("lock unlock", () => {
    m();
  }), n("click", (g, y) => {
    const w = y.target, P = pe(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && P && P.length > 0 && !w.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && w === e.navigation.nextEl || e.navigation.prevEl && w === e.navigation.prevEl)) return;
      const T = P[0].classList.contains(e.params.pagination.hiddenClass);
      i(T === !0 ? "paginationShow" : "paginationHide"), P.forEach((A) => A.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const v = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: g
    } = e.pagination;
    g && (g = pe(g), g.forEach((y) => y.classList.remove(e.params.pagination.paginationDisabledClass))), p(), h(), m();
  }, b = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: g
    } = e.pagination;
    g && (g = pe(g), g.forEach((y) => y.classList.add(e.params.pagination.paginationDisabledClass))), d();
  };
  Object.assign(e.pagination, {
    enable: v,
    disable: b,
    render: h,
    update: m,
    init: p,
    destroy: d
  });
}
function vy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = Fe();
  let s = !1, o = null, l = null, c, u, f, m;
  r({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function h() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: R,
      rtlTranslate: I
    } = e, {
      dragEl: L,
      el: W
    } = R, q = e.params.scrollbar, C = e.params.loop ? e.progressLoop : e.progress;
    let E = u, B = (f - u) * C;
    I ? (B = -B, B > 0 ? (E = u - B, B = 0) : -B + u > f && (E = f + B)) : B < 0 ? (E = u + B, B = 0) : B + u > f && (E = f - B), e.isHorizontal() ? (L.style.transform = `translate3d(${B}px, 0, 0)`, L.style.width = `${E}px`) : (L.style.transform = `translate3d(0px, ${B}px, 0)`, L.style.height = `${E}px`), q.hide && (clearTimeout(o), W.style.opacity = 1, o = setTimeout(() => {
      W.style.opacity = 0, W.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function p(R) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${R}ms`);
  }
  function d() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: R
    } = e, {
      dragEl: I,
      el: L
    } = R;
    I.style.width = "", I.style.height = "", f = e.isHorizontal() ? L.offsetWidth : L.offsetHeight, m = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? u = f * m : u = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? I.style.width = `${u}px` : I.style.height = `${u}px`, m >= 1 ? L.style.display = "none" : L.style.display = "", e.params.scrollbar.hide && (L.style.opacity = 0), e.params.watchOverflow && e.enabled && R.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function v(R) {
    return e.isHorizontal() ? R.clientX : R.clientY;
  }
  function b(R) {
    const {
      scrollbar: I,
      rtlTranslate: L
    } = e, {
      el: W
    } = I;
    let q;
    q = (v(R) - Sa(W)[e.isHorizontal() ? "left" : "top"] - (c !== null ? c : u / 2)) / (f - u), q = Math.max(Math.min(q, 1), 0), L && (q = 1 - q);
    const C = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * q;
    e.updateProgress(C), e.setTranslate(C), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function g(R) {
    const I = e.params.scrollbar, {
      scrollbar: L,
      wrapperEl: W
    } = e, {
      el: q,
      dragEl: C
    } = L;
    s = !0, c = R.target === C ? v(R) - R.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, R.preventDefault(), R.stopPropagation(), W.style.transitionDuration = "100ms", C.style.transitionDuration = "100ms", b(R), clearTimeout(l), q.style.transitionDuration = "0ms", I.hide && (q.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), i("scrollbarDragStart", R);
  }
  function y(R) {
    const {
      scrollbar: I,
      wrapperEl: L
    } = e, {
      el: W,
      dragEl: q
    } = I;
    s && (R.preventDefault && R.cancelable ? R.preventDefault() : R.returnValue = !1, b(R), L.style.transitionDuration = "0ms", W.style.transitionDuration = "0ms", q.style.transitionDuration = "0ms", i("scrollbarDragMove", R));
  }
  function w(R) {
    const I = e.params.scrollbar, {
      scrollbar: L,
      wrapperEl: W
    } = e, {
      el: q
    } = L;
    s && (s = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", W.style.transitionDuration = ""), I.hide && (clearTimeout(l), l = Sr(() => {
      q.style.opacity = 0, q.style.transitionDuration = "400ms";
    }, 1e3)), i("scrollbarDragEnd", R), I.snapOnRelease && e.slideToClosest());
  }
  function P(R) {
    const {
      scrollbar: I,
      params: L
    } = e, W = I.el;
    if (!W) return;
    const q = W, C = L.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, E = L.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!q) return;
    const B = R === "on" ? "addEventListener" : "removeEventListener";
    q[B]("pointerdown", g, C), a[B]("pointermove", y, C), a[B]("pointerup", w, E);
  }
  function T() {
    !e.params.scrollbar.el || !e.scrollbar.el || P("on");
  }
  function A() {
    !e.params.scrollbar.el || !e.scrollbar.el || P("off");
  }
  function j() {
    const {
      scrollbar: R,
      el: I
    } = e;
    e.params.scrollbar = tl(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const L = e.params.scrollbar;
    if (!L.el) return;
    let W;
    if (typeof L.el == "string" && e.isElement && (W = e.el.querySelector(L.el)), !W && typeof L.el == "string") {
      if (W = a.querySelectorAll(L.el), !W.length) return;
    } else W || (W = L.el);
    e.params.uniqueNavElements && typeof L.el == "string" && W.length > 1 && I.querySelectorAll(L.el).length === 1 && (W = I.querySelector(L.el)), W.length > 0 && (W = W[0]), W.classList.add(e.isHorizontal() ? L.horizontalClass : L.verticalClass);
    let q;
    W && (q = W.querySelector(Ht(e.params.scrollbar.dragClass)), q || (q = ut("div", e.params.scrollbar.dragClass), W.append(q))), Object.assign(R, {
      el: W,
      dragEl: q
    }), L.draggable && T(), W && W.classList[e.enabled ? "remove" : "add"](...Jt(e.params.scrollbar.lockClass));
  }
  function O() {
    const R = e.params.scrollbar, I = e.scrollbar.el;
    I && I.classList.remove(...Jt(e.isHorizontal() ? R.horizontalClass : R.verticalClass)), A();
  }
  n("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const R = e.params.scrollbar;
    let {
      el: I
    } = e.scrollbar;
    I = pe(I), I.forEach((L) => {
      L.classList.remove(R.horizontalClass, R.verticalClass), L.classList.add(e.isHorizontal() ? R.horizontalClass : R.verticalClass);
    });
  }), n("init", () => {
    e.params.scrollbar.enabled === !1 ? z() : (j(), d(), h());
  }), n("update resize observerUpdate lock unlock changeDirection", () => {
    d();
  }), n("setTranslate", () => {
    h();
  }), n("setTransition", (R, I) => {
    p(I);
  }), n("enable disable", () => {
    const {
      el: R
    } = e.scrollbar;
    R && R.classList[e.enabled ? "remove" : "add"](...Jt(e.params.scrollbar.lockClass));
  }), n("destroy", () => {
    O();
  });
  const M = () => {
    e.el.classList.remove(...Jt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...Jt(e.params.scrollbar.scrollbarDisabledClass)), j(), d(), h();
  }, z = () => {
    e.el.classList.add(...Jt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...Jt(e.params.scrollbar.scrollbarDisabledClass)), O();
  };
  Object.assign(e.scrollbar, {
    enable: M,
    disable: z,
    updateSize: d,
    setTranslate: h,
    init: j,
    destroy: O
  });
}
function by(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    parallax: {
      enabled: !1
    }
  });
  const i = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", a = (l, c) => {
    const {
      rtl: u
    } = e, f = u ? -1 : 1, m = l.getAttribute("data-swiper-parallax") || "0";
    let h = l.getAttribute("data-swiper-parallax-x"), p = l.getAttribute("data-swiper-parallax-y");
    const d = l.getAttribute("data-swiper-parallax-scale"), v = l.getAttribute("data-swiper-parallax-opacity"), b = l.getAttribute("data-swiper-parallax-rotate");
    if (h || p ? (h = h || "0", p = p || "0") : e.isHorizontal() ? (h = m, p = "0") : (p = m, h = "0"), h.indexOf("%") >= 0 ? h = `${parseInt(h, 10) * c * f}%` : h = `${h * c * f}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * c}%` : p = `${p * c}px`, typeof v < "u" && v !== null) {
      const y = v - (v - 1) * (1 - Math.abs(c));
      l.style.opacity = y;
    }
    let g = `translate3d(${h}, ${p}, 0px)`;
    if (typeof d < "u" && d !== null) {
      const y = d - (d - 1) * (1 - Math.abs(c));
      g += ` scale(${y})`;
    }
    if (b && typeof b < "u" && b !== null) {
      const y = b * c * -1;
      g += ` rotate(${y}deg)`;
    }
    l.style.transform = g;
  }, s = () => {
    const {
      el: l,
      slides: c,
      progress: u,
      snapGrid: f,
      isElement: m
    } = e, h = Ze(l, i);
    e.isElement && h.push(...Ze(e.hostEl, i)), h.forEach((p) => {
      a(p, u);
    }), c.forEach((p, d) => {
      let v = p.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (v += Math.ceil(d / 2) - u * (f.length - 1)), v = Math.min(Math.max(v, -1), 1), p.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach((b) => {
        a(b, v);
      });
    });
  }, o = function(l) {
    l === void 0 && (l = e.params.speed);
    const {
      el: c,
      hostEl: u
    } = e, f = [...c.querySelectorAll(i)];
    e.isElement && f.push(...u.querySelectorAll(i)), f.forEach((m) => {
      let h = parseInt(m.getAttribute("data-swiper-parallax-duration"), 10) || l;
      l === 0 && (h = 0), m.style.transitionDuration = `${h}ms`;
    });
  };
  n("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), n("init", () => {
    e.params.parallax.enabled && s();
  }), n("setTranslate", () => {
    e.params.parallax.enabled && s();
  }), n("setTransition", (l, c) => {
    e.params.parallax.enabled && o(c);
  });
}
function yy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i
  } = t;
  const a = Me();
  r({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let s = 1, o = !1, l = !1, c = {
    x: 0,
    y: 0
  };
  const u = -3;
  let f, m;
  const h = [], p = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, d = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, v = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let b = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return b;
    },
    set(G) {
      if (b !== G) {
        const Z = p.imageEl, Y = p.slideEl;
        i("zoomChange", G, Z, Y);
      }
      b = G;
    }
  });
  function g() {
    if (h.length < 2) return 1;
    const G = h[0].pageX, Z = h[0].pageY, Y = h[1].pageX, te = h[1].pageY;
    return Math.sqrt((Y - G) ** 2 + (te - Z) ** 2);
  }
  function y() {
    const G = e.params.zoom, Z = p.imageWrapEl.getAttribute("data-swiper-zoom") || G.maxRatio;
    if (G.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
      const Y = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
      return Math.min(Y, Z);
    }
    return Z;
  }
  function w() {
    if (h.length < 2) return {
      x: null,
      y: null
    };
    const G = p.imageEl.getBoundingClientRect();
    return [(h[0].pageX + (h[1].pageX - h[0].pageX) / 2 - G.x - a.scrollX) / s, (h[0].pageY + (h[1].pageY - h[0].pageY) / 2 - G.y - a.scrollY) / s];
  }
  function P() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function T(G) {
    const Z = P();
    return !!(G.target.matches(Z) || e.slides.filter((Y) => Y.contains(G.target)).length > 0);
  }
  function A(G) {
    const Z = `.${e.params.zoom.containerClass}`;
    return !!(G.target.matches(Z) || [...e.hostEl.querySelectorAll(Z)].filter((Y) => Y.contains(G.target)).length > 0);
  }
  function j(G) {
    if (G.pointerType === "mouse" && h.splice(0, h.length), !T(G)) return;
    const Z = e.params.zoom;
    if (f = !1, m = !1, h.push(G), !(h.length < 2)) {
      if (f = !0, p.scaleStart = g(), !p.slideEl) {
        p.slideEl = G.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
        let Y = p.slideEl.querySelector(`.${Z.containerClass}`);
        if (Y && (Y = Y.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Y, Y ? p.imageWrapEl = br(p.imageEl, `.${Z.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
          p.imageEl = void 0;
          return;
        }
        p.maxRatio = y();
      }
      if (p.imageEl) {
        const [Y, te] = w();
        p.originX = Y, p.originY = te, p.imageEl.style.transitionDuration = "0ms";
      }
      o = !0;
    }
  }
  function O(G) {
    if (!T(G)) return;
    const Z = e.params.zoom, Y = e.zoom, te = h.findIndex((ue) => ue.pointerId === G.pointerId);
    te >= 0 && (h[te] = G), !(h.length < 2) && (m = !0, p.scaleMove = g(), p.imageEl && (Y.scale = p.scaleMove / p.scaleStart * s, Y.scale > p.maxRatio && (Y.scale = p.maxRatio - 1 + (Y.scale - p.maxRatio + 1) ** 0.5), Y.scale < Z.minRatio && (Y.scale = Z.minRatio + 1 - (Z.minRatio - Y.scale + 1) ** 0.5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${Y.scale})`));
  }
  function M(G) {
    if (!T(G) || G.pointerType === "mouse" && G.type === "pointerout") return;
    const Z = e.params.zoom, Y = e.zoom, te = h.findIndex((ue) => ue.pointerId === G.pointerId);
    te >= 0 && h.splice(te, 1), !(!f || !m) && (f = !1, m = !1, p.imageEl && (Y.scale = Math.max(Math.min(Y.scale, p.maxRatio), Z.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${Y.scale})`, s = Y.scale, o = !1, Y.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${Z.zoomedSlideClass}`) : Y.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${Z.zoomedSlideClass}`), Y.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
  }
  let z;
  function R() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function I() {
    clearTimeout(z), e.touchEventsData.preventTouchMoveFromPointerMove = !0, z = setTimeout(() => {
      e.destroyed || R();
    });
  }
  function L(G) {
    const Z = e.device;
    if (!p.imageEl || d.isTouched) return;
    Z.android && G.cancelable && G.preventDefault(), d.isTouched = !0;
    const Y = h.length > 0 ? h[0] : G;
    d.touchesStart.x = Y.pageX, d.touchesStart.y = Y.pageY;
  }
  function W(G) {
    const Y = G.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!T(G) || !A(G))
      return;
    const te = e.zoom;
    if (!p.imageEl)
      return;
    if (!d.isTouched || !p.slideEl) {
      Y && E(G);
      return;
    }
    if (Y) {
      E(G);
      return;
    }
    d.isMoved || (d.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, d.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, d.startX = _s(p.imageWrapEl, "x") || 0, d.startY = _s(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
    const ue = d.width * te.scale, je = d.height * te.scale;
    if (d.minX = Math.min(p.slideWidth / 2 - ue / 2, 0), d.maxX = -d.minX, d.minY = Math.min(p.slideHeight / 2 - je / 2, 0), d.maxY = -d.minY, d.touchesCurrent.x = h.length > 0 ? h[0].pageX : G.pageX, d.touchesCurrent.y = h.length > 0 ? h[0].pageY : G.pageY, Math.max(Math.abs(d.touchesCurrent.x - d.touchesStart.x), Math.abs(d.touchesCurrent.y - d.touchesStart.y)) > 5 && (e.allowClick = !1), !d.isMoved && !o) {
      if (e.isHorizontal() && (Math.floor(d.minX) === Math.floor(d.startX) && d.touchesCurrent.x < d.touchesStart.x || Math.floor(d.maxX) === Math.floor(d.startX) && d.touchesCurrent.x > d.touchesStart.x)) {
        d.isTouched = !1, R();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(d.minY) === Math.floor(d.startY) && d.touchesCurrent.y < d.touchesStart.y || Math.floor(d.maxY) === Math.floor(d.startY) && d.touchesCurrent.y > d.touchesStart.y)) {
        d.isTouched = !1, R();
        return;
      }
    }
    G.cancelable && G.preventDefault(), G.stopPropagation(), I(), d.isMoved = !0;
    const $e = (te.scale - s) / (p.maxRatio - e.params.zoom.minRatio), {
      originX: Ot,
      originY: Ne
    } = p;
    d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX + $e * (d.width - Ot * 2), d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY + $e * (d.height - Ne * 2), d.currentX < d.minX && (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** 0.8), d.currentX > d.maxX && (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** 0.8), d.currentY < d.minY && (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** 0.8), d.currentY > d.maxY && (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** 0.8), v.prevPositionX || (v.prevPositionX = d.touchesCurrent.x), v.prevPositionY || (v.prevPositionY = d.touchesCurrent.y), v.prevTime || (v.prevTime = Date.now()), v.x = (d.touchesCurrent.x - v.prevPositionX) / (Date.now() - v.prevTime) / 2, v.y = (d.touchesCurrent.y - v.prevPositionY) / (Date.now() - v.prevTime) / 2, Math.abs(d.touchesCurrent.x - v.prevPositionX) < 2 && (v.x = 0), Math.abs(d.touchesCurrent.y - v.prevPositionY) < 2 && (v.y = 0), v.prevPositionX = d.touchesCurrent.x, v.prevPositionY = d.touchesCurrent.y, v.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function q() {
    const G = e.zoom;
    if (h.length = 0, !p.imageEl) return;
    if (!d.isTouched || !d.isMoved) {
      d.isTouched = !1, d.isMoved = !1;
      return;
    }
    d.isTouched = !1, d.isMoved = !1;
    let Z = 300, Y = 300;
    const te = v.x * Z, ue = d.currentX + te, je = v.y * Y, ze = d.currentY + je;
    v.x !== 0 && (Z = Math.abs((ue - d.currentX) / v.x)), v.y !== 0 && (Y = Math.abs((ze - d.currentY) / v.y));
    const $e = Math.max(Z, Y);
    d.currentX = ue, d.currentY = ze;
    const Ot = d.width * G.scale, Ne = d.height * G.scale;
    d.minX = Math.min(p.slideWidth / 2 - Ot / 2, 0), d.maxX = -d.minX, d.minY = Math.min(p.slideHeight / 2 - Ne / 2, 0), d.maxY = -d.minY, d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX), d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY), p.imageWrapEl.style.transitionDuration = `${$e}ms`, p.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function C() {
    const G = e.zoom;
    p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), G.scale = 1, s = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
  }
  function E(G) {
    if (s <= 1 || !p.imageWrapEl || !T(G) || !A(G)) return;
    const Z = a.getComputedStyle(p.imageWrapEl).transform, Y = new a.DOMMatrix(Z);
    if (!l) {
      l = !0, c.x = G.clientX, c.y = G.clientY, d.startX = Y.e, d.startY = Y.f, d.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, d.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
      return;
    }
    const te = (G.clientX - c.x) * u, ue = (G.clientY - c.y) * u, je = d.width * s, ze = d.height * s, $e = p.slideWidth, Ot = p.slideHeight, Ne = Math.min($e / 2 - je / 2, 0), Xe = -Ne, lr = Math.min(Ot / 2 - ze / 2, 0), Ii = -lr, Or = Math.max(Math.min(d.startX + te, Xe), Ne), Tr = Math.max(Math.min(d.startY + ue, Ii), lr);
    p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${Or}px, ${Tr}px, 0)`, c.x = G.clientX, c.y = G.clientY, d.startX = Or, d.startY = Tr, d.currentX = Or, d.currentY = Tr;
  }
  function B(G) {
    const Z = e.zoom, Y = e.params.zoom;
    if (!p.slideEl) {
      G && G.target && (p.slideEl = G.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ze(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
      let rn = p.slideEl.querySelector(`.${Y.containerClass}`);
      rn && (rn = rn.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = rn, rn ? p.imageWrapEl = br(p.imageEl, `.${Y.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    if (!p.imageEl || !p.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${Y.zoomedSlideClass}`);
    let te, ue, je, ze, $e, Ot, Ne, Xe, lr, Ii, Or, Tr, Li, Ri, Ya, qa, Qa, Ja;
    typeof d.touchesStart.x > "u" && G ? (te = G.pageX, ue = G.pageY) : (te = d.touchesStart.x, ue = d.touchesStart.y);
    const Ka = s, jr = typeof G == "number" ? G : null;
    s === 1 && jr && (te = void 0, ue = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0);
    const Tl = y();
    Z.scale = jr || Tl, s = jr || Tl, G && !(s === 1 && jr) ? (Qa = p.slideEl.offsetWidth, Ja = p.slideEl.offsetHeight, je = Sa(p.slideEl).left + a.scrollX, ze = Sa(p.slideEl).top + a.scrollY, $e = je + Qa / 2 - te, Ot = ze + Ja / 2 - ue, lr = p.imageEl.offsetWidth || p.imageEl.clientWidth, Ii = p.imageEl.offsetHeight || p.imageEl.clientHeight, Or = lr * Z.scale, Tr = Ii * Z.scale, Li = Math.min(Qa / 2 - Or / 2, 0), Ri = Math.min(Ja / 2 - Tr / 2, 0), Ya = -Li, qa = -Ri, Ka > 0 && jr && typeof d.currentX == "number" && typeof d.currentY == "number" ? (Ne = d.currentX * Z.scale / Ka, Xe = d.currentY * Z.scale / Ka) : (Ne = $e * Z.scale, Xe = Ot * Z.scale), Ne < Li && (Ne = Li), Ne > Ya && (Ne = Ya), Xe < Ri && (Xe = Ri), Xe > qa && (Xe = qa)) : (Ne = 0, Xe = 0), jr && Z.scale === 1 && (p.originX = 0, p.originY = 0), d.currentX = Ne, d.currentY = Xe, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${Ne}px, ${Xe}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${Z.scale})`;
  }
  function Q() {
    const G = e.zoom, Z = e.params.zoom;
    if (!p.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ze(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
      let Y = p.slideEl.querySelector(`.${Z.containerClass}`);
      Y && (Y = Y.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Y, Y ? p.imageWrapEl = br(p.imageEl, `.${Z.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    !p.imageEl || !p.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), G.scale = 1, s = 1, d.currentX = void 0, d.currentY = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${Z.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (c = {
      x: 0,
      y: 0
    }, l && (l = !1, d.startX = 0, d.startY = 0)));
  }
  function $(G) {
    const Z = e.zoom;
    Z.scale && Z.scale !== 1 ? Q() : B(G);
  }
  function ne() {
    const G = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, Z = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: G,
      activeListenerWithCapture: Z
    };
  }
  function ce() {
    const G = e.zoom;
    if (G.enabled) return;
    G.enabled = !0;
    const {
      passiveListener: Z,
      activeListenerWithCapture: Y
    } = ne();
    e.wrapperEl.addEventListener("pointerdown", j, Z), e.wrapperEl.addEventListener("pointermove", O, Y), ["pointerup", "pointercancel", "pointerout"].forEach((te) => {
      e.wrapperEl.addEventListener(te, M, Z);
    }), e.wrapperEl.addEventListener("pointermove", W, Y);
  }
  function ge() {
    const G = e.zoom;
    if (!G.enabled) return;
    G.enabled = !1;
    const {
      passiveListener: Z,
      activeListenerWithCapture: Y
    } = ne();
    e.wrapperEl.removeEventListener("pointerdown", j, Z), e.wrapperEl.removeEventListener("pointermove", O, Y), ["pointerup", "pointercancel", "pointerout"].forEach((te) => {
      e.wrapperEl.removeEventListener(te, M, Z);
    }), e.wrapperEl.removeEventListener("pointermove", W, Y);
  }
  n("init", () => {
    e.params.zoom.enabled && ce();
  }), n("destroy", () => {
    ge();
  }), n("touchStart", (G, Z) => {
    e.zoom.enabled && L(Z);
  }), n("touchEnd", (G, Z) => {
    e.zoom.enabled && q();
  }), n("doubleTap", (G, Z) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && $(Z);
  }), n("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && C();
  }), n("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && C();
  }), Object.assign(e.zoom, {
    enable: ce,
    disable: ge,
    in: B,
    out: Q,
    toggle: $
  });
}
function wy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function i(c, u) {
    const f = /* @__PURE__ */ function() {
      let d, v, b;
      return (g, y) => {
        for (v = -1, d = g.length; d - v > 1; )
          b = d + v >> 1, g[b] <= y ? v = b : d = b;
        return d;
      };
    }();
    this.x = c, this.y = u, this.lastIndex = c.length - 1;
    let m, h;
    return this.interpolate = function(d) {
      return d ? (h = f(this.x, d), m = h - 1, (d - this.x[m]) * (this.y[h] - this.y[m]) / (this.x[h] - this.x[m]) + this.y[m]) : 0;
    }, this;
  }
  function a(c) {
    e.controller.spline = e.params.loop ? new i(e.slidesGrid, c.slidesGrid) : new i(e.snapGrid, c.snapGrid);
  }
  function s(c, u) {
    const f = e.controller.control;
    let m, h;
    const p = e.constructor;
    function d(v) {
      if (v.destroyed) return;
      const b = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (a(v), h = -e.controller.spline.interpolate(-b)), (!h || e.params.controller.by === "container") && (m = (v.maxTranslate() - v.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(m) || !Number.isFinite(m)) && (m = 1), h = (b - e.minTranslate()) * m + v.minTranslate()), e.params.controller.inverse && (h = v.maxTranslate() - h), v.updateProgress(h), v.setTranslate(h, e), v.updateActiveIndex(), v.updateSlidesClasses();
    }
    if (Array.isArray(f))
      for (let v = 0; v < f.length; v += 1)
        f[v] !== u && f[v] instanceof p && d(f[v]);
    else f instanceof p && u !== f && d(f);
  }
  function o(c, u) {
    const f = e.constructor, m = e.controller.control;
    let h;
    function p(d) {
      d.destroyed || (d.setTransition(c, e), c !== 0 && (d.transitionStart(), d.params.autoHeight && Sr(() => {
        d.updateAutoHeight();
      }), xn(d.wrapperEl, () => {
        m && d.transitionEnd();
      })));
    }
    if (Array.isArray(m))
      for (h = 0; h < m.length; h += 1)
        m[h] !== u && m[h] instanceof f && p(m[h]);
    else m instanceof f && u !== m && p(m);
  }
  function l() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  n("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((u) => {
        if (e.controller.control || (e.controller.control = []), u && u.swiper)
          e.controller.control.push(u.swiper);
        else if (u) {
          const f = `${e.params.eventsPrefix}init`, m = (h) => {
            e.controller.control.push(h.detail[0]), e.update(), u.removeEventListener(f, m);
          };
          u.addEventListener(f, m);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), n("update", () => {
    l();
  }), n("resize", () => {
    l();
  }), n("observerUpdate", () => {
    l();
  }), n("setTranslate", (c, u, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(u, f);
  }), n("setTransition", (c, u, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(u, f);
  }), Object.assign(e.controller, {
    setTranslate: s,
    setTransition: o
  });
}
function Sy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let i = null, a, s, o = (/* @__PURE__ */ new Date()).getTime();
  function l(C) {
    const E = i;
    E.length !== 0 && (E.innerHTML = "", E.innerHTML = C);
  }
  function c(C) {
    const E = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(C).replace(/x/g, E);
  }
  function u(C) {
    C = pe(C), C.forEach((E) => {
      E.setAttribute("tabIndex", "0");
    });
  }
  function f(C) {
    C = pe(C), C.forEach((E) => {
      E.setAttribute("tabIndex", "-1");
    });
  }
  function m(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("role", E);
    });
  }
  function h(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("aria-roledescription", E);
    });
  }
  function p(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("aria-controls", E);
    });
  }
  function d(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("aria-label", E);
    });
  }
  function v(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("id", E);
    });
  }
  function b(C, E) {
    C = pe(C), C.forEach((B) => {
      B.setAttribute("aria-live", E);
    });
  }
  function g(C) {
    C = pe(C), C.forEach((E) => {
      E.setAttribute("aria-disabled", !0);
    });
  }
  function y(C) {
    C = pe(C), C.forEach((E) => {
      E.setAttribute("aria-disabled", !1);
    });
  }
  function w(C) {
    if (C.keyCode !== 13 && C.keyCode !== 32) return;
    const E = e.params.a11y, B = C.target;
    if (!(e.pagination && e.pagination.el && (B === e.pagination.el || e.pagination.el.contains(C.target)) && !C.target.matches(Ht(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const Q = pe(e.navigation.prevEl);
        pe(e.navigation.nextEl).includes(B) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? l(E.lastSlideMessage) : l(E.nextSlideMessage)), Q.includes(B) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? l(E.firstSlideMessage) : l(E.prevSlideMessage));
      }
      e.pagination && B.matches(Ht(e.params.pagination.bulletClass)) && B.click();
    }
  }
  function P() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: C,
      prevEl: E
    } = e.navigation;
    E && (e.isBeginning ? (g(E), f(E)) : (y(E), u(E))), C && (e.isEnd ? (g(C), f(C)) : (y(C), u(C)));
  }
  function T() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function A() {
    return T() && e.params.pagination.clickable;
  }
  function j() {
    const C = e.params.a11y;
    T() && e.pagination.bullets.forEach((E) => {
      e.params.pagination.clickable && (u(E), e.params.pagination.renderBullet || (m(E, "button"), d(E, C.paginationBulletMessage.replace(/\{\{index\}\}/, In(E) + 1)))), E.matches(Ht(e.params.pagination.bulletActiveClass)) ? E.setAttribute("aria-current", "true") : E.removeAttribute("aria-current");
    });
  }
  const O = (C, E, B) => {
    u(C), C.tagName !== "BUTTON" && (m(C, "button"), C.addEventListener("keydown", w)), d(C, B), p(C, E);
  }, M = (C) => {
    s && s !== C.target && !s.contains(C.target) && (a = !0), e.a11y.clicked = !0;
  }, z = () => {
    a = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, R = (C) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, I = (C) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - o < 100) return;
    const E = C.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!E || !e.slides.includes(E)) return;
    s = E;
    const B = e.slides.indexOf(E) === e.activeIndex, Q = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(E);
    B || Q || C.sourceCapabilities && C.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      a || (e.params.loop ? e.slideToLoop(parseInt(E.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(E), 0), a = !1);
    }));
  }, L = () => {
    const C = e.params.a11y;
    C.itemRoleDescriptionMessage && h(e.slides, C.itemRoleDescriptionMessage), C.slideRole && m(e.slides, C.slideRole);
    const E = e.slides.length;
    C.slideLabelMessage && e.slides.forEach((B, Q) => {
      const $ = e.params.loop ? parseInt(B.getAttribute("data-swiper-slide-index"), 10) : Q, ne = C.slideLabelMessage.replace(/\{\{index\}\}/, $ + 1).replace(/\{\{slidesLength\}\}/, E);
      d(B, ne);
    });
  }, W = () => {
    const C = e.params.a11y;
    e.el.append(i);
    const E = e.el;
    C.containerRoleDescriptionMessage && h(E, C.containerRoleDescriptionMessage), C.containerMessage && d(E, C.containerMessage), C.containerRole && m(E, C.containerRole);
    const B = e.wrapperEl, Q = C.id || B.getAttribute("id") || `swiper-wrapper-${c(16)}`, $ = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    v(B, Q), b(B, $), L();
    let {
      nextEl: ne,
      prevEl: ce
    } = e.navigation ? e.navigation : {};
    ne = pe(ne), ce = pe(ce), ne && ne.forEach((G) => O(G, Q, C.nextSlideMessage)), ce && ce.forEach((G) => O(G, Q, C.prevSlideMessage)), A() && pe(e.pagination.el).forEach((Z) => {
      Z.addEventListener("keydown", w);
    }), Fe().addEventListener("visibilitychange", R), e.el.addEventListener("focus", I, !0), e.el.addEventListener("focus", I, !0), e.el.addEventListener("pointerdown", M, !0), e.el.addEventListener("pointerup", z, !0);
  };
  function q() {
    i && i.remove();
    let {
      nextEl: C,
      prevEl: E
    } = e.navigation ? e.navigation : {};
    C = pe(C), E = pe(E), C && C.forEach((Q) => Q.removeEventListener("keydown", w)), E && E.forEach((Q) => Q.removeEventListener("keydown", w)), A() && pe(e.pagination.el).forEach(($) => {
      $.removeEventListener("keydown", w);
    }), Fe().removeEventListener("visibilitychange", R), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", I, !0), e.el.removeEventListener("pointerdown", M, !0), e.el.removeEventListener("pointerup", z, !0));
  }
  n("beforeInit", () => {
    i = ut("span", e.params.a11y.notificationClass), i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true");
  }), n("afterInit", () => {
    e.params.a11y.enabled && W();
  }), n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && L();
  }), n("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && P();
  }), n("paginationUpdate", () => {
    e.params.a11y.enabled && j();
  }), n("destroy", () => {
    e.params.a11y.enabled && q();
  });
}
function xy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let i = !1, a = {};
  const s = (h) => h.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), o = (h) => {
    const p = Me();
    let d;
    h ? d = new URL(h) : d = p.location;
    const v = d.pathname.slice(1).split("/").filter((w) => w !== ""), b = v.length, g = v[b - 2], y = v[b - 1];
    return {
      key: g,
      value: y
    };
  }, l = (h, p) => {
    const d = Me();
    if (!i || !e.params.history.enabled) return;
    let v;
    e.params.url ? v = new URL(e.params.url) : v = d.location;
    const b = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : e.slides[p];
    let g = s(b.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let w = e.params.history.root;
      w[w.length - 1] === "/" && (w = w.slice(0, w.length - 1)), g = `${w}/${h ? `${h}/` : ""}${g}`;
    } else v.pathname.includes(h) || (g = `${h ? `${h}/` : ""}${g}`);
    e.params.history.keepQuery && (g += v.search);
    const y = d.history.state;
    y && y.value === g || (e.params.history.replaceState ? d.history.replaceState({
      value: g
    }, null, g) : d.history.pushState({
      value: g
    }, null, g));
  }, c = (h, p, d) => {
    if (p)
      for (let v = 0, b = e.slides.length; v < b; v += 1) {
        const g = e.slides[v];
        if (s(g.getAttribute("data-history")) === p) {
          const w = e.getSlideIndex(g);
          e.slideTo(w, h, d);
        }
      }
    else
      e.slideTo(0, h, d);
  }, u = () => {
    a = o(e.params.url), c(e.params.speed, a.value, !1);
  }, f = () => {
    const h = Me();
    if (e.params.history) {
      if (!h.history || !h.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (i = !0, a = o(e.params.url), !a.key && !a.value) {
        e.params.history.replaceState || h.addEventListener("popstate", u);
        return;
      }
      c(0, a.value, e.params.runCallbacksOnInit), e.params.history.replaceState || h.addEventListener("popstate", u);
    }
  }, m = () => {
    const h = Me();
    e.params.history.replaceState || h.removeEventListener("popstate", u);
  };
  n("init", () => {
    e.params.history.enabled && f();
  }), n("destroy", () => {
    e.params.history.enabled && m();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    i && l(e.params.history.key, e.activeIndex);
  }), n("slideChange", () => {
    i && e.params.cssMode && l(e.params.history.key, e.activeIndex);
  });
}
function Py(t) {
  let {
    swiper: e,
    extendParams: r,
    emit: n,
    on: i
  } = t, a = !1;
  const s = Fe(), o = Me();
  r({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(m, h) {
        if (e.virtual && e.params.virtual.enabled) {
          const p = e.slides.find((v) => v.getAttribute("data-hash") === h);
          return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(Ze(e.slidesEl, `.${e.params.slideClass}[data-hash="${h}"], swiper-slide[data-hash="${h}"]`)[0]);
      }
    }
  });
  const l = () => {
    n("hashChange");
    const m = s.location.hash.replace("#", ""), h = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = h ? h.getAttribute("data-hash") : "";
    if (m !== p) {
      const d = e.params.hashNavigation.getSlideIndex(e, m);
      if (typeof d > "u" || Number.isNaN(d)) return;
      e.slideTo(d);
    }
  }, c = () => {
    if (!a || !e.params.hashNavigation.enabled) return;
    const m = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], h = m ? m.getAttribute("data-hash") || m.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && o.history && o.history.replaceState ? (o.history.replaceState(null, null, `#${h}` || ""), n("hashSet")) : (s.location.hash = h || "", n("hashSet"));
  }, u = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    a = !0;
    const m = s.location.hash.replace("#", "");
    if (m) {
      const p = e.params.hashNavigation.getSlideIndex(e, m);
      e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && o.addEventListener("hashchange", l);
  }, f = () => {
    e.params.hashNavigation.watchState && o.removeEventListener("hashchange", l);
  };
  i("init", () => {
    e.params.hashNavigation.enabled && u();
  }), i("destroy", () => {
    e.params.hashNavigation.enabled && f();
  }), i("transitionEnd _freeModeNoMomentumRelease", () => {
    a && c();
  }), i("slideChange", () => {
    a && e.params.cssMode && c();
  });
}
function Ay(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: i,
    params: a
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s, o, l = a && a.autoplay ? a.autoplay.delay : 3e3, c = a && a.autoplay ? a.autoplay.delay : 3e3, u, f = (/* @__PURE__ */ new Date()).getTime(), m, h, p, d, v, b, g;
  function y(E) {
    !e || e.destroyed || !e.wrapperEl || E.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", y), !(g || E.detail && E.detail.bySwiperTouchMove) && M());
  }
  const w = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? m = !0 : m && (c = u, m = !1);
    const E = e.autoplay.paused ? u : f + c - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = E, i("autoplayTimeLeft", E, E / l), o = requestAnimationFrame(() => {
      w();
    });
  }, P = () => {
    let E;
    return e.virtual && e.params.virtual.enabled ? E = e.slides.find((Q) => Q.classList.contains("swiper-slide-active")) : E = e.slides[e.activeIndex], E ? parseInt(E.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, T = (E) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(o), w();
    let B = typeof E > "u" ? e.params.autoplay.delay : E;
    l = e.params.autoplay.delay, c = e.params.autoplay.delay;
    const Q = P();
    !Number.isNaN(Q) && Q > 0 && typeof E > "u" && (B = Q, l = Q, c = Q), u = B;
    const $ = e.params.speed, ne = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev($, !0, !0), i("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, $, !0, !0), i("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext($, !0, !0), i("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, $, !0, !0), i("autoplay")), e.params.cssMode && (f = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        T();
      })));
    };
    return B > 0 ? (clearTimeout(s), s = setTimeout(() => {
      ne();
    }, B)) : requestAnimationFrame(() => {
      ne();
    }), B;
  }, A = () => {
    f = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, T(), i("autoplayStart");
  }, j = () => {
    e.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(o), i("autoplayStop");
  }, O = (E, B) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(s), E || (b = !0);
    const Q = () => {
      i("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", y) : M();
    };
    if (e.autoplay.paused = !0, B) {
      v && (u = e.params.autoplay.delay), v = !1, Q();
      return;
    }
    u = (u || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - f), !(e.isEnd && u < 0 && !e.params.loop) && (u < 0 && (u = 0), Q());
  }, M = () => {
    e.isEnd && u < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (f = (/* @__PURE__ */ new Date()).getTime(), b ? (b = !1, T(u)) : T(), e.autoplay.paused = !1, i("autoplayResume"));
  }, z = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const E = Fe();
    E.visibilityState === "hidden" && (b = !0, O(!0)), E.visibilityState === "visible" && M();
  }, R = (E) => {
    E.pointerType === "mouse" && (b = !0, g = !0, !(e.animating || e.autoplay.paused) && O(!0));
  }, I = (E) => {
    E.pointerType === "mouse" && (g = !1, e.autoplay.paused && M());
  }, L = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", R), e.el.addEventListener("pointerleave", I));
  }, W = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", R), e.el.removeEventListener("pointerleave", I));
  }, q = () => {
    Fe().addEventListener("visibilitychange", z);
  }, C = () => {
    Fe().removeEventListener("visibilitychange", z);
  };
  n("init", () => {
    e.params.autoplay.enabled && (L(), q(), A());
  }), n("destroy", () => {
    W(), C(), e.autoplay.running && j();
  }), n("_freeModeStaticRelease", () => {
    (p || b) && M();
  }), n("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? j() : O(!0, !0);
  }), n("beforeTransitionStart", (E, B, Q) => {
    e.destroyed || !e.autoplay.running || (Q || !e.params.autoplay.disableOnInteraction ? O(!0, !0) : j());
  }), n("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        j();
        return;
      }
      h = !0, p = !1, b = !1, d = setTimeout(() => {
        b = !0, p = !0, O(!0);
      }, 200);
    }
  }), n("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !h)) {
      if (clearTimeout(d), clearTimeout(s), e.params.autoplay.disableOnInteraction) {
        p = !1, h = !1;
        return;
      }
      p && e.params.cssMode && M(), p = !1, h = !1;
    }
  }), n("slideChange", () => {
    e.destroyed || !e.autoplay.running || (v = !0);
  }), Object.assign(e.autoplay, {
    start: A,
    stop: j,
    pause: O,
    resume: M
  });
}
function Oy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let i = !1, a = !1;
  e.thumbs = {
    swiper: null
  };
  function s() {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const u = c.clickedIndex, f = c.clickedSlide;
    if (f && f.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null) return;
    let m;
    c.params.loop ? m = parseInt(c.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : m = u, e.params.loop ? e.slideToLoop(m) : e.slideTo(m);
  }
  function o() {
    const {
      thumbs: c
    } = e.params;
    if (i) return !1;
    i = !0;
    const u = e.constructor;
    if (c.swiper instanceof u) {
      if (c.swiper.destroyed)
        return i = !1, !1;
      e.thumbs.swiper = c.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    } else if (fn(c.swiper)) {
      const f = Object.assign({}, c.swiper);
      Object.assign(f, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new u(f), a = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0;
  }
  function l(c) {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed) return;
    const f = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let m = 1;
    const h = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (m = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (m = 1), m = Math.floor(m), u.slides.forEach((v) => v.classList.remove(h)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let v = 0; v < m; v += 1)
        Ze(u.slidesEl, `[data-swiper-slide-index="${e.realIndex + v}"]`).forEach((b) => {
          b.classList.add(h);
        });
    else
      for (let v = 0; v < m; v += 1)
        u.slides[e.realIndex + v] && u.slides[e.realIndex + v].classList.add(h);
    const p = e.params.thumbs.autoScrollOffset, d = p && !u.params.loop;
    if (e.realIndex !== u.realIndex || d) {
      const v = u.activeIndex;
      let b, g;
      if (u.params.loop) {
        const y = u.slides.find((w) => w.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
        b = u.slides.indexOf(y), g = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        b = e.realIndex, g = b > e.previousIndex ? "next" : "prev";
      d && (b += g === "next" ? p : -1 * p), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(b) < 0 && (u.params.centeredSlides ? b > v ? b = b - Math.floor(f / 2) + 1 : b = b + Math.floor(f / 2) - 1 : b > v && u.params.slidesPerGroup, u.slideTo(b, c ? 0 : void 0));
    }
  }
  n("beforeInit", () => {
    const {
      thumbs: c
    } = e.params;
    if (!(!c || !c.swiper))
      if (typeof c.swiper == "string" || c.swiper instanceof HTMLElement) {
        const u = Fe(), f = () => {
          const h = typeof c.swiper == "string" ? u.querySelector(c.swiper) : c.swiper;
          if (h && h.swiper)
            c.swiper = h.swiper, o(), l(!0);
          else if (h) {
            const p = `${e.params.eventsPrefix}init`, d = (v) => {
              c.swiper = v.detail[0], h.removeEventListener(p, d), o(), l(!0), c.swiper.update(), e.update();
            };
            h.addEventListener(p, d);
          }
          return h;
        }, m = () => {
          if (e.destroyed) return;
          f() || requestAnimationFrame(m);
        };
        requestAnimationFrame(m);
      } else
        o(), l(!0);
  }), n("slideChange update resize observerUpdate", () => {
    l();
  }), n("setTransition", (c, u) => {
    const f = e.thumbs.swiper;
    !f || f.destroyed || f.setTransition(u);
  }), n("beforeDestroy", () => {
    const c = e.thumbs.swiper;
    !c || c.destroyed || a && c.destroy();
  }), Object.assign(e.thumbs, {
    init: o,
    update: l
  });
}
function Ty(t) {
  let {
    swiper: e,
    extendParams: r,
    emit: n,
    once: i
  } = t;
  r({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function a() {
    if (e.params.cssMode) return;
    const l = e.getTranslate();
    e.setTranslate(l), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function s() {
    if (e.params.cssMode) return;
    const {
      touchEventsData: l,
      touches: c
    } = e;
    l.velocities.length === 0 && l.velocities.push({
      position: c[e.isHorizontal() ? "startX" : "startY"],
      time: l.touchStartTime
    }), l.velocities.push({
      position: c[e.isHorizontal() ? "currentX" : "currentY"],
      time: vt()
    });
  }
  function o(l) {
    let {
      currentPos: c
    } = l;
    if (e.params.cssMode) return;
    const {
      params: u,
      wrapperEl: f,
      rtlTranslate: m,
      snapGrid: h,
      touchEventsData: p
    } = e, v = vt() - p.touchStartTime;
    if (c < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (c > -e.maxTranslate()) {
      e.slides.length < h.length ? e.slideTo(h.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (u.freeMode.momentum) {
      if (p.velocities.length > 1) {
        const j = p.velocities.pop(), O = p.velocities.pop(), M = j.position - O.position, z = j.time - O.time;
        e.velocity = M / z, e.velocity /= 2, Math.abs(e.velocity) < u.freeMode.minimumVelocity && (e.velocity = 0), (z > 150 || vt() - j.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= u.freeMode.momentumVelocityRatio, p.velocities.length = 0;
      let b = 1e3 * u.freeMode.momentumRatio;
      const g = e.velocity * b;
      let y = e.translate + g;
      m && (y = -y);
      let w = !1, P;
      const T = Math.abs(e.velocity) * 20 * u.freeMode.momentumBounceRatio;
      let A;
      if (y < e.maxTranslate())
        u.freeMode.momentumBounce ? (y + e.maxTranslate() < -T && (y = e.maxTranslate() - T), P = e.maxTranslate(), w = !0, p.allowMomentumBounce = !0) : y = e.maxTranslate(), u.loop && u.centeredSlides && (A = !0);
      else if (y > e.minTranslate())
        u.freeMode.momentumBounce ? (y - e.minTranslate() > T && (y = e.minTranslate() + T), P = e.minTranslate(), w = !0, p.allowMomentumBounce = !0) : y = e.minTranslate(), u.loop && u.centeredSlides && (A = !0);
      else if (u.freeMode.sticky) {
        let j;
        for (let O = 0; O < h.length; O += 1)
          if (h[O] > -y) {
            j = O;
            break;
          }
        Math.abs(h[j] - y) < Math.abs(h[j - 1] - y) || e.swipeDirection === "next" ? y = h[j] : y = h[j - 1], y = -y;
      }
      if (A && i("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (m ? b = Math.abs((-y - e.translate) / e.velocity) : b = Math.abs((y - e.translate) / e.velocity), u.freeMode.sticky) {
          const j = Math.abs((m ? -y : y) - e.translate), O = e.slidesSizesGrid[e.activeIndex];
          j < O ? b = u.speed : j < 2 * O ? b = u.speed * 1.5 : b = u.speed * 2.5;
        }
      } else if (u.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      u.freeMode.momentumBounce && w ? (e.updateProgress(P), e.setTransition(b), e.setTranslate(y), e.transitionStart(!0, e.swipeDirection), e.animating = !0, xn(f, () => {
        !e || e.destroyed || !p.allowMomentumBounce || (n("momentumBounce"), e.setTransition(u.speed), setTimeout(() => {
          e.setTranslate(P), xn(f, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (n("_freeModeNoMomentumRelease"), e.updateProgress(y), e.setTransition(b), e.setTranslate(y), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, xn(f, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(y), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (u.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else u.freeMode && n("_freeModeNoMomentumRelease");
    (!u.freeMode.momentum || v >= u.longSwipesMs) && (n("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: a,
      onTouchMove: s,
      onTouchEnd: o
    }
  });
}
function jy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let i, a, s, o;
  const l = () => {
    let d = e.params.spaceBetween;
    return typeof d == "string" && d.indexOf("%") >= 0 ? d = parseFloat(d.replace("%", "")) / 100 * e.size : typeof d == "string" && (d = parseFloat(d)), d;
  }, c = (d) => {
    const {
      slidesPerView: v
    } = e.params, {
      rows: b,
      fill: g
    } = e.params.grid, y = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : d.length;
    s = Math.floor(y / b), Math.floor(y / b) === y / b ? i = y : i = Math.ceil(y / b) * b, v !== "auto" && g === "row" && (i = Math.max(i, v * b)), a = i / b;
  }, u = () => {
    e.slides && e.slides.forEach((d) => {
      d.swiperSlideGridSet && (d.style.height = "", d.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, f = (d, v, b) => {
    const {
      slidesPerGroup: g
    } = e.params, y = l(), {
      rows: w,
      fill: P
    } = e.params.grid, T = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : b.length;
    let A, j, O;
    if (P === "row" && g > 1) {
      const M = Math.floor(d / (g * w)), z = d - w * g * M, R = M === 0 ? g : Math.min(Math.ceil((T - M * w * g) / w), g);
      O = Math.floor(z / R), j = z - O * R + M * g, A = j + O * i / w, v.style.order = A;
    } else P === "column" ? (j = Math.floor(d / w), O = d - j * w, (j > s || j === s && O === w - 1) && (O += 1, O >= w && (O = 0, j += 1))) : (O = Math.floor(d / a), j = d - O * a);
    v.row = O, v.column = j, v.style.height = `calc((100% - ${(w - 1) * y}px) / ${w})`, v.style[e.getDirectionLabel("margin-top")] = O !== 0 ? y && `${y}px` : "", v.swiperSlideGridSet = !0;
  }, m = (d, v) => {
    const {
      centeredSlides: b,
      roundLengths: g
    } = e.params, y = l(), {
      rows: w
    } = e.params.grid;
    if (e.virtualSize = (d + y) * i, e.virtualSize = Math.ceil(e.virtualSize / w) - y, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + y}px`), b) {
      const P = [];
      for (let T = 0; T < v.length; T += 1) {
        let A = v[T];
        g && (A = Math.floor(A)), v[T] < e.virtualSize + v[0] && P.push(A);
      }
      v.splice(0, v.length), v.push(...P);
    }
  }, h = () => {
    o = e.params.grid && e.params.grid.rows > 1;
  }, p = () => {
    const {
      params: d,
      el: v
    } = e, b = d.grid && d.grid.rows > 1;
    o && !b ? (v.classList.remove(`${d.containerModifierClass}grid`, `${d.containerModifierClass}grid-column`), s = 1, e.emitContainerClasses()) : !o && b && (v.classList.add(`${d.containerModifierClass}grid`), d.grid.fill === "column" && v.classList.add(`${d.containerModifierClass}grid-column`), e.emitContainerClasses()), o = b;
  };
  n("init", h), n("update", p), e.grid = {
    initSlides: c,
    unsetSlides: u,
    updateSlide: f,
    updateWrapperSize: m
  };
}
function ky(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  r.loop && e.loopDestroy();
  const i = (a) => {
    if (typeof a == "string") {
      const s = document.createElement("div");
      s.innerHTML = a, n.append(s.children[0]), s.innerHTML = "";
    } else
      n.append(a);
  };
  if (typeof t == "object" && "length" in t)
    for (let a = 0; a < t.length; a += 1)
      t[a] && i(t[a]);
  else
    i(t);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update();
}
function My(t) {
  const e = this, {
    params: r,
    activeIndex: n,
    slidesEl: i
  } = e;
  r.loop && e.loopDestroy();
  let a = n + 1;
  const s = (o) => {
    if (typeof o == "string") {
      const l = document.createElement("div");
      l.innerHTML = o, i.prepend(l.children[0]), l.innerHTML = "";
    } else
      i.prepend(o);
  };
  if (typeof t == "object" && "length" in t) {
    for (let o = 0; o < t.length; o += 1)
      t[o] && s(t[o]);
    a = n + t.length;
  } else
    s(t);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), e.slideTo(a, 0, !1);
}
function zy(t, e) {
  const r = this, {
    params: n,
    activeIndex: i,
    slidesEl: a
  } = r;
  let s = i;
  n.loop && (s -= r.loopedSlides, r.loopDestroy(), r.recalcSlides());
  const o = r.slides.length;
  if (t <= 0) {
    r.prependSlide(e);
    return;
  }
  if (t >= o) {
    r.appendSlide(e);
    return;
  }
  let l = s > t ? s + 1 : s;
  const c = [];
  for (let u = o - 1; u >= t; u -= 1) {
    const f = r.slides[u];
    f.remove(), c.unshift(f);
  }
  if (typeof e == "object" && "length" in e) {
    for (let u = 0; u < e.length; u += 1)
      e[u] && a.append(e[u]);
    l = s > t ? s + e.length : s;
  } else
    a.append(e);
  for (let u = 0; u < c.length; u += 1)
    a.append(c[u]);
  r.recalcSlides(), n.loop && r.loopCreate(), (!n.observer || r.isElement) && r.update(), n.loop ? r.slideTo(l + r.loopedSlides, 0, !1) : r.slideTo(l, 0, !1);
}
function Ey(t) {
  const e = this, {
    params: r,
    activeIndex: n
  } = e;
  let i = n;
  r.loop && (i -= e.loopedSlides, e.loopDestroy());
  let a = i, s;
  if (typeof t == "object" && "length" in t) {
    for (let o = 0; o < t.length; o += 1)
      s = t[o], e.slides[s] && e.slides[s].remove(), s < a && (a -= 1);
    a = Math.max(a, 0);
  } else
    s = t, e.slides[s] && e.slides[s].remove(), s < a && (a -= 1), a = Math.max(a, 0);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), r.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1);
}
function Cy() {
  const t = this, e = [];
  for (let r = 0; r < t.slides.length; r += 1)
    e.push(r);
  t.removeSlide(e);
}
function Iy(t) {
  let {
    swiper: e
  } = t;
  Object.assign(e, {
    appendSlide: ky.bind(e),
    prependSlide: My.bind(e),
    addSlide: zy.bind(e),
    removeSlide: Ey.bind(e),
    removeAllSlides: Cy.bind(e)
  });
}
function $r(t) {
  const {
    effect: e,
    swiper: r,
    on: n,
    setTranslate: i,
    setTransition: a,
    overwriteParams: s,
    perspective: o,
    recreateShadows: l,
    getEffectParams: c
  } = t;
  n("beforeInit", () => {
    if (r.params.effect !== e) return;
    r.classNames.push(`${r.params.containerModifierClass}${e}`), o && o() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const f = s ? s() : {};
    Object.assign(r.params, f), Object.assign(r.originalParams, f);
  }), n("setTranslate", () => {
    r.params.effect === e && i();
  }), n("setTransition", (f, m) => {
    r.params.effect === e && a(m);
  }), n("transitionEnd", () => {
    if (r.params.effect === e && l) {
      if (!c || !c().slideShadows) return;
      r.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((m) => m.remove());
      }), l();
    }
  });
  let u;
  n("virtualUpdate", () => {
    r.params.effect === e && (r.slides.length || (u = !0), requestAnimationFrame(() => {
      u && r.slides && r.slides.length && (i(), u = !1);
    }));
  });
}
function zi(t, e) {
  const r = xr(e);
  return r !== e && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function Da(t) {
  let {
    swiper: e,
    duration: r,
    transformElements: n,
    allSlides: i
  } = t;
  const {
    activeIndex: a
  } = e, s = (o) => o.parentElement ? o.parentElement : e.slides.find((c) => c.shadowRoot && c.shadowRoot === o.parentNode);
  if (e.params.virtualTranslate && r !== 0) {
    let o = !1, l;
    i ? l = n : l = n.filter((c) => {
      const u = c.classList.contains("swiper-slide-transform") ? s(c) : c;
      return e.getSlideIndex(u) === a;
    }), l.forEach((c) => {
      xn(c, () => {
        if (o || !e || e.destroyed) return;
        o = !0, e.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function Ly(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    fadeEffect: {
      crossFade: !1
    }
  }), $r({
    effect: "fade",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: s
      } = e, o = e.params.fadeEffect;
      for (let l = 0; l < s.length; l += 1) {
        const c = e.slides[l];
        let f = -c.swiperSlideOffset;
        e.params.virtualTranslate || (f -= e.translate);
        let m = 0;
        e.isHorizontal() || (m = f, f = 0);
        const h = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0), p = zi(o, c);
        p.style.opacity = h, p.style.transform = `translate3d(${f}px, ${m}px, 0px)`;
      }
    },
    setTransition: (s) => {
      const o = e.slides.map((l) => xr(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${s}ms`;
      }), Da({
        swiper: e,
        duration: s,
        transformElements: o,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Ry(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const i = (l, c, u) => {
    let f = u ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), m = u ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    f || (f = ut("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "left" : "top"}`.split(" ")), l.append(f)), m || (m = ut("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "right" : "bottom"}`.split(" ")), l.append(m)), f && (f.style.opacity = Math.max(-c, 0)), m && (m.style.opacity = Math.max(c, 0));
  };
  $r({
    effect: "cube",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        el: l,
        wrapperEl: c,
        slides: u,
        width: f,
        height: m,
        rtlTranslate: h,
        size: p,
        browser: d
      } = e, v = Na(e), b = e.params.cubeEffect, g = e.isHorizontal(), y = e.virtual && e.params.virtual.enabled;
      let w = 0, P;
      b.shadow && (g ? (P = e.wrapperEl.querySelector(".swiper-cube-shadow"), P || (P = ut("div", "swiper-cube-shadow"), e.wrapperEl.append(P)), P.style.height = `${f}px`) : (P = l.querySelector(".swiper-cube-shadow"), P || (P = ut("div", "swiper-cube-shadow"), l.append(P))));
      for (let A = 0; A < u.length; A += 1) {
        const j = u[A];
        let O = A;
        y && (O = parseInt(j.getAttribute("data-swiper-slide-index"), 10));
        let M = O * 90, z = Math.floor(M / 360);
        h && (M = -M, z = Math.floor(-M / 360));
        const R = Math.max(Math.min(j.progress, 1), -1);
        let I = 0, L = 0, W = 0;
        O % 4 === 0 ? (I = -z * 4 * p, W = 0) : (O - 1) % 4 === 0 ? (I = 0, W = -z * 4 * p) : (O - 2) % 4 === 0 ? (I = p + z * 4 * p, W = p) : (O - 3) % 4 === 0 && (I = -p, W = 3 * p + p * 4 * z), h && (I = -I), g || (L = I, I = 0);
        const q = `rotateX(${v(g ? 0 : -M)}deg) rotateY(${v(g ? M : 0)}deg) translate3d(${I}px, ${L}px, ${W}px)`;
        R <= 1 && R > -1 && (w = O * 90 + R * 90, h && (w = -O * 90 - R * 90)), j.style.transform = q, b.slideShadows && i(j, R, g);
      }
      if (c.style.transformOrigin = `50% 50% -${p / 2}px`, c.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, b.shadow)
        if (g)
          P.style.transform = `translate3d(0px, ${f / 2 + b.shadowOffset}px, ${-f / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${b.shadowScale})`;
        else {
          const A = Math.abs(w) - Math.floor(Math.abs(w) / 90) * 90, j = 1.5 - (Math.sin(A * 2 * Math.PI / 360) / 2 + Math.cos(A * 2 * Math.PI / 360) / 2), O = b.shadowScale, M = b.shadowScale / j, z = b.shadowOffset;
          P.style.transform = `scale3d(${O}, 1, ${M}) translate3d(0px, ${m / 2 + z}px, ${-m / 2 / M}px) rotateX(-89.99deg)`;
        }
      const T = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -p / 2 : 0;
      c.style.transform = `translate3d(0px,0,${T}px) rotateX(${v(e.isHorizontal() ? 0 : w)}deg) rotateY(${v(e.isHorizontal() ? -w : 0)}deg)`, c.style.setProperty("--swiper-cube-translate-z", `${T}px`);
    },
    setTransition: (l) => {
      const {
        el: c,
        slides: u
      } = e;
      if (u.forEach((f) => {
        f.style.transitionDuration = `${l}ms`, f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((m) => {
          m.style.transitionDuration = `${l}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const f = c.querySelector(".swiper-cube-shadow");
        f && (f.style.transitionDuration = `${l}ms`);
      }
    },
    recreateShadows: () => {
      const l = e.isHorizontal();
      e.slides.forEach((c) => {
        const u = Math.max(Math.min(c.progress, 1), -1);
        i(c, u, l);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function Zr(t, e, r) {
  const n = `swiper-slide-shadow${r ? `-${r}` : ""}${t ? ` swiper-slide-shadow-${t}` : ""}`, i = xr(e);
  let a = i.querySelector(`.${n.split(" ").join(".")}`);
  return a || (a = ut("div", n.split(" ")), i.append(a)), a;
}
function Ny(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const i = (l, c) => {
    let u = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), f = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    u || (u = Zr("flip", l, e.isHorizontal() ? "left" : "top")), f || (f = Zr("flip", l, e.isHorizontal() ? "right" : "bottom")), u && (u.style.opacity = Math.max(-c, 0)), f && (f.style.opacity = Math.max(c, 0));
  };
  $r({
    effect: "flip",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: l,
        rtlTranslate: c
      } = e, u = e.params.flipEffect, f = Na(e);
      for (let m = 0; m < l.length; m += 1) {
        const h = l[m];
        let p = h.progress;
        e.params.flipEffect.limitRotation && (p = Math.max(Math.min(h.progress, 1), -1));
        const d = h.swiperSlideOffset;
        let b = -180 * p, g = 0, y = e.params.cssMode ? -d - e.translate : -d, w = 0;
        e.isHorizontal() ? c && (b = -b) : (w = y, y = 0, g = -b, b = 0), h.style.zIndex = -Math.abs(Math.round(p)) + l.length, u.slideShadows && i(h, p);
        const P = `translate3d(${y}px, ${w}px, 0px) rotateX(${f(g)}deg) rotateY(${f(b)}deg)`, T = zi(u, h);
        T.style.transform = P;
      }
    },
    setTransition: (l) => {
      const c = e.slides.map((u) => xr(u));
      c.forEach((u) => {
        u.style.transitionDuration = `${l}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => {
          f.style.transitionDuration = `${l}ms`;
        });
      }), Da({
        swiper: e,
        duration: l,
        transformElements: c
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((l) => {
        let c = l.progress;
        e.params.flipEffect.limitRotation && (c = Math.max(Math.min(l.progress, 1), -1)), i(l, c);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Dy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), $r({
    effect: "coverflow",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        width: s,
        height: o,
        slides: l,
        slidesSizesGrid: c
      } = e, u = e.params.coverflowEffect, f = e.isHorizontal(), m = e.translate, h = f ? -m + s / 2 : -m + o / 2, p = f ? u.rotate : -u.rotate, d = u.depth, v = Na(e);
      for (let b = 0, g = l.length; b < g; b += 1) {
        const y = l[b], w = c[b], P = y.swiperSlideOffset, T = (h - P - w / 2) / w, A = typeof u.modifier == "function" ? u.modifier(T) : T * u.modifier;
        let j = f ? p * A : 0, O = f ? 0 : p * A, M = -d * Math.abs(A), z = u.stretch;
        typeof z == "string" && z.indexOf("%") !== -1 && (z = parseFloat(u.stretch) / 100 * w);
        let R = f ? 0 : z * A, I = f ? z * A : 0, L = 1 - (1 - u.scale) * Math.abs(A);
        Math.abs(I) < 1e-3 && (I = 0), Math.abs(R) < 1e-3 && (R = 0), Math.abs(M) < 1e-3 && (M = 0), Math.abs(j) < 1e-3 && (j = 0), Math.abs(O) < 1e-3 && (O = 0), Math.abs(L) < 1e-3 && (L = 0);
        const W = `translate3d(${I}px,${R}px,${M}px)  rotateX(${v(O)}deg) rotateY(${v(j)}deg) scale(${L})`, q = zi(u, y);
        if (q.style.transform = W, y.style.zIndex = -Math.abs(Math.round(A)) + 1, u.slideShadows) {
          let C = f ? y.querySelector(".swiper-slide-shadow-left") : y.querySelector(".swiper-slide-shadow-top"), E = f ? y.querySelector(".swiper-slide-shadow-right") : y.querySelector(".swiper-slide-shadow-bottom");
          C || (C = Zr("coverflow", y, f ? "left" : "top")), E || (E = Zr("coverflow", y, f ? "right" : "bottom")), C && (C.style.opacity = A > 0 ? A : 0), E && (E.style.opacity = -A > 0 ? -A : 0);
        }
      }
    },
    setTransition: (s) => {
      e.slides.map((l) => xr(l)).forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function Hy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const i = (o) => typeof o == "string" ? o : `${o}px`;
  $r({
    effect: "creative",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: o,
        wrapperEl: l,
        slidesSizesGrid: c
      } = e, u = e.params.creativeEffect, {
        progressMultiplier: f
      } = u, m = e.params.centeredSlides, h = Na(e);
      if (m) {
        const p = c[0] / 2 - e.params.slidesOffsetBefore || 0;
        l.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < o.length; p += 1) {
        const d = o[p], v = d.progress, b = Math.min(Math.max(d.progress, -u.limitProgress), u.limitProgress);
        let g = b;
        m || (g = Math.min(Math.max(d.originalProgress, -u.limitProgress), u.limitProgress));
        const y = d.swiperSlideOffset, w = [e.params.cssMode ? -y - e.translate : -y, 0, 0], P = [0, 0, 0];
        let T = !1;
        e.isHorizontal() || (w[1] = w[0], w[0] = 0);
        let A = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        b < 0 ? (A = u.next, T = !0) : b > 0 && (A = u.prev, T = !0), w.forEach((L, W) => {
          w[W] = `calc(${L}px + (${i(A.translate[W])} * ${Math.abs(b * f)}))`;
        }), P.forEach((L, W) => {
          let q = A.rotate[W] * Math.abs(b * f);
          P[W] = q;
        }), d.style.zIndex = -Math.abs(Math.round(v)) + o.length;
        const j = w.join(", "), O = `rotateX(${h(P[0])}deg) rotateY(${h(P[1])}deg) rotateZ(${h(P[2])}deg)`, M = g < 0 ? `scale(${1 + (1 - A.scale) * g * f})` : `scale(${1 - (1 - A.scale) * g * f})`, z = g < 0 ? 1 + (1 - A.opacity) * g * f : 1 - (1 - A.opacity) * g * f, R = `translate3d(${j}) ${O} ${M}`;
        if (T && A.shadow || !T) {
          let L = d.querySelector(".swiper-slide-shadow");
          if (!L && A.shadow && (L = Zr("creative", d)), L) {
            const W = u.shadowPerProgress ? b * (1 / u.limitProgress) : b;
            L.style.opacity = Math.min(Math.max(Math.abs(W), 0), 1);
          }
        }
        const I = zi(u, d);
        I.style.transform = R, I.style.opacity = z, A.origin && (I.style.transformOrigin = A.origin);
      }
    },
    setTransition: (o) => {
      const l = e.slides.map((c) => xr(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${o}ms`;
        });
      }), Da({
        swiper: e,
        duration: o,
        transformElements: l,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Wy(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), $r({
    effect: "cards",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: s,
        activeIndex: o,
        rtlTranslate: l
      } = e, c = e.params.cardsEffect, {
        startTranslate: u,
        isTouched: f
      } = e.touchEventsData, m = l ? -e.translate : e.translate;
      for (let h = 0; h < s.length; h += 1) {
        const p = s[h], d = p.progress, v = Math.min(Math.max(d, -4), 4);
        let b = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (b -= s[0].swiperSlideOffset);
        let g = e.params.cssMode ? -b - e.translate : -b, y = 0;
        const w = -100 * Math.abs(v);
        let P = 1, T = -c.perSlideRotate * v, A = c.perSlideOffset - Math.abs(v) * 0.75;
        const j = e.virtual && e.params.virtual.enabled ? e.virtual.from + h : h, O = (j === o || j === o - 1) && v > 0 && v < 1 && (f || e.params.cssMode) && m < u, M = (j === o || j === o + 1) && v < 0 && v > -1 && (f || e.params.cssMode) && m > u;
        if (O || M) {
          const L = (1 - Math.abs((Math.abs(v) - 0.5) / 0.5)) ** 0.5;
          T += -28 * v * L, P += -0.5 * L, A += 96 * L, y = `${-25 * L * Math.abs(v)}%`;
        }
        if (v < 0 ? g = `calc(${g}px ${l ? "-" : "+"} (${A * Math.abs(v)}%))` : v > 0 ? g = `calc(${g}px ${l ? "-" : "+"} (-${A * Math.abs(v)}%))` : g = `${g}px`, !e.isHorizontal()) {
          const L = y;
          y = g, g = L;
        }
        const z = v < 0 ? `${1 + (1 - P) * v}` : `${1 - (1 - P) * v}`, R = `
        translate3d(${g}, ${y}, ${w}px)
        rotateZ(${c.rotate ? l ? -T : T : 0}deg)
        scale(${z})
      `;
        if (c.slideShadows) {
          let L = p.querySelector(".swiper-slide-shadow");
          L || (L = Zr("cards", p)), L && (L.style.opacity = Math.min(Math.max((Math.abs(v) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(d)) + s.length;
        const I = zi(c, p);
        I.style.transform = R;
      }
    },
    setTransition: (s) => {
      const o = e.slides.map((l) => xr(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      }), Da({
        swiper: e,
        duration: s,
        transformElements: o
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      _loopSwapReset: !1,
      watchSlidesProgress: !0,
      loopAdditionalSlides: 3,
      centeredSlides: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const Fy = [fy, py, my, hy, gy, vy, by, yy, wy, Sy, xy, Py, Ay, Oy, Ty, jy, Iy, Ly, Ry, Ny, Dy, Hy, Wy];
lt.use(Fy);
const Ha = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function Xr(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function ro(t, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : Xr(e[n]) && Xr(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : ro(t[n], e[n]) : t[n] = e[n];
  });
}
function Vy(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function Gy(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function Zy(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function la(t) {
  return t === void 0 && (t = ""), t.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function Xy(t) {
  let {
    swiper: e,
    slides: r,
    passedParams: n,
    changedParams: i,
    nextEl: a,
    prevEl: s,
    scrollbarEl: o,
    paginationEl: l
  } = t;
  const c = i.filter((O) => O !== "children" && O !== "direction" && O !== "wrapperClass"), {
    params: u,
    pagination: f,
    navigation: m,
    scrollbar: h,
    virtual: p,
    thumbs: d
  } = e;
  let v, b, g, y, w, P, T, A;
  i.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && u.thumbs && (!u.thumbs.swiper || u.thumbs.swiper.destroyed) && (v = !0), i.includes("controller") && n.controller && n.controller.control && u.controller && !u.controller.control && (b = !0), i.includes("pagination") && n.pagination && (n.pagination.el || l) && (u.pagination || u.pagination === !1) && f && !f.el && (g = !0), i.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || o) && (u.scrollbar || u.scrollbar === !1) && h && !h.el && (y = !0), i.includes("navigation") && n.navigation && (n.navigation.prevEl || s) && (n.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && m && !m.prevEl && !m.nextEl && (w = !0);
  const j = (O) => {
    e[O] && (e[O].destroy(), O === "navigation" ? (e.isElement && (e[O].prevEl.remove(), e[O].nextEl.remove()), u[O].prevEl = void 0, u[O].nextEl = void 0, e[O].prevEl = void 0, e[O].nextEl = void 0) : (e.isElement && e[O].el.remove(), u[O].el = void 0, e[O].el = void 0));
  };
  i.includes("loop") && e.isElement && (u.loop && !n.loop ? P = !0 : !u.loop && n.loop ? T = !0 : A = !0), c.forEach((O) => {
    if (Xr(u[O]) && Xr(n[O]))
      Object.assign(u[O], n[O]), (O === "navigation" || O === "pagination" || O === "scrollbar") && "enabled" in n[O] && !n[O].enabled && j(O);
    else {
      const M = n[O];
      (M === !0 || M === !1) && (O === "navigation" || O === "pagination" || O === "scrollbar") ? M === !1 && j(O) : u[O] = n[O];
    }
  }), c.includes("controller") && !b && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), i.includes("children") && r && p && u.virtual.enabled ? (p.slides = r, p.update(!0)) : i.includes("virtual") && p && u.virtual.enabled && (r && (p.slides = r), p.update(!0)), i.includes("children") && r && u.loop && (A = !0), v && d.init() && d.update(!0), b && (e.controller.control = u.controller.control), g && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), e.el.appendChild(l)), l && (u.pagination.el = l), f.init(), f.render(), f.update()), y && (e.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), e.el.appendChild(o)), o && (u.scrollbar.el = o), h.init(), h.updateSize(), h.setTranslate()), w && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = e.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), e.el.appendChild(s))), a && (u.navigation.nextEl = a), s && (u.navigation.prevEl = s), m.init(), m.update()), i.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), i.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), i.includes("direction") && e.changeDirection(n.direction, !1), (P || A) && e.loopDestroy(), (T || A) && e.loopCreate(), e.update();
}
const mc = (t) => {
  if (parseFloat(t) === Number(t)) return Number(t);
  if (t === "true" || t === "") return !0;
  if (t === "false") return !1;
  if (t === "null") return null;
  if (t !== "undefined") {
    if (typeof t == "string" && t.includes("{") && t.includes("}") && t.includes('"')) {
      let e;
      try {
        e = JSON.parse(t);
      } catch {
        e = t;
      }
      return e;
    }
    return t;
  }
}, hc = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function gc(t, e, r) {
  const n = {}, i = {};
  ro(n, to);
  const a = [...Ha, "on"], s = a.map((l) => l.replace(/_/, ""));
  a.forEach((l) => {
    l = l.replace("_", ""), typeof t[l] < "u" && (i[l] = t[l]);
  });
  const o = [...t.attributes];
  return typeof e == "string" && typeof r < "u" && o.push({
    name: e,
    value: Xr(r) ? {
      ...r
    } : r
  }), o.forEach((l) => {
    const c = hc.find((u) => l.name.startsWith(`${u}-`));
    if (c) {
      const u = la(c), f = la(l.name.split(`${c}-`)[1]);
      typeof i[u] > "u" && (i[u] = {}), i[u] === !0 && (i[u] = {
        enabled: !0
      }), i[u][f] = mc(l.value);
    } else {
      const u = la(l.name);
      if (!s.includes(u)) return;
      const f = mc(l.value);
      i[u] && hc.includes(l.name) && !Xr(f) ? (i[u].constructor !== Object && (i[u] = {}), i[u].enabled = !!f) : i[u] = f;
    }
  }), ro(n, i), n.navigation ? n.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...n.navigation !== !0 ? n.navigation : {}
  } : n.navigation === !1 && delete n.navigation, n.scrollbar ? n.scrollbar = {
    el: ".swiper-scrollbar",
    ...n.scrollbar !== !0 ? n.scrollbar : {}
  } : n.scrollbar === !1 && delete n.scrollbar, n.pagination ? n.pagination = {
    el: ".swiper-pagination",
    ...n.pagination !== !0 ? n.pagination : {}
  } : n.pagination === !1 && delete n.pagination, {
    params: n,
    passedParams: i
  };
}
const By = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", Uy = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class Yy {
}
const Gf = typeof window > "u" || typeof HTMLElement > "u" ? Yy : HTMLElement, vc = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, Zf = (t, e) => {
  if (typeof CSSStyleSheet < "u" && t.adoptedStyleSheets) {
    const r = new CSSStyleSheet();
    r.replaceSync(e), t.adoptedStyleSheets = [r];
  } else {
    const r = document.createElement("style");
    r.rel = "stylesheet", r.textContent = e, t.appendChild(r);
  }
};
class Xf extends Gf {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return vc;
  }
  static get prevButtonSvg() {
    return vc.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      By,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, r = [...this.querySelectorAll("[slot^=slide-]")].map((n) => parseInt(n.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = r.length ? Math.max(...r) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let n = e; n < this.slideSlots; n += 1) {
          const i = document.createElement("swiper-slide");
          i.setAttribute("part", `slide slide-${n + 1}`);
          const a = document.createElement("slot");
          a.setAttribute("name", `slide-${n + 1}`), i.appendChild(a), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(i);
        }
      else if (this.slideSlots < e) {
        const n = this.swiper.slides;
        for (let i = n.length - 1; i >= 0; i -= 1)
          i > this.slideSlots && n[i].remove();
      }
    }
  }
  render() {
    if (this.rendered) return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && Zf(this.shadowRoot, e), this.cssLinks().forEach((n) => {
      if (this.shadowRoot.querySelector(`link[href="${n}"]`)) return;
      const a = document.createElement("link");
      a.rel = "stylesheet", a.href = n, this.shadowRoot.appendChild(a);
    });
    const r = document.createElement("div");
    r.classList.add("swiper"), r.part = "container", r.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((n, i) => `
        <swiper-slide part="slide slide-${i}">
          <slot name="slide-${i}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${Vy(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${Gy(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${Zy(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(r), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.swiper && this.swiper.initialized) return;
    const {
      params: r,
      passedParams: n
    } = gc(this);
    this.swiperParams = r, this.passedParams = n, delete this.swiperParams.init, this.render(), this.swiper = new lt(this.shadowRoot.querySelector(".swiper"), {
      ...r.virtual ? {} : {
        observer: !0
      },
      ...r,
      touchEventsTarget: "container",
      onAny: function(i) {
        i === "observerUpdate" && e.calcSlideSlots();
        const a = r.eventsPrefix ? `${r.eventsPrefix}${i.toLowerCase()}` : i.toLowerCase();
        for (var s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
          o[l - 1] = arguments[l];
        const c = new CustomEvent(a, {
          detail: o,
          bubbles: i !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(c);
      }
    });
  }
  connectedCallback() {
    this.swiper && this.swiper.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.swiper && this.swiper.destroy && this.swiper.destroy();
  }
  updateSwiperOnPropChange(e, r) {
    const {
      params: n,
      passedParams: i
    } = gc(this, e, r);
    this.passedParams = i, this.swiperParams = n, !(this.swiper && this.swiper.params[e] === r) && Xy({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [la(e)],
      ...e === "navigation" && i[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && i[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && i[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, r, n) {
    this.swiper && this.swiper.initialized && (r === "true" && n === null && (n = !1), this.updateSwiperOnPropChange(e, n));
  }
  static get observedAttributes() {
    return Ha.filter((r) => r.includes("_")).map((r) => r.replace(/[A-Z]/g, (n) => `-${n}`).replace("_", "").toLowerCase());
  }
}
Ha.forEach((t) => {
  t !== "init" && (t = t.replace("_", ""), Object.defineProperty(Xf.prototype, t, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[t];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[t] = e, this.swiper && this.swiper.initialized && this.updateSwiperOnPropChange(t, e);
    }
  }));
});
class qy extends Gf {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (Zf(this.shadowRoot, Uy), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const r = document.createElement("div");
      r.classList.add("swiper-lazy-preloader"), r.part.add("preloader"), this.shadowRoot.appendChild(r);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.swiperLoopMoveDOM || this.initialize();
  }
}
const Qy = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", Xf), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", qy));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (t) => {
  Ha.push(...t);
});
const Jy = ["pagination", "navigation"], Ky = /* @__PURE__ */ V({
  __name: "ImageCarousel",
  props: {
    pagination: { type: [Object, Boolean], default: !0 },
    navigation: { type: [Object, Boolean], default: !1 }
  },
  setup(t) {
    const e = t, r = oe(() => e.pagination === !0 ? { clickable: !0 } : e.pagination), n = oe(() => e.navigation === !0 ? { clickable: !0 } : e.navigation);
    return Qy(), (i, a) => (x(), N("swiper-container", {
      class: "rounded-md overflow-hidden",
      pagination: i.pagination ? r.value : !1,
      navigation: i.navigation ? n.value : !1
    }, [
      H(i.$slots, "default", {}, void 0, !0)
    ], 8, Jy));
  }
}), uk = /* @__PURE__ */ se(Ky, [["__scopeId", "data-v-baa0495f"]]), _y = {};
function $y(t, e) {
  return x(), N("swiper-slide", null, [
    H(t.$slots, "default")
  ]);
}
const dk = /* @__PURE__ */ se(_y, [["render", $y]]), e2 = { class: "flex rounded-md border border-blue-400 bg-blue-50 p-4 text-sm text-blue-800" }, t2 = /* @__PURE__ */ V({
  __name: "InfoBox",
  setup(t) {
    return (e, r) => (x(), N("div", e2, [
      U(S(ae), {
        icon: S(X1),
        class: "mr-3 mt-1 text-lg",
        "aria-hidden": "true"
      }, null, 8, ["icon"]),
      k("div", null, [
        H(e.$slots, "default")
      ])
    ]));
  }
}), r2 = { class: "relative rounded-md shadow-sm" }, n2 = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex py-1.5 pr-1.5"
}, i2 = { class: "inline-flex items-center rounded border border-default-200 px-1 font-sans text-xs text-default-400" }, a2 = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby", "type"], s2 = ["disabled", "tabindex", "aria-disabled"], fk = /* @__PURE__ */ V({
  __name: "Input",
  props: /* @__PURE__ */ sr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    keyboardShortcut: { default: void 0 },
    leadingIcon: { default: void 0 },
    trailingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, r = or(t, "modelValue"), n = de(), [i, a] = jn(!1), s = oe(() => e.type === "password"), o = me("field-id", null);
    return (l, c) => (x(), N("div", r2, [
      l.leadingIcon || l.trailingIcon ? (x(), N("div", {
        key: 0,
        class: X([
          "pointer-events-none absolute inset-y-0 flex items-center",
          l.leadingIcon && "left-0 pl-3",
          l.trailingIcon && "right-0 pr-3"
        ])
      }, [
        U(S(ae), {
          icon: l.leadingIcon ?? l.trailingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ], 2)) : J("", !0),
      l.keyboardShortcut ? (x(), N("div", n2, [
        k("kbd", i2, _(l.keyboardShortcut), 1)
      ])) : J("", !0),
      dt(k("input", _e({
        id: S(o) ?? void 0,
        ref_key: "input",
        ref: n,
        "onUpdate:modelValue": c[0] || (c[0] = (u) => r.value = u),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900 ring-1 ring-inset ring-default-300",
          "placeholder:text-default-400",
          "focus:ring-2 focus:ring-inset focus:ring-primary-600",
          "sm:text-sm sm:leading-6",
          l.leadingIcon && "pl-10",
          (l.trailingIcon || l.keyboardShortcut || s.value) && "pr-10",
          l.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ],
        disabled: l.disabled,
        tabindex: l.disabled ? "-1" : 0,
        "aria-disabled": l.disabled,
        "aria-invalid": !!l.invalid,
        "aria-describedby": l.invalid ? `${S(o)}-error` : void 0,
        type: S(i) ? "text" : l.type
      }, l.$attrs), null, 16, a2), [
        [Td, r.value]
      ]),
      s.value && !l.trailingIcon ? (x(), N("button", {
        key: 2,
        class: X([
          "absolute inset-y-0 right-0 flex items-center rounded-md px-3",
          "focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600",
          l.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ]),
        type: "button",
        disabled: l.disabled,
        tabindex: l.disabled ? "-1" : 0,
        "aria-disabled": l.disabled,
        onClick: c[1] || (c[1] = () => S(a)())
      }, [
        U(S(ae), {
          icon: S(zf),
          class: X([S(i) ? "text-neutral-800" : "text-default-400", "size-5 cursor-pointer"]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"]),
        c[2] || (c[2] = k("span", { class: "sr-only" }, " Show password ", -1))
      ], 10, s2)) : J("", !0)
    ]));
  }
});
function o2(t, e, r) {
  if (!t) throw new Error("You need to provide `widgetName` in your data");
  var n = ["ais-" + t];
  return e && n.push("-" + e), r && n.push("--" + r), n.join("");
}
var he = function(t) {
  var e = t.name;
  return { props: { classNames: { type: Object, default: void 0 } }, methods: { suit: function(r, n) {
    var i = o2(e, r, n), a = this.classNames && this.classNames[i];
    return a ? [i, a].join(" ") : i;
  } } };
};
function Ln(t) {
  for (var e = arguments, r = 1; r < arguments.length; r++) {
    var n = e[r] != null ? e[r] : {}, i = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), i.forEach(function(a) {
      l2(t, a, n[a]);
    });
  }
  return t;
}
function l2(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var c2 = !1, u2 = !0;
function rl(t) {
  function e(r, n) {
    for (var i = [], a = arguments.length - 2; a-- > 0; ) i[a] = arguments[a + 2];
    var s = i.length > 0 ? i : void 0;
    if (typeof n == "object" && (n.attrs || n.props || n.scopedSlots || n.on)) {
      var o = Object.keys(n.on || {}), l = Object.assign({}, n, n.attrs, n.props, o.reduce(function(c, u) {
        return c["on" + u[0].toUpperCase() + u.slice(1)] = n.on[u], c;
      }, {}));
      return delete l.attrs, delete l.props, delete l.scopedSlots, o.forEach(function(c) {
        return delete l.on[c];
      }), l.on && Object.keys(l.on).length === 0 && delete l.on, vr(r, l, n.scopedSlots ? Object.assign({ default: function() {
        return s;
      } }, n.scopedSlots) : s);
    }
    return vr(r, n, s);
  }
  return function() {
    return t.call(this, e);
  };
}
function nl(t) {
  var e = t.$slots || t.slots;
  return typeof e.default == "function" ? e.default() : e.default;
}
var bc = /* @__PURE__ */ new Set();
function Fr(t) {
  bc.has(t) || (bc.add(t), console.warn(t));
}
var Se = function(t, e) {
  var r;
  t === void 0 && (t = {});
  var n = t.connector;
  return e === void 0 && (e = {}), (r = { inject: { instantSearchInstance: { from: "$_ais_instantSearchInstance", default: function() {
    var i = this.$options._componentTag;
    throw new TypeError('It looks like you forgot to wrap your Algolia search component "<' + i + '>" inside of an "<ais-instant-search>" component.');
  } }, getParentIndex: { from: "$_ais_getParentIndex", default: function() {
    var i = this;
    return function() {
      return i.instantSearchInstance.mainIndex;
    };
  } } }, data: function() {
    return { state: null };
  }, created: function() {
    if (typeof n == "function") {
      if (this.factory = n(this.updateState, function() {
      }), this.widget = Ln(this.factory(this.widgetParams), e), this.getParentIndex().addWidgets([this.widget]), this.instantSearchInstance._initialResults && !this.instantSearchInstance.started) {
        if (typeof this.instantSearchInstance.__forceRender != "function") throw new Error("You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.");
        this.instantSearchInstance.__forceRender(this.widget, this.getParentIndex());
      }
    } else n !== !0 && Fr(`You are using the InstantSearch widget mixin, but didn't provide a connector.
While this is technically possible, and will give you access to the Helper,
it's not the recommended way of making custom components.

If you want to disable this message, pass { connector: true } to the mixin.

Read more on using connectors: https://alg.li/vue-custom`);
  } }).beforeUnmount = function() {
    this.widget && this.getParentIndex().removeWidgets([this.widget]);
  }, r.watch = { widgetParams: { handler: function(i) {
    this.state = null, this.getParentIndex().removeWidgets([this.widget]), this.widget = Ln(this.factory(i), e), this.getParentIndex().addWidgets([this.widget]);
  }, deep: !0 } }, r.methods = { updateState: function(i, a) {
    i === void 0 && (i = {}), a || (this.state = i);
  } }, r;
}, d2 = 0;
function f2(t) {
  t.dependsOn === "recommend" && (t.$$id = d2++);
}
function yc(t) {
  return t.toString().charAt(0).toUpperCase() + t.toString().slice(1);
}
function fe() {
}
var Bt = function(e, r) {
  return e;
}, us = fe, ie = fe;
process.env.NODE_ENV === "development" && (us = function(e) {
  console.warn("[InstantSearch.js]: ".concat(e.trim()));
}, Bt = function(e, r) {
  var n = !1;
  return function() {
    return n || (n = !0, process.env.NODE_ENV === "development" && us(r)), e.apply(void 0, arguments);
  };
}, ie = function(e, r) {
  if (!e) {
    var n = ie.cache[r];
    n || (ie.cache[r] = !0, process.env.NODE_ENV === "development" && us(r));
  }
}, ie.cache = {});
var p2 = Object.keys;
function m2(t) {
  return v2(t) || g2(t) || Bf(t) || h2();
}
function h2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g2(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function v2(t) {
  if (Array.isArray(t)) return no(t);
}
function nn(t, e) {
  return w2(t) || y2(t, e) || Bf(t, e) || b2();
}
function b2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bf(t, e) {
  if (t) {
    if (typeof t == "string") return no(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return no(t, e);
  }
}
function no(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function y2(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function w2(t) {
  if (Array.isArray(t)) return t;
}
function S2(t) {
  switch (t) {
    case "range":
      return [];
    case "menu":
      return ["menu", "menuSelect"];
    default:
      return [t];
  }
}
var x2 = {
  query: {
    connectors: ["connectSearchBox"],
    widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"]
  },
  refinementList: {
    connectors: ["connectRefinementList"],
    widgets: ["ais.refinementList"]
  },
  menu: {
    connectors: ["connectMenu"],
    widgets: ["ais.menu"]
  },
  hierarchicalMenu: {
    connectors: ["connectHierarchicalMenu"],
    widgets: ["ais.hierarchicalMenu"]
  },
  numericMenu: {
    connectors: ["connectNumericMenu"],
    widgets: ["ais.numericMenu"]
  },
  ratingMenu: {
    connectors: ["connectRatingMenu"],
    widgets: ["ais.ratingMenu"]
  },
  range: {
    connectors: ["connectRange"],
    widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"]
  },
  toggle: {
    connectors: ["connectToggleRefinement"],
    widgets: ["ais.toggleRefinement"]
  },
  geoSearch: {
    connectors: ["connectGeoSearch"],
    widgets: ["ais.geoSearch"]
  },
  sortBy: {
    connectors: ["connectSortBy"],
    widgets: ["ais.sortBy"]
  },
  page: {
    connectors: ["connectPagination"],
    widgets: ["ais.pagination", "ais.infiniteHits"]
  },
  hitsPerPage: {
    connectors: ["connectHitsPerPage"],
    widgets: ["ais.hitsPerPage"]
  },
  configure: {
    connectors: ["connectConfigure"],
    widgets: ["ais.configure"]
  },
  places: {
    connectors: [],
    widgets: ["ais.places"]
  }
};
function Uf(t) {
  var e = t.index, r = t.indexUiState, n = e.getWidgets().map(function(a) {
    return a.$$type;
  }).filter(Boolean), i = p2(r).reduce(function(a, s) {
    var o = x2[s];
    if (!o)
      return a;
    var l = o.widgets;
    return l && !l.some(function(c) {
      return n.includes(c);
    }) && a.push([s, {
      connectors: o.connectors,
      widgets: o.widgets.map(function(c) {
        return c.split("ais.")[1];
      })
    }]), a;
  }, []);
  process.env.NODE_ENV === "development" && ie(i.length === 0, 'The UI state for the index "'.concat(e.getIndexId(), '" is not consistent with the widgets mounted.\n\nThis can happen when the UI state is specified via `initialUiState`, `routing` or `setUiState` but that the widgets responsible for this state were not added. This results in those query parameters not being sent to the API.\n\nTo fully reflect the state, some widgets need to be added to the index "').concat(e.getIndexId(), `":

`).concat(i.map(function(a) {
    var s, o = nn(a, 2), l = o[0], c = o[1].widgets;
    return "- `".concat(l, "` needs one of these widgets: ").concat((s = []).concat.apply(s, m2(c.map(function(u) {
      return S2(u);
    }))).map(function(u) {
      return '"'.concat(u, '"');
    }).join(", "));
  }).join(`
`), `

If you do not wish to display widgets but still want to support their search parameters, you can mount "virtual widgets" that don't render anything:

\`\`\`
`).concat(i.filter(function(a) {
    var s = nn(a, 2);
    s[0];
    var o = s[1].connectors;
    return o.length > 0;
  }).map(function(a) {
    var s = nn(a, 2);
    s[0];
    var o = s[1], l = o.connectors, c = o.widgets, u = yc(c[0]), f = l[0];
    return "const virtual".concat(u, " = ").concat(f, "(() => null);");
  }).join(`
`), `

search.addWidgets([
  `).concat(i.filter(function(a) {
    var s = nn(a, 2);
    s[0];
    var o = s[1].connectors;
    return o.length > 0;
  }).map(function(a) {
    var s = nn(a, 2);
    s[0];
    var o = s[1].widgets, l = yc(o[0]);
    return "virtual".concat(l, "({ /* ... */ })");
  }).join(`,
  `), `
]);
\`\`\`

If you're using custom widgets that do set these query parameters, we recommend using connectors instead.

See https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/js/#customize-the-complete-ui-of-the-widgets`));
}
function Yf(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function Ie(t, e) {
  if (t === void 0 || typeof t != "function")
    throw new Error("The render function is not valid (received type ".concat(Yf(t), `).

`).concat(e));
}
function wc(t) {
  var e = t.helper, r = t.attributesToClear, n = r === void 0 ? [] : r, i = e.state.setPage(0);
  return i = n.reduce(function(a, s) {
    return i.isNumericRefined(s) ? a.removeNumericRefinement(s) : i.isHierarchicalFacet(s) ? a.removeHierarchicalFacetRefinement(s) : i.isDisjunctiveFacet(s) ? a.removeDisjunctiveFacetRefinement(s) : i.isConjunctiveFacet(s) ? a.removeFacetRefinement(s) : a;
  }, i), n.indexOf("query") !== -1 && (i = i.setQuery("")), i;
}
var P2 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, qf = /[&<>"']/g, A2 = RegExp(qf.source);
function O2(t) {
  return t && A2.test(t) ? t.replace(qf, function(e) {
    return P2[e];
  }) : t;
}
var T2 = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, Qf = /&(amp|quot|lt|gt|#39);/g, j2 = RegExp(Qf.source);
function Jf(t) {
  return t && j2.test(t) ? t.replace(Qf, function(e) {
    return T2[e];
  }) : t;
}
function io(t) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, io(t);
}
function k2(t) {
  return t === null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
function M2(t) {
  return io(t) === "object" && t !== null;
}
function Kf(t) {
  if (!M2(t) || k2(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  for (var e = t; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
function Rn(t) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rn(t);
}
function z2(t) {
  if (t == null) throw new TypeError("Cannot destructure " + t);
}
function ao() {
  return ao = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ao.apply(this, arguments);
}
function Sc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sc(Object(r), !0).forEach(function(n) {
      _f(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Sc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function _f(t, e, r) {
  return e = E2(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function E2(t) {
  var e = C2(t, "string");
  return Rn(e) == "symbol" ? e : String(e);
}
function C2(t, e) {
  if (Rn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Rn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Ct = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
}, Je = {
  highlightPreTag: "<mark>",
  highlightPostTag: "</mark>"
};
function $f(t) {
  return O2(t).replace(new RegExp(Ct.highlightPreTag, "g"), Je.highlightPreTag).replace(new RegExp(Ct.highlightPostTag, "g"), Je.highlightPostTag);
}
function xa(t) {
  return Kf(t) && typeof t.value != "string" ? Object.keys(t).reduce(function(e, r) {
    return Dr(Dr({}, e), {}, _f({}, r, xa(t[r])));
  }, {}) : Array.isArray(t) ? t.map(xa) : Dr(Dr({}, t), {}, {
    value: $f(t.value)
  });
}
function Wa(t) {
  return t.__escaped === void 0 && (t = t.map(function(e) {
    var r = ao({}, (z2(e), e));
    return r._highlightResult && (r._highlightResult = xa(r._highlightResult)), r._snippetResult && (r._snippetResult = xa(r._snippetResult)), r;
  }), t.__escaped = !0), t;
}
function I2(t) {
  return t.map(function(e) {
    return Dr(Dr({}, e), {}, {
      highlighted: $f(e.highlighted)
    });
  });
}
function ep(t) {
  var e = Je.highlightPreTag, r = Je.highlightPostTag;
  return t.map(function(n) {
    return n.isHighlighted ? e + n.value + r : n.value;
  }).join("");
}
function L2() {
  var t = -1, e = -1, r = void 0;
  return function(i) {
    var a = ++t;
    return Promise.resolve(i).then(function(s) {
      return r && a < e ? r : (e = a, r = s, s);
    });
  };
}
function R2(t, e, r) {
  return t.state.isHierarchicalFacet(e) ? t.state.isHierarchicalFacetRefined(e, r) : t.state.isConjunctiveFacet(e) ? t.state.isFacetRefined(e, r) : t.state.isDisjunctiveFacetRefined(e, r);
}
function xc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function N2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xc(Object(r), !0).forEach(function(n) {
      D2(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function D2(t, e, r) {
  return e = H2(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function H2(t) {
  var e = W2(t, "string");
  return Br(e) == "symbol" ? e : String(e);
}
function W2(t, e) {
  if (Br(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Br(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Br(t) {
  "@babel/helpers - typeof";
  return Br = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Br(t);
}
function F2(t, e) {
  return X2(t) || Z2(t, e) || G2(t, e) || V2();
}
function V2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function G2(t, e) {
  if (t) {
    if (typeof t == "string") return Pc(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Pc(t, e);
  }
}
function Pc(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Z2(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function X2(t) {
  if (Array.isArray(t)) return t;
}
function il(t) {
  var e = t.instantSearchInstance, r = t.helper, n = t.attribute, i = t.widgetType, a = function() {
    for (var o = arguments.length, l = new Array(o), c = 0; c < o; c++)
      l[c] = arguments[c];
    var u = l[1], f = l[2], m = f === void 0 ? "Filter Applied" : f, h = l[3], p = h === void 0 ? {} : h, d = l[0].split(":"), v = F2(d, 2), b = v[0], g = v[1], y = typeof n == "string" ? n : n(u);
    if (l.length === 1 && Br(l[0]) === "object")
      e.sendEventToInsights(l[0]);
    else if (b === "click" && l.length >= 2 && l.length <= 4)
      R2(r, y, u) || e.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: i,
        eventType: b,
        eventModifier: g,
        payload: N2({
          eventName: m,
          index: r.getIndex(),
          filters: ["".concat(y, ":").concat(u)]
        }, p),
        attribute: y
      });
    else if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass between two and four arguments like:
  sendEvent('click', facetValue, eventName?, additionalData?);

If you want to send a custom payload, you can pass one object: sendEvent(customPayload);
`);
  };
  return a;
}
function tp(t) {
  return btoa(encodeURIComponent(JSON.stringify(t)));
}
function Ac(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ds(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ac(Object(r), !0).forEach(function(n) {
      B2(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ac(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function B2(t, e, r) {
  return e = U2(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function U2(t) {
  var e = Y2(t, "string");
  return Ur(e) == "symbol" ? e : String(e);
}
function Y2(t, e) {
  if (Ur(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Ur(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function q2(t, e) {
  return _2(t) || K2(t, e) || J2(t, e) || Q2();
}
function Q2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function J2(t, e) {
  if (t) {
    if (typeof t == "string") return Oc(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Oc(t, e);
  }
}
function Oc(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function K2(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function _2(t) {
  if (Array.isArray(t)) return t;
}
function Ur(t) {
  "@babel/helpers - typeof";
  return Ur = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ur(t);
}
function $2(t) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, r = [], n = 0; n < Math.ceil(t.length / e); n++)
    r.push(t.slice(n * e, (n + 1) * e));
  return r;
}
function rp(t) {
  var e = t.getIndex, r = t.widgetType, n = t.methodName, i = t.args, a = t.instantSearchInstance;
  if (i.length === 1 && Ur(i[0]) === "object")
    return [i[0]];
  var s = i[0].split(":"), o = q2(s, 2), l = o[0], c = o[1], u = i[1], f = i[2], m = i[3] || {};
  if (!u) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass hit or hits as the second argument like:
  `.concat(n, `(eventType, hit);
  `));
    return [];
  }
  if ((l === "click" || l === "conversion") && !f) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass eventName as the third argument for 'click' or 'conversion' events like:
  `.concat(n, `('click', hit, 'Product Purchased');

  To learn more about event naming: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/
  `));
    return [];
  }
  var h = Array.isArray(u) ? u : [u];
  if (h.length === 0)
    return [];
  var p = h[0].__queryID, d = $2(h), v = d.map(function(g) {
    return g.map(function(y) {
      return y.objectID;
    });
  }), b = d.map(function(g) {
    return g.map(function(y) {
      return y.__position;
    });
  });
  if (l === "view")
    return a.status !== "idle" ? [] : d.map(function(g, y) {
      return {
        insightsMethod: "viewedObjectIDs",
        widgetType: r,
        eventType: l,
        payload: ds({
          eventName: f || "Hits Viewed",
          index: e(),
          objectIDs: v[y]
        }, m),
        hits: g,
        eventModifier: c
      };
    });
  if (l === "click")
    return d.map(function(g, y) {
      return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: ds({
          eventName: f || "Hit Clicked",
          index: e(),
          queryID: p,
          objectIDs: v[y],
          positions: b[y]
        }, m),
        hits: g,
        eventModifier: c
      };
    });
  if (l === "conversion")
    return d.map(function(g, y) {
      return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: ds({
          eventName: f || "Hit Converted",
          index: e(),
          queryID: p,
          objectIDs: v[y]
        }, m),
        hits: g,
        eventModifier: c
      };
    });
  if (process.env.NODE_ENV === "development")
    throw new Error('eventType("'.concat(l, `") is not supported.
    If you want to send a custom payload, you can pass one object: `).concat(n, `(customPayload);
    `));
  return [];
}
function al(t) {
  var e = t.instantSearchInstance, r = t.getIndex, n = t.widgetType, i = {}, a = void 0, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    var f = rp({
      widgetType: n,
      getIndex: r,
      methodName: "sendEvent",
      args: c,
      instantSearchInstance: e
    });
    f.forEach(function(m) {
      m.eventType === "click" && m.eventModifier === "internal" && i[m.eventType] || (i[m.eventType] = !0, e.sendEventToInsights(m));
    }), clearTimeout(a), a = setTimeout(function() {
      i = {};
    }, 0);
  };
  return s;
}
function np(t) {
  var e = t.getIndex, r = t.widgetType, n = t.instantSearchInstance, i = function() {
    for (var s = arguments.length, o = new Array(s), l = 0; l < s; l++)
      o[l] = arguments[l];
    var c = rp({
      widgetType: r,
      getIndex: e,
      methodName: "bindEvent",
      args: o,
      instantSearchInstance: n
    });
    return c.length ? "data-insights-event=".concat(tp(c)) : "";
  };
  return i;
}
function at(t) {
  return t.$$type === "ais.index";
}
function so(t, e) {
  var r = t[e.getIndexId()] || {};
  process.env.NODE_ENV === "development" && Uf({
    index: e,
    indexUiState: r
  }), e.getHelper().setState(e.getWidgetSearchParameters(e.getHelper().state, {
    uiState: r
  })), e.getWidgets().filter(at).forEach(function(n) {
    return so(t, n);
  });
}
function Tc(t, e) {
  var r = null;
  return function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return new Promise(function(s, o) {
      r && clearTimeout(r), r = setTimeout(function() {
        r = null, Promise.resolve(t.apply(void 0, i)).then(s).catch(o);
      }, e);
    });
  };
}
var e3 = Promise.resolve();
function an(t) {
  var e = null, r = !1, n = function() {
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    e === null && (e = e3.then(function() {
      if (e = null, r) {
        r = !1;
        return;
      }
      t.apply(void 0, s);
    }));
  };
  return n.wait = function() {
    if (e === null)
      throw new Error("The deferred function should be called before calling `wait()`");
    return e;
  }, n.cancel = function() {
    e !== null && (r = !0);
  }, n;
}
function Nn(t) {
  var e = t.name, r = t.connector, n = r === void 0 ? !1 : r;
  return ["https://www.algolia.com/doc/api-reference/widgets/", e, "/js/", n ? "#connector" : ""].join("");
}
function Pe() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = e.map(function(i) {
    return Nn(i);
  }).join(", ");
  return function(i) {
    return [i, "See documentation: ".concat(n)].filter(Boolean).join(`

`);
  };
}
function t3(t) {
  return typeof t == "string" ? t.replace(/^\\-/, "-") : t;
}
function mn(t) {
  return typeof t == "number" && t < 0 || typeof t == "string" ? String(t).replace(/^-/, "\\-") : t;
}
function Gt(t, e) {
  for (var r, n = 0; n < t.length; n++)
    if (r = t[n], e(r, n, t))
      return r;
}
function r3(t, e) {
  if (!Array.isArray(t))
    return -1;
  for (var r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
  return -1;
}
function n3(t) {
  if (t.appId && t.apiKey)
    return [t.appId, t.apiKey];
  if (t.transporter) {
    var e = t.transporter, r = e.headers || e.baseHeaders, n = e.queryParameters || e.baseQueryParameters, i = "x-algolia-application-id", a = "x-algolia-api-key", s = r[i] || n[i], o = r[a] || n[a];
    return [s, o];
  } else
    return [t.applicationID, t.apiKey];
}
function sl(t) {
  var e = Je.highlightPostTag, r = Je.highlightPreTag, n = t.split(r), i = n.shift(), a = i ? [{
    value: i,
    isHighlighted: !1
  }] : [];
  return n.forEach(function(s) {
    var o = s.split(e);
    a.push({
      value: o[0],
      isHighlighted: !0
    }), o[1] !== "" && a.push({
      value: o[1],
      isHighlighted: !1
    });
  }), a;
}
var i3 = new RegExp(/\w/i);
function a3(t, e) {
  var r, n, i = t[e], a = ((r = t[e + 1]) === null || r === void 0 ? void 0 : r.isHighlighted) || !0, s = ((n = t[e - 1]) === null || n === void 0 ? void 0 : n.isHighlighted) || !0;
  return !i3.test(Jf(i.value)) && s === a ? s : i.isHighlighted;
}
function en(t, e) {
  var r = Array.isArray(e) ? e : e.split(".");
  return r.reduce(function(n, i) {
    return n && n[i];
  }, t);
}
function fs(t, e, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
    type: e,
    attribute: r,
    name: n,
    escapedValue: mn(n)
  }, s = Gt(i, function(h) {
    return h.name === r;
  }), o;
  if (e === "hierarchical") {
    for (var l = t.getHierarchicalFacetByName(r), c = n.split(l.separator), u = function(p) {
      return function(d) {
        return p[d];
      };
    }, f = function(p) {
      s = s && s.data && Gt(Object.keys(s.data).map(u(s.data)), function(d) {
        return d.name === c[p];
      });
    }, m = 0; s !== void 0 && m < c.length; ++m)
      f(m);
    o = s && s.count;
  } else
    o = s && s.data && s.data[a.name];
  return o !== void 0 && (a.count = o), s && s.exhaustive !== void 0 && (a.exhaustive = s.exhaustive), a;
}
function ol(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = t || {}, i = [], a = e.facetsRefinements, s = a === void 0 ? {} : a, o = e.facetsExcludes, l = o === void 0 ? {} : o, c = e.disjunctiveFacetsRefinements, u = c === void 0 ? {} : c, f = e.hierarchicalFacetsRefinements, m = f === void 0 ? {} : f, h = e.numericRefinements, p = h === void 0 ? {} : h, d = e.tagRefinements, v = d === void 0 ? [] : d;
  return Object.keys(s).forEach(function(b) {
    var g = s[b];
    g.forEach(function(y) {
      i.push(fs(e, "facet", b, y, n.facets));
    });
  }), Object.keys(l).forEach(function(b) {
    var g = l[b];
    g.forEach(function(y) {
      i.push({
        type: "exclude",
        attribute: b,
        name: y,
        exclude: !0
      });
    });
  }), Object.keys(u).forEach(function(b) {
    var g = u[b];
    g.forEach(function(y) {
      i.push(fs(
        e,
        "disjunctive",
        b,
        // We unescape any disjunctive refined values with `unescapeFacetValue` because
        // they can be escaped on negative numeric values with `escapeFacetValue`.
        t3(y),
        n.disjunctiveFacets
      ));
    });
  }), Object.keys(m).forEach(function(b) {
    var g = m[b];
    g.forEach(function(y) {
      i.push(fs(e, "hierarchical", b, y, n.hierarchicalFacets));
    });
  }), Object.keys(p).forEach(function(b) {
    var g = p[b];
    Object.keys(g).forEach(function(y) {
      var w = y, P = g[w], T = Array.isArray(P) ? P : [P];
      T.forEach(function(A) {
        i.push({
          type: "numeric",
          attribute: b,
          name: "".concat(A),
          numericValue: A,
          operator: w
        });
      });
    });
  }), v.forEach(function(b) {
    i.push({
      type: "tag",
      attribute: "_tags",
      name: b
    });
  }), r && e.query && e.query.trim() && i.push({
    attribute: "query",
    type: "query",
    name: e.query,
    query: e.query
  }), i;
}
function s3(t, e) {
  var r, n = (r = t.getWidgetRenderState) === null || r === void 0 ? void 0 : r.call(t, e), i = null;
  if (n && n.widgetParams) {
    var a = n.widgetParams;
    a.attribute ? i = a.attribute : Array.isArray(a.attributes) && (i = a.attributes[0]);
  }
  if (typeof i != "string")
    throw new Error(`Could not find the attribute of the widget:

`.concat(JSON.stringify(t), `

Please check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly.`));
  return i;
}
function Dn(t) {
  "@babel/helpers - typeof";
  return Dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dn(t);
}
function jc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jc(Object(r), !0).forEach(function(n) {
      o3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function o3(t, e, r) {
  return e = l3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function l3(t) {
  var e = c3(t, "string");
  return Dn(e) == "symbol" ? e : String(e);
}
function c3(t, e) {
  if (Dn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Dn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ll(t, e, r) {
  return t.map(function(n, i) {
    return kc(kc({}, n), {}, {
      __position: r * e + i + 1
    });
  });
}
function Hn(t) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hn(t);
}
function Mc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mc(Object(r), !0).forEach(function(n) {
      u3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function u3(t, e, r) {
  return e = d3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function d3(t) {
  var e = f3(t, "string");
  return Hn(e) == "symbol" ? e : String(e);
}
function f3(t, e) {
  if (Hn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Hn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function cl(t, e) {
  return e ? t.map(function(r) {
    return zc(zc({}, r), {}, {
      __queryID: e
    });
  }) : t;
}
function Wn(t) {
  "@babel/helpers - typeof";
  return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wn(t);
}
function Ec(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ec(Object(r), !0).forEach(function(n) {
      p3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ec(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function p3(t, e, r) {
  return e = m3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function m3(t) {
  var e = h3(t, "string");
  return Wn(e) == "symbol" ? e : String(e);
}
function h3(t, e) {
  if (Wn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Wn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function g3(t, e) {
  var r = Object.keys(e).reduce(function(n, i) {
    var a = e[i];
    return a.recommendResults ? Cc(Cc({}, n), a.recommendResults.results) : n;
  }, {});
  t._recommendCache = r;
}
function Fn(t) {
  "@babel/helpers - typeof";
  return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Fn(t);
}
function v3(t, e) {
  return S3(t) || w3(t, e) || y3(t, e) || b3();
}
function b3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y3(t, e) {
  if (t) {
    if (typeof t == "string") return Ic(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ic(t, e);
  }
}
function Ic(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function w3(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function S3(t) {
  if (Array.isArray(t)) return t;
}
function Lc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Lc(Object(r), !0).forEach(function(n) {
      ip(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Lc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ip(t, e, r) {
  return e = x3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function x3(t) {
  var e = P3(t, "string");
  return Fn(e) == "symbol" ? e : String(e);
}
function P3(t, e) {
  if (Fn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Fn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function A3(t, e) {
  if (e && !((!("transporter" in t) || t._cacheHydrated) && (!t._useCache || typeof t.addAlgoliaAgent != "function"))) {
    var r = [Object.keys(e).reduce(function(s, o) {
      var l = e[o], c = l.state, u = l.requestParams, f = l.results, m = f && c ? f.map(function(h, p) {
        return sn({
          indexName: c.index || h.index
        }, u != null && u[p] || h.params ? {
          params: ps((u == null ? void 0 : u[p]) || O3(h.params))
        } : {});
      }) : [];
      return s.concat(m);
    }, [])], n = Object.keys(e).reduce(function(s, o) {
      var l = e[o].results;
      return l ? s.concat(l) : s;
    }, []);
    if ("transporter" in t && !t._cacheHydrated) {
      t._cacheHydrated = !0;
      var i = t.search.bind(t);
      t.search = function(s) {
        for (var o = arguments.length, l = new Array(o > 1 ? o - 1 : 0), c = 1; c < o; c++)
          l[c - 1] = arguments[c];
        var u = Array.isArray(s) ? (
          // search client
          s.map(function(f) {
            return sn(sn({}, f), {}, {
              params: ps(f.params)
            });
          })
        ) : (
          // composition client
          ps(s.requestBody.params)
        );
        return t.transporter.responsesCache.get({
          method: "search",
          args: [u].concat(l)
        }, function() {
          return i.apply(void 0, [s].concat(l));
        });
      }, t.transporter.responsesCache.set({
        method: "search",
        args: r
      }, {
        results: n
      });
    }
    if (!("transporter" in t)) {
      var a = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: r
      }));
      t.cache = sn(sn({}, t.cache), {}, ip({}, a, JSON.stringify({
        results: Object.keys(e).map(function(s) {
          return e[s].results;
        })
      })));
    }
  }
}
function O3(t) {
  return t.split("&").reduce(function(e, r) {
    var n = r.split("="), i = v3(n, 2), a = i[0], s = i[1];
    return e[a] = s ? decodeURIComponent(s) : "", e;
  }, {});
}
function ps(t) {
  var e = function(i) {
    return Object.prototype.toString.call(i) === "[object Object]" || Object.prototype.toString.call(i) === "[object Array]";
  }, r = function(i) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      s[o - 1] = arguments[o];
    var l = 0;
    return i.replace(/%s/g, function() {
      return encodeURIComponent(s[l++]);
    });
  };
  return Object.keys(t).map(function(n) {
    return r("%s=%s", n, e(t[n]) ? JSON.stringify(t[n]) : t[n]);
  }).join("&");
}
function Rc(t) {
  return t !== Object(t);
}
function Pr(t, e) {
  if (t === e)
    return !0;
  if (Rc(t) || Rc(e) || typeof t == "function" || typeof e == "function")
    return t === e;
  if (Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var i = n[r];
    if (!(i in e) || !Pr(t[i], e[i]))
      return !1;
  }
  return !0;
}
function we(t) {
  return typeof t == "number" && isFinite(t);
}
function ap(t, e) {
  e(t), t.getWidgets().forEach(function(r) {
    at(r) && ap(r, e);
  });
}
function ul(t) {
  return t.filter(function(e, r, n) {
    return n.indexOf(e) === r;
  });
}
function Vn(t) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vn(t);
}
var T3 = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"];
function Nc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function It(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Nc(Object(r), !0).forEach(function(n) {
      j3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Nc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function j3(t, e, r) {
  return e = k3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function k3(t) {
  var e = M3(t, "string");
  return Vn(e) == "symbol" ? e : String(e);
}
function M3(t, e) {
  if (Vn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Vn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function z3(t, e) {
  if (t == null) return {};
  var r = E3(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function E3(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
var C3 = function(e, r) {
  r.facets, r.disjunctiveFacets, r.facetsRefinements, r.facetsExcludes, r.disjunctiveFacetsRefinements, r.numericRefinements, r.tagRefinements, r.hierarchicalFacets, r.hierarchicalFacetsRefinements, r.ruleContexts;
  var n = z3(r, T3);
  return e.setQueryParameters(n);
}, I3 = function(e, r) {
  return r.facets.reduce(function(n, i) {
    return n.addFacet(i);
  }, e);
}, L3 = function(e, r) {
  return r.disjunctiveFacets.reduce(function(n, i) {
    return n.addDisjunctiveFacet(i);
  }, e);
}, R3 = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacets: r.hierarchicalFacets.reduce(function(n, i) {
      var a = r3(n, function(o) {
        return o.name === i.name;
      });
      if (a === -1)
        return n.concat(i);
      var s = n.slice();
      return s.splice(a, 1, i), s;
    }, e.hierarchicalFacets)
  });
}, N3 = function(e, r) {
  return r.tagRefinements.reduce(function(n, i) {
    return n.addTagRefinement(i);
  }, e);
}, D3 = function(e, r) {
  return e.setQueryParameters({
    facetsRefinements: It(It({}, e.facetsRefinements), r.facetsRefinements)
  });
}, H3 = function(e, r) {
  return e.setQueryParameters({
    facetsExcludes: It(It({}, e.facetsExcludes), r.facetsExcludes)
  });
}, W3 = function(e, r) {
  return e.setQueryParameters({
    disjunctiveFacetsRefinements: It(It({}, e.disjunctiveFacetsRefinements), r.disjunctiveFacetsRefinements)
  });
}, F3 = function(e, r) {
  return e.setQueryParameters({
    numericRefinements: It(It({}, e.numericRefinements), r.numericRefinements)
  });
}, V3 = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacetsRefinements: It(It({}, e.hierarchicalFacetsRefinements), r.hierarchicalFacetsRefinements)
  });
}, G3 = function(e, r) {
  var n = ul([].concat(e.ruleContexts).concat(r.ruleContexts).filter(Boolean));
  return n.length > 0 ? e.setQueryParameters({
    ruleContexts: n
  }) : e;
}, Pn = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.reduce(function(i, a) {
    var s = V3(i, a), o = R3(s, a), l = N3(o, a), c = F3(l, a), u = W3(c, a), f = H3(u, a), m = D3(f, a), h = L3(m, a), p = G3(h, a), d = I3(p, a);
    return C3(d, a);
  });
};
function Z3(t) {
  return Y3(t) || U3(t) || B3(t) || X3();
}
function X3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B3(t, e) {
  if (t) {
    if (typeof t == "string") return oo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oo(t, e);
  }
}
function U3(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Y3(t) {
  if (Array.isArray(t)) return oo(t);
}
function oo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Dc(t) {
  var e = t.start, r = e === void 0 ? 0 : e, n = t.end, i = t.step, a = i === void 0 ? 1 : i, s = a === 0 ? 1 : a, o = Math.round((n - r) / s);
  return Z3(Array(o)).map(function(l, c) {
    return r + c * s;
  });
}
function hn(t, e, r) {
  var n = e.getHelper();
  return {
    uiState: r,
    helper: n,
    parent: e,
    instantSearchInstance: t,
    state: n.state,
    renderState: t.renderState,
    templatesConfig: t.templatesConfig,
    createURL: e.createURL,
    scopedResults: [],
    searchMetadata: {
      isSearchStalled: t.status === "stalled"
    },
    status: t.status,
    error: t.error
  };
}
function Hc(t, e, r) {
  var n = e.getResultsForWidget(r), i = e.getHelper();
  return {
    helper: i,
    parent: e,
    instantSearchInstance: t,
    results: n,
    scopedResults: e.getScopedResults(),
    state: n && "_state" in n ? n._state : i.state,
    renderState: t.renderState,
    templatesConfig: t.templatesConfig,
    createURL: e.createURL,
    searchMetadata: {
      isSearchStalled: t.status === "stalled"
    },
    status: t.status,
    error: t.error
  };
}
function q3(t) {
  for (var e = t.getParent(), r = [t.getHelper().state]; e !== null; )
    r = [e.getHelper().state].concat(r), e = e.getParent();
  return r;
}
function Gn(t) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gn(t);
}
function Wc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Bi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wc(Object(r), !0).forEach(function(n) {
      Q3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Q3(t, e, r) {
  return e = J3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function J3(t) {
  var e = K3(t, "string");
  return Gn(e) == "symbol" ? e : String(e);
}
function K3(t, e) {
  if (Gn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Gn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function sp(t) {
  return t.some(function(e) {
    return e.isHighlighted;
  }) ? t.map(function(e, r) {
    return Bi(Bi({}, e), {}, {
      isHighlighted: !a3(t, r)
    });
  }) : t.map(function(e) {
    return Bi(Bi({}, e), {}, {
      isHighlighted: !1
    });
  });
}
function zt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    fallback: function() {
    }
  }, r = e.fallback;
  return typeof window > "u" ? r() : t({
    window
  });
}
function ms(t) {
  return Array.isArray(t) ? t : [t];
}
function Zn(t) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zn(t);
}
function Fc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fc(Object(r), !0).forEach(function(n) {
      _3(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Fc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function _3(t, e, r) {
  return e = $3(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function $3(t) {
  var e = ew(t, "string");
  return Zn(e) == "symbol" ? e : String(e);
}
function ew(t, e) {
  if (Zn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Zn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function tw(t) {
  return typeof t.findAnswers == "function";
}
var Ui = Pe({
  name: "answers",
  connector: !0
}), rw = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Ui()), function(n) {
    var i = n || {}, a = i.queryLanguages, s = i.attributesForPrediction, o = i.nbHits, l = o === void 0 ? 1 : o, c = i.renderDebounceTime, u = c === void 0 ? 100 : c, f = i.searchDebounceTime, m = f === void 0 ? 100 : f, h = i.escapeHTML, p = h === void 0 ? !0 : h, d = i.extraParameters, v = d === void 0 ? {} : d;
    if (!a || a.length === 0)
      throw new Error(Ui("The `queryLanguages` expects an array of strings."));
    var b = L2(), g = [], y = !1, w = Tc(e, u), P;
    return {
      $$type: "ais.answers",
      init: function(A) {
        var j = A.state, O = A.instantSearchInstance;
        if (typeof O.client.initIndex != "function")
          throw new Error(Ui("`algoliasearch` <5 required."));
        var M = O.client.initIndex(j.index);
        if (!tw(M))
          throw new Error(Ui("`algoliasearch` >= 4.8.0 required."));
        P = Tc(M.findAnswers, m), e(pt(pt({}, this.getWidgetRenderState(A)), {}, {
          instantSearchInstance: A.instantSearchInstance
        }), !0);
      },
      render: function(A) {
        var j = this, O = A.state.query;
        if (!O) {
          g = [], y = !1, e(pt(pt({}, this.getWidgetRenderState(A)), {}, {
            instantSearchInstance: A.instantSearchInstance
          }), !1);
          return;
        }
        g = [], y = !0, e(pt(pt({}, this.getWidgetRenderState(A)), {}, {
          instantSearchInstance: A.instantSearchInstance
        }), !1), b(P(O, a, pt(pt({}, v), {}, {
          nbHits: l,
          attributesForPrediction: s
        }))).then(function(M) {
          if (M) {
            p && M.hits.length > 0 && (M.hits = Wa(M.hits));
            var z = ll(M.hits, 0, l), R = cl(z, M.queryID);
            g = R, y = !1, w(pt(pt({}, j.getWidgetRenderState(A)), {}, {
              instantSearchInstance: A.instantSearchInstance
            }), !1);
          }
        });
      },
      getRenderState: function(A, j) {
        return pt(pt({}, A), {}, {
          answers: this.getWidgetRenderState(j)
        });
      },
      getWidgetRenderState: function() {
        return {
          hits: g,
          isLoading: y,
          widgetParams: n
        };
      },
      dispose: function(A) {
        var j = A.state;
        return r(), j;
      },
      getWidgetSearchParameters: function(A) {
        return A;
      }
    };
  };
};
function Fa(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Ke() {
  this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
}
var dl = Ke;
Ke.prototype._events = void 0;
Ke.prototype._maxListeners = void 0;
Ke.defaultMaxListeners = 10;
Ke.prototype.setMaxListeners = function(t) {
  if (!nw(t) || t < 0 || isNaN(t))
    throw TypeError("n must be a positive number");
  return this._maxListeners = t, this;
};
Ke.prototype.emit = function(t) {
  var e, r, n, i, a, s;
  if (this._events || (this._events = {}), t === "error" && (!this._events.error || Xn(this._events.error) && !this._events.error.length)) {
    if (e = arguments[1], e instanceof Error)
      throw e;
    var o = new Error('Uncaught, unspecified "error" event. (' + e + ")");
    throw o.context = e, o;
  }
  if (r = this._events[t], op(r))
    return !1;
  if (Zt(r))
    switch (arguments.length) {
      case 1:
        r.call(this);
        break;
      case 2:
        r.call(this, arguments[1]);
        break;
      case 3:
        r.call(this, arguments[1], arguments[2]);
        break;
      default:
        i = Array.prototype.slice.call(arguments, 1), r.apply(this, i);
    }
  else if (Xn(r))
    for (i = Array.prototype.slice.call(arguments, 1), s = r.slice(), n = s.length, a = 0; a < n; a++)
      s[a].apply(this, i);
  return !0;
};
Ke.prototype.addListener = function(t, e) {
  var r;
  if (!Zt(e))
    throw TypeError("listener must be a function");
  return this._events || (this._events = {}), this._events.newListener && this.emit(
    "newListener",
    t,
    Zt(e.listener) ? e.listener : e
  ), this._events[t] ? Xn(this._events[t]) ? this._events[t].push(e) : this._events[t] = [this._events[t], e] : this._events[t] = e, Xn(this._events[t]) && !this._events[t].warned && (op(this._maxListeners) ? r = Ke.defaultMaxListeners : r = this._maxListeners, r && r > 0 && this._events[t].length > r && (this._events[t].warned = !0, console.error(
    "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
    this._events[t].length
  ), typeof console.trace == "function" && console.trace())), this;
};
Ke.prototype.on = Ke.prototype.addListener;
Ke.prototype.once = function(t, e) {
  if (!Zt(e))
    throw TypeError("listener must be a function");
  var r = !1;
  function n() {
    this.removeListener(t, n), r || (r = !0, e.apply(this, arguments));
  }
  return n.listener = e, this.on(t, n), this;
};
Ke.prototype.removeListener = function(t, e) {
  var r, n, i, a;
  if (!Zt(e))
    throw TypeError("listener must be a function");
  if (!this._events || !this._events[t])
    return this;
  if (r = this._events[t], i = r.length, n = -1, r === e || Zt(r.listener) && r.listener === e)
    delete this._events[t], this._events.removeListener && this.emit("removeListener", t, e);
  else if (Xn(r)) {
    for (a = i; a-- > 0; )
      if (r[a] === e || r[a].listener && r[a].listener === e) {
        n = a;
        break;
      }
    if (n < 0)
      return this;
    r.length === 1 ? (r.length = 0, delete this._events[t]) : r.splice(n, 1), this._events.removeListener && this.emit("removeListener", t, e);
  }
  return this;
};
Ke.prototype.removeAllListeners = function(t) {
  var e, r;
  if (!this._events)
    return this;
  if (!this._events.removeListener)
    return arguments.length === 0 ? this._events = {} : this._events[t] && delete this._events[t], this;
  if (arguments.length === 0) {
    for (e in this._events)
      e !== "removeListener" && this.removeAllListeners(e);
    return this.removeAllListeners("removeListener"), this._events = {}, this;
  }
  if (r = this._events[t], Zt(r))
    this.removeListener(t, r);
  else if (r)
    for (; r.length; )
      this.removeListener(t, r[r.length - 1]);
  return delete this._events[t], this;
};
Ke.prototype.listeners = function(t) {
  var e;
  return !this._events || !this._events[t] ? e = [] : Zt(this._events[t]) ? e = [this._events[t]] : e = this._events[t].slice(), e;
};
Ke.prototype.listenerCount = function(t) {
  if (this._events) {
    var e = this._events[t];
    if (Zt(e))
      return 1;
    if (e)
      return e.length;
  }
  return 0;
};
Ke.listenerCount = function(t, e) {
  return t.listenerCount(e);
};
function Zt(t) {
  return typeof t == "function";
}
function nw(t) {
  return typeof t == "number";
}
function Xn(t) {
  return typeof t == "object" && t !== null;
}
function op(t) {
  return t === void 0;
}
const iw = /* @__PURE__ */ Fa(dl);
function aw(t, e) {
  t.prototype = Object.create(e.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
}
var lp = aw, sw = dl, ow = lp;
function Ei(t, e, r) {
  this.main = t, this.fn = e, this.recommendFn = r, this.lastResults = null, this.lastRecommendResults = null;
}
ow(Ei, sw);
Ei.prototype.detach = function() {
  this.removeAllListeners(), this.main.detachDerivedHelper(this);
};
Ei.prototype.getModifiedState = function(t) {
  return this.fn(t);
};
Ei.prototype.getModifiedRecommendState = function(t) {
  return this.recommendFn(t);
};
var lw = Ei;
function cw(t) {
  return typeof t != "string" ? t : String(t).replace(/^-/, "\\-");
}
function uw(t) {
  return typeof t != "string" ? t : t.replace(/^\\-/, "-");
}
var fl = {
  escapeFacetValue: cw,
  unescapeFacetValue: uw
};
function dw(t) {
  return typeof t == "object" && t !== null ? pl(Array.isArray(t) ? [] : {}, t) : t;
}
function Pa(t) {
  return typeof t == "function" || Array.isArray(t) || Object.prototype.toString.call(t) === "[object Object]";
}
function pl(t, e) {
  if (t === e)
    return t;
  for (var r in e)
    if (!(!Object.prototype.hasOwnProperty.call(e, r) || r === "__proto__" || r === "constructor")) {
      var n = e[r], i = t[r];
      typeof i < "u" && typeof n > "u" || (Pa(i) && Pa(n) ? t[r] = pl(i, n) : t[r] = dw(n));
    }
  return t;
}
function fw(t) {
  Pa(t) || (t = {});
  for (var e = 1, r = arguments.length; e < r; e++) {
    var n = arguments[e];
    Pa(n) && pl(t, n);
  }
  return t;
}
var ml = fw;
function pw(t) {
  return t && Object.keys(t).length > 0;
}
var hl = pw;
function mw(t, e) {
  if (t === null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
var gl = mw;
function gn(t) {
  t = t || {}, this.params = t.params || [];
}
gn.prototype = {
  constructor: gn,
  addParams: function(t) {
    var e = this.params.slice();
    return e.push(t), new gn({ params: e });
  },
  removeParams: function(t) {
    return new gn({
      params: this.params.filter(function(e) {
        return e.$$id !== t;
      })
    });
  },
  addFrequentlyBoughtTogether: function(t) {
    return this.addParams(
      Object.assign({}, t, { model: "bought-together" })
    );
  },
  addRelatedProducts: function(t) {
    return this.addParams(
      Object.assign({}, t, { model: "related-products" })
    );
  },
  addTrendingItems: function(t) {
    return this.addParams(
      Object.assign({}, t, { model: "trending-items" })
    );
  },
  addTrendingFacets: function(t) {
    return this.addParams(
      Object.assign({}, t, { model: "trending-facets" })
    );
  },
  addLookingSimilar: function(t) {
    return this.addParams(
      Object.assign({}, t, { model: "looking-similar" })
    );
  },
  _buildQueries: function(t, e) {
    return this.params.filter(function(r) {
      return e[r.$$id] === void 0;
    }).map(function(r) {
      var n = Object.assign({}, r, {
        indexName: t,
        // @TODO: remove this if it ever gets handled by the API
        threshold: r.threshold || 0
      });
      return delete n.$$id, n;
    });
  }
};
var cp = gn;
function lo(t, e) {
  this._state = t, this._rawResults = {};
  var r = this;
  t.params.forEach(function(n) {
    var i = n.$$id;
    r[i] = e[i], r._rawResults[i] = e[i];
  });
}
lo.prototype = {
  constructor: lo
};
var up = lo, Yi = ml;
function qi(t) {
  return Object.keys(t).sort().reduce(function(e, r) {
    return e[r] = t[r], e;
  }, {});
}
var He = {
  /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */
  _getQueries: function(e, r) {
    var n = [];
    return n.push({
      indexName: e,
      params: He._getHitsSearchParams(r)
    }), r.getRefinedDisjunctiveFacets().forEach(function(i) {
      n.push({
        indexName: e,
        params: He._getDisjunctiveFacetSearchParams(
          r,
          i
        )
      });
    }), r.getRefinedHierarchicalFacets().forEach(function(i) {
      var a = r.getHierarchicalFacetByName(i), s = r.getHierarchicalRefinement(i), o = r._getHierarchicalFacetSeparator(a);
      if (s.length > 0 && s[0].split(o).length > 1) {
        var l = s[0].split(o).slice(0, -1).reduce(function(u, f, m) {
          return u.concat({
            attribute: a.attributes[m],
            value: m === 0 ? f : [u[u.length - 1].value, f].join(o)
          });
        }, []);
        l.forEach(function(c, u) {
          var f = He._getDisjunctiveFacetSearchParams(
            r,
            c.attribute,
            u === 0
          );
          function m(d) {
            return a.attributes.some(function(v) {
              return v === d.split(":")[0];
            });
          }
          var h = (f.facetFilters || []).reduce(
            function(d, v) {
              if (Array.isArray(v)) {
                var b = v.filter(function(g) {
                  return !m(g);
                });
                b.length > 0 && d.push(b);
              }
              return typeof v == "string" && !m(v) && d.push(v), d;
            },
            []
          ), p = l[u - 1];
          u > 0 ? f.facetFilters = h.concat(
            p.attribute + ":" + p.value
          ) : h.length > 0 ? f.facetFilters = h : delete f.facetFilters, n.push({ indexName: e, params: f });
        });
      }
    }), n;
  },
  /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */
  _getCompositionQueries: function(e) {
    return [
      {
        compositionID: e.index,
        requestBody: {
          params: He._getCompositionHitsSearchParams(e)
        }
      }
    ];
  },
  /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */
  _getHitsSearchParams: function(t) {
    var e = t.facets.concat(t.disjunctiveFacets).concat(He._getHitsHierarchicalFacetsAttributes(t)).sort(), r = He._getFacetFilters(t), n = He._getNumericFilters(t), i = He._getTagFilters(t), a = {};
    return e.length > 0 && (a.facets = e.indexOf("*") > -1 ? ["*"] : e), i.length > 0 && (a.tagFilters = i), r.length > 0 && (a.facetFilters = r), n.length > 0 && (a.numericFilters = n), qi(Yi({}, t.getQueryParams(), a));
  },
  /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */
  _getCompositionHitsSearchParams: function(t) {
    var e = t.facets.concat(
      t.disjunctiveFacets.map(function(o) {
        return "disjunctive(" + o + ")";
      })
    ).concat(He._getHitsHierarchicalFacetsAttributes(t)).sort(), r = He._getFacetFilters(t), n = He._getNumericFilters(t), i = He._getTagFilters(t), a = {};
    e.length > 0 && (a.facets = e.indexOf("*") > -1 ? ["*"] : e), i.length > 0 && (a.tagFilters = i), r.length > 0 && (a.facetFilters = r), n.length > 0 && (a.numericFilters = n);
    var s = t.getQueryParams();
    return delete s.highlightPreTag, delete s.highlightPostTag, delete s.index, qi(Yi({}, s, a));
  },
  /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */
  _getDisjunctiveFacetSearchParams: function(t, e, r) {
    var n = He._getFacetFilters(
      t,
      e,
      r
    ), i = He._getNumericFilters(t, e), a = He._getTagFilters(t), s = {
      hitsPerPage: 0,
      page: 0,
      analytics: !1,
      clickAnalytics: !1
    };
    a.length > 0 && (s.tagFilters = a);
    var o = t.getHierarchicalFacetByName(e);
    return o ? s.facets = He._getDisjunctiveHierarchicalFacetAttribute(
      t,
      o,
      r
    ) : s.facets = e, i.length > 0 && (s.numericFilters = i), n.length > 0 && (s.facetFilters = n), qi(Yi({}, t.getQueryParams(), s));
  },
  /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */
  _getNumericFilters: function(t, e) {
    if (t.numericFilters)
      return t.numericFilters;
    var r = [];
    return Object.keys(t.numericRefinements).forEach(function(n) {
      var i = t.numericRefinements[n] || {};
      Object.keys(i).forEach(function(a) {
        var s = i[a] || [];
        e !== n && s.forEach(function(o) {
          if (Array.isArray(o)) {
            var l = o.map(function(c) {
              return n + a + c;
            });
            r.push(l);
          } else
            r.push(n + a + o);
        });
      });
    }), r;
  },
  /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */
  _getTagFilters: function(t) {
    return t.tagFilters ? t.tagFilters : t.tagRefinements.join(",");
  },
  /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */
  _getFacetFilters: function(t, e, r) {
    var n = [], i = t.facetsRefinements || {};
    Object.keys(i).sort().forEach(function(l) {
      var c = i[l] || [];
      c.slice().sort().forEach(function(u) {
        n.push(l + ":" + u);
      });
    });
    var a = t.facetsExcludes || {};
    Object.keys(a).sort().forEach(function(l) {
      var c = a[l] || [];
      c.sort().forEach(function(u) {
        n.push(l + ":-" + u);
      });
    });
    var s = t.disjunctiveFacetsRefinements || {};
    Object.keys(s).sort().forEach(function(l) {
      var c = s[l] || [];
      if (!(l === e || !c || c.length === 0)) {
        var u = [];
        c.slice().sort().forEach(function(f) {
          u.push(l + ":" + f);
        }), n.push(u);
      }
    });
    var o = t.hierarchicalFacetsRefinements || {};
    return Object.keys(o).sort().forEach(function(l) {
      var c = o[l] || [], u = c[0];
      if (u !== void 0) {
        var f = t.getHierarchicalFacetByName(l), m = t._getHierarchicalFacetSeparator(f), h = t._getHierarchicalRootPath(f), p, d;
        if (e === l) {
          if (u.indexOf(m) === -1 || !h && r === !0 || h && h.split(m).length === u.split(m).length)
            return;
          h ? (d = h.split(m).length - 1, u = h) : (d = u.split(m).length - 2, u = u.slice(0, u.lastIndexOf(m))), p = f.attributes[d];
        } else
          d = u.split(m).length - 1, p = f.attributes[d];
        p && n.push([p + ":" + u]);
      }
    }), n;
  },
  _getHitsHierarchicalFacetsAttributes: function(t) {
    var e = [];
    return t.hierarchicalFacets.reduce(
      // ask for as much levels as there's hierarchical refinements
      function(n, i) {
        var a = t.getHierarchicalRefinement(
          i.name
        )[0];
        if (!a)
          return n.push(i.attributes[0]), n;
        var s = t._getHierarchicalFacetSeparator(i), o = a.split(s).length, l = i.attributes.slice(0, o + 1);
        return n.concat(l);
      },
      e
    );
  },
  _getDisjunctiveHierarchicalFacetAttribute: function(t, e, r) {
    var n = t._getHierarchicalFacetSeparator(e);
    if (r === !0) {
      var i = t._getHierarchicalRootPath(e), a = 0;
      return i && (a = i.split(n).length), [e.attributes[a]];
    }
    var s = t.getHierarchicalRefinement(e.name)[0] || "", o = s.split(n).length - 1;
    return e.attributes.slice(0, o + 1);
  },
  getSearchForFacetQuery: function(t, e, r, n) {
    var i = n.isDisjunctiveFacet(t) ? n.clearRefinements(t) : n, a = {
      facetQuery: e,
      facetName: t
    };
    return typeof r == "number" && (a.maxFacetHits = r), qi(
      Yi(
        {},
        He._getHitsSearchParams(i),
        a
      )
    );
  }
}, hw = He, vl = function() {
  var e = Array.prototype.slice.call(arguments);
  return e.reduceRight(function(r, n) {
    return Object.keys(Object(n)).forEach(function(i) {
      n[i] !== void 0 && (r[i] !== void 0 && delete r[i], r[i] = n[i]);
    }), r;
  }, {});
}, Ci = function(e, r) {
  if (Array.isArray(e)) {
    for (var n = 0; n < e.length; n++)
      if (r(e[n]))
        return e[n];
  }
};
function gw(t, e) {
  return t.filter(function(r, n) {
    return e.indexOf(r) > -1 && t.indexOf(r) === n;
  });
}
var vw = gw;
function dp(t) {
  if (typeof t == "number")
    return t;
  if (typeof t == "string")
    return parseFloat(t);
  if (Array.isArray(t))
    return t.map(dp);
  throw new Error(
    "The value should be a number, a parsable string or an array of those."
  );
}
var bw = dp, yw = function(e) {
  return e === null ? !1 : /^[a-zA-Z0-9_-]{1,64}$/.test(e);
}, ww = vl, Sw = hl, xw = gl, dr = {
  /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */
  addRefinement: function(e, r, n) {
    if (dr.isRefined(e, r, n))
      return e;
    var i = "" + n, a = e[r] ? e[r].concat(i) : [i], s = {};
    return s[r] = a, ww(s, e);
  },
  /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */
  removeRefinement: function(e, r, n) {
    if (n === void 0)
      return dr.clearRefinement(e, function(a, s) {
        return r === s;
      });
    var i = "" + n;
    return dr.clearRefinement(e, function(a, s) {
      return r === s && i === a;
    });
  },
  /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */
  toggleRefinement: function(e, r, n) {
    if (n === void 0)
      throw new Error("toggleRefinement should be used with a value");
    return dr.isRefined(e, r, n) ? dr.removeRefinement(e, r, n) : dr.addRefinement(e, r, n);
  },
  /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */
  clearRefinement: function(e, r, n) {
    if (r === void 0)
      return Sw(e) ? {} : e;
    if (typeof r == "string")
      return xw(e, [r]);
    if (typeof r == "function") {
      var i = !1, a = Object.keys(e).reduce(
        function(s, o) {
          var l = e[o] || [], c = l.filter(function(u) {
            return !r(u, o, n);
          });
          return c.length !== l.length && (i = !0), s[o] = c, s;
        },
        {}
      );
      return i ? a : e;
    }
  },
  /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */
  isRefined: function(e, r, n) {
    var i = !!e[r] && e[r].length > 0;
    if (n === void 0 || !i)
      return i;
    var a = "" + n;
    return e[r].indexOf(a) !== -1;
  }
}, Pw = dr, hs = vl, fp = Ci, Vc = vw, co = ml, uo = hl, Gc = gl, gs = bw, Aw = yw, Ee = Pw;
function bl(t, e) {
  return Array.isArray(t) && Array.isArray(e) ? t.length === e.length && t.every(function(r, n) {
    return bl(e[n], r);
  }) : t === e;
}
function Ow(t, e) {
  return fp(t, function(r) {
    return bl(r, e);
  });
}
function st(t) {
  var e = t ? st._parseNumbers(t) : {};
  e.userToken !== void 0 && !Aw(e.userToken) && console.warn(
    "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"
  ), this.facets = e.facets || [], this.disjunctiveFacets = e.disjunctiveFacets || [], this.hierarchicalFacets = e.hierarchicalFacets || [], this.facetsRefinements = e.facetsRefinements || {}, this.facetsExcludes = e.facetsExcludes || {}, this.disjunctiveFacetsRefinements = e.disjunctiveFacetsRefinements || {}, this.numericRefinements = e.numericRefinements || {}, this.tagRefinements = e.tagRefinements || [], this.hierarchicalFacetsRefinements = e.hierarchicalFacetsRefinements || {};
  var r = this;
  Object.keys(e).forEach(function(n) {
    var i = st.PARAMETERS.indexOf(n) !== -1, a = e[n] !== void 0;
    !i && a && (r[n] = e[n]);
  });
}
st.PARAMETERS = Object.keys(new st());
st._parseNumbers = function(t) {
  if (t instanceof st) return t;
  var e = {}, r = [
    "aroundPrecision",
    "aroundRadius",
    "getRankingInfo",
    "minWordSizefor2Typos",
    "minWordSizefor1Typo",
    "page",
    "maxValuesPerFacet",
    "distinct",
    "minimumAroundRadius",
    "hitsPerPage",
    "minProximity"
  ];
  if (r.forEach(function(i) {
    var a = t[i];
    if (typeof a == "string") {
      var s = parseFloat(a);
      e[i] = isNaN(s) ? a : s;
    }
  }), Array.isArray(t.insideBoundingBox) && (e.insideBoundingBox = t.insideBoundingBox.map(function(i) {
    return Array.isArray(i) ? i.map(function(a) {
      return parseFloat(a);
    }) : i;
  })), t.numericRefinements) {
    var n = {};
    Object.keys(t.numericRefinements).forEach(function(i) {
      var a = t.numericRefinements[i] || {};
      n[i] = {}, Object.keys(a).forEach(function(s) {
        var o = a[s], l = o.map(function(c) {
          return Array.isArray(c) ? c.map(function(u) {
            return typeof u == "string" ? parseFloat(u) : u;
          }) : typeof c == "string" ? parseFloat(c) : c;
        });
        n[i][s] = l;
      });
    }), e.numericRefinements = n;
  }
  return co(t, e);
};
st.make = function(e) {
  var r = new st(e), n = e.hierarchicalFacets || [];
  return n.forEach(function(i) {
    if (i.rootPath) {
      var a = r.getHierarchicalRefinement(i.name);
      a.length > 0 && a[0].indexOf(i.rootPath) !== 0 && (r = r.clearRefinements(i.name)), a = r.getHierarchicalRefinement(i.name), a.length === 0 && (r = r.toggleHierarchicalFacetRefinement(
        i.name,
        i.rootPath
      ));
    }
  }), r;
};
st.validate = function(t, e) {
  var r = e || {};
  return t.tagFilters && r.tagRefinements && r.tagRefinements.length > 0 ? new Error(
    "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method."
  ) : t.tagRefinements.length > 0 && r.tagFilters ? new Error(
    "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method."
  ) : t.numericFilters && r.numericRefinements && uo(r.numericRefinements) ? new Error(
    "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
  ) : uo(t.numericRefinements) && r.numericFilters ? new Error(
    "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
  ) : null;
};
st.prototype = {
  constructor: st,
  /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */
  clearRefinements: function(e) {
    var r = {
      numericRefinements: this._clearNumericRefinements(e),
      facetsRefinements: Ee.clearRefinement(
        this.facetsRefinements,
        e,
        "conjunctiveFacet"
      ),
      facetsExcludes: Ee.clearRefinement(
        this.facetsExcludes,
        e,
        "exclude"
      ),
      disjunctiveFacetsRefinements: Ee.clearRefinement(
        this.disjunctiveFacetsRefinements,
        e,
        "disjunctiveFacet"
      ),
      hierarchicalFacetsRefinements: Ee.clearRefinement(
        this.hierarchicalFacetsRefinements,
        e,
        "hierarchicalFacet"
      )
    };
    return r.numericRefinements === this.numericRefinements && r.facetsRefinements === this.facetsRefinements && r.facetsExcludes === this.facetsExcludes && r.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && r.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(r);
  },
  /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */
  clearTags: function() {
    return this.tagFilters === void 0 && this.tagRefinements.length === 0 ? this : this.setQueryParameters({
      tagFilters: void 0,
      tagRefinements: []
    });
  },
  /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */
  setIndex: function(e) {
    return e === this.index ? this : this.setQueryParameters({
      index: e
    });
  },
  /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */
  setQuery: function(e) {
    return e === this.query ? this : this.setQueryParameters({
      query: e
    });
  },
  /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */
  setPage: function(e) {
    return e === this.page ? this : this.setQueryParameters({
      page: e
    });
  },
  /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */
  setFacets: function(e) {
    return this.setQueryParameters({
      facets: e
    });
  },
  /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */
  setDisjunctiveFacets: function(e) {
    return this.setQueryParameters({
      disjunctiveFacets: e
    });
  },
  /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */
  setHitsPerPage: function(e) {
    return this.hitsPerPage === e ? this : this.setQueryParameters({
      hitsPerPage: e
    });
  },
  /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */
  setTypoTolerance: function(e) {
    return this.typoTolerance === e ? this : this.setQueryParameters({
      typoTolerance: e
    });
  },
  /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */
  addNumericRefinement: function(t, e, r) {
    var n = gs(r);
    if (this.isNumericRefined(t, e, n)) return this;
    var i = co({}, this.numericRefinements);
    return i[t] = co({}, i[t]), i[t][e] ? (i[t][e] = i[t][e].slice(), i[t][e].push(n)) : i[t][e] = [n], this.setQueryParameters({
      numericRefinements: i
    });
  },
  /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getConjunctiveRefinements: function(t) {
    return this.isConjunctiveFacet(t) ? this.facetsRefinements[t] || [] : [];
  },
  /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getDisjunctiveRefinements: function(t) {
    return this.isDisjunctiveFacet(t) ? this.disjunctiveFacetsRefinements[t] || [] : [];
  },
  /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getHierarchicalRefinement: function(t) {
    return this.hierarchicalFacetsRefinements[t] || [];
  },
  /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getExcludeRefinements: function(t) {
    return this.isConjunctiveFacet(t) ? this.facetsExcludes[t] || [] : [];
  },
  /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */
  removeNumericRefinement: function(t, e, r) {
    var n = r;
    return n !== void 0 ? this.isNumericRefined(t, e, n) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function(i, a) {
        return a === t && i.op === e && bl(i.val, gs(n));
      })
    }) : this : e !== void 0 ? this.isNumericRefined(t, e) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function(i, a) {
        return a === t && i.op === e;
      })
    }) : this : this.isNumericRefined(t) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function(i, a) {
        return a === t;
      })
    }) : this;
  },
  /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */
  getNumericRefinements: function(t) {
    return this.numericRefinements[t] || {};
  },
  /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */
  getNumericRefinement: function(t, e) {
    return this.numericRefinements[t] && this.numericRefinements[t][e];
  },
  /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */
  _clearNumericRefinements: function(e) {
    if (e === void 0)
      return uo(this.numericRefinements) ? {} : this.numericRefinements;
    if (typeof e == "string")
      return Gc(this.numericRefinements, [e]);
    if (typeof e == "function") {
      var r = !1, n = this.numericRefinements, i = Object.keys(n).reduce(
        function(a, s) {
          var o = n[s], l = {};
          return o = o || {}, Object.keys(o).forEach(function(c) {
            var u = o[c] || [], f = [];
            u.forEach(function(m) {
              var h = e(
                { val: m, op: c },
                s,
                "numeric"
              );
              h || f.push(m);
            }), f.length !== u.length && (r = !0), l[c] = f;
          }), a[s] = l, a;
        },
        {}
      );
      return r ? i : this.numericRefinements;
    }
  },
  /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */
  addFacet: function(e) {
    return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
      facets: this.facets.concat([e])
    });
  },
  /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */
  addDisjunctiveFacet: function(e) {
    return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.concat([e])
    });
  },
  /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */
  addHierarchicalFacet: function(e) {
    if (this.isHierarchicalFacet(e.name))
      throw new Error(
        "Cannot declare two hierarchical facets with the same name: `" + e.name + "`"
      );
    return this.setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.concat([e])
    });
  },
  /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */
  addFacetRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return Ee.isRefined(this.facetsRefinements, e, r) ? this : this.setQueryParameters({
      facetsRefinements: Ee.addRefinement(
        this.facetsRefinements,
        e,
        r
      )
    });
  },
  /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */
  addExcludeRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return Ee.isRefined(this.facetsExcludes, e, r) ? this : this.setQueryParameters({
      facetsExcludes: Ee.addRefinement(
        this.facetsExcludes,
        e,
        r
      )
    });
  },
  /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */
  addDisjunctiveFacetRefinement: function(e, r) {
    if (!this.isDisjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the disjunctiveFacets attribute of the helper configuration"
      );
    return Ee.isRefined(this.disjunctiveFacetsRefinements, e, r) ? this : this.setQueryParameters({
      disjunctiveFacetsRefinements: Ee.addRefinement(
        this.disjunctiveFacetsRefinements,
        e,
        r
      )
    });
  },
  /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */
  addTagRefinement: function(e) {
    if (this.isTagRefined(e)) return this;
    var r = {
      tagRefinements: this.tagRefinements.concat(e)
    };
    return this.setQueryParameters(r);
  },
  /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */
  removeFacet: function(e) {
    return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
      facets: this.facets.filter(function(r) {
        return r !== e;
      })
    }) : this;
  },
  /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */
  removeDisjunctiveFacet: function(e) {
    return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.filter(function(r) {
        return r !== e;
      })
    }) : this;
  },
  /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */
  removeHierarchicalFacet: function(e) {
    return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.filter(function(r) {
        return r.name !== e;
      })
    }) : this;
  },
  /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */
  removeFacetRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return Ee.isRefined(this.facetsRefinements, e, r) ? this.setQueryParameters({
      facetsRefinements: Ee.removeRefinement(
        this.facetsRefinements,
        e,
        r
      )
    }) : this;
  },
  /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */
  removeExcludeRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return Ee.isRefined(this.facetsExcludes, e, r) ? this.setQueryParameters({
      facetsExcludes: Ee.removeRefinement(
        this.facetsExcludes,
        e,
        r
      )
    }) : this;
  },
  /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */
  removeDisjunctiveFacetRefinement: function(e, r) {
    if (!this.isDisjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the disjunctiveFacets attribute of the helper configuration"
      );
    return Ee.isRefined(this.disjunctiveFacetsRefinements, e, r) ? this.setQueryParameters({
      disjunctiveFacetsRefinements: Ee.removeRefinement(
        this.disjunctiveFacetsRefinements,
        e,
        r
      )
    }) : this;
  },
  /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */
  removeTagRefinement: function(e) {
    if (!this.isTagRefined(e)) return this;
    var r = {
      tagRefinements: this.tagRefinements.filter(function(n) {
        return n !== e;
      })
    };
    return this.setQueryParameters(r);
  },
  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */
  toggleRefinement: function(e, r) {
    return this.toggleFacetRefinement(e, r);
  },
  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */
  toggleFacetRefinement: function(e, r) {
    if (this.isHierarchicalFacet(e))
      return this.toggleHierarchicalFacetRefinement(e, r);
    if (this.isConjunctiveFacet(e))
      return this.toggleConjunctiveFacetRefinement(e, r);
    if (this.isDisjunctiveFacet(e))
      return this.toggleDisjunctiveFacetRefinement(e, r);
    throw new Error(
      "Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
    );
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */
  toggleConjunctiveFacetRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return this.setQueryParameters({
      facetsRefinements: Ee.toggleRefinement(
        this.facetsRefinements,
        e,
        r
      )
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */
  toggleExcludeFacetRefinement: function(e, r) {
    if (!this.isConjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the facets attribute of the helper configuration"
      );
    return this.setQueryParameters({
      facetsExcludes: Ee.toggleRefinement(
        this.facetsExcludes,
        e,
        r
      )
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */
  toggleDisjunctiveFacetRefinement: function(e, r) {
    if (!this.isDisjunctiveFacet(e))
      throw new Error(
        e + " is not defined in the disjunctiveFacets attribute of the helper configuration"
      );
    return this.setQueryParameters({
      disjunctiveFacetsRefinements: Ee.toggleRefinement(
        this.disjunctiveFacetsRefinements,
        e,
        r
      )
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */
  toggleHierarchicalFacetRefinement: function(e, r) {
    if (!this.isHierarchicalFacet(e))
      throw new Error(
        e + " is not defined in the hierarchicalFacets attribute of the helper configuration"
      );
    var n = this._getHierarchicalFacetSeparator(
      this.getHierarchicalFacetByName(e)
    ), i = {}, a = this.hierarchicalFacetsRefinements[e] !== void 0 && this.hierarchicalFacetsRefinements[e].length > 0 && // remove current refinement:
    // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
    (this.hierarchicalFacetsRefinements[e][0] === r || // remove a parent refinement of the current refinement:
    //  - refinement was 'beer > IPA > Flying dog'
    //  - call is toggleRefine('beer > IPA')
    //  - refinement should be `beer`
    this.hierarchicalFacetsRefinements[e][0].indexOf(
      r + n
    ) === 0);
    return a ? r.indexOf(n) === -1 ? i[e] = [] : i[e] = [r.slice(0, r.lastIndexOf(n))] : i[e] = [r], this.setQueryParameters({
      hierarchicalFacetsRefinements: hs(
        i,
        this.hierarchicalFacetsRefinements
      )
    });
  },
  /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */
  addHierarchicalFacetRefinement: function(t, e) {
    if (this.isHierarchicalFacetRefined(t))
      throw new Error(t + " is already refined.");
    if (!this.isHierarchicalFacet(t))
      throw new Error(
        t + " is not defined in the hierarchicalFacets attribute of the helper configuration."
      );
    var r = {};
    return r[t] = [e], this.setQueryParameters({
      hierarchicalFacetsRefinements: hs(
        r,
        this.hierarchicalFacetsRefinements
      )
    });
  },
  /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */
  removeHierarchicalFacetRefinement: function(t) {
    if (!this.isHierarchicalFacetRefined(t))
      return this;
    var e = {};
    return e[t] = [], this.setQueryParameters({
      hierarchicalFacetsRefinements: hs(
        e,
        this.hierarchicalFacetsRefinements
      )
    });
  },
  /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */
  toggleTagRefinement: function(e) {
    return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
  },
  /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */
  isDisjunctiveFacet: function(t) {
    return this.disjunctiveFacets.indexOf(t) > -1;
  },
  /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */
  isHierarchicalFacet: function(t) {
    return this.getHierarchicalFacetByName(t) !== void 0;
  },
  /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */
  isConjunctiveFacet: function(t) {
    return this.facets.indexOf(t) > -1;
  },
  /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isFacetRefined: function(e, r) {
    return this.isConjunctiveFacet(e) ? Ee.isRefined(this.facetsRefinements, e, r) : !1;
  },
  /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isExcludeRefined: function(e, r) {
    return this.isConjunctiveFacet(e) ? Ee.isRefined(this.facetsExcludes, e, r) : !1;
  },
  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */
  isDisjunctiveFacetRefined: function(e, r) {
    return this.isDisjunctiveFacet(e) ? Ee.isRefined(
      this.disjunctiveFacetsRefinements,
      e,
      r
    ) : !1;
  },
  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */
  isHierarchicalFacetRefined: function(e, r) {
    if (!this.isHierarchicalFacet(e))
      return !1;
    var n = this.getHierarchicalRefinement(e);
    return r ? n.indexOf(r) !== -1 : n.length > 0;
  },
  /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */
  isNumericRefined: function(e, r, n) {
    if (n === void 0 && r === void 0)
      return !!this.numericRefinements[e];
    var i = this.numericRefinements[e] && this.numericRefinements[e][r] !== void 0;
    if (n === void 0 || !i)
      return i;
    var a = gs(n), s = Ow(this.numericRefinements[e][r], a) !== void 0;
    return i && s;
  },
  /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */
  isTagRefined: function(e) {
    return this.tagRefinements.indexOf(e) !== -1;
  },
  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */
  getRefinedDisjunctiveFacets: function() {
    var e = this, r = Vc(
      Object.keys(this.numericRefinements).filter(function(n) {
        return Object.keys(e.numericRefinements[n]).length > 0;
      }),
      this.disjunctiveFacets
    );
    return Object.keys(this.disjunctiveFacetsRefinements).filter(function(n) {
      return e.disjunctiveFacetsRefinements[n].length > 0;
    }).concat(r).concat(this.getRefinedHierarchicalFacets()).sort();
  },
  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */
  getRefinedHierarchicalFacets: function() {
    var e = this;
    return Vc(
      // enforce the order between the two arrays,
      // so that refinement name index === hierarchical facet index
      this.hierarchicalFacets.map(function(r) {
        return r.name;
      }),
      Object.keys(this.hierarchicalFacetsRefinements).filter(function(r) {
        return e.hierarchicalFacetsRefinements[r].length > 0;
      })
    ).sort();
  },
  /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */
  getUnrefinedDisjunctiveFacets: function() {
    var t = this.getRefinedDisjunctiveFacets();
    return this.disjunctiveFacets.filter(function(e) {
      return t.indexOf(e) === -1;
    });
  },
  managedParameters: [
    "index",
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "hierarchicalFacets",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacetsRefinements"
  ],
  getQueryParams: function() {
    var e = this.managedParameters, r = {}, n = this;
    return Object.keys(this).forEach(function(i) {
      var a = n[i];
      e.indexOf(i) === -1 && a !== void 0 && (r[i] = a);
    }), r;
  },
  /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */
  setQueryParameter: function(e, r) {
    if (this[e] === r) return this;
    var n = {};
    return n[e] = r, this.setQueryParameters(n);
  },
  /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */
  setQueryParameters: function(e) {
    if (!e) return this;
    var r = st.validate(this, e);
    if (r)
      throw r;
    var n = this, i = st._parseNumbers(e), a = Object.keys(this).reduce(function(o, l) {
      return o[l] = n[l], o;
    }, {}), s = Object.keys(i).reduce(
      function(o, l) {
        var c = o[l] !== void 0, u = i[l] !== void 0;
        return c && !u ? Gc(o, [l]) : (u && (o[l] = i[l]), o);
      },
      a
    );
    return new this.constructor(s);
  },
  /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */
  resetPage: function() {
    return this.page === void 0 ? this : this.setPage(0);
  },
  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSortBy: function(t) {
    return t.sortBy || ["isRefined:desc", "name:asc"];
  },
  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSeparator: function(t) {
    return t.separator || " > ";
  },
  /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */
  _getHierarchicalRootPath: function(t) {
    return t.rootPath || null;
  },
  /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */
  _getHierarchicalShowParentLevel: function(t) {
    return typeof t.showParentLevel == "boolean" ? t.showParentLevel : !0;
  },
  /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */
  getHierarchicalFacetByName: function(t) {
    return fp(this.hierarchicalFacets, function(e) {
      return e.name === t;
    });
  },
  /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */
  getHierarchicalFacetBreadcrumb: function(t) {
    if (!this.isHierarchicalFacet(t))
      return [];
    var e = this.getHierarchicalRefinement(t)[0];
    if (!e) return [];
    var r = this._getHierarchicalFacetSeparator(
      this.getHierarchicalFacetByName(t)
    ), n = e.split(r);
    return n.map(function(i) {
      return i.trim();
    });
  },
  toString: function() {
    return JSON.stringify(this, null, 2);
  }
};
var pp = st, Tw = function(e) {
  return Array.isArray(e) ? e.filter(Boolean) : [];
}, jw = function(e, r) {
  if (!Array.isArray(e))
    return -1;
  for (var n = 0; n < e.length; n++)
    if (r(e[n]))
      return n;
  return -1;
}, kw = Ci, mp = function(e, r) {
  var n = (r || []).map(function(i) {
    return i.split(":");
  });
  return e.reduce(
    function(a, s) {
      var o = s.split(":"), l = kw(
        n,
        function(c) {
          return c[0] === o[0];
        }
      );
      return o.length > 1 || !l ? (a[0].push(o[0]), a[1].push(o[1]), a) : (a[0].push(l[0]), a[1].push(l[1]), a);
    },
    [[], []]
  );
};
function Mw() {
  var t = Array.prototype.slice.call(arguments);
  return t.reduceRight(function(e, r) {
    return Object.keys(Object(r)).forEach(function(n) {
      var i = typeof e[n] == "number" ? e[n] : 0, a = r[n];
      a !== void 0 && a >= i && (e[n] !== void 0 && delete e[n], e[n] = a);
    }), e;
  }, {});
}
var zw = Mw;
function Ew(t, e) {
  if (t !== e) {
    var r = t !== void 0, n = t === null, i = e !== void 0, a = e === null;
    if (!a && t > e || n && i || !r)
      return 1;
    if (!n && t < e || a && r || !i)
      return -1;
  }
  return 0;
}
function Cw(t, e, r) {
  if (!Array.isArray(t))
    return [];
  Array.isArray(r) || (r = []);
  var n = t.map(function(i, a) {
    return {
      criteria: e.map(function(s) {
        return i[s];
      }),
      index: a,
      value: i
    };
  });
  return n.sort(function(a, s) {
    for (var o = -1; ++o < a.criteria.length; ) {
      var l = Ew(a.criteria[o], s.criteria[o]);
      if (l)
        return o >= r.length ? l : r[o] === "desc" ? -l : l;
    }
    return a.index - s.index;
  }), n.map(function(i) {
    return i.value;
  });
}
var hp = Cw, Iw = Ww, gp = fl, Lw = Ci, Rw = mp, Nw = hp, Dw = gp.escapeFacetValue, Hw = gp.unescapeFacetValue;
function Ww(t) {
  return function(r, n) {
    var i = t.hierarchicalFacets[n], a = t.hierarchicalFacetsRefinements[i.name] && t.hierarchicalFacetsRefinements[i.name][0] || "", s = t._getHierarchicalFacetSeparator(i), o = t._getHierarchicalRootPath(i), l = t._getHierarchicalShowParentLevel(i), c = Rw(
      t._getHierarchicalFacetSortBy(i)
    ), u = r.every(function(h) {
      return h.exhaustive;
    }), f = Fw(
      c,
      s,
      o,
      l,
      a
    ), m = r;
    return o && (m = r.slice(
      o.split(s).length
    )), m.reduce(f, {
      name: t.hierarchicalFacets[n].name,
      count: null,
      // root level, no count
      isRefined: !0,
      // root level, always refined
      path: null,
      // root level, no path
      escapedValue: null,
      exhaustive: u,
      data: null
    });
  };
}
function Fw(t, e, r, n, i) {
  return function(s, o, l) {
    var c = s;
    if (l > 0) {
      var u = 0;
      for (c = s; u < l; ) {
        var f = c && Array.isArray(c.data) ? c.data : [];
        c = Lw(f, function(h) {
          return h.isRefined;
        }), u++;
      }
    }
    if (c) {
      var m = Object.keys(o.data).map(function(h) {
        return [h, o.data[h]];
      }).filter(function(h) {
        var p = h[0];
        return Vw(
          p,
          c.path || r,
          i,
          e,
          r,
          n
        );
      });
      c.data = Nw(
        m.map(function(h) {
          var p = h[0], d = h[1];
          return Gw(
            d,
            p,
            e,
            Hw(i),
            o.exhaustive
          );
        }),
        t[0],
        t[1]
      );
    }
    return s;
  };
}
function Vw(t, e, r, n, i, a) {
  return i && (t.indexOf(i) !== 0 || i === t) ? !1 : !i && t.indexOf(n) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
  i && t.split(n).length - i.split(n).length === 1 || // if current refinement is a root level and current facetValue is a root level,
  // keep the facetValue
  t.indexOf(n) === -1 && r.indexOf(n) === -1 || // currentRefinement is a child of the facet value
  r.indexOf(t) === 0 || // facetValue is a child of the current parent, add it
  t.indexOf(e + n) === 0 && (a || t.indexOf(r) === 0);
}
function Gw(t, e, r, n, i) {
  var a = e.split(r);
  return {
    name: a[a.length - 1].trim(),
    path: e,
    escapedValue: Dw(e),
    count: t,
    isRefined: n === e || n.indexOf(e + r) === 0,
    exhaustive: i,
    data: null
  };
}
var vs = Tw, An = vl, vp = fl, Pt = Ci, on = jw, Zw = mp, Zc = zw, bp = hp, Xc = vp.escapeFacetValue, yp = vp.unescapeFacetValue, Xw = Iw;
function Bc(t) {
  var e = {};
  return t.forEach(function(r, n) {
    e[r] = n;
  }), e;
}
function bs(t, e, r) {
  e && e[r] && (t.stats = e[r]);
}
function Bw(t, e) {
  return Pt(
    t,
    function(n) {
      var i = n.attributes || [];
      return i.indexOf(e) > -1;
    }
  );
}
function tr(t, e, r) {
  var n = e[0] || {};
  this._rawResults = e;
  var i = this;
  Object.keys(n).forEach(function(f) {
    i[f] = n[f];
  });
  var a = An(r, {
    persistHierarchicalRootCount: !1
  });
  Object.keys(a).forEach(function(f) {
    i[f] = a[f];
  }), this.processingTimeMS = e.reduce(function(f, m) {
    return m.processingTimeMS === void 0 ? f : f + m.processingTimeMS;
  }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = t.hierarchicalFacets.map(
    function() {
      return [];
    }
  ), this.facets = [];
  var s = t.getRefinedDisjunctiveFacets(), o = Bc(t.facets), l = Bc(t.disjunctiveFacets), c = 1, u = n.facets || {};
  Object.keys(u).forEach(function(f) {
    var m = u[f], h = Bw(
      t.hierarchicalFacets,
      f
    );
    if (h) {
      var p = h.attributes.indexOf(f), d = on(t.hierarchicalFacets, function(y) {
        return y.name === h.name;
      });
      i.hierarchicalFacets[d][p] = {
        attribute: f,
        data: m,
        exhaustive: n.exhaustiveFacetsCount
      };
    } else {
      var v = t.disjunctiveFacets.indexOf(f) !== -1, b = t.facets.indexOf(f) !== -1, g;
      v && (g = l[f], i.disjunctiveFacets[g] = {
        name: f,
        data: m,
        exhaustive: n.exhaustiveFacetsCount
      }, bs(
        i.disjunctiveFacets[g],
        n.facets_stats,
        f
      )), b && (g = o[f], i.facets[g] = {
        name: f,
        data: m,
        exhaustive: n.exhaustiveFacetsCount
      }, bs(
        i.facets[g],
        n.facets_stats,
        f
      ));
    }
  }), this.hierarchicalFacets = vs(this.hierarchicalFacets), s.forEach(function(f) {
    var m = e[c], h = m && m.facets ? m.facets : {}, p = t.getHierarchicalFacetByName(f);
    Object.keys(h).forEach(function(d) {
      var v = h[d], b;
      if (p) {
        b = on(t.hierarchicalFacets, function(w) {
          return w.name === p.name;
        });
        var g = on(
          i.hierarchicalFacets[b],
          function(w) {
            return w.attribute === d;
          }
        );
        if (g === -1)
          return;
        i.hierarchicalFacets[b][g].data = i.persistHierarchicalRootCount ? Zc(
          i.hierarchicalFacets[b][g].data,
          v
        ) : An(
          v,
          i.hierarchicalFacets[b][g].data
        );
      } else {
        b = l[d];
        var y = n.facets && n.facets[d] || {};
        i.disjunctiveFacets[b] = {
          name: d,
          data: Zc(y, v),
          exhaustive: m.exhaustiveFacetsCount
        }, bs(
          i.disjunctiveFacets[b],
          m.facets_stats,
          d
        ), t.disjunctiveFacetsRefinements[d] && t.disjunctiveFacetsRefinements[d].forEach(function(w) {
          !i.disjunctiveFacets[b].data[w] && t.disjunctiveFacetsRefinements[d].indexOf(
            yp(w)
          ) > -1 && (i.disjunctiveFacets[b].data[w] = 0);
        });
      }
    }), c++;
  }), t.getRefinedHierarchicalFacets().forEach(function(f) {
    var m = t.getHierarchicalFacetByName(f), h = t._getHierarchicalFacetSeparator(m), p = t.getHierarchicalRefinement(f);
    p.length === 0 || p[0].split(h).length < 2 || e.slice(c).forEach(function(d) {
      var v = d && d.facets ? d.facets : {};
      Object.keys(v).forEach(function(b) {
        var g = v[b], y = on(t.hierarchicalFacets, function(A) {
          return A.name === m.name;
        }), w = on(
          i.hierarchicalFacets[y],
          function(A) {
            return A.attribute === b;
          }
        );
        if (w !== -1) {
          var P = {};
          if (p.length > 0 && !i.persistHierarchicalRootCount) {
            var T = p[0].split(h)[0];
            P[T] = i.hierarchicalFacets[y][w].data[T];
          }
          i.hierarchicalFacets[y][w].data = An(
            P,
            g,
            i.hierarchicalFacets[y][w].data
          );
        }
      }), c++;
    });
  }), Object.keys(t.facetsExcludes).forEach(function(f) {
    var m = t.facetsExcludes[f], h = o[f];
    i.facets[h] = {
      name: f,
      data: u[f],
      exhaustive: n.exhaustiveFacetsCount
    }, m.forEach(function(p) {
      i.facets[h] = i.facets[h] || { name: f }, i.facets[h].data = i.facets[h].data || {}, i.facets[h].data[p] = 0;
    });
  }), this.hierarchicalFacets = this.hierarchicalFacets.map(
    Xw(t)
  ), this.facets = vs(this.facets), this.disjunctiveFacets = vs(this.disjunctiveFacets), this._state = t;
}
tr.prototype.getFacetByName = function(t) {
  function e(r) {
    return r.name === t;
  }
  return Pt(this.facets, e) || Pt(this.disjunctiveFacets, e) || Pt(this.hierarchicalFacets, e);
};
function Uw(t, e) {
  function r(u) {
    return u.name === e;
  }
  if (t._state.isConjunctiveFacet(e)) {
    var n = Pt(t.facets, r);
    return n ? Object.keys(n.data).map(function(u) {
      var f = Xc(u);
      return {
        name: u,
        escapedValue: f,
        count: n.data[u],
        isRefined: t._state.isFacetRefined(e, f),
        isExcluded: t._state.isExcludeRefined(e, u)
      };
    }) : [];
  } else if (t._state.isDisjunctiveFacet(e)) {
    var i = Pt(t.disjunctiveFacets, r);
    return i ? Object.keys(i.data).map(function(u) {
      var f = Xc(u);
      return {
        name: u,
        escapedValue: f,
        count: i.data[u],
        isRefined: t._state.isDisjunctiveFacetRefined(e, f)
      };
    }) : [];
  } else if (t._state.isHierarchicalFacet(e)) {
    var a = Pt(t.hierarchicalFacets, r);
    if (!a) return a;
    var s = t._state.getHierarchicalFacetByName(e), o = t._state._getHierarchicalFacetSeparator(s), l = yp(
      t._state.getHierarchicalRefinement(e)[0] || ""
    );
    l.indexOf(s.rootPath) === 0 && (l = l.replace(
      s.rootPath + o,
      ""
    ));
    var c = l.split(o);
    return c.unshift(e), wp(a, c, 0), a;
  }
}
function wp(t, e, r) {
  t.isRefined = t.name === (e[r] && e[r].trim()), t.data && t.data.forEach(function(n) {
    wp(n, e, r + 1);
  });
}
function Sp(t, e, r, n) {
  if (n = n || 0, Array.isArray(e))
    return t(e, r[n]);
  if (!e.data || e.data.length === 0)
    return e;
  var i = e.data.map(function(o) {
    return Sp(t, o, r, n + 1);
  }), a = t(i, r[n]), s = An({ data: a }, e);
  return s;
}
tr.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"];
function Yw(t, e) {
  return e.sort(t);
}
function qw(t, e) {
  var r = [], n = [], i = e.hide || [], a = e.order || [], s = a.reduce(function(c, u, f) {
    return c[u] = f, c;
  }, {});
  t.forEach(function(c) {
    var u = c.path || c.name, f = i.indexOf(u) > -1;
    !f && s[u] !== void 0 ? r[s[u]] = c : f || n.push(c);
  }), r = r.filter(function(c) {
    return c;
  });
  var o = e.sortRemainingBy, l;
  return o === "hidden" ? r : (o === "alpha" ? l = [
    ["path", "name"],
    ["asc", "asc"]
  ] : l = [["count"], ["desc"]], r.concat(
    bp(n, l[0], l[1])
  ));
}
function Qw(t, e) {
  return t.renderingContent && t.renderingContent.facetOrdering && t.renderingContent.facetOrdering.values && t.renderingContent.facetOrdering.values[e];
}
tr.prototype.getFacetValues = function(t, e) {
  var r = Uw(this, t);
  if (r) {
    var n = An(e, {
      sortBy: tr.DEFAULT_SORT,
      // if no sortBy is given, attempt to sort based on facetOrdering
      // if it is given, we still allow to sort via facet ordering first
      facetOrdering: !(e && e.sortBy)
    }), i = this, a;
    if (Array.isArray(r))
      a = [t];
    else {
      var s = i._state.getHierarchicalFacetByName(r.name);
      a = s.attributes;
    }
    return Sp(
      function(o, l) {
        if (n.facetOrdering) {
          var c = Qw(i, l);
          if (c)
            return qw(o, c);
        }
        if (Array.isArray(n.sortBy)) {
          var u = Zw(n.sortBy, tr.DEFAULT_SORT);
          return bp(o, u[0], u[1]);
        } else if (typeof n.sortBy == "function")
          return Yw(n.sortBy, o);
        throw new Error(
          "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function"
        );
      },
      r,
      a
    );
  }
};
tr.prototype.getFacetStats = function(t) {
  if (this._state.isConjunctiveFacet(t))
    return Uc(this.facets, t);
  if (this._state.isDisjunctiveFacet(t))
    return Uc(this.disjunctiveFacets, t);
};
function Uc(t, e) {
  var r = Pt(t, function(n) {
    return n.name === e;
  });
  return r && r.stats;
}
tr.prototype.getRefinements = function() {
  var t = this._state, e = this, r = [];
  return Object.keys(t.facetsRefinements).forEach(function(n) {
    t.facetsRefinements[n].forEach(function(i) {
      r.push(
        ys(t, "facet", n, i, e.facets)
      );
    });
  }), Object.keys(t.facetsExcludes).forEach(function(n) {
    t.facetsExcludes[n].forEach(function(i) {
      r.push(
        ys(t, "exclude", n, i, e.facets)
      );
    });
  }), Object.keys(t.disjunctiveFacetsRefinements).forEach(function(n) {
    t.disjunctiveFacetsRefinements[n].forEach(function(i) {
      r.push(
        ys(
          t,
          "disjunctive",
          n,
          i,
          e.disjunctiveFacets
        )
      );
    });
  }), Object.keys(t.hierarchicalFacetsRefinements).forEach(function(n) {
    t.hierarchicalFacetsRefinements[n].forEach(function(i) {
      r.push(
        Jw(
          t,
          n,
          i,
          e.hierarchicalFacets
        )
      );
    });
  }), Object.keys(t.numericRefinements).forEach(function(n) {
    var i = t.numericRefinements[n];
    Object.keys(i).forEach(function(a) {
      i[a].forEach(function(s) {
        r.push({
          type: "numeric",
          attributeName: n,
          name: s,
          numericValue: s,
          operator: a
        });
      });
    });
  }), t.tagRefinements.forEach(function(n) {
    r.push({ type: "tag", attributeName: "_tags", name: n });
  }), r;
};
function ys(t, e, r, n, i) {
  var a = Pt(i, function(l) {
    return l.name === r;
  }), s = a && a.data && a.data[n] ? a.data[n] : 0, o = a && a.exhaustive || !1;
  return {
    type: e,
    attributeName: r,
    name: n,
    count: s,
    exhaustive: o
  };
}
function Jw(t, e, r, n) {
  var i = t.getHierarchicalFacetByName(e), a = t._getHierarchicalFacetSeparator(i), s = r.split(a), o = Pt(n, function(m) {
    return m.name === e;
  }), l = s.reduce(function(m, h) {
    var p = m && Pt(m.data, function(d) {
      return d.name === h;
    });
    return p !== void 0 ? p : m;
  }, o), c = l && l.count || 0, u = l && l.exhaustive || !1, f = l && l.path || "";
  return {
    type: "hierarchical",
    attributeName: e,
    name: f,
    count: c,
    exhaustive: u
  };
}
var xp = tr, Kw = function(e) {
  return e.reduce(function(r, n) {
    return r.concat(n);
  }, []);
}, _w = Ci, $w = Kw;
function e4(t, e) {
  var r = [];
  return Object.keys(t).forEach(function(n) {
    t[n].count < 2 && (t[n].indexSum += 100), r.push({
      objectID: n,
      avgOfIndices: t[n].indexSum / e
    });
  }), r.sort(function(n, i) {
    return n.avgOfIndices > i.avgOfIndices ? 1 : -1;
  });
}
function t4(t) {
  var e = {};
  t.forEach(function(i) {
    i.forEach(function(a, s) {
      e[a.objectID] ? e[a.objectID] = {
        indexSum: e[a.objectID].indexSum + s,
        count: e[a.objectID].count + 1
      } : e[a.objectID] = { indexSum: s, count: 1 };
    });
  });
  var r = e4(e, t.length), n = r.reduce(
    function(i, a) {
      var s = _w($w(t), function(o) {
        return o.objectID === a.objectID;
      });
      return s ? i.concat(s) : i;
    },
    []
  );
  return n;
}
var r4 = t4, Pp = "3.24.1", n4 = dl, i4 = lw, Ap = fl.escapeFacetValue, a4 = lp, s4 = ml, o4 = hl, l4 = gl, Op = cp, c4 = up, ar = hw, yl = pp, fo = xp, u4 = r4, Tp = Pp;
function K(t, e, r, n) {
  typeof t.addAlgoliaAgent == "function" && t.addAlgoliaAgent("JS Helper (" + Tp + ")"), this.setClient(t);
  var i = r || {};
  i.index = e, this.state = yl.make(i), this.recommendState = new Op({
    params: i.recommendState
  }), this.lastResults = null, this.lastRecommendResults = null, this._queryId = 0, this._recommendQueryId = 0, this._lastQueryIdReceived = -1, this._lastRecommendQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0, this._currentNbRecommendQueries = 0, this._searchResultsOptions = n, this._recommendCache = {};
}
a4(K, n4);
K.prototype.search = function() {
  return this._search({ onlyWithDerivedHelpers: !1 }), this;
};
K.prototype.searchOnlyWithDerivedHelpers = function() {
  return this._search({ onlyWithDerivedHelpers: !0 }), this;
};
K.prototype.searchWithComposition = function() {
  return this._runComposition({ onlyWithDerivedHelpers: !0 }), this;
};
K.prototype.recommend = function() {
  return this._recommend(), this;
};
K.prototype.getQuery = function() {
  var t = this.state;
  return ar._getHitsSearchParams(t);
};
K.prototype.searchOnce = function(t, e) {
  var r = t ? this.state.setQueryParameters(t) : this.state, n = ar._getQueries(r.index, r), i = this;
  if (this._currentNbQueries++, this.emit("searchOnce", {
    state: r
  }), e) {
    this.client.search(n).then(function(a) {
      i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), e(null, new fo(r, a.results), r);
    }).catch(function(a) {
      i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), e(a, null, r);
    });
    return;
  }
  return this.client.search(n).then(
    function(a) {
      return i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), {
        content: new fo(r, a.results),
        state: r,
        _originalResponse: a
      };
    },
    function(a) {
      throw i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), a;
    }
  );
};
K.prototype.findAnswers = function(t) {
  console.warn("[algoliasearch-helper] answers is no longer supported");
  var e = this.state, r = this.derivedHelpers[0];
  if (!r)
    return Promise.resolve([]);
  var n = r.getModifiedState(e), i = s4(
    {
      attributesForPrediction: t.attributesForPrediction,
      nbHits: t.nbHits
    },
    {
      params: l4(ar._getHitsSearchParams(n), [
        "attributesToSnippet",
        "hitsPerPage",
        "restrictSearchableAttributes",
        "snippetEllipsisText"
      ])
    }
  ), a = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
  if (typeof this.client.initIndex != "function")
    throw new Error(a);
  var s = this.client.initIndex(n.index);
  if (typeof s.findAnswers != "function")
    throw new Error(a);
  return s.findAnswers(n.query, t.queryLanguages, i);
};
K.prototype.searchForFacetValues = function(t, e, r, n) {
  var i = typeof this.client.searchForFacetValues == "function" && // v5 has a wrong sffv signature
  typeof this.client.searchForFacets != "function", a = typeof this.client.initIndex == "function";
  if (!i && !a && typeof this.client.search != "function")
    throw new Error(
      "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues"
    );
  var s = this.state.setQueryParameters(n || {}), o = s.isDisjunctiveFacet(t), l = ar.getSearchForFacetQuery(
    t,
    e,
    r,
    s
  );
  this._currentNbQueries++;
  var c = this, u;
  return i ? u = this.client.searchForFacetValues([
    { indexName: s.index, params: l }
  ]) : a ? u = this.client.initIndex(s.index).searchForFacetValues(l) : (delete l.facetName, u = this.client.search([
    {
      type: "facet",
      facet: t,
      indexName: s.index,
      params: l
    }
  ]).then(function(m) {
    return m.results[0];
  })), this.emit("searchForFacetValues", {
    state: s,
    facet: t,
    query: e
  }), u.then(
    function(m) {
      return c._currentNbQueries--, c._currentNbQueries === 0 && c.emit("searchQueueEmpty"), m = Array.isArray(m) ? m[0] : m, m.facetHits.forEach(function(h) {
        h.escapedValue = Ap(h.value), h.isRefined = o ? s.isDisjunctiveFacetRefined(t, h.escapedValue) : s.isFacetRefined(t, h.escapedValue);
      }), m;
    },
    function(f) {
      throw c._currentNbQueries--, c._currentNbQueries === 0 && c.emit("searchQueueEmpty"), f;
    }
  );
};
K.prototype.searchForCompositionFacetValues = function(t, e, r, n) {
  if (typeof this.client.searchForFacetValues != "function")
    throw new Error(
      "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues"
    );
  var i = this.state.setQueryParameters(n || {}), a = i.isDisjunctiveFacet(t);
  this._currentNbQueries++;
  var s = this, o;
  return o = this.client.searchForFacetValues({
    compositionID: i.index,
    facetName: t,
    searchForFacetValuesRequest: {
      params: {
        query: e,
        maxFacetHits: r,
        searchQuery: ar._getCompositionHitsSearchParams(i)
      }
    }
  }), this.emit("searchForFacetValues", {
    state: i,
    facet: t,
    query: e
  }), o.then(
    function(c) {
      return s._currentNbQueries--, s._currentNbQueries === 0 && s.emit("searchQueueEmpty"), c = c.results[0], c.facetHits.forEach(function(u) {
        u.escapedValue = Ap(u.value), u.isRefined = a ? i.isDisjunctiveFacetRefined(t, u.escapedValue) : i.isFacetRefined(t, u.escapedValue);
      }), c;
    },
    function(l) {
      throw s._currentNbQueries--, s._currentNbQueries === 0 && s.emit("searchQueueEmpty"), l;
    }
  );
};
K.prototype.setQuery = function(t) {
  return this._change({
    state: this.state.resetPage().setQuery(t),
    isPageReset: !0
  }), this;
};
K.prototype.clearRefinements = function(t) {
  return this._change({
    state: this.state.resetPage().clearRefinements(t),
    isPageReset: !0
  }), this;
};
K.prototype.clearTags = function() {
  return this._change({
    state: this.state.resetPage().clearTags(),
    isPageReset: !0
  }), this;
};
K.prototype.addDisjunctiveFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().addDisjunctiveFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.addDisjunctiveRefine = function() {
  return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
K.prototype.addHierarchicalFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().addHierarchicalFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.addNumericRefinement = function(t, e, r) {
  return this._change({
    state: this.state.resetPage().addNumericRefinement(t, e, r),
    isPageReset: !0
  }), this;
};
K.prototype.addFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().addFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.addRefine = function() {
  return this.addFacetRefinement.apply(this, arguments);
};
K.prototype.addFacetExclusion = function(t, e) {
  return this._change({
    state: this.state.resetPage().addExcludeRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.addExclude = function() {
  return this.addFacetExclusion.apply(this, arguments);
};
K.prototype.addTag = function(t) {
  return this._change({
    state: this.state.resetPage().addTagRefinement(t),
    isPageReset: !0
  }), this;
};
K.prototype.addFrequentlyBoughtTogether = function(t) {
  return this._recommendChange({
    state: this.recommendState.addFrequentlyBoughtTogether(t)
  }), this;
};
K.prototype.addRelatedProducts = function(t) {
  return this._recommendChange({
    state: this.recommendState.addRelatedProducts(t)
  }), this;
};
K.prototype.addTrendingItems = function(t) {
  return this._recommendChange({
    state: this.recommendState.addTrendingItems(t)
  }), this;
};
K.prototype.addTrendingFacets = function(t) {
  return this._recommendChange({
    state: this.recommendState.addTrendingFacets(t)
  }), this;
};
K.prototype.addLookingSimilar = function(t) {
  return this._recommendChange({
    state: this.recommendState.addLookingSimilar(t)
  }), this;
};
K.prototype.removeNumericRefinement = function(t, e, r) {
  return this._change({
    state: this.state.resetPage().removeNumericRefinement(t, e, r),
    isPageReset: !0
  }), this;
};
K.prototype.removeDisjunctiveFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().removeDisjunctiveFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.removeDisjunctiveRefine = function() {
  return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
K.prototype.removeHierarchicalFacetRefinement = function(t) {
  return this._change({
    state: this.state.resetPage().removeHierarchicalFacetRefinement(t),
    isPageReset: !0
  }), this;
};
K.prototype.removeFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().removeFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.removeRefine = function() {
  return this.removeFacetRefinement.apply(this, arguments);
};
K.prototype.removeFacetExclusion = function(t, e) {
  return this._change({
    state: this.state.resetPage().removeExcludeRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.removeExclude = function() {
  return this.removeFacetExclusion.apply(this, arguments);
};
K.prototype.removeTag = function(t) {
  return this._change({
    state: this.state.resetPage().removeTagRefinement(t),
    isPageReset: !0
  }), this;
};
K.prototype.removeFrequentlyBoughtTogether = function(t) {
  return this._recommendChange({
    state: this.recommendState.removeParams(t)
  }), this;
};
K.prototype.removeRelatedProducts = function(t) {
  return this._recommendChange({
    state: this.recommendState.removeParams(t)
  }), this;
};
K.prototype.removeTrendingItems = function(t) {
  return this._recommendChange({
    state: this.recommendState.removeParams(t)
  }), this;
};
K.prototype.removeTrendingFacets = function(t) {
  return this._recommendChange({
    state: this.recommendState.removeParams(t)
  }), this;
};
K.prototype.removeLookingSimilar = function(t) {
  return this._recommendChange({
    state: this.recommendState.removeParams(t)
  }), this;
};
K.prototype.toggleFacetExclusion = function(t, e) {
  return this._change({
    state: this.state.resetPage().toggleExcludeFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.toggleExclude = function() {
  return this.toggleFacetExclusion.apply(this, arguments);
};
K.prototype.toggleRefinement = function(t, e) {
  return this.toggleFacetRefinement(t, e);
};
K.prototype.toggleFacetRefinement = function(t, e) {
  return this._change({
    state: this.state.resetPage().toggleFacetRefinement(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.toggleRefine = function() {
  return this.toggleFacetRefinement.apply(this, arguments);
};
K.prototype.toggleTag = function(t) {
  return this._change({
    state: this.state.resetPage().toggleTagRefinement(t),
    isPageReset: !0
  }), this;
};
K.prototype.nextPage = function() {
  var t = this.state.page || 0;
  return this.setPage(t + 1);
};
K.prototype.previousPage = function() {
  var t = this.state.page || 0;
  return this.setPage(t - 1);
};
function jp(t) {
  if (t < 0) throw new Error("Page requested below 0.");
  return this._change({
    state: this.state.setPage(t),
    isPageReset: !1
  }), this;
}
K.prototype.setCurrentPage = jp;
K.prototype.setPage = jp;
K.prototype.setIndex = function(t) {
  return this._change({
    state: this.state.resetPage().setIndex(t),
    isPageReset: !0
  }), this;
};
K.prototype.setQueryParameter = function(t, e) {
  return this._change({
    state: this.state.resetPage().setQueryParameter(t, e),
    isPageReset: !0
  }), this;
};
K.prototype.setState = function(t) {
  return this._change({
    state: yl.make(t),
    isPageReset: !1
  }), this;
};
K.prototype.overrideStateWithoutTriggeringChangeEvent = function(t) {
  return this.state = new yl(t), this;
};
K.prototype.hasRefinements = function(t) {
  return o4(this.state.getNumericRefinements(t)) ? !0 : this.state.isConjunctiveFacet(t) ? this.state.isFacetRefined(t) : this.state.isDisjunctiveFacet(t) ? this.state.isDisjunctiveFacetRefined(t) : this.state.isHierarchicalFacet(t) ? this.state.isHierarchicalFacetRefined(t) : !1;
};
K.prototype.isExcluded = function(t, e) {
  return this.state.isExcludeRefined(t, e);
};
K.prototype.isDisjunctiveRefined = function(t, e) {
  return this.state.isDisjunctiveFacetRefined(t, e);
};
K.prototype.hasTag = function(t) {
  return this.state.isTagRefined(t);
};
K.prototype.isTagRefined = function() {
  return this.hasTagRefinements.apply(this, arguments);
};
K.prototype.getIndex = function() {
  return this.state.index;
};
function kp() {
  return this.state.page;
}
K.prototype.getCurrentPage = kp;
K.prototype.getPage = kp;
K.prototype.getTags = function() {
  return this.state.tagRefinements;
};
K.prototype.getRefinements = function(t) {
  var e = [];
  if (this.state.isConjunctiveFacet(t)) {
    var r = this.state.getConjunctiveRefinements(t);
    r.forEach(function(s) {
      e.push({
        value: s,
        type: "conjunctive"
      });
    });
    var n = this.state.getExcludeRefinements(t);
    n.forEach(function(s) {
      e.push({
        value: s,
        type: "exclude"
      });
    });
  } else if (this.state.isDisjunctiveFacet(t)) {
    var i = this.state.getDisjunctiveRefinements(t);
    i.forEach(function(s) {
      e.push({
        value: s,
        type: "disjunctive"
      });
    });
  }
  var a = this.state.getNumericRefinements(t);
  return Object.keys(a).forEach(function(s) {
    var o = a[s];
    e.push({
      value: o,
      operator: s,
      type: "numeric"
    });
  }), e;
};
K.prototype.getNumericRefinement = function(t, e) {
  return this.state.getNumericRefinement(t, e);
};
K.prototype.getHierarchicalFacetBreadcrumb = function(t) {
  return this.state.getHierarchicalFacetBreadcrumb(t);
};
K.prototype._search = function(t) {
  var e = this.state, r = [], n = [];
  t.onlyWithDerivedHelpers || (n = ar._getQueries(e.index, e), r.push({
    state: e,
    queriesCount: n.length,
    helper: this
  }), this.emit("search", {
    state: e,
    results: this.lastResults
  }));
  var i = this.derivedHelpers.map(function(o) {
    var l = o.getModifiedState(e), c = l.index ? ar._getQueries(l.index, l) : [];
    return r.push({
      state: l,
      queriesCount: c.length,
      helper: o
    }), o.emit("search", {
      state: l,
      results: o.lastResults
    }), c;
  }), a = Array.prototype.concat.apply(n, i), s = this._queryId++;
  if (this._currentNbQueries++, !a.length)
    return Promise.resolve({ results: [] }).then(
      this._dispatchAlgoliaResponse.bind(this, r, s)
    );
  try {
    this.client.search(a).then(this._dispatchAlgoliaResponse.bind(this, r, s)).catch(this._dispatchAlgoliaError.bind(this, s));
  } catch (o) {
    this.emit("error", {
      error: o
    });
  }
};
K.prototype._runComposition = function() {
  var t = this.state, e = [], r = [], n = this.derivedHelpers.map(function(o) {
    var l = o.getModifiedState(t), c = ar._getCompositionQueries(l);
    return e.push({
      state: l,
      queriesCount: c.length,
      helper: o
    }), o.emit("search", {
      state: l,
      results: o.lastResults
    }), c;
  }), i = Array.prototype.concat.apply(r, n), a = this._queryId++;
  if (this._currentNbQueries++, !i.length)
    return Promise.resolve({ results: [] }).then(
      this._dispatchAlgoliaResponse.bind(this, e, a)
    );
  if (i.length > 1)
    throw new Error("Only one query is allowed when using a composition.");
  var s = i[0];
  try {
    this.client.search(s).then(this._dispatchAlgoliaResponse.bind(this, e, a)).catch(this._dispatchAlgoliaError.bind(this, a));
  } catch (o) {
    this.emit("error", {
      error: o
    });
  }
};
K.prototype._recommend = function() {
  var t = this.state, e = this.recommendState, r = this.getIndex(), n = [{ state: e, index: r, helper: this }], i = e.params.map(function(c) {
    return c.$$id;
  });
  this.emit("fetch", {
    recommend: {
      state: e,
      results: this.lastRecommendResults
    }
  });
  var a = this._recommendCache, s = this.derivedHelpers.map(function(c) {
    var u = c.getModifiedState(t).index;
    if (!u)
      return [];
    var f = c.getModifiedRecommendState(
      new Op()
    );
    return n.push({
      state: f,
      index: u,
      helper: c
    }), i = Array.prototype.concat.apply(
      i,
      f.params.map(function(m) {
        return m.$$id;
      })
    ), c.emit("fetch", {
      recommend: {
        state: f,
        results: c.lastRecommendResults
      }
    }), f._buildQueries(u, a);
  }), o = Array.prototype.concat.apply(
    this.recommendState._buildQueries(r, a),
    s
  );
  if (o.length !== 0) {
    if (o.length > 0 && typeof this.client.getRecommendations > "u") {
      console.warn(
        "Please update algoliasearch/lite to the latest version in order to use recommend widgets."
      );
      return;
    }
    var l = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
      this.client.getRecommendations(o).then(this._dispatchRecommendResponse.bind(this, l, n, i)).catch(this._dispatchRecommendError.bind(this, l));
    } catch (c) {
      this.emit("error", {
        error: c
      });
    }
  }
};
K.prototype._dispatchAlgoliaResponse = function(t, e, r) {
  var n = this;
  if (!(e < this._lastQueryIdReceived)) {
    this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this._currentNbQueries === 0 && this.emit("searchQueueEmpty");
    var i = r.results.slice(), a = Object.keys(r).reduce(function(s, o) {
      return o !== "results" && (s[o] = r[o]), s;
    }, {});
    Object.keys(a).length <= 0 && (a = void 0), t.forEach(function(s) {
      var o = s.state, l = s.queriesCount, c = s.helper, u = i.splice(0, l);
      if (!o.index) {
        c.emit("result", {
          results: null,
          state: o
        });
        return;
      }
      c.lastResults = new fo(
        o,
        u,
        n._searchResultsOptions
      ), a !== void 0 && (c.lastResults._rawContent = a), c.emit("result", {
        results: c.lastResults,
        state: o
      });
    });
  }
};
K.prototype._dispatchRecommendResponse = function(t, e, r, n) {
  if (!(t < this._lastRecommendQueryIdReceived)) {
    this._currentNbRecommendQueries -= t - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = t, this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty");
    var i = this._recommendCache, a = {};
    r.filter(function(o) {
      return i[o] === void 0;
    }).forEach(function(o, l) {
      a[o] || (a[o] = []), a[o].push(l);
    }), Object.keys(a).forEach(function(o) {
      var l = a[o], c = n.results[l[0]];
      if (l.length === 1) {
        i[o] = c;
        return;
      }
      i[o] = Object.assign({}, c, {
        hits: u4(
          l.map(function(u) {
            return n.results[u].hits;
          })
        )
      });
    });
    var s = {};
    r.forEach(function(o) {
      s[o] = i[o];
    }), e.forEach(function(o) {
      var l = o.state, c = o.helper;
      if (!o.index) {
        c.emit("recommend:result", {
          results: null,
          state: l
        });
        return;
      }
      c.lastRecommendResults = new c4(l, s), c.emit("recommend:result", {
        recommend: {
          results: c.lastRecommendResults,
          state: l
        }
      });
    });
  }
};
K.prototype._dispatchAlgoliaError = function(t, e) {
  t < this._lastQueryIdReceived || (this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, this.emit("error", {
    error: e
  }), this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
};
K.prototype._dispatchRecommendError = function(t, e) {
  t < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= t - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = t, this.emit("error", {
    error: e
  }), this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty"));
};
K.prototype.containsRefinement = function(t, e, r, n) {
  return t || e.length !== 0 || r.length !== 0 || n.length !== 0;
};
K.prototype._hasDisjunctiveRefinements = function(t) {
  return this.state.disjunctiveRefinements[t] && this.state.disjunctiveRefinements[t].length > 0;
};
K.prototype._change = function(t) {
  var e = t.state, r = t.isPageReset;
  e !== this.state && (this.state = e, this.emit("change", {
    state: this.state,
    results: this.lastResults,
    isPageReset: r
  }));
};
K.prototype._recommendChange = function(t) {
  var e = t.state;
  e !== this.recommendState && (this.recommendState = e, this.emit("recommend:change", {
    search: {
      results: this.lastResults,
      state: this.state
    },
    recommend: {
      results: this.lastRecommendResults,
      state: this.recommendState
    }
  }));
};
K.prototype.clearCache = function() {
  return this.client.clearCache && this.client.clearCache(), this;
};
K.prototype.setClient = function(t) {
  return this.client === t ? this : (typeof t.addAlgoliaAgent == "function" && t.addAlgoliaAgent("JS Helper (" + Tp + ")"), this.client = t, this);
};
K.prototype.getClient = function() {
  return this.client;
};
K.prototype.derive = function(t, e) {
  var r = new i4(this, t, e);
  return this.derivedHelpers.push(r), r;
};
K.prototype.detachDerivedHelper = function(t) {
  var e = this.derivedHelpers.indexOf(t);
  if (e === -1) throw new Error("Derived helper already detached");
  this.derivedHelpers.splice(e, 1);
};
K.prototype.hasPendingRequests = function() {
  return this._currentNbQueries > 0;
};
var d4 = K, Mp = d4, f4 = cp, p4 = up, m4 = pp, h4 = xp;
function Ar(t, e, r, n) {
  return new Mp(t, e, r, n);
}
Ar.version = Pp;
Ar.AlgoliaSearchHelper = Mp;
Ar.SearchParameters = m4;
Ar.RecommendParameters = f4;
Ar.SearchResults = h4;
Ar.RecommendResults = p4;
var g4 = Ar;
const qe = /* @__PURE__ */ Fa(g4);
function Bn(t) {
  "@babel/helpers - typeof";
  return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bn(t);
}
function Yc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function We(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Yc(Object(r), !0).forEach(function(n) {
      zp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Yc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function zp(t, e, r) {
  return e = v4(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function v4(t) {
  var e = b4(t, "string");
  return Bn(e) == "symbol" ? e : String(e);
}
function b4(t, e) {
  if (Bn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Bn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var y4 = Pe({
  name: "configure",
  connector: !0
});
function qc(t, e) {
  return t.setQueryParameters(Object.keys(e.searchParameters).reduce(function(r, n) {
    return We(We({}, r), {}, zp({}, n, void 0));
  }, {}));
}
var Ep = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return function(n) {
    if (!n || !Kf(n.searchParameters))
      throw new Error(y4("The `searchParameters` option expects an object."));
    var i = {};
    function a(s) {
      return function(o) {
        var l = qc(s.state, n), c = Pn(l, new qe.SearchParameters(o));
        n.searchParameters = o, s.setState(c).search();
      };
    }
    return {
      $$type: "ais.configure",
      init: function(o) {
        var l = o.instantSearchInstance;
        e(We(We({}, this.getWidgetRenderState(o)), {}, {
          instantSearchInstance: l
        }), !0);
      },
      render: function(o) {
        var l = o.instantSearchInstance;
        e(We(We({}, this.getWidgetRenderState(o)), {}, {
          instantSearchInstance: l
        }), !1);
      },
      dispose: function(o) {
        var l = o.state;
        return r(), qc(l, n);
      },
      getRenderState: function(o, l) {
        var c, u = this.getWidgetRenderState(l);
        return We(We({}, o), {}, {
          configure: We(We({}, u), {}, {
            widgetParams: We(We({}, u.widgetParams), {}, {
              searchParameters: Pn(new qe.SearchParameters((c = o.configure) === null || c === void 0 ? void 0 : c.widgetParams.searchParameters), new qe.SearchParameters(u.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function(o) {
        var l = o.helper;
        return i.refine || (i.refine = a(l)), {
          refine: i.refine,
          widgetParams: n
        };
      },
      getWidgetSearchParameters: function(o, l) {
        var c = l.uiState;
        return Pn(o, new qe.SearchParameters(We(We({}, c.configure), n.searchParameters)));
      },
      getWidgetUiState: function(o) {
        return We(We({}, o), {}, {
          configure: We(We({}, o.configure), n.searchParameters)
        });
      }
    };
  };
};
function Un(t) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Un(t);
}
function Qc(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ws(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qc(Object(r), !0).forEach(function(n) {
      w4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qc(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function w4(t, e, r) {
  return e = S4(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function S4(t) {
  var e = x4(t, "string");
  return Un(e) == "symbol" ? e : String(e);
}
function x4(t, e) {
  if (Un(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Un(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Jc(t) {
  return T4(t) || O4(t) || A4(t) || P4();
}
function P4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function A4(t, e) {
  if (t) {
    if (typeof t == "string") return po(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return po(t, e);
  }
}
function O4(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function T4(t) {
  if (Array.isArray(t)) return po(t);
}
function po(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var Kc = Pe({
  name: "configure-related-items",
  connector: !0
});
function _c(t) {
  var e = t.attributeName, r = t.attributeValue, n = t.attributeScore;
  return "".concat(e, ":").concat(r, "<score=").concat(n || 1, ">");
}
var j4 = function(e, r) {
  return function(n) {
    var i = n || {}, a = i.hit, s = i.matchingPatterns, o = i.transformSearchParameters, l = o === void 0 ? function(m) {
      return m;
    } : o;
    if (!a)
      throw new Error(Kc("The `hit` option is required."));
    if (!s)
      throw new Error(Kc("The `matchingPatterns` option is required."));
    var c = Object.keys(s).reduce(function(m, h) {
      var p = s[h], d = en(a, h), v = p.score;
      return Array.isArray(d) ? [].concat(Jc(m), [d.map(function(b) {
        return _c({
          attributeName: h,
          attributeValue: b,
          attributeScore: v
        });
      })]) : typeof d == "string" ? [].concat(Jc(m), [_c({
        attributeName: h,
        attributeValue: d,
        attributeScore: v
      })]) : (process.env.NODE_ENV === "development" && ie(!1, "\nThe `matchingPatterns` option returned a value of type ".concat(Yf(d), ' for the "').concat(h, '" key. This value was not sent to Algolia because `optionalFilters` only supports strings and array of strings.\n\nYou can remove the "').concat(h, `" key from the \`matchingPatterns\` option.

See https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/
            `)), m);
    }, []), u = ws({}, l(new qe.SearchParameters({
      sumOrFiltersScores: !0,
      facetFilters: ["objectID:-".concat(a.objectID)],
      optionalFilters: c
    }))), f = Ep(e, r);
    return ws(ws({}, f({
      searchParameters: u
    })), {}, {
      $$type: "ais.configureRelatedItems"
    });
  };
};
function $c(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $c(Object(r), !0).forEach(function(n) {
      k4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $c(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function k4(t, e, r) {
  return e = M4(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function M4(t) {
  var e = z4(t, "string");
  return Yr(e) == "symbol" ? e : String(e);
}
function z4(t, e) {
  if (Yr(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Yr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Yr(t) {
  "@babel/helpers - typeof";
  return Yr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yr(t);
}
var Qi = Pe({
  name: "dynamic-widgets",
  connector: !0
}), eu = 20, Cp = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Qi()), function(n) {
    var i = n.widgets, a = n.maxValuesPerFacet, s = a === void 0 ? 20 : a, o = n.facets, l = o === void 0 ? ["*"] : o, c = n.transformItems, u = c === void 0 ? function(h) {
      return h;
    } : c, f = n.fallbackWidget;
    if (!(i && Array.isArray(i) && i.every(function(h) {
      return Yr(h) === "object";
    })))
      throw new Error(Qi("The `widgets` option expects an array of widgets."));
    if (!Array.isArray(l))
      throw new Error(Qi("The `facets` option only accepts an array of facets, you passed ".concat(JSON.stringify(l))));
    var m = /* @__PURE__ */ new Map();
    return {
      $$type: "ais.dynamicWidgets",
      init: function(p) {
        i.forEach(function(d) {
          var v = s3(d, p);
          m.set(v, {
            widget: d,
            isMounted: !1
          });
        }), e(Mr(Mr({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !0);
      },
      render: function(p) {
        var d = p.parent, v = this.getWidgetRenderState(p), b = [], g = [];
        f && v.attributesToRender.forEach(function(y) {
          if (!m.has(y)) {
            var w = f({
              attribute: y
            });
            m.set(y, {
              widget: w,
              isMounted: !1
            });
          }
        }), m.forEach(function(y, w) {
          var P = y.widget, T = y.isMounted, A = v.attributesToRender.indexOf(w) > -1;
          !T && A ? (g.push(P), m.set(w, {
            widget: P,
            isMounted: !0
          })) : T && !A && (b.push(P), m.set(w, {
            widget: P,
            isMounted: !1
          }));
        }), d.addWidgets(g), setTimeout(function() {
          return d.removeWidgets(b);
        }, 0), e(Mr(Mr({}, v), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !1);
      },
      dispose: function(p) {
        var d = p.parent, v = [];
        m.forEach(function(b) {
          var g = b.widget, y = b.isMounted;
          y && v.push(g);
        }), d.removeWidgets(v), r();
      },
      getWidgetSearchParameters: function(p) {
        return l.reduce(function(d, v) {
          return d.addFacet(v);
        }, p.setQueryParameters({
          maxValuesPerFacet: Math.max(s || 0, p.maxValuesPerFacet || 0)
        }));
      },
      getRenderState: function(p, d) {
        return Mr(Mr({}, p), {}, {
          dynamicWidgets: this.getWidgetRenderState(d)
        });
      },
      getWidgetRenderState: function(p) {
        var d, v, b, g, y = p.results, w = p.state;
        if (!y)
          return {
            attributesToRender: [],
            widgetParams: n
          };
        var P = u((d = (v = y.renderingContent) === null || v === void 0 || (b = v.facetOrdering) === null || b === void 0 || (g = b.facets) === null || g === void 0 ? void 0 : g.order) !== null && d !== void 0 ? d : [], {
          results: y
        });
        if (!Array.isArray(P))
          throw new Error(Qi("The `transformItems` option expects a function that returns an Array."));
        return process.env.NODE_ENV === "development" && ie(s >= (w.maxValuesPerFacet || 0), "The maxValuesPerFacet set by dynamic widgets (".concat(s, ") is smaller than one of the limits set by a widget (").concat(w.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")), process.env.NODE_ENV === "development" && ie(P.length <= eu || n.facets !== void 0, "More than ".concat(eu, ` facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set "facets" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.`)), {
          attributesToRender: P,
          widgetParams: n
        };
      }
    };
  };
};
function Yn(t) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yn(t);
}
function E4(t) {
  return R4(t) || L4(t) || I4(t) || C4();
}
function C4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I4(t, e) {
  if (t) {
    if (typeof t == "string") return mo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mo(t, e);
  }
}
function L4(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function R4(t) {
  if (Array.isArray(t)) return mo(t);
}
function mo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function tu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tu(Object(r), !0).forEach(function(n) {
      N4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function N4(t, e, r) {
  return e = D4(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function D4(t) {
  var e = H4(t, "string");
  return Yn(e) == "symbol" ? e : String(e);
}
function H4(t, e) {
  if (Yn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Yn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ru = Pe({
  name: "clear-refinements",
  connector: !0
}), W4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, ru()), function(n) {
    var i = n || {}, a = i.includedAttributes, s = a === void 0 ? [] : a, o = i.excludedAttributes, l = o === void 0 ? ["query"] : o, c = i.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    if (n && n.includedAttributes && n.excludedAttributes)
      throw new Error(ru("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var f = {
      refine: fe,
      createURL: function() {
        return "";
      },
      attributesToClear: []
    }, m = function() {
      return f.refine();
    }, h = function() {
      return f.createURL();
    };
    return {
      $$type: "ais.clearRefinements",
      init: function(d) {
        var v = d.instantSearchInstance;
        e(zr(zr({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: v
        }), !0);
      },
      render: function(d) {
        var v = d.instantSearchInstance;
        e(zr(zr({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: v
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(d, v) {
        return zr(zr({}, d), {}, {
          clearRefinements: this.getWidgetRenderState(v)
        });
      },
      getWidgetRenderState: function(d) {
        var v = d.createURL, b = d.scopedResults, g = d.results;
        f.attributesToClear = b.reduce(function(w, P) {
          return w.concat(F4({
            scopedResult: P,
            includedAttributes: s,
            excludedAttributes: l,
            transformItems: u,
            results: g
          }));
        }, []), f.refine = function() {
          f.attributesToClear.forEach(function(w) {
            var P = w.helper, T = w.items;
            P.setState(wc({
              helper: P,
              attributesToClear: T
            })).search();
          });
        }, f.createURL = function() {
          return v(Pn.apply(void 0, E4(f.attributesToClear.map(function(w) {
            var P = w.helper, T = w.items;
            return wc({
              helper: P,
              attributesToClear: T
            });
          }))));
        };
        var y = f.attributesToClear.some(function(w) {
          return w.items.length > 0;
        });
        return {
          canRefine: y,
          hasRefinements: y,
          refine: m,
          createURL: h,
          widgetParams: n
        };
      }
    };
  };
};
function F4(t) {
  var e = t.scopedResult, r = t.includedAttributes, n = t.excludedAttributes, i = t.transformItems, a = t.results, s = r.indexOf("query") !== -1 || n.indexOf("query") === -1;
  return {
    helper: e.helper,
    items: i(ul(ol(e.results, e.helper.state, s).map(function(o) {
      return o.attribute;
    }).filter(function(o) {
      return (
        // If the array is empty (default case), we keep all the attributes
        r.length === 0 || // Otherwise, only add the specified attributes
        r.indexOf(o) !== -1
      );
    }).filter(function(o) {
      return (
        // If the query is included, we ignore the default `excludedAttributes = ['query']`
        o === "query" && s || // Otherwise, ignore the excluded attributes
        n.indexOf(o) === -1
      );
    })), {
      results: a
    })
  };
}
function qn(t) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qn(t);
}
function V4(t) {
  return B4(t) || X4(t) || Z4(t) || G4();
}
function G4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z4(t, e) {
  if (t) {
    if (typeof t == "string") return ho(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ho(t, e);
  }
}
function X4(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function B4(t) {
  if (Array.isArray(t)) return ho(t);
}
function ho(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function nu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nu(Object(r), !0).forEach(function(n) {
      U4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : nu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function U4(t, e, r) {
  return e = Y4(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Y4(t) {
  var e = q4(t, "string");
  return qn(e) == "symbol" ? e : String(e);
}
function q4(t, e) {
  if (qn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var iu = Pe({
  name: "current-refinements",
  connector: !0
}), Q4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, iu()), function(n) {
    if ((n || {}).includedAttributes && (n || {}).excludedAttributes)
      throw new Error(iu("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var i = n || {}, a = i.includedAttributes, s = i.excludedAttributes, o = s === void 0 ? ["query"] : s, l = i.transformItems, c = l === void 0 ? function(u) {
      return u;
    } : l;
    return {
      $$type: "ais.currentRefinements",
      init: function(f) {
        var m = f.instantSearchInstance;
        e(Er(Er({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: m
        }), !0);
      },
      render: function(f) {
        var m = f.instantSearchInstance;
        e(Er(Er({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(f, m) {
        return Er(Er({}, f), {}, {
          currentRefinements: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(f) {
        var m = f.results, h = f.scopedResults, p = f.createURL, d = f.helper;
        function v() {
          return m ? h.reduce(function(g, y) {
            return g.concat(c(au({
              results: y.results,
              helper: y.helper,
              indexId: y.indexId,
              includedAttributes: a,
              excludedAttributes: o
            }), {
              results: m
            }));
          }, []) : c(au({
            results: null,
            helper: d,
            indexId: d.state.index,
            includedAttributes: a,
            excludedAttributes: o
          }), {
            results: m
          });
        }
        var b = v();
        return {
          items: b,
          canRefine: b.length > 0,
          refine: function(y) {
            return Lp(d, y);
          },
          createURL: function(y) {
            return p(Ip(d.state, y));
          },
          widgetParams: n
        };
      }
    };
  };
};
function au(t) {
  var e = t.results, r = t.helper, n = t.indexId, i = t.includedAttributes, a = t.excludedAttributes, s = (i || []).indexOf("query") !== -1 || (a || []).indexOf("query") === -1, o = i ? function(c) {
    return i.indexOf(c.attribute) !== -1;
  } : function(c) {
    return a.indexOf(c.attribute) === -1;
  }, l = ol(e, r.state, s).map(K4).filter(o);
  return l.reduce(function(c, u) {
    return [].concat(V4(c.filter(function(f) {
      return f.attribute !== u.attribute;
    })), [{
      indexName: r.state.index,
      indexId: n,
      attribute: u.attribute,
      label: u.attribute,
      refinements: l.filter(function(f) {
        return f.attribute === u.attribute;
      }).sort(function(f, m) {
        return f.type === "numeric" ? f.value - m.value : 0;
      }),
      refine: function(m) {
        return Lp(r, m);
      }
    }]);
  }, []);
}
function Ip(t, e) {
  switch (t = t.resetPage(), e.type) {
    case "facet":
      return t.removeFacetRefinement(e.attribute, String(e.value));
    case "disjunctive":
      return t.removeDisjunctiveFacetRefinement(e.attribute, String(e.value));
    case "hierarchical":
      return t.removeHierarchicalFacetRefinement(e.attribute);
    case "exclude":
      return t.removeExcludeRefinement(e.attribute, String(e.value));
    case "numeric":
      return t.removeNumericRefinement(e.attribute, e.operator, String(e.value));
    case "tag":
      return t.removeTagRefinement(String(e.value));
    case "query":
      return t.setQueryParameter("query", "");
    default:
      return process.env.NODE_ENV === "development" && ie(!1, 'The refinement type "'.concat(e.type, '" does not exist and cannot be cleared from the current refinements.')), t;
  }
}
function Lp(t, e) {
  t.setState(Ip(t.state, e)).search();
}
function J4(t) {
  switch (t) {
    case ">=":
      return "≥";
    case "<=":
      return "≤";
    default:
      return t;
  }
}
function K4(t) {
  var e = _4(t), r = t.operator ? "".concat(J4(t.operator), " ").concat(t.name) : t.name, n = {
    attribute: t.attribute,
    type: t.type,
    value: e,
    label: r
  };
  return t.operator !== void 0 && (n.operator = t.operator), t.count !== void 0 && (n.count = t.count), t.exhaustive !== void 0 && (n.exhaustive = t.exhaustive), n;
}
function _4(t) {
  return t.type === "numeric" ? Number(t.name) : "escapedValue" in t ? t.escapedValue : t.name;
}
function Qn(t) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qn(t);
}
var $4 = ["name", "escapedValue", "data", "path"];
function su(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Be(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? su(Object(r), !0).forEach(function(n) {
      ca(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : su(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ca(t, e, r) {
  return e = e6(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function e6(t) {
  var e = t6(t, "string");
  return Qn(e) == "symbol" ? e : String(e);
}
function t6(t, e) {
  if (Qn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function r6(t, e) {
  if (t == null) return {};
  var r = n6(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function n6(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function i6(t, e) {
  return l6(t) || o6(t, e) || s6(t, e) || a6();
}
function a6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s6(t, e) {
  if (t) {
    if (typeof t == "string") return ou(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ou(t, e);
  }
}
function ou(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function o6(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function l6(t) {
  if (Array.isArray(t)) return t;
}
var Ss = Pe({
  name: "hierarchical-menu",
  connector: !0
}), lu = ["name:asc"], c6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Ss()), function(n) {
    var i = n || {}, a = i.attributes, s = i.separator, o = s === void 0 ? " > " : s, l = i.rootPath, c = l === void 0 ? null : l, u = i.showParentLevel, f = u === void 0 ? !0 : u, m = i.limit, h = m === void 0 ? 10 : m, p = i.showMore, d = p === void 0 ? !1 : p, v = i.showMoreLimit, b = v === void 0 ? 20 : v, g = i.sortBy, y = g === void 0 ? lu : g, w = i.transformItems, P = w === void 0 ? function(q) {
      return q;
    } : w;
    if (!a || !Array.isArray(a) || a.length === 0)
      throw new Error(Ss("The `attributes` option expects an array of strings."));
    if (d === !0 && b <= h)
      throw new Error(Ss("The `showMoreLimit` option must be greater than `limit`."));
    var T = i6(a, 1), A = T[0], j, O = function() {
    };
    function M() {
      O();
    }
    var z, R = !1;
    function I(q, C) {
      return function() {
        R = !R, C.render(q);
      };
    }
    function L() {
      return R ? b : h;
    }
    function W(q) {
      return q.slice(0, L()).map(function(C) {
        var E = C.name, B = C.escapedValue, Q = C.data;
        C.path;
        var $ = r6(C, $4), ne = Be(Be({}, $), {}, {
          value: B,
          label: E,
          data: null
        });
        return Array.isArray(Q) && (ne.data = W(Q)), ne;
      });
    }
    return {
      $$type: "ais.hierarchicalMenu",
      init: function(C) {
        var E = C.instantSearchInstance;
        e(Be(Be({}, this.getWidgetRenderState(C)), {}, {
          instantSearchInstance: E
        }), !0);
      },
      render: function(C) {
        var E = C.instantSearchInstance;
        O = I(C, this), e(Be(Be({}, this.getWidgetRenderState(C)), {}, {
          instantSearchInstance: E
        }), !1);
      },
      dispose: function(C) {
        var E = C.state;
        return r(), E.removeHierarchicalFacet(A).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(C, E) {
        return Be(Be({}, C), {}, {
          hierarchicalMenu: Be(Be({}, C.hierarchicalMenu), {}, ca({}, A, this.getWidgetRenderState(E)))
        });
      },
      getWidgetRenderState: function(C) {
        var E = this, B = C.results, Q = C.state, $ = C.createURL, ne = C.instantSearchInstance, ce = C.helper, ge = [], G = !1, Z = function(ze) {
          return $(function($e) {
            return E.getWidgetUiState($e, {
              searchParameters: Q.resetPage().toggleFacetRefinement(A, ze),
              helper: ce
            });
          });
        };
        if (j || (j = il({
          instantSearchInstance: ne,
          helper: ce,
          attribute: function(ze) {
            var $e = ze.split(o).length - 1;
            return a[$e];
          },
          widgetType: this.$$type
        })), z || (z = function(ze) {
          j("click:internal", ze), ce.toggleFacetRefinement(A, ze).search();
        }), B) {
          var Y = B.getFacetValues(A, {
            sortBy: y,
            facetOrdering: y === lu
          }), te = Y && !Array.isArray(Y) && Y.data ? Y.data : [], ue = (Q.maxValuesPerFacet || 0) > L() ? te.length <= L() : te.length < L();
          G = d && (R || !ue), ge = P(W(te), {
            results: B
          });
        }
        return {
          items: ge,
          refine: z,
          canRefine: ge.length > 0,
          createURL: Z,
          sendEvent: j,
          widgetParams: n,
          isShowingMore: R,
          toggleShowMore: M,
          canToggleShowMore: G
        };
      },
      getWidgetUiState: function(C, E) {
        var B = E.searchParameters, Q = B.getHierarchicalFacetBreadcrumb(A);
        return u6(Be(Be({}, C), {}, {
          hierarchicalMenu: Be(Be({}, C.hierarchicalMenu), {}, ca({}, A, Q))
        }), A);
      },
      getWidgetSearchParameters: function(C, E) {
        var B = E.uiState, Q = B.hierarchicalMenu && B.hierarchicalMenu[A];
        if (C.isConjunctiveFacet(A) || C.isDisjunctiveFacet(A))
          return process.env.NODE_ENV === "development" && ie(!1, 'HierarchicalMenu: Attribute "'.concat(A, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), C;
        if (C.isHierarchicalFacet(A)) {
          var $ = C.getHierarchicalFacetByName(A);
          process.env.NODE_ENV === "development" && ie(Pr($.attributes, a) && $.separator === o && $.rootPath === c, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var ne = C.removeHierarchicalFacet(A).addHierarchicalFacet({
          name: A,
          attributes: a,
          separator: o,
          rootPath: c,
          showParentLevel: f
        }), ce = ne.maxValuesPerFacet || 0, ge = Math.max(ce, d ? b : h), G = ne.setQueryParameter("maxValuesPerFacet", ge);
        return Q ? G.addHierarchicalFacetRefinement(A, Q.join(o)) : G.setQueryParameters({
          hierarchicalFacetsRefinements: Be(Be({}, G.hierarchicalFacetsRefinements), {}, ca({}, A, []))
        });
      }
    };
  };
};
function u6(t, e) {
  return t.hierarchicalMenu && ((!t.hierarchicalMenu[e] || t.hierarchicalMenu[e].length === 0) && delete t.hierarchicalMenu[e], Object.keys(t.hierarchicalMenu).length === 0 && delete t.hierarchicalMenu), t;
}
function Jn(t) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jn(t);
}
function cu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ut(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cu(Object(r), !0).forEach(function(n) {
      Rp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : cu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Rp(t, e, r) {
  return e = d6(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function d6(t) {
  var e = f6(t, "string");
  return Jn(e) == "symbol" ? e : String(e);
}
function f6(t, e) {
  if (Jn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Jn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var p6 = Pe({
  name: "hits",
  connector: !0
});
const m6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, p6()), function(n) {
    var i = n || {}, a = i.escapeHTML, s = a === void 0 ? !0 : a, o = i.transformItems, l = o === void 0 ? function(f) {
      return f;
    } : o, c, u;
    return {
      $$type: "ais.hits",
      init: function(m) {
        e(Ut(Ut({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: m.instantSearchInstance
        }), !0);
      },
      render: function(m) {
        var h = this.getWidgetRenderState(m);
        e(Ut(Ut({}, h), {}, {
          instantSearchInstance: m.instantSearchInstance
        }), !1), h.sendEvent("view:internal", h.items);
      },
      getRenderState: function(m, h) {
        return Ut(Ut({}, m), {}, {
          hits: this.getWidgetRenderState(h)
        });
      },
      getWidgetRenderState: function(m) {
        var h, p, d, v = m.results, b = m.helper, g = m.instantSearchInstance;
        if (c || (c = al({
          instantSearchInstance: g,
          getIndex: function() {
            return b.getIndex();
          },
          widgetType: this.$$type
        })), u || (u = np({
          getIndex: function() {
            return b.getIndex();
          },
          widgetType: this.$$type,
          instantSearchInstance: g
        })), !v)
          return {
            hits: [],
            items: [],
            results: void 0,
            banner: void 0,
            sendEvent: c,
            bindEvent: u,
            widgetParams: n
          };
        s && v.hits.length > 0 && (v.hits = Wa(v.hits));
        var y = ll(v.hits, v.page, v.hitsPerPage), w = cl(y, v.queryID), P = l(w, {
          results: v
        }), T = (h = v.renderingContent) === null || h === void 0 || (p = h.widgets) === null || p === void 0 || (d = p.banners) === null || d === void 0 ? void 0 : d[0];
        return {
          hits: P,
          items: P,
          results: v,
          banner: T,
          sendEvent: c,
          bindEvent: u,
          widgetParams: n
        };
      },
      dispose: function(m) {
        var h = m.state;
        return r(), s ? h.setQueryParameters(Object.keys(Ct).reduce(function(p, d) {
          return Ut(Ut({}, p), {}, Rp({}, d, void 0));
        }, {})) : h;
      },
      getWidgetSearchParameters: function(m, h) {
        return s ? m.setQueryParameters(Ct) : m;
      }
    };
  };
};
function Kn(t) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kn(t);
}
function uu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Aa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? uu(Object(r), !0).forEach(function(n) {
      h6(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : uu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function h6(t, e, r) {
  return e = g6(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function g6(t) {
  var e = v6(t, "string");
  return Kn(e) == "symbol" ? e : String(e);
}
function v6(t, e) {
  if (Kn(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Kn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var b6 = function(e, r) {
  return r.map(function(n) {
    var i = Gt(e, function(a) {
      return a.objectID === n;
    });
    if (typeof i > "u")
      throw new Error('Could not find objectID "'.concat(n, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
    return i;
  });
}, y6 = function(e) {
  var r = ul(e.map(function(i) {
    return i.__queryID;
  }));
  if (r.length > 1)
    throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
  var n = r[0];
  if (typeof n != "string")
    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
  return n;
}, w6 = function(e) {
  return e.map(function(r) {
    return r.__position;
  });
}, S6 = function(e) {
  var r = e.method, n = e.results, i = e.hits, a = e.objectIDs, s = n.index, o = b6(i, a), l = y6(o);
  switch (r) {
    case "clickedObjectIDsAfterSearch": {
      var c = w6(o);
      return {
        index: s,
        queryID: l,
        objectIDs: a,
        positions: c
      };
    }
    case "convertedObjectIDsAfterSearch":
      return {
        index: s,
        queryID: l,
        objectIDs: a
      };
    default:
      throw new Error('Unsupported method passed to insights: "'.concat(r, '".'));
  }
}, x6 = function(e, r, n) {
  return function(i) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      s[o - 1] = arguments[o];
    var l = s[0];
    if (process.env.NODE_ENV === "development" && ie(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), !e) {
      var c = Pe({
        name: "instantsearch"
      });
      throw new Error(c("The `insightsClient` option has not been provided to `instantsearch`."));
    }
    if (!Array.isArray(l.objectIDs))
      throw new TypeError("Expected `objectIDs` to be an array.");
    var u = S6({
      method: i,
      results: r,
      hits: n,
      objectIDs: l.objectIDs
    });
    e(i, Aa(Aa({}, u), l));
  };
};
function Np(t) {
  return function(e, r) {
    return t(function(n, i) {
      var a = n.results, s = n.hits, o = n.instantSearchInstance;
      if (a && s && o) {
        var l = x6(o.insightsClient, a, s);
        return e(Aa(Aa({}, n), {}, {
          insights: l
        }), i);
      }
      return e(n, i);
    }, r);
  };
}
function go(t) {
  "@babel/helpers - typeof";
  return go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, go(t);
}
function P6(t) {
  var e = t.method, r = t.payload;
  if (go(r) !== "object")
    throw new Error("The insights helper expects the payload to be an object.");
  var n;
  try {
    n = tp(r);
  } catch {
    throw new Error("Could not JSON serialize the payload object.");
  }
  return 'data-insights-method="'.concat(e, '" data-insights-payload="').concat(n, '"');
}
function Dp(t, e) {
  return process.env.NODE_ENV === "development" && ie(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), P6({
    method: t,
    payload: e
  });
}
var A6 = Np(m6);
function _n(t) {
  "@babel/helpers - typeof";
  return _n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _n(t);
}
function O6(t) {
  return M6(t) || k6(t) || j6(t) || T6();
}
function T6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function j6(t, e) {
  if (t) {
    if (typeof t == "string") return vo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vo(t, e);
  }
}
function k6(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function M6(t) {
  if (Array.isArray(t)) return vo(t);
}
function vo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function du(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? du(Object(r), !0).forEach(function(n) {
      z6(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : du(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function z6(t, e, r) {
  return e = E6(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function E6(t) {
  var e = C6(t, "string");
  return _n(e) == "symbol" ? e : String(e);
}
function C6(t, e) {
  if (_n(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (_n(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Ji = Pe({
  name: "hits-per-page",
  connector: !0
}), I6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Ji()), function(n) {
    var i = n || {}, a = i.items, s = i.transformItems, o = s === void 0 ? function(h) {
      return h;
    } : s;
    if (!Array.isArray(a))
      throw new Error(Ji("The `items` option expects an array of objects."));
    var l = a, c = l.filter(function(h) {
      return h.default === !0;
    });
    if (c.length === 0)
      throw new Error(Ji("A default value must be specified in `items`."));
    if (c.length > 1)
      throw new Error(Ji("More than one default value is specified in `items`."));
    var u = c[0], f = function(p) {
      var d = p.hitsPerPage;
      return l.map(function(v) {
        return Tt(Tt({}, v), {}, {
          isRefined: Number(v.value) === Number(d)
        });
      });
    }, m = {
      getRefine: function(p) {
        return function(d) {
          return !d && d !== 0 ? p.setQueryParameter("hitsPerPage", void 0).search() : p.setQueryParameter("hitsPerPage", d).search();
        };
      },
      createURLFactory: function(p) {
        var d = p.state, v = p.createURL, b = p.getWidgetUiState, g = p.helper;
        return function(y) {
          return v(function(w) {
            return b(w, {
              searchParameters: d.resetPage().setQueryParameter("hitsPerPage", !y && y !== 0 ? void 0 : y),
              helper: g
            });
          });
        };
      }
    };
    return {
      $$type: "ais.hitsPerPage",
      init: function(p) {
        var d = p.state, v = p.instantSearchInstance, b = l.some(function(g) {
          return Number(d.hitsPerPage) === Number(g.value);
        });
        b || (process.env.NODE_ENV === "development" && ie(d.hitsPerPage !== void 0, "\n`hitsPerPage` is not defined.\nThe option `hitsPerPage` needs to be set using the `configure` widget.\n\nLearn more: https://www.algolia.com/doc/api-reference/widgets/hits-per-page/js/\n            "), process.env.NODE_ENV === "development" && ie(!1, '\nThe `items` option of `hitsPerPage` does not contain the "hits per page" value coming from the state: '.concat(d.hitsPerPage, ".\n\nYou may want to add another entry to the `items` option with this value.")), l = [
          // The helper will convert the empty string to `undefined`.
          {
            value: "",
            label: ""
          }
        ].concat(O6(l))), e(Tt(Tt({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: v
        }), !0);
      },
      render: function(p) {
        var d = p.instantSearchInstance;
        e(Tt(Tt({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !1);
      },
      dispose: function(p) {
        var d = p.state;
        return r(), d.setQueryParameter("hitsPerPage", void 0);
      },
      getRenderState: function(p, d) {
        return Tt(Tt({}, p), {}, {
          hitsPerPage: this.getWidgetRenderState(d)
        });
      },
      getWidgetRenderState: function(p) {
        var d = p.state, v = p.results, b = p.createURL, g = p.helper, y = v ? v.nbHits > 0 : !1;
        return {
          items: o(f(d), {
            results: v
          }),
          refine: m.getRefine(g),
          createURL: m.createURLFactory({
            state: d,
            createURL: b,
            getWidgetUiState: this.getWidgetUiState,
            helper: g
          }),
          hasNoResults: !y,
          canRefine: y,
          widgetParams: n
        };
      },
      getWidgetUiState: function(p, d) {
        var v = d.searchParameters, b = v.hitsPerPage;
        return b === void 0 || b === u.value ? p : Tt(Tt({}, p), {}, {
          hitsPerPage: b
        });
      },
      getWidgetSearchParameters: function(p, d) {
        var v = d.uiState;
        return p.setQueryParameters({
          hitsPerPage: v.hitsPerPage || u.value
        });
      }
    };
  };
};
function $n(t) {
  "@babel/helpers - typeof";
  return $n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $n(t);
}
var L6 = ["page"], R6 = ["clickAnalytics", "userToken"];
function fu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fu(Object(r), !0).forEach(function(n) {
      Hp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : fu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Hp(t, e, r) {
  return e = N6(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function N6(t) {
  var e = D6(t, "string");
  return $n(e) == "symbol" ? e : String(e);
}
function D6(t, e) {
  if ($n(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if ($n(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function pu(t) {
  return V6(t) || F6(t) || W6(t) || H6();
}
function H6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W6(t, e) {
  if (t) {
    if (typeof t == "string") return bo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bo(t, e);
  }
}
function F6(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function V6(t) {
  if (Array.isArray(t)) return bo(t);
}
function bo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Wp(t, e) {
  if (t == null) return {};
  var r = G6(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function G6(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
var Z6 = Pe({
  name: "infinite-hits",
  connector: !0
});
function mu(t) {
  var e = t || {};
  e.page;
  var r = Wp(e, L6);
  return r;
}
function Ki(t) {
  var e = t || {};
  e.clickAnalytics, e.userToken;
  var r = Wp(e, R6);
  return r;
}
function X6() {
  var t = null, e = null;
  return {
    read: function(n) {
      var i = n.state;
      return Pr(e, mu(i)) ? t : null;
    },
    write: function(n) {
      var i = n.state, a = n.hits;
      e = mu(i), t = a;
    }
  };
}
function B6(t) {
  return Object.keys(t).map(Number).sort(function(e, r) {
    return e - r;
  }).reduce(function(e, r) {
    return e.concat(t[r]);
  }, []);
}
const U6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Z6()), function(n) {
    var i = n || {}, a = i.escapeHTML, s = a === void 0 ? !0 : a, o = i.transformItems, l = o === void 0 ? function(y) {
      return y;
    } : o, c = i.cache, u = c === void 0 ? X6() : c, f, m, h, p, d = function(w, P) {
      var T = w.page, A = T === void 0 ? 0 : T, j = Object.keys(P).map(Number);
      return j.length === 0 ? A : Math.min.apply(Math, [A].concat(pu(j)));
    }, v = function(w, P) {
      var T = w.page, A = T === void 0 ? 0 : T, j = Object.keys(P).map(Number);
      return j.length === 0 ? A : Math.max.apply(Math, [A].concat(pu(j)));
    }, b = function(w) {
      return function() {
        w.overrideStateWithoutTriggeringChangeEvent(mt(mt({}, w.state), {}, {
          page: d(w.state, u.read({
            state: Ki(w.state)
          }) || {}) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    }, g = function(w) {
      return function() {
        w.setPage(v(w.state, u.read({
          state: Ki(w.state)
        }) || {}) + 1).search();
      };
    };
    return {
      $$type: "ais.infiniteHits",
      init: function(w) {
        e(mt(mt({}, this.getWidgetRenderState(w)), {}, {
          instantSearchInstance: w.instantSearchInstance
        }), !0);
      },
      render: function(w) {
        var P = w.instantSearchInstance, T = this.getWidgetRenderState(w);
        e(mt(mt({}, T), {}, {
          instantSearchInstance: P
        }), !1), h("view:internal", T.currentPageHits);
      },
      getRenderState: function(w, P) {
        return mt(mt({}, w), {}, {
          infiniteHits: this.getWidgetRenderState(P)
        });
      },
      getWidgetRenderState: function(w) {
        var P, T, A, j = w.results, O = w.helper, M = w.parent, z = w.state, R = w.instantSearchInstance, I, L = [], W = M.getPreviousState() || z, q = u.read({
          state: Ki(W)
        }) || {}, C = j == null || (P = j.renderingContent) === null || P === void 0 || (T = P.widgets) === null || T === void 0 || (A = T.banners) === null || A === void 0 ? void 0 : A[0];
        if (!j)
          f = b(O), m = g(O), h = al({
            instantSearchInstance: R,
            getIndex: function() {
              return O.getIndex();
            },
            widgetType: this.$$type
          }), p = np({
            getIndex: function() {
              return O.getIndex();
            },
            widgetType: this.$$type,
            instantSearchInstance: R
          }), I = W.page === void 0 || d(W, q) === 0;
        else {
          var E, B, Q = W.page, $ = Q === void 0 ? 0 : Q;
          s && j.hits.length > 0 && (j.hits = Wa(j.hits));
          var ne = ll(j.hits, j.page, j.hitsPerPage), ce = cl(ne, j.queryID), ge = l(ce, {
            results: j
          }), G = !1;
          ap(R.mainIndex, function(ue) {
            !G && ue.getWidgets().some(function(je) {
              var ze = je.$$type;
              return ze === "ais.dynamicWidgets";
            }) && (G = !0);
          });
          var Z = !((E = W.disjunctiveFacets) !== null && E !== void 0 && E.length) && !(W.facets || []).filter(function(ue) {
            return ue !== "*";
          }).length && !((B = W.hierarchicalFacets) !== null && B !== void 0 && B.length);
          q[$] === void 0 && !j.__isArtificial && R.status === "idle" && !(G && Z) && (q[$] = ge, u.write({
            state: Ki(W),
            hits: q
          })), L = ge, I = d(W, q) === 0;
        }
        var Y = B6(q), te = j ? j.nbPages <= v(W, q) + 1 : !0;
        return {
          hits: Y,
          items: Y,
          currentPageHits: L,
          sendEvent: h,
          bindEvent: p,
          banner: C,
          results: j || void 0,
          showPrevious: f,
          showMore: m,
          isFirstPage: I,
          isLastPage: te,
          widgetParams: n
        };
      },
      dispose: function(w) {
        var P = w.state;
        r();
        var T = P.setQueryParameter("page", void 0);
        return s ? T.setQueryParameters(Object.keys(Ct).reduce(function(A, j) {
          return mt(mt({}, A), {}, Hp({}, j, void 0));
        }, {})) : T;
      },
      getWidgetUiState: function(w, P) {
        var T = P.searchParameters, A = T.page || 0;
        return A ? mt(mt({}, w), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: A + 1
        }) : w;
      },
      getWidgetSearchParameters: function(w, P) {
        var T = P.uiState, A = w;
        s && (A = w.setQueryParameters(Ct));
        var j = T.page ? T.page - 1 : 0;
        return A.setQueryParameter("page", j);
      }
    };
  };
};
var Y6 = Np(U6), q6 = ["name", "escapedValue", "path"];
function ei(t) {
  "@babel/helpers - typeof";
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ei(t);
}
function Q6(t, e) {
  if (t == null) return {};
  var r = J6(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function J6(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function hu(t, e) {
  return eS(t) || $6(t, e) || _6(t, e) || K6();
}
function K6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _6(t, e) {
  if (t) {
    if (typeof t == "string") return gu(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gu(t, e);
  }
}
function gu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function $6(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function eS(t) {
  if (Array.isArray(t)) return t;
}
function vu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ue(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vu(Object(r), !0).forEach(function(n) {
      ua(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ua(t, e, r) {
  return e = tS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function tS(t) {
  var e = rS(t, "string");
  return ei(e) == "symbol" ? e : String(e);
}
function rS(t, e) {
  if (ei(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ei(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var xs = Pe({
  name: "menu",
  connector: !0
}), bu = ["isRefined", "name:asc"], Fp = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, xs()), function(n) {
    var i = n || {}, a = i.attribute, s = i.limit, o = s === void 0 ? 10 : s, l = i.showMore, c = l === void 0 ? !1 : l, u = i.showMoreLimit, f = u === void 0 ? 20 : u, m = i.sortBy, h = m === void 0 ? bu : m, p = i.transformItems, d = p === void 0 ? function(j) {
      return j;
    } : p;
    if (!a)
      throw new Error(xs("The `attribute` option is required."));
    if (c === !0 && f <= o)
      throw new Error(xs("The `showMoreLimit` option must be greater than `limit`."));
    var v, b, g, y = !1, w = function() {
    };
    function P(j, O) {
      return function() {
        y = !y, O.render(j);
      };
    }
    function T() {
      w();
    }
    function A() {
      return y ? f : o;
    }
    return {
      $$type: "ais.menu",
      init: function(O) {
        var M = O.instantSearchInstance;
        e(Ue(Ue({}, this.getWidgetRenderState(O)), {}, {
          instantSearchInstance: M
        }), !0);
      },
      render: function(O) {
        var M = O.instantSearchInstance;
        e(Ue(Ue({}, this.getWidgetRenderState(O)), {}, {
          instantSearchInstance: M
        }), !1);
      },
      dispose: function(O) {
        var M = O.state;
        return r(), M.removeHierarchicalFacet(a).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(O, M) {
        return Ue(Ue({}, O), {}, {
          menu: Ue(Ue({}, O.menu), {}, ua({}, a, this.getWidgetRenderState(M)))
        });
      },
      getWidgetRenderState: function(O) {
        var M = this, z = O.results, R = O.createURL, I = O.instantSearchInstance, L = O.helper, W = [], q = !1;
        if (v || (v = il({
          instantSearchInstance: I,
          helper: L,
          attribute: a,
          widgetType: this.$$type
        })), b || (b = function(Q) {
          return R(function($) {
            return M.getWidgetUiState($, {
              searchParameters: L.state.resetPage().toggleFacetRefinement(a, Q),
              helper: L
            });
          });
        }), g || (g = function(Q) {
          var $ = L.getHierarchicalFacetBreadcrumb(a), ne = hu($, 1), ce = ne[0];
          v("click:internal", Q || ce), L.toggleFacetRefinement(a, Q || ce).search();
        }), O.results && (w = P(O, this)), z) {
          var C = z.getFacetValues(a, {
            sortBy: h,
            facetOrdering: h === bu
          }), E = C && !Array.isArray(C) && C.data ? C.data : [];
          q = c && (y || E.length > A()), W = d(E.slice(0, A()).map(function(B) {
            var Q = B.name, $ = B.escapedValue;
            B.path;
            var ne = Q6(B, q6);
            return Ue(Ue({}, ne), {}, {
              label: Q,
              value: $
            });
          }), {
            results: z
          });
        }
        return {
          items: W,
          createURL: b,
          refine: g,
          sendEvent: v,
          canRefine: W.length > 0,
          widgetParams: n,
          isShowingMore: y,
          toggleShowMore: T,
          canToggleShowMore: q
        };
      },
      getWidgetUiState: function(O, M) {
        var z = M.searchParameters, R = z.getHierarchicalFacetBreadcrumb(a), I = hu(R, 1), L = I[0];
        return nS(Ue(Ue({}, O), {}, {
          menu: Ue(Ue({}, O.menu), {}, ua({}, a, L))
        }), a);
      },
      getWidgetSearchParameters: function(O, M) {
        var z = M.uiState, R = z.menu && z.menu[a];
        if (O.isConjunctiveFacet(a) || O.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ie(!1, 'Menu: Attribute "'.concat(a, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this Menu widget will not work at all.`)), O;
        var I = O.removeHierarchicalFacet(a).addHierarchicalFacet({
          name: a,
          attributes: [a]
        }), L = I.maxValuesPerFacet || 0, W = Math.max(L, c ? f : o), q = I.setQueryParameter("maxValuesPerFacet", W);
        return R ? q.addHierarchicalFacetRefinement(a, R) : q.setQueryParameters({
          hierarchicalFacetsRefinements: Ue(Ue({}, q.hierarchicalFacetsRefinements), {}, ua({}, a, []))
        });
      }
    };
  };
};
function nS(t, e) {
  return t.menu && (t.menu[e] === void 0 && delete t.menu[e], Object.keys(t.menu).length === 0 && delete t.menu), t;
}
function ti(t) {
  "@babel/helpers - typeof";
  return ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ti(t);
}
function iS(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!r) {
    if (Array.isArray(t) || (r = Vp(t)) || e) {
      r && (t = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(t);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    s = !0, o = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s) throw o;
    }
  } };
}
function aS(t, e) {
  return lS(t) || oS(t, e) || Vp(t, e) || sS();
}
function sS() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vp(t, e) {
  if (t) {
    if (typeof t == "string") return yu(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yu(t, e);
  }
}
function yu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function oS(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function lS(t) {
  if (Array.isArray(t)) return t;
}
function wu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function De(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wu(Object(r), !0).forEach(function(n) {
      vn(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function vn(t, e, r) {
  return e = cS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cS(t) {
  var e = uS(t, "string");
  return ti(e) == "symbol" ? e : String(e);
}
function uS(t, e) {
  if (ti(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ti(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Ps = Pe({
  name: "numeric-menu",
  connector: !0
}), dS = "ais.numericMenu", fS = function(e) {
  var r = e.instantSearchInstance;
  return function() {
    if (arguments.length === 1) {
      r.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
      return;
    }
  };
}, pS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Ps()), function(n) {
    var i = n || {}, a = i.attribute, s = a === void 0 ? "" : a, o = i.items, l = o === void 0 ? [] : o, c = i.transformItems, u = c === void 0 ? function(h) {
      return h;
    } : c;
    if (s === "")
      throw new Error(Ps("The `attribute` option is required."));
    if (!l || l.length === 0)
      throw new Error(Ps("The `items` option expects an array of objects."));
    var f = function(p) {
      return l.map(function(d) {
        var v = d.start, b = d.end, g = d.label;
        return {
          label: g,
          value: encodeURI(JSON.stringify({
            start: v,
            end: b
          })),
          isRefined: Gp(p, s, {
            start: v,
            end: b
          })
        };
      });
    }, m = {};
    return {
      $$type: dS,
      init: function(p) {
        var d = p.instantSearchInstance;
        e(De(De({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !0);
      },
      render: function(p) {
        var d = p.instantSearchInstance;
        e(De(De({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !1);
      },
      dispose: function(p) {
        var d = p.state;
        return r(), d.removeNumericRefinement(s);
      },
      getWidgetUiState: function(p, d) {
        var v = d.searchParameters, b = v.getNumericRefinements(s), g = b["="] && b["="][0];
        if (g || g === 0)
          return De(De({}, p), {}, {
            numericMenu: De(De({}, p.numericMenu), {}, vn({}, s, "".concat(b["="])))
          });
        var y = b[">="] && b[">="][0] || "", w = b["<="] && b["<="][0] || "";
        return mS(De(De({}, p), {}, {
          numericMenu: De(De({}, p.numericMenu), {}, vn({}, s, "".concat(y, ":").concat(w)))
        }), s);
      },
      getWidgetSearchParameters: function(p, d) {
        var v = d.uiState, b = v.numericMenu && v.numericMenu[s], g = p.setQueryParameters({
          numericRefinements: De(De({}, p.numericRefinements), {}, vn({}, s, {}))
        });
        if (!b)
          return g;
        var y = b.indexOf(":") === -1;
        if (y)
          return g.addNumericRefinement(s, "=", Number(b));
        var w = b.split(":").map(parseFloat), P = aS(w, 2), T = P[0], A = P[1], j = we(T) ? g.addNumericRefinement(s, ">=", T) : g, O = we(A) ? j.addNumericRefinement(s, "<=", A) : j;
        return O;
      },
      getRenderState: function(p, d) {
        return De(De({}, p), {}, {
          numericMenu: De(De({}, p.numericMenu), {}, vn({}, s, this.getWidgetRenderState(d)))
        });
      },
      getWidgetRenderState: function(p) {
        var d = this, v = p.results, b = p.state, g = p.instantSearchInstance, y = p.helper, w = p.createURL;
        m.refine || (m.refine = function(z) {
          var R = Su(y.state, s, z);
          m.sendEvent("click:internal", z), y.setState(R).search();
        }), m.createURL || (m.createURL = function(z) {
          return function(R) {
            return w(function(I) {
              return d.getWidgetUiState(I, {
                searchParameters: Su(z, s, R),
                helper: y
              });
            });
          };
        }), m.sendEvent || (m.sendEvent = fS({
          instantSearchInstance: g
        }));
        var P = v ? v.nbHits === 0 : !0, T = f(b), A = !0, j = iS(T), O;
        try {
          for (j.s(); !(O = j.n()).done; ) {
            var M = O.value;
            if (M.isRefined && decodeURI(M.value) !== "{}") {
              A = !1;
              break;
            }
          }
        } catch (z) {
          j.e(z);
        } finally {
          j.f();
        }
        return {
          createURL: m.createURL(b),
          items: u(T, {
            results: v
          }),
          hasNoResults: P,
          canRefine: !(P && A),
          refine: m.refine,
          sendEvent: m.sendEvent,
          widgetParams: n
        };
      }
    };
  };
};
function Gp(t, e, r) {
  var n = t.getNumericRefinements(e);
  return r.start !== void 0 && r.end !== void 0 ? r.start === r.end ? $t(n, "=", r.start) : $t(n, ">=", r.start) && $t(n, "<=", r.end) : r.start !== void 0 ? $t(n, ">=", r.start) : r.end !== void 0 ? $t(n, "<=", r.end) : r.start === void 0 && r.end === void 0 ? Object.keys(n).every(function(i) {
    return (n[i] || []).length === 0;
  }) : !1;
}
function Su(t, e, r) {
  var n = t, i = JSON.parse(decodeURI(r)), a = n.getNumericRefinements(e);
  if (i.start === void 0 && i.end === void 0)
    return n.removeNumericRefinement(e);
  if (Gp(n, e, i) || (n = n.removeNumericRefinement(e)), i.start !== void 0 && i.end !== void 0) {
    if (i.start > i.end)
      throw new Error("option.start should be > to option.end");
    if (i.start === i.end)
      return $t(a, "=", i.start) ? n = n.removeNumericRefinement(e, "=", i.start) : n = n.addNumericRefinement(e, "=", i.start), n;
  }
  return i.start !== void 0 && ($t(a, ">=", i.start) && (n = n.removeNumericRefinement(e, ">=", i.start)), n = n.addNumericRefinement(e, ">=", i.start)), i.end !== void 0 && ($t(a, "<=", i.end) && (n = n.removeNumericRefinement(e, "<=", i.end)), n = n.addNumericRefinement(e, "<=", i.end)), typeof n.page == "number" && (n.page = 0), n;
}
function $t(t, e, r) {
  return t[e] !== void 0 && t[e].includes(r);
}
function mS(t, e) {
  return t.numericMenu && (t.numericMenu[e] === ":" && delete t.numericMenu[e], Object.keys(t.numericMenu).length === 0 && delete t.numericMenu), t;
}
function ri(t) {
  "@babel/helpers - typeof";
  return ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ri(t);
}
function hS(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Zp(n.key), n);
  }
}
function vS(t, e, r) {
  return e && gS(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function As(t, e, r) {
  return e = Zp(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Zp(t) {
  var e = bS(t, "string");
  return ri(e) == "symbol" ? e : String(e);
}
function bS(t, e) {
  if (ri(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ri(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var yS = /* @__PURE__ */ function() {
  function t(e) {
    hS(this, t), As(this, "currentPage", void 0), As(this, "total", void 0), As(this, "padding", void 0), this.currentPage = e.currentPage, this.total = e.total, this.padding = e.padding;
  }
  return vS(t, [{
    key: "pages",
    value: function() {
      var r = this.total, n = this.currentPage, i = this.padding;
      if (r === 0) return [0];
      var a = this.nbPagesDisplayed(i, r);
      if (a === r)
        return Dc({
          end: r
        });
      var s = this.calculatePaddingLeft(n, i, r, a), o = a - s, l = n - s, c = n + o;
      return Dc({
        start: l,
        end: c
      });
    }
  }, {
    key: "nbPagesDisplayed",
    value: function(r, n) {
      return Math.min(2 * r + 1, n);
    }
  }, {
    key: "calculatePaddingLeft",
    value: function(r, n, i, a) {
      return r <= n ? r : r >= i - n ? a - (i - r) : n;
    }
  }, {
    key: "isLastPage",
    value: function() {
      return this.currentPage >= this.total - 1;
    }
  }, {
    key: "isFirstPage",
    value: function() {
      return this.currentPage <= 0;
    }
  }]), t;
}();
function ni(t) {
  "@babel/helpers - typeof";
  return ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ni(t);
}
function xu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xu(Object(r), !0).forEach(function(n) {
      wS(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function wS(t, e, r) {
  return e = SS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function SS(t) {
  var e = xS(t, "string");
  return ni(e) == "symbol" ? e : String(e);
}
function xS(t, e) {
  if (ni(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ni(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var PS = Pe({
  name: "pagination",
  connector: !0
}), AS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, PS()), function(n) {
    var i = n || {}, a = i.totalPages, s = i.padding, o = s === void 0 ? 3 : s, l = new yS({
      currentPage: 0,
      total: 0,
      padding: o
    }), c = {};
    function u(f) {
      var m = f.nbPages;
      return a !== void 0 ? Math.min(a, m) : m;
    }
    return {
      $$type: "ais.pagination",
      init: function(m) {
        var h = m.instantSearchInstance;
        e(jt(jt({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: h
        }), !0);
      },
      render: function(m) {
        var h = m.instantSearchInstance;
        e(jt(jt({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: h
        }), !1);
      },
      dispose: function(m) {
        var h = m.state;
        return r(), h.setQueryParameter("page", void 0);
      },
      getWidgetUiState: function(m, h) {
        var p = h.searchParameters, d = p.page || 0;
        return d ? jt(jt({}, m), {}, {
          page: d + 1
        }) : m;
      },
      getWidgetSearchParameters: function(m, h) {
        var p = h.uiState, d = p.page ? p.page - 1 : 0;
        return m.setQueryParameter("page", d);
      },
      getWidgetRenderState: function(m) {
        var h = m.results, p = m.helper, d = m.state, v = m.createURL;
        c.refine || (c.refine = function(y) {
          p.setPage(y), p.search();
        }), c.createURL || (c.createURL = function(y) {
          return v(function(w) {
            return jt(jt({}, w), {}, {
              page: y + 1
            });
          });
        });
        var b = d.page || 0, g = u(h || {
          nbPages: 0
        });
        return l.currentPage = b, l.total = g, {
          createURL: c.createURL,
          refine: c.refine,
          canRefine: g > 1,
          currentRefinement: b,
          nbHits: (h == null ? void 0 : h.nbHits) || 0,
          nbPages: g,
          pages: h ? l.pages() : [],
          isFirstPage: l.isFirstPage(),
          isLastPage: l.isLastPage(),
          widgetParams: n
        };
      },
      getRenderState: function(m, h) {
        return jt(jt({}, m), {}, {
          pagination: this.getWidgetRenderState(h)
        });
      }
    };
  };
};
function ii(t) {
  "@babel/helpers - typeof";
  return ii = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ii(t);
}
function Pu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ye(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pu(Object(r), !0).forEach(function(n) {
      da(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Pu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function da(t, e, r) {
  return e = OS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function OS(t) {
  var e = TS(t, "string");
  return ii(e) == "symbol" ? e : String(e);
}
function TS(t, e) {
  if (ii(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ii(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Cr(t, e) {
  return zS(t) || MS(t, e) || kS(t, e) || jS();
}
function jS() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kS(t, e) {
  if (t) {
    if (typeof t == "string") return Au(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Au(t, e);
  }
}
function Au(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function MS(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function zS(t) {
  if (Array.isArray(t)) return t;
}
var Os = Pe({
  name: "range-input",
  connector: !0
}, {
  name: "range-slider",
  connector: !0
}), ES = "ais.range";
function Ou(t) {
  var e = t.min, r = t.max, n = t.precision, i = Math.pow(10, n);
  return {
    min: e && Math.floor(e * i) / i,
    max: r && Math.ceil(r * i) / i
  };
}
var CS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Os()), function(n) {
    var i = n || {}, a = i.attribute, s = a === void 0 ? "" : a, o = i.min, l = i.max, c = i.precision, u = c === void 0 ? 0 : c;
    if (!s)
      throw new Error(Os("The `attribute` option is required."));
    if (we(o) && we(l) && o > l)
      throw new Error(Os("The `max` option can't be lower than `min`."));
    var f = function(y) {
      return Number(Number(y).toFixed(u));
    }, m = {
      from: function(y) {
        return y.toLocaleString();
      },
      to: function(y) {
        return f(y).toLocaleString();
      }
    }, h = function(y, w, P, T) {
      var A = y.state, j = w.min, O = w.max, M = A.getNumericRefinement(s, ">=") || [], z = Cr(M, 1), R = z[0], I = A.getNumericRefinement(s, "<=") || [], L = Cr(I, 1), W = L[0], q = P === void 0 || P === "", C = T === void 0 || T === "", E = Ou({
        min: q ? void 0 : parseFloat(P),
        max: C ? void 0 : parseFloat(T),
        precision: u
      }), B = E.min, Q = E.max, $;
      !we(o) && j === B ? $ = void 0 : we(o) && q ? $ = o : $ = B;
      var ne;
      !we(l) && O === Q ? ne = void 0 : we(l) && C ? ne = l : ne = Q;
      var ce = $ === void 0, ge = we(j) && j <= $, G = ce || we($) && (!we(j) || ge), Z = ne === void 0, Y = we(ne) && O >= ne, te = Z || we(ne) && (!we(O) || Y), ue = R !== $, je = W !== ne;
      return (ue || je) && G && te ? (A = A.removeNumericRefinement(s), we($) && (A = A.addNumericRefinement(s, ">=", $)), we(ne) && (A = A.addNumericRefinement(s, "<=", ne)), A.resetPage()) : null;
    }, p = function(y) {
      return function() {
        if (arguments.length === 1) {
          y.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
          return;
        }
      };
    };
    function d(g) {
      var y;
      we(o) ? y = o : we(g.min) ? y = g.min : y = 0;
      var w;
      return we(l) ? w = l : we(g.max) ? w = g.max : w = 0, Ou({
        min: y,
        max: w,
        precision: u
      });
    }
    function v(g) {
      var y = g.getNumericRefinement(s, ">=") || [], w = Cr(y, 1), P = w[0], T = g.getNumericRefinement(s, "<=") || [], A = Cr(T, 1), j = A[0], O = we(P) ? P : -1 / 0, M = we(j) ? j : 1 / 0;
      return [O, M];
    }
    function b(g, y) {
      return function() {
        var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [void 0, void 0], P = Cr(w, 2), T = P[0], A = P[1], j = h(g, y, T, A);
        j && g.setState(j).search();
      };
    }
    return {
      $$type: ES,
      init: function(y) {
        e(Ye(Ye({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: y.instantSearchInstance
        }), !0);
      },
      render: function(y) {
        e(Ye(Ye({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: y.instantSearchInstance
        }), !1);
      },
      getRenderState: function(y, w) {
        return Ye(Ye({}, y), {}, {
          range: Ye(Ye({}, y.range), {}, da({}, s, this.getWidgetRenderState(w)))
        });
      },
      getWidgetRenderState: function(y) {
        var w = y.results, P = y.helper, T = y.instantSearchInstance, A = w && w.disjunctiveFacets || [], j = Gt(A, function(I) {
          return I.name === s;
        }), O = j && j.stats || {
          min: void 0,
          max: void 0
        }, M = d(O), z = v(P), R;
        return w ? R = b(P, M) : R = b(P, {
          min: void 0,
          max: void 0
        }), {
          refine: R,
          canRefine: M.min !== M.max,
          format: m,
          range: M,
          sendEvent: p(T),
          widgetParams: Ye(Ye({}, n), {}, {
            precision: u
          }),
          start: z
        };
      },
      dispose: function(y) {
        var w = y.state;
        return r(), w.removeDisjunctiveFacet(s).removeNumericRefinement(s);
      },
      getWidgetUiState: function(y, w) {
        var P = w.searchParameters, T = P.getNumericRefinements(s), A = T[">="], j = A === void 0 ? [] : A, O = T["<="], M = O === void 0 ? [] : O;
        return j.length === 0 && M.length === 0 ? y : Ye(Ye({}, y), {}, {
          range: Ye(Ye({}, y.range), {}, da({}, s, "".concat(j, ":").concat(M)))
        });
      },
      getWidgetSearchParameters: function(y, w) {
        var P = w.uiState, T = y.addDisjunctiveFacet(s).setQueryParameters({
          numericRefinements: Ye(Ye({}, y.numericRefinements), {}, da({}, s, {}))
        });
        we(o) && (T = T.addNumericRefinement(s, ">=", o)), we(l) && (T = T.addNumericRefinement(s, "<=", l));
        var A = P.range && P.range[s];
        if (!A || A.indexOf(":") === -1)
          return T;
        var j = A.split(":").map(parseFloat), O = Cr(j, 2), M = O[0], z = O[1];
        return we(M) && (!we(o) || o < M) && (T = T.removeNumericRefinement(s, ">="), T = T.addNumericRefinement(s, ">=", M)), we(z) && (!we(l) || z < l) && (T = T.removeNumericRefinement(s, "<="), T = T.addNumericRefinement(s, "<=", z)), T;
      }
    };
  };
};
function ai(t) {
  "@babel/helpers - typeof";
  return ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ai(t);
}
var IS = ["name", "escapedValue"], LS = ["escapedValue", "value"];
function Tu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ae(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Tu(Object(r), !0).forEach(function(n) {
      bn(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Tu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function bn(t, e, r) {
  return e = RS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function RS(t) {
  var e = NS(t, "string");
  return ai(e) == "symbol" ? e : String(e);
}
function NS(t, e) {
  if (ai(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ai(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ju(t, e) {
  if (t == null) return {};
  var r = DS(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function DS(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
var _i = Pe({
  name: "refinement-list",
  connector: !0
}), ku = ["isRefined", "count:desc", "name:asc"], HS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, _i()), function(n) {
    var i = n || {}, a = i.attribute, s = i.operator, o = s === void 0 ? "or" : s, l = i.limit, c = l === void 0 ? 10 : l, u = i.showMore, f = u === void 0 ? !1 : u, m = i.showMoreLimit, h = m === void 0 ? 20 : m, p = i.sortBy, d = p === void 0 ? ku : p, v = i.escapeFacetValues, b = v === void 0 ? !0 : v, g = i.transformItems, y = g === void 0 ? function(C) {
      return C;
    } : g;
    if (!a)
      throw new Error(_i("The `attribute` option is required."));
    if (!/^(and|or)$/.test(o))
      throw new Error(_i('The `operator` must one of: `"and"`, `"or"` (got "'.concat(o, '").')));
    if (f === !0 && h <= c)
      throw new Error(_i("`showMoreLimit` should be greater than `limit`."));
    var w = function(E) {
      var B = E.name, Q = E.escapedValue, $ = ju(E, IS);
      return Ae(Ae({}, $), {}, {
        value: Q,
        label: B,
        highlighted: B
      });
    }, P, T = [], A = !0, j, O, M = !1, z = function() {
    };
    function R() {
      z();
    }
    function I(C, E) {
      return function() {
        M = !M, E.render(C);
      };
    }
    function L() {
      return M ? h : c;
    }
    var W = function() {
      return function() {
      };
    }, q = function(E, B) {
      return function(Q) {
        return function($) {
          var ne = Q.instantSearchInstance, ce = Q.results;
          if ($ === "" && T)
            e(Ae(Ae({}, B.getWidgetRenderState(Ae(Ae({}, Q), {}, {
              results: P
            }))), {}, {
              instantSearchInstance: ne
            }), !1);
          else {
            var ge = {
              highlightPreTag: b ? Ct.highlightPreTag : Je.highlightPreTag,
              highlightPostTag: b ? Ct.highlightPostTag : Je.highlightPostTag
            };
            E.searchForFacetValues(
              a,
              $,
              // We cap the `maxFacetHits` value to 100 because the Algolia API
              // doesn't support a greater number.
              // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
              Math.min(L(), 100),
              ge
            ).then(function(G) {
              var Z = b ? I2(G.facetHits) : G.facetHits, Y = y(Z.map(function(te) {
                var ue = te.escapedValue, je = te.value, ze = ju(te, LS);
                return Ae(Ae({}, ze), {}, {
                  value: ue,
                  label: je
                });
              }), {
                results: ce
              });
              e(Ae(Ae({}, B.getWidgetRenderState(Ae(Ae({}, Q), {}, {
                results: P
              }))), {}, {
                items: Y,
                canToggleShowMore: !1,
                canRefine: !0,
                isFromSearch: !0,
                instantSearchInstance: ne
              }), !1);
            });
          }
        };
      };
    };
    return {
      $$type: "ais.refinementList",
      init: function(E) {
        e(Ae(Ae({}, this.getWidgetRenderState(E)), {}, {
          instantSearchInstance: E.instantSearchInstance
        }), !0);
      },
      render: function(E) {
        e(Ae(Ae({}, this.getWidgetRenderState(E)), {}, {
          instantSearchInstance: E.instantSearchInstance
        }), !1);
      },
      getRenderState: function(E, B) {
        return Ae(Ae({}, E), {}, {
          refinementList: Ae(Ae({}, E.refinementList), {}, bn({}, a, this.getWidgetRenderState(B)))
        });
      },
      getWidgetRenderState: function(E) {
        var B = this, Q = E.results, $ = E.state, ne = E.createURL, ce = E.instantSearchInstance, ge = E.helper, G = [], Z = [];
        if ((!O || !j || !W) && (O = il({
          instantSearchInstance: ce,
          helper: ge,
          attribute: a,
          widgetType: this.$$type
        }), j = function(Xe) {
          O("click:internal", Xe), ge.toggleFacetRefinement(a, Xe).search();
        }, W = q(ge, this)), Q) {
          var Y = Q.getFacetValues(a, {
            sortBy: d,
            facetOrdering: d === ku
          });
          Z = Y && Array.isArray(Y) ? Y : [], G = y(Z.slice(0, L()).map(w), {
            results: Q
          });
          var te = $.maxValuesPerFacet, ue = L();
          A = te > ue ? Z.length <= ue : Z.length < ue, P = Q, T = G, E.results && (z = I(E, this));
        }
        var je = W && W(E), ze = M && T.length > c, $e = f && !A, Ot = ze || $e;
        return {
          createURL: function(Xe) {
            return ne(function(lr) {
              return B.getWidgetUiState(lr, {
                searchParameters: $.resetPage().toggleFacetRefinement(a, Xe),
                helper: ge
              });
            });
          },
          items: G,
          refine: j,
          searchForItems: je,
          isFromSearch: !1,
          canRefine: G.length > 0,
          widgetParams: n,
          isShowingMore: M,
          canToggleShowMore: Ot,
          toggleShowMore: R,
          sendEvent: O,
          hasExhaustiveItems: A
        };
      },
      dispose: function(E) {
        var B = E.state;
        r();
        var Q = B.setQueryParameter("maxValuesPerFacet", void 0);
        return o === "and" ? Q.removeFacet(a) : Q.removeDisjunctiveFacet(a);
      },
      getWidgetUiState: function(E, B) {
        var Q = B.searchParameters, $ = o === "or" ? Q.getDisjunctiveRefinements(a) : Q.getConjunctiveRefinements(a);
        return WS(Ae(Ae({}, E), {}, {
          refinementList: Ae(Ae({}, E.refinementList), {}, bn({}, a, $))
        }), a);
      },
      getWidgetSearchParameters: function(E, B) {
        var Q = B.uiState, $ = o === "or";
        if (E.isHierarchicalFacet(a))
          return process.env.NODE_ENV === "development" && ie(!1, 'RefinementList: Attribute "'.concat(a, `" is already used by another widget applying hierarchical faceting.
As this is not supported, please make sure to remove this other widget or this RefinementList widget will not work at all.`)), E;
        if ($ && E.isConjunctiveFacet(a) || !$ && E.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ie(!1, 'RefinementList: Attribute "'.concat(a, `" is used by another refinement list with a different operator.
As this is not supported, please make sure to only use this attribute with one of the two operators.`)), E;
        var ne = Q.refinementList && Q.refinementList[a], ce = $ ? E.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a) : E.addFacet(a).removeFacetRefinement(a), ge = ce.maxValuesPerFacet || 0, G = Math.max(ge, f ? h : c), Z = ce.setQueryParameter("maxValuesPerFacet", G);
        if (!ne) {
          var Y = $ ? "disjunctiveFacetsRefinements" : "facetsRefinements";
          return Z.setQueryParameters(bn({}, Y, Ae(Ae({}, Z[Y]), {}, bn({}, a, []))));
        }
        return ne.reduce(function(te, ue) {
          return $ ? te.addDisjunctiveFacetRefinement(a, ue) : te.addFacetRefinement(a, ue);
        }, Z);
      }
    };
  };
};
function WS(t, e) {
  return t.refinementList && ((!t.refinementList[e] || t.refinementList[e].length === 0) && delete t.refinementList[e], Object.keys(t.refinementList).length === 0 && delete t.refinementList), t;
}
function si(t) {
  "@babel/helpers - typeof";
  return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, si(t);
}
function Mu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mu(Object(r), !0).forEach(function(n) {
      FS(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function FS(t, e, r) {
  return e = VS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function VS(t) {
  var e = GS(t, "string");
  return si(e) == "symbol" ? e : String(e);
}
function GS(t, e) {
  if (si(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (si(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ZS = Pe({
  name: "search-box",
  connector: !0
}), XS = function(e, r) {
  return r(e);
}, BS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, ZS()), function(n) {
    var i = n || {}, a = i.queryHook, s = a === void 0 ? XS : a, o, l;
    return {
      $$type: "ais.searchBox",
      init: function(u) {
        var f = u.instantSearchInstance;
        e(Yt(Yt({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(u) {
        var f = u.instantSearchInstance;
        e(Yt(Yt({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      dispose: function(u) {
        var f = u.state;
        return r(), f.setQueryParameter("query", void 0);
      },
      getRenderState: function(u, f) {
        return Yt(Yt({}, u), {}, {
          searchBox: this.getWidgetRenderState(f)
        });
      },
      getWidgetRenderState: function(u) {
        var f = u.helper, m = u.instantSearchInstance, h = u.state;
        return o || (o = function(d) {
          s(d, function(v) {
            return f.setQuery(v).search();
          });
        }, l = function() {
          f.setQuery("").search();
        }), {
          query: h.query || "",
          refine: o,
          clear: l,
          widgetParams: n,
          isSearchStalled: m.status === "stalled"
        };
      },
      getWidgetUiState: function(u, f) {
        var m = f.searchParameters, h = m.query || "";
        return h === "" || u && u.query === h ? u : Yt(Yt({}, u), {}, {
          query: h
        });
      },
      getWidgetSearchParameters: function(u, f) {
        var m = f.uiState;
        return u.setQueryParameter("query", m.query || "");
      }
    };
  };
};
function oi(t) {
  "@babel/helpers - typeof";
  return oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, oi(t);
}
function zu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zu(Object(r), !0).forEach(function(n) {
      US(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function US(t, e, r) {
  return e = YS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function YS(t) {
  var e = qS(t, "string");
  return oi(e) == "symbol" ? e : String(e);
}
function qS(t, e) {
  if (oi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (oi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Eu = Pe({
  name: "sort-by",
  connector: !0
}), QS = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  Ie(e, Eu());
  var n = {};
  return function(i) {
    var a = i || {}, s = a.items, o = a.transformItems, l = o === void 0 ? function(c) {
      return c;
    } : o;
    if (!Array.isArray(s))
      throw new Error(Eu("The `items` option expects an array of objects."));
    return {
      $$type: "ais.sortBy",
      init: function(u) {
        var f = u.instantSearchInstance, m = this.getWidgetRenderState(u), h = m.currentRefinement, p = Gt(s, function(d) {
          return d.value === h;
        });
        process.env.NODE_ENV === "development" && ie(p !== void 0, 'The index named "'.concat(h, '" is not listed in the `items` of `sortBy`.')), e(qt(qt({}, m), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(u) {
        var f = u.instantSearchInstance;
        e(qt(qt({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      dispose: function(u) {
        var f = u.state;
        return r(), n.initialIndex ? f.setIndex(n.initialIndex) : f;
      },
      getRenderState: function(u, f) {
        return qt(qt({}, u), {}, {
          sortBy: this.getWidgetRenderState(f)
        });
      },
      getWidgetRenderState: function(u) {
        var f = u.results, m = u.helper, h = u.state, p = u.parent;
        !n.initialIndex && p && (n.initialIndex = p.getIndexName()), n.setIndex || (n.setIndex = function(v) {
          m.setIndex(v).search();
        });
        var d = f ? f.nbHits === 0 : !0;
        return {
          currentRefinement: h.index,
          options: l(s, {
            results: f
          }),
          refine: n.setIndex,
          hasNoResults: d,
          canRefine: !d && s.length > 0,
          widgetParams: i
        };
      },
      getWidgetUiState: function(u, f) {
        var m = f.searchParameters, h = m.index;
        return qt(qt({}, u), {}, {
          sortBy: h !== n.initialIndex ? h : void 0
        });
      },
      getWidgetSearchParameters: function(u, f) {
        var m = f.uiState;
        return u.setQueryParameter("index", m.sortBy || n.initialIndex || u.index);
      }
    };
  };
};
function li(t) {
  "@babel/helpers - typeof";
  return li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, li(t);
}
function JS(t) {
  return $S(t) || _S(t) || Bp(t) || KS();
}
function KS() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _S(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function $S(t) {
  if (Array.isArray(t)) return yo(t);
}
function Cu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cu(Object(r), !0).forEach(function(n) {
      fa(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Cu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function fa(t, e, r) {
  return e = e5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function e5(t) {
  var e = t5(t, "string");
  return li(e) == "symbol" ? e : String(e);
}
function t5(t, e) {
  if (li(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Xp(t, e) {
  return i5(t) || n5(t, e) || Bp(t, e) || r5();
}
function r5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bp(t, e) {
  if (t) {
    if (typeof t == "string") return yo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yo(t, e);
  }
}
function yo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function n5(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function i5(t) {
  if (Array.isArray(t)) return t;
}
var Iu = Pe({
  name: "rating-menu",
  connector: !0
}), Up = "ais.ratingMenu", Ts = 1e3, $i = 1, a5 = function(e) {
  var r = e.instantSearchInstance, n = e.helper, i = e.getRefinedStar, a = e.attribute;
  return function() {
    for (var s = arguments.length, o = new Array(s), l = 0; l < s; l++)
      o[l] = arguments[l];
    if (o.length === 1) {
      r.sendEventToInsights(o[0]);
      return;
    }
    var c = o[1], u = o[2], f = u === void 0 ? "Filter Applied" : u, m = o[0].split(":"), h = Xp(m, 2), p = h[0], d = h[1];
    if (p === "click") {
      var v = i() === Number(c);
      v || r.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: Up,
        eventType: p,
        eventModifier: d,
        payload: {
          eventName: f,
          index: n.getIndex(),
          filters: ["".concat(a, ">=").concat(c)]
        },
        attribute: a
      });
    }
  };
}, s5 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Iu()), function(n) {
    var i = n || {}, a = i.attribute, s = i.max, o = s === void 0 ? 5 : s, l;
    if (!a)
      throw new Error(Iu("The `attribute` option is required."));
    var c = function(v) {
      var b, g = v.getNumericRefinements(a);
      if ((b = g[">="]) !== null && b !== void 0 && b.length)
        return g[">="][0];
    }, u = function(v) {
      var b = 0;
      return v.forEach(function(g) {
        var y = g.name.split("."), w = Xp(y, 2), P = w[1], T = P === void 0 ? "" : P;
        b = Math.max(b, T.length);
      }), b;
    }, f = function(v) {
      var b = v.maxDecimalPlaces, g = v.maxFacets, y = v.maxValuesPerFacet, w = Math.max(0, Math.floor(Math.log10(Ts / o))), P = Math.min(Ts, Math.pow(10, w) * o), T = [];
      return g > Ts && T.push('- Update your records to lower the precision of the values in the "'.concat(a, '" attribute (for example: ').concat(5.123456789.toPrecision(b + 1), " to ").concat(5.123456789.toPrecision(w + 1), ")")), y < P && T.push("- Increase the maximum number of facet values to ".concat(P, ' using the "configure" widget ').concat(Nn({
        name: "configure"
      }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/')), "The ".concat(a, " attribute can have ").concat(g, " different values (0 to ").concat(o, " with a maximum of ").concat(b, " decimals = ").concat(g, ") but you retrieved only ").concat(y, ` facet values. Therefore the number of results that match the refinements can be incorrect.
    `).concat(T.length ? `To resolve this problem you can:
`.concat(T.join(`
`)) : "");
    };
    function m(d, v) {
      var b = c(d) === Number(v), g = d.resetPage().removeNumericRefinement(a);
      return b ? g : g.addNumericRefinement(a, "<=", o).addNumericRefinement(a, ">=", Number(v));
    }
    var h = function(v, b) {
      l("click:internal", b), v.setState(m(v.state, b)).search();
    }, p = {
      toggleRefinementFactory: function(v) {
        return h.bind(null, v);
      },
      createURLFactory: function(v) {
        var b = v.state, g = v.createURL, y = v.getWidgetUiState, w = v.helper;
        return function(P) {
          return g(function(T) {
            return y(T, {
              searchParameters: m(b, P),
              helper: w
            });
          });
        };
      }
    };
    return {
      $$type: Up,
      init: function(v) {
        var b = v.instantSearchInstance;
        e(tt(tt({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !0);
      },
      render: function(v) {
        var b = v.instantSearchInstance;
        e(tt(tt({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !1);
      },
      getRenderState: function(v, b) {
        return tt(tt({}, v), {}, {
          ratingMenu: tt(tt({}, v.ratingMenu), {}, fa({}, a, this.getWidgetRenderState(b)))
        });
      },
      getWidgetRenderState: function(v) {
        var b = v.helper, g = v.results, y = v.state, w = v.instantSearchInstance, P = v.createURL, T = [];
        l || (l = a5({
          instantSearchInstance: w,
          helper: b,
          getRefinedStar: function() {
            return c(b.state);
          },
          attribute: a
        }));
        var A = !1, j = 0, O = g == null ? void 0 : g.getFacetValues(a, {});
        if (g && O) {
          var M = O.length, z = u(O), R = Math.pow(10, z) * o;
          process.env.NODE_ENV === "development" && ie(R <= M || !!g.__isArtificial, f({
            maxDecimalPlaces: z,
            maxFacets: R,
            maxValuesPerFacet: M
          }));
          for (var I = c(y), L = function(B) {
            var Q = I === B;
            A = A || Q;
            var $ = O.filter(function(ce) {
              return Number(ce.name) >= B && Number(ce.name) <= o;
            }).map(function(ce) {
              return ce.count;
            }).reduce(function(ce, ge) {
              return ce + ge;
            }, 0);
            if (j += $, I && !Q && $ === 0)
              return "continue";
            var ne = JS(new Array(Math.floor(o / $i))).map(function(ce, ge) {
              return ge * $i < B;
            });
            T.push({
              stars: ne,
              name: String(B),
              label: String(B),
              value: String(B),
              count: $,
              isRefined: Q
            });
          }, W = $i; W < o; W += $i)
            var q = L(W);
        }
        T = T.reverse();
        var C = g ? g.nbHits === 0 : !0;
        return {
          items: T,
          hasNoResults: C,
          canRefine: (!C || A) && j > 0,
          refine: p.toggleRefinementFactory(b),
          sendEvent: l,
          createURL: p.createURLFactory({
            state: y,
            createURL: P,
            helper: b,
            getWidgetUiState: this.getWidgetUiState
          }),
          widgetParams: n
        };
      },
      dispose: function(v) {
        var b = v.state;
        return r(), b.removeNumericRefinement(a);
      },
      getWidgetUiState: function(v, b) {
        var g = b.searchParameters, y = c(g);
        return o5(tt(tt({}, v), {}, {
          ratingMenu: tt(tt({}, v.ratingMenu), {}, fa({}, a, typeof y == "number" ? y : void 0))
        }), a);
      },
      getWidgetSearchParameters: function(v, b) {
        var g = b.uiState, y = g.ratingMenu && g.ratingMenu[a], w = v.addDisjunctiveFacet(a).removeNumericRefinement(a).removeDisjunctiveFacetRefinement(a);
        return y ? w.addNumericRefinement(a, "<=", o).addNumericRefinement(a, ">=", y) : w.setQueryParameters({
          numericRefinements: tt(tt({}, w.numericRefinements), {}, fa({}, a, {}))
        });
      }
    };
  };
};
function o5(t, e) {
  return t.ratingMenu && (typeof t.ratingMenu[e] != "number" && delete t.ratingMenu[e], Object.keys(t.ratingMenu).length === 0 && delete t.ratingMenu), t;
}
function ci(t) {
  "@babel/helpers - typeof";
  return ci = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ci(t);
}
function Lu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ir(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Lu(Object(r), !0).forEach(function(n) {
      l5(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Lu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function l5(t, e, r) {
  return e = c5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function c5(t) {
  var e = u5(t, "string");
  return ci(e) == "symbol" ? e : String(e);
}
function u5(t, e) {
  if (ci(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ci(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var d5 = Pe({
  name: "stats",
  connector: !0
}), f5 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, d5()), function(n) {
    return {
      $$type: "ais.stats",
      init: function(a) {
        var s = a.instantSearchInstance;
        e(Ir(Ir({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !0);
      },
      render: function(a) {
        var s = a.instantSearchInstance;
        e(Ir(Ir({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(a, s) {
        return Ir(Ir({}, a), {}, {
          stats: this.getWidgetRenderState(s)
        });
      },
      getWidgetRenderState: function(a) {
        var s = a.results, o = a.state;
        return s ? {
          hitsPerPage: s.hitsPerPage,
          nbHits: s.nbHits,
          nbSortedHits: s.nbSortedHits,
          areHitsSorted: typeof s.appliedRelevancyStrictness < "u" && s.appliedRelevancyStrictness > 0 && s.nbSortedHits !== s.nbHits,
          nbPages: s.nbPages,
          page: s.page,
          processingTimeMS: s.processingTimeMS,
          query: s.query,
          widgetParams: n
        } : {
          hitsPerPage: o.hitsPerPage,
          nbHits: 0,
          nbSortedHits: void 0,
          areHitsSorted: !1,
          nbPages: 0,
          page: o.page || 0,
          processingTimeMS: -1,
          query: o.query || "",
          widgetParams: n
        };
      }
    };
  };
};
function ui(t) {
  "@babel/helpers - typeof";
  return ui = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ui(t);
}
function Ru(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ru(Object(r), !0).forEach(function(n) {
      pa(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ru(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function pa(t, e, r) {
  return e = p5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function p5(t) {
  var e = m5(t, "string");
  return ui(e) == "symbol" ? e : String(e);
}
function m5(t, e) {
  if (ui(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ui(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function h5(t, e) {
  return y5(t) || b5(t, e) || v5(t, e) || g5();
}
function g5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v5(t, e) {
  if (t) {
    if (typeof t == "string") return Nu(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Nu(t, e);
  }
}
function Nu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function b5(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function y5(t) {
  if (Array.isArray(t)) return t;
}
var Du = Pe({
  name: "toggle-refinement",
  connector: !0
}), Yp = "ais.toggleRefinement", w5 = function(e) {
  var r = e.instantSearchInstance, n = e.helper, i = e.attribute, a = e.on, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    if (c.length === 1) {
      r.sendEventToInsights(c[0]);
      return;
    }
    var f = c[1], m = c[2], h = m === void 0 ? "Filter Applied" : m, p = c[0].split(":"), d = h5(p, 2), v = d[0], b = d[1];
    v !== "click" || a === void 0 || f || r.sendEventToInsights({
      insightsMethod: "clickedFilters",
      widgetType: Yp,
      eventType: v,
      eventModifier: b,
      payload: {
        eventName: h,
        index: n.getIndex(),
        filters: a.map(function(g) {
          return "".concat(i, ":").concat(g);
        })
      },
      attribute: i
    });
  };
  return s;
}, S5 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Du()), function(n) {
    var i = n || {}, a = i.attribute, s = i.on, o = s === void 0 ? !0 : s, l = i.off;
    if (!a)
      throw new Error(Du("The `attribute` option is required."));
    var c = l !== void 0, u = ms(o).map(mn), f = c ? ms(l).map(mn) : void 0, m, h = function(v) {
      return function() {
        var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
          isRefined: !1
        }, g = b.isRefined;
        g ? (u.forEach(function(y) {
          return v.removeDisjunctiveFacetRefinement(a, y);
        }), c && f.forEach(function(y) {
          return v.addDisjunctiveFacetRefinement(a, y);
        })) : (m("click:internal", g), c && f.forEach(function(y) {
          return v.removeDisjunctiveFacetRefinement(a, y);
        }), u.forEach(function(y) {
          return v.addDisjunctiveFacetRefinement(a, y);
        })), v.search();
      };
    }, p = {
      createURLFactory: function(v, b) {
        var g = b.state, y = b.createURL, w = b.getWidgetUiState, P = b.helper;
        return function() {
          g = g.resetPage();
          var T = v ? u : f;
          T && T.forEach(function(j) {
            g = g.removeDisjunctiveFacetRefinement(a, j);
          });
          var A = v ? f : u;
          return A && A.forEach(function(j) {
            g = g.addDisjunctiveFacetRefinement(a, j);
          }), y(function(j) {
            return w(j, {
              searchParameters: g,
              helper: P
            });
          });
        };
      }
    };
    return {
      $$type: Yp,
      init: function(v) {
        var b = v.instantSearchInstance;
        e(rt(rt({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !0);
      },
      render: function(v) {
        var b = v.instantSearchInstance;
        e(rt(rt({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !1);
      },
      dispose: function(v) {
        var b = v.state;
        return r(), b.removeDisjunctiveFacet(a);
      },
      getRenderState: function(v, b) {
        return rt(rt({}, v), {}, {
          toggleRefinement: rt(rt({}, v.toggleRefinement), {}, pa({}, a, this.getWidgetRenderState(b)))
        });
      },
      getWidgetRenderState: function(v) {
        var b = v.state, g = v.helper, y = v.results, w = v.createURL, P = v.instantSearchInstance, T = y ? u.every(function(L) {
          return b.isDisjunctiveFacetRefined(a, L);
        }) : u.every(function(L) {
          return b.isDisjunctiveFacetRefined(a, L);
        }), A = {
          isRefined: T,
          count: 0
        }, j = {
          isRefined: c && !T,
          count: 0
        };
        if (y) {
          var O = ms(f || !1), M = y.getFacetValues(a, {}) || [], z = u.map(function(L) {
            return Gt(M, function(W) {
              var q = W.escapedValue;
              return q === mn(String(L));
            });
          }).filter(function(L) {
            return L !== void 0;
          }), R = c ? O.map(function(L) {
            return Gt(M, function(W) {
              var q = W.escapedValue;
              return q === mn(String(L));
            });
          }).filter(function(L) {
            return L !== void 0;
          }) : [];
          A = {
            isRefined: z.length ? z.every(function(L) {
              return L.isRefined;
            }) : !1,
            count: z.reduce(function(L, W) {
              return L + W.count;
            }, 0) || null
          }, j = {
            isRefined: R.length ? R.every(function(L) {
              return L.isRefined;
            }) : !1,
            count: R.reduce(function(L, W) {
              return L + W.count;
            }, 0) || M.reduce(function(L, W) {
              var q = W.count;
              return L + q;
            }, 0)
          };
        }
        m || (m = w5({
          instantSearchInstance: P,
          attribute: a,
          on: u,
          helper: g
        }));
        var I = T ? j : A;
        return {
          value: {
            name: a,
            isRefined: T,
            count: y ? I.count : null,
            onFacetValue: A,
            offFacetValue: j
          },
          createURL: p.createURLFactory(T, {
            state: b,
            createURL: w,
            helper: g,
            getWidgetUiState: this.getWidgetUiState
          }),
          sendEvent: m,
          canRefine: !!(y && I.count),
          refine: h(g),
          widgetParams: n
        };
      },
      getWidgetUiState: function(v, b) {
        var g = b.searchParameters, y = u && u.every(function(P) {
          return g.isDisjunctiveFacetRefined(a, P);
        });
        if (!y) {
          var w;
          return (w = v.toggle) === null || w === void 0 || delete w[a], v;
        }
        return rt(rt({}, v), {}, {
          toggle: rt(rt({}, v.toggle), {}, pa({}, a, y))
        });
      },
      getWidgetSearchParameters: function(v, b) {
        var g = b.uiState;
        if (v.isHierarchicalFacet(a) || v.isConjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ie(!1, 'ToggleRefinement: Attribute "'.concat(a, `" is already used by another widget of a different type.
As this is not supported, please make sure to remove this other widget or this ToggleRefinement widget will not work at all.`)), v;
        var y = v.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a), w = !!(g.toggle && g.toggle[a]);
        return w ? (u && u.forEach(function(P) {
          y = y.addDisjunctiveFacetRefinement(a, P);
        }), y) : c ? (f && f.forEach(function(P) {
          y = y.addDisjunctiveFacetRefinement(a, P);
        }), y) : y.setQueryParameters({
          disjunctiveFacetsRefinements: rt(rt({}, v.disjunctiveFacetsRefinements), {}, pa({}, a, []))
        });
      }
    };
  };
};
function di(t) {
  "@babel/helpers - typeof";
  return di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, di(t);
}
function Hu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hu(Object(r), !0).forEach(function(n) {
      ma(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Hu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ma(t, e, r) {
  return e = x5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function x5(t) {
  var e = P5(t, "string");
  return di(e) == "symbol" ? e : String(e);
}
function P5(t, e) {
  if (di(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (di(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Wu(t, e) {
  return j5(t) || T5(t, e) || O5(t, e) || A5();
}
function A5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O5(t, e) {
  if (t) {
    if (typeof t == "string") return Fu(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Fu(t, e);
  }
}
function Fu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function T5(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e !== 0) for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function j5(t) {
  if (Array.isArray(t)) return t;
}
var Vu = Pe({
  name: "breadcrumb",
  connector: !0
}), k5 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  Ie(e, Vu());
  var n = {};
  return function(i) {
    var a = i || {}, s = a.attributes, o = a.separator, l = o === void 0 ? " > " : o, c = a.rootPath, u = c === void 0 ? null : c, f = a.transformItems, m = f === void 0 ? function(v) {
      return v;
    } : f;
    if (!s || !Array.isArray(s) || s.length === 0)
      throw new Error(Vu("The `attributes` option expects an array of strings."));
    var h = Wu(s, 1), p = h[0];
    function d(v, b) {
      if (!b) {
        var g = v.getHierarchicalFacetBreadcrumb(p);
        return g.length === 0 ? v : v.resetPage().toggleFacetRefinement(p, g[0]);
      }
      return v.resetPage().toggleFacetRefinement(p, b);
    }
    return {
      $$type: "ais.breadcrumb",
      init: function(b) {
        e(nt(nt({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !0);
      },
      render: function(b) {
        e(nt(nt({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(b, g) {
        return nt(nt({}, b), {}, {
          breadcrumb: nt(nt({}, b.breadcrumb), {}, ma({}, p, this.getWidgetRenderState(g)))
        });
      },
      getWidgetRenderState: function(b) {
        var g = this, y = b.helper, w = b.createURL, P = b.results, T = b.state;
        function A() {
          if (!P || T.hierarchicalFacets.length === 0)
            return [];
          var O = Wu(T.hierarchicalFacets, 1), M = O[0].name, z = P.getFacetValues(M, {}), R = z && !Array.isArray(z) && z.data ? z.data : [], I = m(M5(qp(R)), {
            results: P
          });
          return I;
        }
        var j = A();
        return n.createURL || (n.createURL = function(O) {
          return w(function(M) {
            return g.getWidgetUiState(M, {
              searchParameters: d(y.state, O),
              helper: y
            });
          });
        }), n.refine || (n.refine = function(O) {
          y.setState(d(y.state, O)).search();
        }), {
          canRefine: j.length > 0,
          createURL: n.createURL,
          items: j,
          refine: n.refine,
          widgetParams: i
        };
      },
      getWidgetUiState: function(b, g) {
        var y = g.searchParameters, w = y.getHierarchicalFacetBreadcrumb(p);
        return z5(nt(nt({}, b), {}, {
          hierarchicalMenu: nt(nt({}, b.hierarchicalMenu), {}, ma({}, p, w))
        }), p);
      },
      getWidgetSearchParameters: function(b, g) {
        var y = g.uiState, w = y.hierarchicalMenu && y.hierarchicalMenu[p];
        if (b.isConjunctiveFacet(p) || b.isDisjunctiveFacet(p))
          return process.env.NODE_ENV === "development" && ie(!1, 'HierarchicalMenu: Attribute "'.concat(p, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), b;
        if (b.isHierarchicalFacet(p)) {
          var P = b.getHierarchicalFacetByName(p);
          process.env.NODE_ENV === "development" && ie(Pr(P.attributes, s) && P.separator === l && P.rootPath === u, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var T = b.removeHierarchicalFacet(p).addHierarchicalFacet({
          name: p,
          attributes: s,
          separator: l,
          rootPath: u
        });
        return w ? T.addHierarchicalFacetRefinement(p, w.join(l)) : T.setQueryParameters({
          hierarchicalFacetsRefinements: nt(nt({}, T.hierarchicalFacetsRefinements), {}, ma({}, p, []))
        });
      }
    };
  };
};
function qp(t) {
  return t.reduce(function(e, r) {
    return r.isRefined && (e.push({
      label: r.name,
      value: r.escapedValue
    }), Array.isArray(r.data) && (e = e.concat(qp(r.data)))), e;
  }, []);
}
function M5(t) {
  return t.map(function(e, r) {
    return {
      label: e.label,
      value: r + 1 === t.length ? null : t[r + 1].value
    };
  });
}
function z5(t, e) {
  return t.hierarchicalMenu && ((!t.hierarchicalMenu[e] || !t.hierarchicalMenu[e].length) && delete t.hierarchicalMenu[e], Object.keys(t.hierarchicalMenu).length === 0 && delete t.hierarchicalMenu), t;
}
function fi(t) {
  "@babel/helpers - typeof";
  return fi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fi(t);
}
function Gu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ht(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gu(Object(r), !0).forEach(function(n) {
      Qp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Gu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Qp(t, e, r) {
  return e = E5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function E5(t) {
  var e = C5(t, "string");
  return fi(e) == "symbol" ? e : String(e);
}
function C5(t, e) {
  if (fi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (fi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var I5 = Pe({
  name: "autocomplete",
  connector: !0
}), L5 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, I5()), function(n) {
    var i = n || {}, a = i.escapeHTML, s = a === void 0 ? !0 : a;
    process.env.NODE_ENV === "development" && ie(!n.indices, `
The option \`indices\` has been removed from the Autocomplete connector.

The indices to target are now inferred from the widgets tree.
`.concat(Array.isArray(n.indices) ? `
An alternative would be:

const autocomplete = connectAutocomplete(renderer);

search.addWidgets([
  `.concat(n.indices.map(function(l) {
      var c = l.value;
      return "index({ indexName: '".concat(c, "' }),");
    }).join(`
  `), `
  autocomplete()
]);
`) : "", `
      `));
    var o = {};
    return {
      $$type: "ais.autocomplete",
      init: function(c) {
        var u = c.instantSearchInstance;
        e(ht(ht({}, this.getWidgetRenderState(c)), {}, {
          instantSearchInstance: u
        }), !0);
      },
      render: function(c) {
        var u = c.instantSearchInstance, f = this.getWidgetRenderState(c);
        f.indices.forEach(function(m) {
          var h = m.sendEvent, p = m.hits;
          h("view:internal", p);
        }), e(ht(ht({}, f), {}, {
          instantSearchInstance: u
        }), !1);
      },
      getRenderState: function(c, u) {
        return ht(ht({}, c), {}, {
          autocomplete: this.getWidgetRenderState(u)
        });
      },
      getWidgetRenderState: function(c) {
        var u = this, f = c.helper, m = c.state, h = c.scopedResults, p = c.instantSearchInstance;
        o.refine || (o.refine = function(v) {
          f.setQuery(v).search();
        });
        var d = h.map(function(v) {
          var b, g;
          v.results && (v.results.hits = s ? Wa(v.results.hits) : v.results.hits);
          var y = al({
            instantSearchInstance: p,
            getIndex: function() {
              var P;
              return ((P = v.results) === null || P === void 0 ? void 0 : P.index) || "";
            },
            widgetType: u.$$type
          });
          return {
            indexId: v.indexId,
            indexName: ((b = v.results) === null || b === void 0 ? void 0 : b.index) || "",
            hits: ((g = v.results) === null || g === void 0 ? void 0 : g.hits) || [],
            results: v.results || {},
            sendEvent: y
          };
        });
        return {
          currentRefinement: m.query || "",
          indices: d,
          refine: o.refine,
          widgetParams: n
        };
      },
      getWidgetUiState: function(c, u) {
        var f = u.searchParameters, m = f.query || "";
        return m === "" || c && c.query === m ? c : ht(ht({}, c), {}, {
          query: m
        });
      },
      getWidgetSearchParameters: function(c, u) {
        var f = u.uiState, m = {
          query: f.query || ""
        };
        return s ? c.setQueryParameters(ht(ht({}, m), Ct)) : c.setQueryParameters(m);
      },
      dispose: function(c) {
        var u = c.state;
        r();
        var f = u.setQueryParameter("query", void 0);
        return s ? f.setQueryParameters(Object.keys(Ct).reduce(function(m, h) {
          return ht(ht({}, m), {}, Qp({}, h, void 0));
        }, {})) : f;
      }
    };
  };
};
function pi(t) {
  "@babel/helpers - typeof";
  return pi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pi(t);
}
function Zu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _t(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Zu(Object(r), !0).forEach(function(n) {
      R5(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function R5(t, e, r) {
  return e = N5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function N5(t) {
  var e = D5(t, "string");
  return pi(e) == "symbol" ? e : String(e);
}
function D5(t, e) {
  if (pi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (pi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Oa(t) {
  return V5(t) || F5(t) || W5(t) || H5();
}
function H5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W5(t, e) {
  if (t) {
    if (typeof t == "string") return wo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wo(t, e);
  }
}
function F5(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function V5(t) {
  if (Array.isArray(t)) return wo(t);
}
function wo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var Xu = Pe({
  name: "query-rules",
  connector: !0
});
function G5(t) {
  return [t.disjunctiveFacetsRefinements, t.facetsRefinements, t.hierarchicalFacetsRefinements, t.numericRefinements].some(function(e) {
    return !!(e && Object.keys(e).length > 0);
  });
}
function Z5(t) {
  return t.replace(/[^a-z0-9-_]+/gi, "_");
}
function X5(t) {
  var e = t.helper, r = t.sharedHelperState, n = t.trackedFilters, i = Object.keys(n).reduce(function(a, s) {
    var o = ol(e.lastResults || {}, r, !0).filter(function(u) {
      return u.attribute === s;
    }).map(function(u) {
      return u.numericValue || u.name;
    }), l = n[s], c = l(o);
    return [].concat(Oa(a), Oa(o.filter(function(u) {
      return c.includes(u);
    }).map(function(u) {
      return Z5("ais-".concat(s, "-").concat(u));
    })));
  }, []);
  return i;
}
function B5(t) {
  var e = this.helper, r = this.initialRuleContexts, n = this.trackedFilters, i = this.transformRuleContexts, a = t.state, s = a.ruleContexts || [], o = X5({
    helper: e,
    sharedHelperState: a,
    trackedFilters: n
  }), l = [].concat(Oa(r), Oa(o));
  process.env.NODE_ENV === "development" && ie(l.length <= 10, "\nThe maximum number of `ruleContexts` is 10. They have been sliced to that limit.\nConsider using `transformRuleContexts` to minimize the number of rules sent to Algolia.\n");
  var c = i(l).slice(0, 10);
  Pr(s, c) || e.overrideStateWithoutTriggeringChangeEvent(_t(_t({}, a), {}, {
    ruleContexts: c
  }));
}
var Jp = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, Xu()), function(n) {
    var i = n || {}, a = i.trackedFilters, s = a === void 0 ? {} : a, o = i.transformRuleContexts, l = o === void 0 ? function(p) {
      return p;
    } : o, c = i.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    Object.keys(s).forEach(function(p) {
      if (typeof s[p] != "function")
        throw new Error(Xu(`'The "`.concat(p, '" filter value in the `trackedFilters` option expects a function.')));
    });
    var f = Object.keys(s).length > 0, m = [], h;
    return {
      $$type: "ais.queryRules",
      init: function(d) {
        var v = d.helper, b = d.state, g = d.instantSearchInstance;
        m = b.ruleContexts || [], h = B5.bind({
          helper: v,
          initialRuleContexts: m,
          trackedFilters: s,
          transformRuleContexts: l
        }), f && ((G5(b) || n.transformRuleContexts) && h({
          state: b
        }), v.on("change", h)), e(_t(_t({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(d) {
        var v = d.instantSearchInstance;
        e(_t(_t({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: v
        }), !1);
      },
      getWidgetRenderState: function(d) {
        var v = d.results, b = v || {}, g = b.userData, y = g === void 0 ? [] : g, w = u(y, {
          results: v
        });
        return {
          items: w,
          widgetParams: n
        };
      },
      getRenderState: function(d, v) {
        return _t(_t({}, d), {}, {
          queryRules: this.getWidgetRenderState(v)
        });
      },
      dispose: function(d) {
        var v = d.helper, b = d.state;
        return r(), f ? (v.removeListener("change", h), b.setQueryParameter("ruleContexts", m)) : b;
      }
    };
  };
};
function mi(t) {
  "@babel/helpers - typeof";
  return mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mi(t);
}
function Bu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Uu(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bu(Object(r), !0).forEach(function(n) {
      U5(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Bu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function U5(t, e, r) {
  return e = Y5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Y5(t) {
  var e = q5(t, "string");
  return mi(e) == "symbol" ? e : String(e);
}
function q5(t, e) {
  if (mi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (mi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Q5 = function(e) {
  var r = e.searchAsYouSpeak, n = e.language, i = e.onQueryChange, a = e.onStateChange, s = window.webkitSpeechRecognition || window.SpeechRecognition, o = function(A) {
    return {
      status: A,
      transcript: "",
      isSpeechFinal: !1,
      errorCode: void 0
    };
  }, l = o("initial"), c, u = function() {
    return !!s;
  }, f = function() {
    return l.status === "askingPermission" || l.status === "waiting" || l.status === "recognizing";
  }, m = function() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    l = Uu(Uu({}, l), A), a();
  }, h = function() {
    return l;
  }, p = function() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "initial";
    m(o(A));
  }, d = function() {
    m({
      status: "waiting"
    });
  }, v = function(A) {
    m({
      status: "error",
      errorCode: A.error
    });
  }, b = function(A) {
    m({
      status: "recognizing",
      transcript: A.results[0] && A.results[0][0] && A.results[0][0].transcript || "",
      isSpeechFinal: A.results[0] && A.results[0].isFinal
    }), r && l.transcript && i(l.transcript);
  }, g = function() {
    !l.errorCode && l.transcript && !r && i(l.transcript), l.status !== "error" && m({
      status: "finished"
    });
  }, y = function() {
    c = new s(), c && (p("askingPermission"), c.interimResults = !0, n && (c.lang = n), c.addEventListener("start", d), c.addEventListener("error", v), c.addEventListener("result", b), c.addEventListener("end", g), c.start());
  }, w = function() {
    c && (c.stop(), c.removeEventListener("start", d), c.removeEventListener("error", v), c.removeEventListener("result", b), c.removeEventListener("end", g), c = void 0);
  }, P = function() {
    w(), p("finished");
  };
  return {
    getState: h,
    isBrowserSupported: u,
    isListening: f,
    startListening: y,
    stopListening: P,
    dispose: w
  };
};
function hi(t) {
  "@babel/helpers - typeof";
  return hi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hi(t);
}
function Yu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Yu(Object(r), !0).forEach(function(n) {
      J5(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Yu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function J5(t, e, r) {
  return e = K5(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function K5(t) {
  var e = _5(t, "string");
  return hi(e) == "symbol" ? e : String(e);
}
function _5(t, e) {
  if (hi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (hi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var $5 = Pe({
  name: "voice-search",
  connector: !0
}), e8 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Ie(e, $5()), function(n) {
    var i = n.searchAsYouSpeak, a = i === void 0 ? !1 : i, s = n.language, o = n.additionalQueryParameters, l = n.createVoiceSearchHelper, c = l === void 0 ? Q5 : l;
    return {
      $$type: "ais.voiceSearch",
      init: function(f) {
        var m = f.instantSearchInstance;
        e(gt(gt({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: m
        }), !0);
      },
      render: function(f) {
        var m = f.instantSearchInstance;
        e(gt(gt({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      getRenderState: function(f, m) {
        return gt(gt({}, f), {}, {
          voiceSearch: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(f) {
        var m = this, h = f.helper, p = f.instantSearchInstance;
        this._refine || (this._refine = function(P) {
          if (P !== h.state.query) {
            var T = s ? [s.split("-")[0]] : void 0;
            h.setQueryParameter("queryLanguages", T), typeof o == "function" && h.setState(h.state.setQueryParameters(gt({
              ignorePlurals: !0,
              removeStopWords: !0,
              // @ts-ignore optionalWords is allowed to be a string too
              optionalWords: P
            }, o({
              query: P
            })))), h.setQuery(P).search();
          }
        }), this._voiceSearchHelper || (this._voiceSearchHelper = c({
          searchAsYouSpeak: a,
          language: s,
          onQueryChange: function(T) {
            return m._refine(T);
          },
          onStateChange: function() {
            e(gt(gt({}, m.getWidgetRenderState(f)), {}, {
              instantSearchInstance: p
            }), !1);
          }
        }));
        var d = this._voiceSearchHelper, v = d.isBrowserSupported, b = d.isListening, g = d.startListening, y = d.stopListening, w = d.getState;
        return {
          isBrowserSupported: v(),
          isListening: b(),
          toggleListening: function() {
            v() && (b() ? y() : g());
          },
          voiceListeningState: w(),
          widgetParams: n
        };
      },
      dispose: function(f) {
        var m = f.state;
        this._voiceSearchHelper.dispose(), r();
        var h = m;
        if (typeof o == "function") {
          var p = o({
            query: ""
          }), d = p ? Object.keys(p).reduce(function(v, b) {
            return v[b] = void 0, v;
          }, {}) : {};
          h = m.setQueryParameters(gt({
            // @ts-ignore (queryLanguages is not added to algoliasearch v3)
            queryLanguages: void 0,
            ignorePlurals: void 0,
            removeStopWords: void 0,
            optionalWords: void 0
          }, d));
        }
        return h.setQueryParameter("query", void 0);
      },
      getWidgetUiState: function(f, m) {
        var h = m.searchParameters, p = h.query || "";
        return p ? gt(gt({}, f), {}, {
          query: p
        }) : f;
      },
      getWidgetSearchParameters: function(f, m) {
        var h = m.uiState;
        return f.setQueryParameter("query", h.query || "");
      }
    };
  };
};
function gi(t) {
  "@babel/helpers - typeof";
  return gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, gi(t);
}
function qu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qu(Object(r), !0).forEach(function(n) {
      t8(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function t8(t, e, r) {
  return e = r8(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function r8(t) {
  var e = n8(t, "string");
  return gi(e) == "symbol" ? e : String(e);
}
function n8(t, e) {
  if (gi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (gi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var i8 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return function(n) {
    var i = {};
    return {
      $$type: "ais.relevantSort",
      init: function(s) {
        var o = s.instantSearchInstance;
        e(Qt(Qt({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: o
        }), !0);
      },
      render: function(s) {
        var o = s.instantSearchInstance;
        e(Qt(Qt({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: o
        }), !1);
      },
      dispose: function(s) {
        var o = s.state;
        return r(), o.setQueryParameter("relevancyStrictness", void 0);
      },
      getRenderState: function(s, o) {
        return Qt(Qt({}, s), {}, {
          relevantSort: this.getWidgetRenderState(o)
        });
      },
      getWidgetRenderState: function(s) {
        var o = s.results, l = s.helper;
        i.refine || (i.refine = function(m) {
          l.setQueryParameter("relevancyStrictness", m).search();
        });
        var c = o || {}, u = c.appliedRelevancyStrictness, f = u !== void 0;
        return {
          isRelevantSorted: typeof u < "u" && u > 0,
          isVirtualReplica: f,
          canRefine: f,
          refine: i.refine,
          widgetParams: n
        };
      },
      getWidgetSearchParameters: function(s, o) {
        var l, c = o.uiState;
        return s.setQueryParameter("relevancyStrictness", (l = c.relevantSort) !== null && l !== void 0 ? l : s.relevancyStrictness);
      },
      getWidgetUiState: function(s, o) {
        var l = o.searchParameters;
        return Qt(Qt({}, s), {}, {
          relevantSort: l.relevancyStrictness || s.relevantSort
        });
      }
    };
  };
};
Bt(rw, "answers is no longer supported");
var a8 = Bt(j4, "EXPERIMENTAL_connectConfigureRelatedItems is deprecated and will be removed in a next minor version of InstantSearch. Please use connectRelatedItems instead.");
Bt(Cp, "use connectDynamicWidgets");
Se({ connector: L5 }, { $$widgetType: "ais.autocomplete" }), he({ name: "Autocomplete" });
k("p", null, " This widget doesn't render anything without a filled in default slot. ", -1);
k("p", null, "query, function to refine and results are provided.", -1);
k("pre", null, "refine: Function", -1);
k("summary", null, [k("code", null, "indices"), le(":")], -1);
function s8(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, r) {
    var n = t.get(e);
    n && n.push(r) || t.set(e, [r]);
  }, off: function(e, r) {
    var n = t.get(e);
    n && n.splice(n.indexOf(r) >>> 0, 1);
  }, emit: function(e, r) {
    (t.get(e) || []).slice().map(function(n) {
      n(r);
    }), (t.get("*") || []).slice().map(function(n) {
      n(e, r);
    });
  } };
}
var o8 = function() {
  var t;
  return (t = { props: { emitter: { type: Object, required: !1, default: function() {
    return s8();
  } } }, provide: function() {
    var e;
    return (e = {}).instantSearchPanelEmitter = this.emitter, e;
  }, data: function() {
    return { canRefine: !0 };
  }, created: function() {
    var e = this;
    this.emitter.on("PANEL_CHANGE_EVENT", function(r) {
      e.updateCanRefine(r);
    });
  } }).beforeUnmount = function() {
    this.emitter.all.clear();
  }, t.methods = { updateCanRefine: function(e) {
    this.canRefine = e;
  } }, t;
}, ot = function(t) {
  t === void 0 && (t = {});
  var e = t.mapStateToCanRefine;
  return e === void 0 && (e = function(r) {
    return !!r.canRefine;
  }), { inject: { emitter: { from: "instantSearchPanelEmitter", default: function() {
    return { emit: function() {
    } };
  } } }, data: function() {
    return { state: null, hasAlreadyEmitted: !1 };
  }, watch: { state: { immediate: !0, handler: function(r, n) {
    if (r) {
      var i = e(n || {}), a = e(r);
      this.hasAlreadyEmitted && i === a || (this.emitter.emit("PANEL_CHANGE_EVENT", a), this.hasAlreadyEmitted = !0);
    }
  } } } };
};
Se({ connector: k5 }, { $$widgetType: "ais.breadcrumb" }), ot(), he({ name: "Breadcrumb" });
Se({ connector: W4 }, { $$widgetType: "ais.clearRefinements" }), ot(), he({ name: "ClearRefinements" });
he({ name: "Configure" }), Se({ connector: Ep }, { $$widgetType: "ais.configure" });
Se({ connector: a8 }, { $$widgetType: "ais.configureRelatedItems" });
he({ name: "CurrentRefinements" }), Se({ connector: Q4 }, { $$widgetType: "ais.currentRefinements" }), ot();
he({ name: "HierarchicalMenu" }), Se({ connector: c6 }, { $$widgetType: "ais.hierarchicalMenu" }), ot();
function So() {
  return So = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, So.apply(null, arguments);
}
function l8(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
    if (e.indexOf(n) !== -1) continue;
    r[n] = t[n];
  }
  return r;
}
function c8(t, e) {
  if (t == null) return {};
  var r, n, i = l8(t, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (n = 0; n < a.length; n++) r = a[n], e.indexOf(r) === -1 && {}.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
  }
  return i;
}
function u8() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return e.reduce(function(n, i) {
    return Array.isArray(i) ? n.concat(i) : n.concat([i]);
  }, []).filter(Boolean).join(" ");
}
var d8 = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function f8(t) {
  var e = t.createElement;
  return function(n) {
    var i = n.classNames, a = n.children, s = n.highlightedTagName, o = n.isHighlighted, l = n.nonHighlightedTagName, c = o ? s : l;
    return e(c, {
      className: o ? i.highlighted : i.nonHighlighted
    }, a);
  };
}
function p8(t) {
  var e = t.createElement, r = t.Fragment, n = f8({
    createElement: e
  });
  return function(a) {
    var s = a.parts, o = a.highlightedTagName, l = o === void 0 ? "mark" : o, c = a.nonHighlightedTagName, u = c === void 0 ? "span" : c, f = a.separator, m = f === void 0 ? ", " : f, h = a.className, p = a.classNames, d = p === void 0 ? {} : p, v = c8(a, d8);
    return e("span", So({}, v, {
      className: u8(d.root, h)
    }), s.map(function(b, g) {
      var y = g === s.length - 1;
      return e(r, {
        key: g
      }, b.map(function(w, P) {
        return e(n, {
          key: P,
          classNames: d,
          highlightedTagName: l,
          nonHighlightedTagName: u,
          isHighlighted: w.isHighlighted
        }, w.value);
      }), !y && e("span", {
        className: d.separator
      }, m));
    }));
  };
}
var Kp = function(t, e, r) {
  if (!r) return vr(t, e);
  if (t === xe) return vr(t, Array.isArray(r) ? r : [r]);
  var n = typeof r == "string" ? { default: function() {
    return r;
  } } : r, i = typeof t == "string" ? e : Object.assign(e, { children: r });
  return vr(t, i, n);
}, m8 = p8({ createElement: Kp, Fragment: xe });
const h8 = { name: "AisHighlighter", props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" }, suit: { type: Function, required: !0 }, highlightProperty: { type: String, required: !0 }, preTag: { type: String, required: !0 }, postTag: { type: String, required: !0 } }, render: function() {
  var t = en(this.hit[this.highlightProperty], this.attribute) || [], e = (Array.isArray(t) ? t : [t]).map(function(r) {
    return sl(Jf(r.value || "")).map(function(n) {
      var i = n.value;
      return { value: i === " " ? "  " : i, isHighlighted: n.isHighlighted };
    });
  });
  return Kp(m8, { classNames: { root: this.suit(), highlighted: this.suit("highlighted") }, highlightedTagName: this.highlightedTagName, nonHighlightedTagName: xe, parts: e });
} }, _p = { name: "AisHighlight", mixins: [he({ name: "Highlight" })], components: { AisHighlighter: h8 }, props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" } } };
function g8(t, e, r, n, i, a) {
  var s = jd("ais-highlighter");
  return x(), F(s, { hit: r.hit, attribute: r.attribute, "highlighted-tag-name": r.highlightedTagName, suit: t.suit, "highlight-property": "_highlightResult", "pre-tag": "<mark>", "post-tag": "</mark>" }, null, 8, ["hit", "attribute", "highlighted-tag-name", "suit"]);
}
_p.render = g8;
Se({ connector: A6 }, { $$widgetType: "ais.hits" }), he({ name: "Hits" });
he({ name: "HitsPerPage" }), Se({ connector: I6 }, { $$widgetType: "ais.hitsPerPage" }), ot();
function vi(t) {
  "@babel/helpers - typeof";
  return vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vi(t);
}
var v8 = ["initialSearchParameters"], b8 = ["initialRecommendParameters"];
function Qu(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qu(Object(r), !0).forEach(function(n) {
      Hr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qu(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Hr(t, e, r) {
  return e = y8(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function y8(t) {
  var e = w8(t, "string");
  return vi(e) == "symbol" ? e : String(e);
}
function w8(t, e) {
  if (vi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (vi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function $p(t) {
  return A8(t) || P8(t) || x8(t) || S8();
}
function S8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x8(t, e) {
  if (t) {
    if (typeof t == "string") return xo(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xo(t, e);
  }
}
function P8(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function A8(t) {
  if (Array.isArray(t)) return xo(t);
}
function xo(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function em(t, e) {
  if (t == null) return {};
  var r = O8(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function O8(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
var ln = Pe({
  name: "index-widget"
});
function tm(t, e) {
  var r = e.state, n = e.recommendState, i = e.isPageReset, a = e._uiState;
  r !== t.state && (t.state = r, t.emit("change", {
    state: t.state,
    results: t.lastResults,
    isPageReset: i,
    _uiState: a
  })), n !== t.recommendState && (t.recommendState = n);
}
function cn(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return t.reduce(function(n, i) {
    return at(i) || !i.getWidgetUiState && !i.getWidgetState ? n : i.getWidgetUiState ? i.getWidgetUiState(n, e) : i.getWidgetState(n, e);
  }, r);
}
function un(t, e) {
  var r = e.initialSearchParameters, n = em(e, v8);
  return t.reduce(function(i, a) {
    return !a.getWidgetSearchParameters || at(a) ? i : a.dependsOn === "search" && a.getWidgetParameters ? a.getWidgetParameters(i, n) : a.getWidgetSearchParameters(i, n);
  }, r);
}
function Ju(t, e) {
  var r = e.initialRecommendParameters, n = em(e, b8);
  return t.reduce(function(i, a) {
    return !at(a) && a.dependsOn === "recommend" && a.getWidgetParameters ? a.getWidgetParameters(i, n) : i;
  }, r);
}
function rm(t) {
  var e = t.filter(at);
  e.length !== 0 && e.forEach(function(r) {
    var n = r.getHelper();
    tm(n, {
      state: n.state.resetPage(),
      recommendState: n.recommendState,
      isPageReset: !0
    }), rm(r.getWidgets());
  });
}
function nm(t) {
  var e = t.filter(at);
  return e.reduce(function(r, n) {
    return r.concat.apply(r, [{
      indexId: n.getIndexId(),
      results: n.getResults(),
      helper: n.getHelper()
    }].concat($p(nm(n.getWidgets()))));
  }, []);
}
var im = function(e) {
  if (e === void 0 || e.indexName === void 0)
    throw new Error(ln("The `indexName` option is required."));
  var r = e.indexName, n = e.indexId, i = n === void 0 ? r : n, a = [], s = {}, o = null, l = null, c = null, u = null, f = null, m = !1, h = !1;
  return {
    $$type: "ais.index",
    $$widgetType: "ais.index",
    getIndexName: function() {
      return r;
    },
    getIndexId: function() {
      return i;
    },
    getHelper: function() {
      return c;
    },
    getResults: function() {
      var d;
      return (d = u) !== null && d !== void 0 && d.lastResults ? (u.lastResults._state = c.state, u.lastResults) : null;
    },
    getResultsForWidget: function(d) {
      var v;
      return d.dependsOn !== "recommend" || at(d) || d.$$id === void 0 ? this.getResults() : (v = c) !== null && v !== void 0 && v.lastRecommendResults ? c.lastRecommendResults[d.$$id] : null;
    },
    getPreviousState: function() {
      return f;
    },
    getScopedResults: function() {
      var d = this.getParent(), v;
      return d ? v = d.getWidgets() : r.length === 0 ? v = this.getWidgets() : v = [this], nm(v);
    },
    getParent: function() {
      return l;
    },
    createURL: function(d) {
      return typeof d == "function" ? o._createURL(Hr({}, i, d(s))) : o._createURL(Hr({}, i, cn(a, {
        searchParameters: d,
        helper: c
      })));
    },
    getWidgets: function() {
      return a;
    },
    addWidgets: function(d) {
      var v = this;
      if (!Array.isArray(d))
        throw new Error(ln("The `addWidgets` method expects an array of widgets."));
      if (d.some(function(b) {
        return typeof b.init != "function" && typeof b.render != "function";
      }))
        throw new Error(ln("The widget definition expects a `render` and/or an `init` method."));
      return d.forEach(function(b) {
        at(b) || (o && b.dependsOn === "recommend" ? o._hasRecommendWidget = !0 : o ? o._hasSearchWidget = !0 : b.dependsOn === "recommend" ? m = !0 : h = !0, f2(b));
      }), a = a.concat(d), o && d.length && (tm(c, {
        state: un(a, {
          uiState: s,
          initialSearchParameters: c.state
        }),
        recommendState: Ju(a, {
          uiState: s,
          initialRecommendParameters: c.recommendState
        }),
        _uiState: s
      }), d.forEach(function(b) {
        if (b.getRenderState) {
          var g = b.getRenderState(o.renderState[v.getIndexId()] || {}, hn(o, v, o._initialUiState));
          js({
            renderState: g,
            instantSearchInstance: o,
            parent: v
          });
        }
      }), d.forEach(function(b) {
        b.init && b.init(hn(o, v, o._initialUiState));
      }), o.scheduleSearch()), this;
    },
    removeWidgets: function(d) {
      var v = this;
      if (!Array.isArray(d))
        throw new Error(ln("The `removeWidgets` method expects an array of widgets."));
      if (d.some(function(P) {
        return typeof P.dispose != "function";
      }))
        throw new Error(ln("The widget definition expects a `dispose` method."));
      if (a = a.filter(function(P) {
        return d.indexOf(P) === -1;
      }), a.forEach(function(P) {
        at(P) || (o && P.dependsOn === "recommend" ? o._hasRecommendWidget = !0 : o ? o._hasSearchWidget = !0 : P.dependsOn === "recommend" ? m = !0 : h = !0);
      }), o && d.length) {
        var b = d.reduce(function(P, T) {
          var A = T.dispose({
            helper: c,
            state: P.cleanedSearchState,
            recommendState: P.cleanedRecommendState,
            parent: v
          });
          return A instanceof qe.RecommendParameters ? P.cleanedRecommendState = A : A && (P.cleanedSearchState = A), P;
        }, {
          cleanedSearchState: c.state,
          cleanedRecommendState: c.recommendState
        }), g = b.cleanedSearchState, y = b.cleanedRecommendState, w = o.future.preserveSharedStateOnUnmount ? un(a, {
          uiState: s,
          initialSearchParameters: new qe.SearchParameters({
            index: this.getIndexName()
          })
        }) : un(a, {
          uiState: cn(a, {
            searchParameters: g,
            helper: c
          }),
          initialSearchParameters: g
        });
        s = cn(a, {
          searchParameters: w,
          helper: c
        }), c.setState(w), c.recommendState = y, a.length && o.scheduleSearch();
      }
      return this;
    },
    init: function(d) {
      var v = this, b, g = d.instantSearchInstance, y = d.parent, w = d.uiState;
      if (c === null) {
        o = g, l = y, s = w[i] || {};
        var P = g.mainHelper, T = un(a, {
          uiState: s,
          initialSearchParameters: new qe.SearchParameters({
            index: r
          })
        }), A = Ju(a, {
          uiState: s,
          initialRecommendParameters: new qe.RecommendParameters()
        });
        c = qe({}, T.index, T), c.recommendState = A, c.search = function() {
          return g.onStateChange ? (g.onStateChange({
            uiState: g.mainIndex.getWidgetUiState({}),
            setUiState: function(R) {
              return g.setUiState(R, !1);
            }
          }), P) : P.search();
        }, c.searchWithoutTriggeringOnStateChange = function() {
          return P.search();
        }, c.searchForFacetValues = function(z, R, I, L) {
          var W = c.state.setQueryParameters(L);
          return P.searchForFacetValues(z, R, I, W);
        }, u = P.derive(function() {
          return Pn.apply(void 0, [P.state].concat($p(q3(v))));
        }, function() {
          return v.getHelper().recommendState;
        });
        var j = (b = g._initialResults) === null || b === void 0 ? void 0 : b[this.getIndexId()];
        if (j != null && j.results) {
          var O = new qe.SearchResults(new qe.SearchParameters(j.state), j.results);
          u.lastResults = O, c.lastResults = O;
        }
        if (j != null && j.recommendResults) {
          var M = new qe.RecommendResults(new qe.RecommendParameters({
            params: j.recommendResults.params
          }), j.recommendResults.results);
          u.lastRecommendResults = M, c.lastRecommendResults = M;
        }
        c.on("change", function(z) {
          var R = z.isPageReset;
          R && rm(a);
        }), u.on("search", function() {
          g.scheduleStalledRender(), process.env.NODE_ENV === "development" && Uf({
            index: v,
            indexUiState: s
          });
        }), u.on("result", function(z) {
          var R = z.results;
          g.scheduleRender(), c.lastResults = R, f = R == null ? void 0 : R._state;
        }), u.on("recommend:result", function(z) {
          var R = z.recommend;
          g.scheduleRender(), c.lastRecommendResults = R.results;
        }), a.forEach(function(z) {
          if (z.getRenderState) {
            var R = z.getRenderState(g.renderState[v.getIndexId()] || {}, hn(g, v, w));
            js({
              renderState: R,
              instantSearchInstance: g,
              parent: v
            });
          }
        }), a.forEach(function(z) {
          process.env.NODE_ENV === "development" && ie(
            // if it has NO getWidgetState or if it has getWidgetUiState, we don't warn
            // aka we warn if there's _only_ getWidgetState
            !z.getWidgetState || !!z.getWidgetUiState,
            "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."
          ), z.init && z.init(hn(g, v, w));
        }), c.on("change", function(z) {
          var R = z.state, I = z._uiState;
          s = cn(a, {
            searchParameters: R,
            helper: c
          }, I || {}), g.onStateChange || g.onInternalStateChange();
        }), j && g.scheduleRender(), m && (g._hasRecommendWidget = !0), h && (g._hasSearchWidget = !0);
      }
    },
    render: function(d) {
      var v, b = this, g = d.instantSearchInstance;
      g.status === "error" && !g.mainHelper.hasPendingRequests() && f && c.setState(f);
      var y = this.getResults() || (v = u) !== null && v !== void 0 && v.lastRecommendResults ? a : a.filter(at);
      y = y.filter(function(w) {
        return w.shouldRender ? w.shouldRender({
          instantSearchInstance: g
        }) : !0;
      }), y.forEach(function(w) {
        if (w.getRenderState) {
          var P = w.getRenderState(g.renderState[b.getIndexId()] || {}, Hc(g, b, w));
          js({
            renderState: P,
            instantSearchInstance: g,
            parent: b
          });
        }
      }), y.forEach(function(w) {
        w.render && w.render(Hc(g, b, w));
      });
    },
    dispose: function() {
      var d = this, v, b;
      a.forEach(function(g) {
        g.dispose && c && g.dispose({
          helper: c,
          state: c.state,
          recommendState: c.recommendState,
          parent: d
        });
      }), o = null, l = null, (v = c) === null || v === void 0 || v.removeAllListeners(), c = null, (b = u) === null || b === void 0 || b.detach(), u = null;
    },
    getWidgetUiState: function(d) {
      return a.filter(at).reduce(function(v, b) {
        return b.getWidgetUiState(v);
      }, Mt(Mt({}, d), {}, Hr({}, i, Mt(Mt({}, d[i]), s))));
    },
    getWidgetState: function(d) {
      return process.env.NODE_ENV === "development" && ie(!1, "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."), this.getWidgetUiState(d);
    },
    getWidgetSearchParameters: function(d, v) {
      var b = v.uiState;
      return un(a, {
        uiState: b,
        initialSearchParameters: d
      });
    },
    refreshUiState: function() {
      s = cn(a, {
        searchParameters: this.getHelper().state,
        helper: this.getHelper()
      }, s);
    },
    setIndexUiState: function(d) {
      var v = typeof d == "function" ? d(s) : d;
      o.setUiState(function(b) {
        return Mt(Mt({}, b), {}, Hr({}, i, v));
      });
    }
  };
};
function js(t) {
  var e = t.renderState, r = t.instantSearchInstance, n = t.parent, i = n ? n.getIndexId() : r.mainIndex.getIndexId();
  r.renderState = Mt(Mt({}, r.renderState), {}, Hr({}, i, Mt(Mt({}, r.renderState[i]), e)));
}
he({ name: "Index" }), Se({ connector: function() {
  return im;
} }, { $$widgetType: "ais.index" });
var T8 = "ais", Va = function(e) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.descendantName, i = r.modifierName, a = n ? "-".concat(n) : "", s = i ? "--".concat(i) : "";
    return "".concat(T8, "-").concat(e).concat(a).concat(s);
  };
}, j8 = Va("Highlight");
function am(t) {
  var e = t.attribute, r = t.highlightedTagName, n = r === void 0 ? "mark" : r, i = t.hit, a = t.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ie(!1, "`instantsearch.highlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Highlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = en(i._highlightResult, e);
  process.env.NODE_ENV === "development" && ie(o, 'Could not enable highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = o || {}, c = l.value, u = c === void 0 ? "" : c, f = j8({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(Je.highlightPreTag, "g"), "<".concat(n, ' class="').concat(f, '">')).replace(new RegExp(Je.highlightPostTag, "g"), "</".concat(n, ">"));
}
var k8 = Va("ReverseHighlight");
function sm(t) {
  var e = t.attribute, r = t.highlightedTagName, n = r === void 0 ? "mark" : r, i = t.hit, a = t.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ie(!1, "`instantsearch.reverseHighlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseHighlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = en(i._highlightResult, e);
  process.env.NODE_ENV === "development" && ie(o, 'Could not enable reverse highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = o || {}, c = l.value, u = c === void 0 ? "" : c, f = k8({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), m = ep(sp(sl(u)));
  return m.replace(new RegExp(Je.highlightPreTag, "g"), "<".concat(n, ' class="').concat(f, '">')).replace(new RegExp(Je.highlightPostTag, "g"), "</".concat(n, ">"));
}
var M8 = Va("Snippet");
function om(t) {
  var e = t.attribute, r = t.highlightedTagName, n = r === void 0 ? "mark" : r, i = t.hit, a = t.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ie(!1, "`instantsearch.snippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Snippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = en(i._snippetResult, e);
  process.env.NODE_ENV === "development" && ie(o, 'Could not enable snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = o || {}, c = l.value, u = c === void 0 ? "" : c, f = M8({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(Je.highlightPreTag, "g"), "<".concat(n, ' class="').concat(f, '">')).replace(new RegExp(Je.highlightPostTag, "g"), "</".concat(n, ">"));
}
var z8 = Va("ReverseSnippet");
function lm(t) {
  var e = t.attribute, r = t.highlightedTagName, n = r === void 0 ? "mark" : r, i = t.hit, a = t.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ie(!1, "`instantsearch.reverseSnippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseSnippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = en(i._snippetResult, e);
  process.env.NODE_ENV === "development" && ie(o, 'Could not enable reverse snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = o || {}, c = l.value, u = c === void 0 ? "" : c, f = z8({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), m = ep(sp(sl(u)));
  return m.replace(new RegExp(Je.highlightPreTag, "g"), "<".concat(n, ' class="').concat(f, '">')).replace(new RegExp(Je.highlightPostTag, "g"), "</".concat(n, ">"));
}
function Po(t) {
  "@babel/helpers - typeof";
  return Po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Po(t);
}
var E8 = "_ALGOLIA";
function C8(t) {
  if (!((typeof document > "u" ? "undefined" : Po(document)) !== "object" || typeof document.cookie != "string"))
    for (var e = "".concat(t, "="), r = document.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var i = r[n]; i.charAt(0) === " "; )
        i = i.substring(1);
      if (i.indexOf(e) === 0)
        return i.substring(e.length, i.length);
    }
}
function cm() {
  return C8(E8);
}
function I8() {
  return process.env.NODE_ENV === "development" && ie(!1, "`getInsightsAnonymousUserToken` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), cm();
}
var L8 = ["page"];
function R8(t, e) {
  if (t == null) return {};
  var r = N8(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function N8(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function Ku(t) {
  var e = t || {};
  e.page;
  var r = R8(e, L8);
  return r;
}
function D8() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.key, r = ["ais.infiniteHits", e].filter(Boolean).join(":");
  return {
    read: function(i) {
      var a = i.state, s = zt(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (!s)
        return null;
      try {
        var o = JSON.parse(
          // @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
          s.getItem(r)
        );
        return o && Pr(o.state, Ku(a)) ? o.hits : null;
      } catch (l) {
        if (l instanceof SyntaxError)
          try {
            s.removeItem(r);
          } catch {
          }
        return null;
      }
    },
    write: function(i) {
      var a = i.state, s = i.hits, o = zt(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (o)
        try {
          o.setItem(r, JSON.stringify({
            state: Ku(a),
            hits: s
          }));
        } catch {
        }
    }
  };
}
function H8() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
    var e = Math.random() * 16 | 0, r = t === "x" ? e : e & 3 | 8;
    return r.toString(16);
  });
}
function bi(t) {
  "@babel/helpers - typeof";
  return bi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bi(t);
}
function _u(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _u(Object(r), !0).forEach(function(n) {
      W8(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _u(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function W8(t, e, r) {
  return e = F8(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function F8(t) {
  var e = V8(t, "string");
  return bi(e) == "symbol" ? e : String(e);
}
function V8(t, e) {
  if (bi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (bi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Kt(t, e) {
  return X8(t) || Z8(t, e) || um(t, e) || G8();
}
function G8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z8(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = a.call(r)).done) && (o.push(n.value), o.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function X8(t) {
  if (Array.isArray(t)) return t;
}
function B8(t) {
  return q8(t) || Y8(t) || um(t) || U8();
}
function U8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function um(t, e) {
  if (t) {
    if (typeof t == "string") return Ao(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ao(t, e);
  }
}
function Y8(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function q8(t) {
  if (Array.isArray(t)) return Ao(t);
}
function Ao(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var dm = "2.17.2", Q8 = "https://cdn.jsdelivr.net/npm/search-insights@".concat(dm, "/dist/search-insights.min.js");
function $u() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.insightsClient, r = t.insightsInitParams, n = t.onEvent, i = t.$$internal, a = i === void 0 ? !1 : i, s = t.$$automatic, o = s === void 0 ? !1 : s, l = e;
  !e && e !== null && zt(function(u) {
    var f = u.window, m = f.AlgoliaAnalyticsObject || "aa";
    typeof m == "string" && (l = f[m]), l || (f.AlgoliaAnalyticsObject = m, f[m] || (f[m] = function() {
      f[m].queue || (f[m].queue = []);
      for (var h = arguments.length, p = new Array(h), d = 0; d < h; d++)
        p[d] = arguments[d];
      f[m].queue.push(p);
    }, f[m].version = dm, f[m].shouldAddScript = !0), l = f[m]);
  });
  var c = l || fe;
  return function(u) {
    var f = u.instantSearchInstance, m = f.middleware.filter(function(O) {
      return O.instance.$$type === "ais.insights" && O.instance.$$internal;
    }).map(function(O) {
      return O.creator;
    });
    f.unuse.apply(f, B8(m));
    var h = n3(f.client), p = Kt(h, 2), d = p[0], v = p[1];
    process.env.NODE_ENV === "development" && ie(!!(d && v), "could not extract Algolia credentials from searchClient in insights middleware.");
    var b = void 0, g = void 0, y = void 0, w = c.queue;
    if (Array.isArray(w)) {
      var P = ["setUserToken", "init"].map(function(O) {
        var M = Gt(w.slice().reverse(), function(I) {
          var L = Kt(I, 1), W = L[0];
          return W === O;
        }) || [], z = Kt(M, 2), R = z[1];
        return R;
      }), T = Kt(P, 2);
      g = T[0], b = T[1];
    }
    c("getUserToken", null, function(O, M) {
      y = td(M);
    }), (r || !ed(c)) && c("init", cr({
      appId: d,
      apiKey: v,
      partial: !0
    }, r));
    var A, j;
    return {
      $$type: "ais.insights",
      $$internal: a,
      $$automatic: o,
      onStateChange: function() {
      },
      subscribe: function() {
        if (c.shouldAddScript) {
          var M = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
          try {
            var z = document.createElement("script");
            z.async = !0, z.src = Q8, z.onerror = function() {
              f.emit("error", new Error(M));
            }, document.body.appendChild(z), c.shouldAddScript = !1;
          } catch {
            c.shouldAddScript = !1, f.emit("error", new Error(M));
          }
        }
      },
      started: function() {
        c("addAlgoliaAgent", "insights-middleware"), j = f.mainHelper;
        var M = c.queue;
        if (Array.isArray(M)) {
          var z = ["setUserToken", "init"].map(function(G) {
            var Z = Gt(M.slice().reverse(), function(ue) {
              var je = Kt(ue, 1), ze = je[0];
              return ze === G;
            }) || [], Y = Kt(Z, 2), te = Y[1];
            return te;
          }), R = Kt(z, 2);
          g = R[0], b = R[1];
        }
        A = J8(f), o || j.overrideStateWithoutTriggeringChangeEvent(cr(cr({}, j.state), {}, {
          clickAnalytics: !0
        })), a || f.scheduleSearch();
        var I = function(Z) {
          var Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, te = td(Z);
          if (!te)
            return;
          var ue = j.state.userToken;
          function je() {
            j.overrideStateWithoutTriggeringChangeEvent(cr(cr({}, j.state), {}, {
              userToken: te
            })), ue && ue !== Z && f.scheduleSearch();
          }
          Y ? je() : setTimeout(je, 0);
        };
        function L(G) {
          I(G, !0), c("setUserToken", G);
        }
        var W = void 0, q = cm();
        if (q)
          W = q;
        else {
          var C = "anonymous-".concat(H8());
          W = C;
        }
        var E, B = A.userToken;
        if (r != null && r.userToken && (E = r.userToken), E)
          L(E);
        else if (B)
          L(B);
        else if (y)
          L(y);
        else if (g)
          L(g);
        else if (W) {
          var Q;
          if (L(W), r != null && r.useCookie || (Q = b) !== null && Q !== void 0 && Q.useCookie) {
            var $;
            K8(W, (r == null ? void 0 : r.cookieDuration) || (($ = b) === null || $ === void 0 ? void 0 : $.cookieDuration));
          }
        }
        c("onUserTokenChange", function(G) {
          return I(G, !0);
        }, {
          immediate: !0
        });
        var ne = c;
        ed(c) && (ne = function(Z, Y) {
          var te = {
            headers: {
              "X-Algolia-Application-Id": d,
              "X-Algolia-API-Key": v
            }
          };
          return c(Z, Y, te);
        });
        var ce = /* @__PURE__ */ new Set(), ge;
        f.mainHelper.derivedHelpers[0].on("result", function(G) {
          var Z = G.results;
          Z && (!Z.queryID || Z.queryID !== ge) && (ge = Z.queryID, ce.clear());
        }), f.sendEventToInsights = function(G) {
          if (n)
            n(G, ne);
          else if (G.insightsMethod) {
            if (G.insightsMethod === "viewedObjectIDs") {
              var Z = G.payload, Y = Z.objectIDs.filter(function(te) {
                return !ce.has(te);
              });
              if (Y.length === 0)
                return;
              Y.forEach(function(te) {
                return ce.add(te);
              }), Z.objectIDs = Y;
            }
            G.payload.algoliaSource = ["instantsearch"], o && G.payload.algoliaSource.push("instantsearch-automatic"), G.eventModifier === "internal" && G.payload.algoliaSource.push("instantsearch-internal"), ne(G.insightsMethod, G.payload), process.env.NODE_ENV === "development" && ie(!!j.state.userToken, `
Cannot send event to Algolia Insights because \`userToken\` is not set.

See documentation: https://www.algolia.com/doc/guides/building-search-ui/going-further/send-insights-events/js/#setting-the-usertoken
`);
          } else
            process.env.NODE_ENV === "development" && ie(!1, "Cannot send event to Algolia Insights because `insightsMethod` option is missing.");
        };
      },
      unsubscribe: function() {
        c("onUserTokenChange", void 0), f.sendEventToInsights = fe, j && A && (j.overrideStateWithoutTriggeringChangeEvent(cr(cr({}, j.state), A)), f.scheduleSearch());
      }
    };
  };
}
function J8(t) {
  var e, r, n = ((e = t._initialResults) === null || e === void 0 || (r = e[t.indexName]) === null || r === void 0 ? void 0 : r.state) || {}, i = t.mainHelper.state;
  return {
    userToken: n.userToken || i.userToken,
    clickAnalytics: n.clickAnalytics || i.clickAnalytics
  };
}
function K8(t, e) {
  var r = 2592e6, n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + (e || r * 6));
  var i = "expires=".concat(n.toUTCString());
  document.cookie = "_ALGOLIA=".concat(t, ";").concat(i, ";path=/");
}
function ed(t) {
  var e = (t.version || "").split(".").map(Number), r = Kt(e, 2), n = r[0], i = r[1], a = n >= 3, s = n === 2 && i >= 6, o = n === 1 && i >= 10;
  return a || s || o;
}
function td(t) {
  if (t)
    return typeof t == "number" ? t.toString() : t;
}
function fm(t, e, r) {
  var n = hn(e, e.mainIndex, e._initialUiState);
  t.forEach(function(i) {
    var a = {};
    if (i.getWidgetRenderState) {
      var s = i.getWidgetRenderState(n);
      s && s.widgetParams && (a = s.widgetParams);
    }
    var o = Object.keys(a).filter(function(l) {
      return a[l] !== void 0;
    });
    r.widgets.push({
      type: i.$$type,
      widgetType: i.$$widgetType,
      params: o
    }), i.$$type === "ais.index" && fm(i.getWidgets(), e, r);
  });
}
function _8() {
  return zt(function(t) {
    var e, r, n = t.window;
    return ((e = n.navigator) === null || e === void 0 || (r = e.userAgent) === null || r === void 0 ? void 0 : r.indexOf("Algolia Crawler")) > -1;
  }, {
    fallback: function() {
      return !1;
    }
  });
}
function $8() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.$$internal, r = e === void 0 ? !1 : e;
  return function(n) {
    var i = n.instantSearchInstance, a = {
      widgets: []
    }, s = document.createElement("meta"), o = document.querySelector("head");
    return s.name = "instantsearch:widgets", {
      $$type: "ais.metadata",
      $$internal: r,
      onStateChange: function() {
      },
      subscribe: function() {
        setTimeout(function() {
          var c = i.client;
          a.ua = c.transporter && c.transporter.userAgent ? c.transporter.userAgent.value : c._ua, fm(i.mainIndex.getWidgets(), i, a), i.middleware.forEach(function(u) {
            return a.widgets.push({
              middleware: !0,
              type: u.instance.$$type,
              internal: u.instance.$$internal
            });
          }), s.content = JSON.stringify(a), o.appendChild(s);
        }, 0);
      },
      started: function() {
      },
      unsubscribe: function() {
        s.remove();
      }
    };
  };
}
var e7 = String.prototype.replace, t7 = /%20/g, ks = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, wl = {
  default: ks.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return e7.call(t, t7, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: ks.RFC1738,
  RFC3986: ks.RFC3986
}, r7 = wl, Ms = Object.prototype.hasOwnProperty, pr = Array.isArray, kt = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), n7 = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), n = r.obj[r.prop];
    if (pr(n)) {
      for (var i = [], a = 0; a < n.length; ++a)
        typeof n[a] < "u" && i.push(n[a]);
      r.obj[r.prop] = i;
    }
  }
}, pm = function(e, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < e.length; ++i)
    typeof e[i] < "u" && (n[i] = e[i]);
  return n;
}, i7 = function t(e, r, n) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (pr(e))
      e.push(r);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !Ms.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var i = e;
  return pr(e) && !pr(r) && (i = pm(e, n)), pr(e) && pr(r) ? (r.forEach(function(a, s) {
    if (Ms.call(e, s)) {
      var o = e[s];
      o && typeof o == "object" && a && typeof a == "object" ? e[s] = t(o, a, n) : e.push(a);
    } else
      e[s] = a;
  }), e) : Object.keys(r).reduce(function(a, s) {
    var o = r[s];
    return Ms.call(a, s) ? a[s] = t(a[s], o, n) : a[s] = o, a;
  }, i);
}, a7 = function(e, r) {
  return Object.keys(r).reduce(function(n, i) {
    return n[i] = r[i], n;
  }, e);
}, s7 = function(t, e, r) {
  var n = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, o7 = function(e, r, n, i, a) {
  if (e.length === 0)
    return e;
  var s = e;
  if (typeof e == "symbol" ? s = Symbol.prototype.toString.call(e) : typeof e != "string" && (s = String(e)), n === "iso-8859-1")
    return escape(s).replace(/%u[0-9a-f]{4}/gi, function(u) {
      return "%26%23" + parseInt(u.slice(2), 16) + "%3B";
    });
  for (var o = "", l = 0; l < s.length; ++l) {
    var c = s.charCodeAt(l);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || a === r7.RFC1738 && (c === 40 || c === 41)) {
      o += s.charAt(l);
      continue;
    }
    if (c < 128) {
      o = o + kt[c];
      continue;
    }
    if (c < 2048) {
      o = o + (kt[192 | c >> 6] + kt[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      o = o + (kt[224 | c >> 12] + kt[128 | c >> 6 & 63] + kt[128 | c & 63]);
      continue;
    }
    l += 1, c = 65536 + ((c & 1023) << 10 | s.charCodeAt(l) & 1023), o += kt[240 | c >> 18] + kt[128 | c >> 12 & 63] + kt[128 | c >> 6 & 63] + kt[128 | c & 63];
  }
  return o;
}, l7 = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], n = [], i = 0; i < r.length; ++i)
    for (var a = r[i], s = a.obj[a.prop], o = Object.keys(s), l = 0; l < o.length; ++l) {
      var c = o[l], u = s[c];
      typeof u == "object" && u !== null && n.indexOf(u) === -1 && (r.push({ obj: s, prop: c }), n.push(u));
    }
  return n7(r), e;
}, c7 = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, u7 = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, d7 = function(e, r) {
  return [].concat(e, r);
}, f7 = function(e, r) {
  if (pr(e)) {
    for (var n = [], i = 0; i < e.length; i += 1)
      n.push(r(e[i]));
    return n;
  }
  return r(e);
}, mm = {
  arrayToObject: pm,
  assign: a7,
  combine: d7,
  compact: l7,
  decode: s7,
  encode: o7,
  isBuffer: u7,
  isRegExp: c7,
  maybeMap: f7,
  merge: i7
}, Oo = mm, On = wl, p7 = Object.prototype.hasOwnProperty, rd = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, gr = Array.isArray, m7 = String.prototype.split, h7 = Array.prototype.push, hm = function(t, e) {
  h7.apply(t, gr(e) ? e : [e]);
}, g7 = Date.prototype.toISOString, nd = On.default, Ge = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: Oo.encode,
  encodeValuesOnly: !1,
  format: nd,
  formatter: On.formatters[nd],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return g7.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, v7 = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, b7 = function t(e, r, n, i, a, s, o, l, c, u, f, m, h, p) {
  var d = e;
  if (typeof o == "function" ? d = o(r, d) : d instanceof Date ? d = u(d) : n === "comma" && gr(d) && (d = Oo.maybeMap(d, function(z) {
    return z instanceof Date ? u(z) : z;
  })), d === null) {
    if (i)
      return s && !h ? s(r, Ge.encoder, p, "key", f) : r;
    d = "";
  }
  if (v7(d) || Oo.isBuffer(d)) {
    if (s) {
      var v = h ? r : s(r, Ge.encoder, p, "key", f);
      if (n === "comma" && h) {
        for (var b = m7.call(String(d), ","), g = "", y = 0; y < b.length; ++y)
          g += (y === 0 ? "" : ",") + m(s(b[y], Ge.encoder, p, "value", f));
        return [m(v) + "=" + g];
      }
      return [m(v) + "=" + m(s(d, Ge.encoder, p, "value", f))];
    }
    return [m(r) + "=" + m(String(d))];
  }
  var w = [];
  if (typeof d > "u")
    return w;
  var P;
  if (n === "comma" && gr(d))
    P = [{ value: d.length > 0 ? d.join(",") || null : void 0 }];
  else if (gr(o))
    P = o;
  else {
    var T = Object.keys(d);
    P = l ? T.sort(l) : T;
  }
  for (var A = 0; A < P.length; ++A) {
    var j = P[A], O = typeof j == "object" && typeof j.value < "u" ? j.value : d[j];
    if (!(a && O === null)) {
      var M = gr(d) ? typeof n == "function" ? n(r, j) : r : r + (c ? "." + j : "[" + j + "]");
      hm(w, t(
        O,
        M,
        n,
        i,
        a,
        s,
        o,
        l,
        c,
        u,
        f,
        m,
        h,
        p
      ));
    }
  }
  return w;
}, y7 = function(e) {
  if (!e)
    return Ge;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || Ge.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = On.default;
  if (typeof e.format < "u") {
    if (!p7.call(On.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var i = On.formatters[n], a = Ge.filter;
  return (typeof e.filter == "function" || gr(e.filter)) && (a = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : Ge.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? Ge.allowDots : !!e.allowDots,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Ge.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? Ge.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : Ge.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : Ge.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : Ge.encodeValuesOnly,
    filter: a,
    format: n,
    formatter: i,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : Ge.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : Ge.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Ge.strictNullHandling
  };
}, w7 = function(t, e) {
  var r = t, n = y7(e), i, a;
  typeof n.filter == "function" ? (a = n.filter, r = a("", r)) : gr(n.filter) && (a = n.filter, i = a);
  var s = [];
  if (typeof r != "object" || r === null)
    return "";
  var o;
  e && e.arrayFormat in rd ? o = e.arrayFormat : e && "indices" in e ? o = e.indices ? "indices" : "repeat" : o = "indices";
  var l = rd[o];
  i || (i = Object.keys(r)), n.sort && i.sort(n.sort);
  for (var c = 0; c < i.length; ++c) {
    var u = i[c];
    n.skipNulls && r[u] === null || hm(s, b7(
      r[u],
      u,
      l,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset
    ));
  }
  var f = s.join(n.delimiter), m = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? m += "utf8=%26%2310003%3B&" : m += "utf8=%E2%9C%93&"), f.length > 0 ? m + f : "";
}, qr = mm, To = Object.prototype.hasOwnProperty, S7 = Array.isArray, Ve = {
  allowDots: !1,
  allowPrototypes: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: qr.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, x7 = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, gm = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, P7 = "utf8=%26%2310003%3B", A7 = "utf8=%E2%9C%93", O7 = function(e, r) {
  var n = {}, i = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, a = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, s = i.split(r.delimiter, a), o = -1, l, c = r.charset;
  if (r.charsetSentinel)
    for (l = 0; l < s.length; ++l)
      s[l].indexOf("utf8=") === 0 && (s[l] === A7 ? c = "utf-8" : s[l] === P7 && (c = "iso-8859-1"), o = l, l = s.length);
  for (l = 0; l < s.length; ++l)
    if (l !== o) {
      var u = s[l], f = u.indexOf("]="), m = f === -1 ? u.indexOf("=") : f + 1, h, p;
      m === -1 ? (h = r.decoder(u, Ve.decoder, c, "key"), p = r.strictNullHandling ? null : "") : (h = r.decoder(u.slice(0, m), Ve.decoder, c, "key"), p = qr.maybeMap(
        gm(u.slice(m + 1), r),
        function(d) {
          return r.decoder(d, Ve.decoder, c, "value");
        }
      )), p && r.interpretNumericEntities && c === "iso-8859-1" && (p = x7(p)), u.indexOf("[]=") > -1 && (p = S7(p) ? [p] : p), To.call(n, h) ? n[h] = qr.combine(n[h], p) : n[h] = p;
    }
  return n;
}, T7 = function(t, e, r, n) {
  for (var i = n ? e : gm(e, r), a = t.length - 1; a >= 0; --a) {
    var s, o = t[a];
    if (o === "[]" && r.parseArrays)
      s = [].concat(i);
    else {
      s = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = o.charAt(0) === "[" && o.charAt(o.length - 1) === "]" ? o.slice(1, -1) : o, c = parseInt(l, 10);
      !r.parseArrays && l === "" ? s = { 0: i } : !isNaN(c) && o !== l && String(c) === l && c >= 0 && r.parseArrays && c <= r.arrayLimit ? (s = [], s[c] = i) : l !== "__proto__" && (s[l] = i);
    }
    i = s;
  }
  return i;
}, j7 = function(e, r, n, i) {
  if (e) {
    var a = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, s = /(\[[^[\]]*])/, o = /(\[[^[\]]*])/g, l = n.depth > 0 && s.exec(a), c = l ? a.slice(0, l.index) : a, u = [];
    if (c) {
      if (!n.plainObjects && To.call(Object.prototype, c) && !n.allowPrototypes)
        return;
      u.push(c);
    }
    for (var f = 0; n.depth > 0 && (l = o.exec(a)) !== null && f < n.depth; ) {
      if (f += 1, !n.plainObjects && To.call(Object.prototype, l[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      u.push(l[1]);
    }
    return l && u.push("[" + a.slice(l.index) + "]"), T7(u, r, n, i);
  }
}, k7 = function(e) {
  if (!e)
    return Ve;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? Ve.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? Ve.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : Ve.allowPrototypes,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : Ve.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Ve.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : Ve.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : Ve.decoder,
    delimiter: typeof e.delimiter == "string" || qr.isRegExp(e.delimiter) ? e.delimiter : Ve.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : Ve.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : Ve.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : Ve.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : Ve.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Ve.strictNullHandling
  };
}, M7 = function(t, e) {
  var r = k7(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof t == "string" ? O7(t, r) : t, i = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = Object.keys(n), s = 0; s < a.length; ++s) {
    var o = a[s], l = j7(o, n[o], r, typeof t == "string");
    i = qr.merge(i, l, r);
  }
  return qr.compact(i);
}, z7 = w7, E7 = M7, C7 = wl, I7 = {
  formats: C7,
  parse: E7,
  stringify: z7
};
const id = /* @__PURE__ */ Fa(I7);
function yi(t) {
  "@babel/helpers - typeof";
  return yi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, yi(t);
}
function L7(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function R7(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, vm(n.key), n);
  }
}
function N7(t, e, r) {
  return e && R7(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function et(t, e, r) {
  return e = vm(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function vm(t) {
  var e = D7(t, "string");
  return yi(e) == "symbol" ? e : String(e);
}
function D7(t, e) {
  if (yi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (yi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ad = function(e) {
  e && (window.document.title = e);
}, H7 = /* @__PURE__ */ function() {
  function t(e) {
    var r = this, n = e.windowTitle, i = e.writeDelay, a = i === void 0 ? 400 : i, s = e.createURL, o = e.parseURL, l = e.getLocation, c = e.start, u = e.dispose, f = e.push, m = e.cleanUrlOnDispose;
    L7(this, t), et(this, "$$type", "ais.browser"), et(this, "windowTitle", void 0), et(this, "writeDelay", void 0), et(this, "_createURL", void 0), et(this, "parseURL", void 0), et(this, "getLocation", void 0), et(this, "writeTimer", void 0), et(this, "_onPopState", void 0), et(this, "inPopState", !1), et(this, "isDisposed", !1), et(this, "latestAcknowledgedHistory", 0), et(this, "_start", void 0), et(this, "_dispose", void 0), et(this, "_push", void 0), et(this, "_cleanUrlOnDispose", void 0), this.windowTitle = n, this.writeTimer = void 0, this.writeDelay = a, this._createURL = s, this.parseURL = o, this.getLocation = l, this._start = c, this._dispose = u, this._push = f, this._cleanUrlOnDispose = typeof m > "u" ? !0 : m, process.env.NODE_ENV === "development" && typeof m > "u" && console.info(`Starting from the next major version, InstantSearch will not clean up the URL from active refinements when it is disposed.

We recommend setting \`cleanUrlOnDispose\` to false to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to true.

See documentation: `.concat(Nn({
      name: "history-router"
    }), "#widget-param-cleanurlondispose")), zt(function(h) {
      var p = h.window, d = r.windowTitle && r.windowTitle(r.read());
      ad(d), r.latestAcknowledgedHistory = p.history.length;
    });
  }
  return N7(t, [{
    key: "read",
    value: function() {
      return this.parseURL({
        qsModule: id,
        location: this.getLocation()
      });
    }
    /**
     * Pushes a search state into the URL.
     */
  }, {
    key: "write",
    value: function(r) {
      var n = this;
      zt(function(i) {
        var a = i.window, s = n.createURL(r), o = n.windowTitle && n.windowTitle(r);
        n.writeTimer && clearTimeout(n.writeTimer), n.writeTimer = setTimeout(function() {
          ad(o), n.shouldWrite(s) && (n._push ? n._push(s) : a.history.pushState(r, o || "", s), n.latestAcknowledgedHistory = a.history.length), n.inPopState = !1, n.writeTimer = void 0;
        }, n.writeDelay);
      });
    }
    /**
     * Sets a callback on the `onpopstate` event of the history API of the current page.
     * It enables the URL sync to keep track of the changes.
     */
  }, {
    key: "onUpdate",
    value: function(r) {
      var n = this;
      this._start && this._start(function() {
        r(n.read());
      }), this._onPopState = function() {
        n.writeTimer && (clearTimeout(n.writeTimer), n.writeTimer = void 0), n.inPopState = !0, r(n.read());
      }, zt(function(i) {
        var a = i.window;
        a.addEventListener("popstate", n._onPopState);
      });
    }
    /**
     * Creates a complete URL from a given syncable UI state.
     *
     * It always generates the full URL, not a relative one.
     * This allows to handle cases like using a <base href>.
     * See: https://github.com/algolia/instantsearch/issues/790
     */
  }, {
    key: "createURL",
    value: function(r) {
      var n = this._createURL({
        qsModule: id,
        routeState: r,
        location: this.getLocation()
      });
      if (process.env.NODE_ENV === "development")
        try {
          new URL(n);
        } catch {
          process.env.NODE_ENV === "development" && ie(!1, "The URL returned by the `createURL` function is invalid.\nPlease make sure it returns an absolute URL to avoid issues, e.g: `https://algolia.com/search?query=iphone`.");
        }
      return n;
    }
    /**
     * Removes the event listener and cleans up the URL.
     */
  }, {
    key: "dispose",
    value: function() {
      var r = this;
      this._dispose && this._dispose(), this.isDisposed = !0, zt(function(n) {
        var i = n.window;
        r._onPopState && i.removeEventListener("popstate", r._onPopState);
      }), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
    }
  }, {
    key: "start",
    value: function() {
      this.isDisposed = !1;
    }
  }, {
    key: "shouldWrite",
    value: function(r) {
      var n = this;
      return zt(function(i) {
        var a = i.window;
        if (n.isDisposed && !n._cleanUrlOnDispose)
          return !1;
        var s = !(n.isDisposed && n.latestAcknowledgedHistory !== a.history.length);
        return (
          // When the last state change was through popstate, the IS.js state changes,
          // but that should not write the URL.
          !n.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
          s && // When the URL is the same as the current one, we do not want to write it.
          r !== a.location.href
        );
      });
    }
  }]), t;
}();
function W7() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.createURL, r = e === void 0 ? function(p) {
    var d = p.qsModule, v = p.routeState, b = p.location, g = b.protocol, y = b.hostname, w = b.port, P = w === void 0 ? "" : w, T = b.pathname, A = b.hash, j = d.stringify(v), O = P === "" ? "" : ":".concat(P);
    return j ? "".concat(g, "//").concat(y).concat(O).concat(T, "?").concat(j).concat(A) : "".concat(g, "//").concat(y).concat(O).concat(T).concat(A);
  } : e, n = t.parseURL, i = n === void 0 ? function(p) {
    var d = p.qsModule, v = p.location;
    return d.parse(v.search.slice(1), {
      arrayLimit: 99
    });
  } : n, a = t.writeDelay, s = a === void 0 ? 400 : a, o = t.windowTitle, l = t.getLocation, c = l === void 0 ? function() {
    return zt(function(p) {
      var d = p.window;
      return d.location;
    }, {
      fallback: function() {
        throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
      }
    });
  } : l, u = t.start, f = t.dispose, m = t.push, h = t.cleanUrlOnDispose;
  return new H7({
    createURL: r,
    parseURL: i,
    writeDelay: s,
    windowTitle: o,
    getLocation: c,
    start: u,
    dispose: f,
    push: m,
    cleanUrlOnDispose: h
  });
}
function wi(t) {
  "@babel/helpers - typeof";
  return wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wi(t);
}
var F7 = ["configure"];
function sd(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ea(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sd(Object(r), !0).forEach(function(n) {
      jo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sd(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function jo(t, e, r) {
  return e = V7(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function V7(t) {
  var e = G7(t, "string");
  return wi(e) == "symbol" ? e : String(e);
}
function G7(t, e) {
  if (wi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (wi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Z7(t, e) {
  if (t == null) return {};
  var r = X7(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function X7(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function od(t) {
  t.configure;
  var e = Z7(t, F7);
  return e;
}
function B7() {
  return {
    $$type: "ais.simple",
    stateToRoute: function(e) {
      return Object.keys(e).reduce(function(r, n) {
        return ea(ea({}, r), {}, jo({}, n, od(e[n])));
      }, {});
    },
    routeToState: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Object.keys(e).reduce(function(r, n) {
        return ea(ea({}, r), {}, jo({}, n, od(e[n])));
      }, {});
    }
  };
}
function Si(t) {
  "@babel/helpers - typeof";
  return Si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Si(t);
}
function ld(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ta(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ld(Object(r), !0).forEach(function(n) {
      bm(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ld(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function bm(t, e, r) {
  return e = U7(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function U7(t) {
  var e = Y7(t, "string");
  return Si(e) == "symbol" ? e : String(e);
}
function Y7(t, e) {
  if (Si(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Si(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var q7 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.router, n = r === void 0 ? W7() : r, i = e.stateMapping, a = i === void 0 ? B7() : i, s = e.$$internal, o = s === void 0 ? !1 : s;
  return function(l) {
    var c = l.instantSearchInstance;
    function u(h) {
      var p = (
        // If only the mainIndex is initialized, we don't yet know what other
        // index widgets are used. Therefore we fall back to the initialUiState.
        // We can't indiscriminately use the initialUiState because then we
        // reintroduce state that was changed by the user.
        // When there are no widgets, we are sure the user can't yet have made
        // any changes.
        c.mainIndex.getWidgets().length === 0 ? c._initialUiState : c.mainIndex.getWidgetUiState({})
      ), d = Object.keys(h).reduce(function(b, g) {
        return ta(ta({}, b), {}, bm({}, g, h[g]));
      }, p), v = a.stateToRoute(d);
      return n.createURL(v);
    }
    c._createURL = u;
    var f = void 0, m = c._initialUiState;
    return {
      $$type: "ais.router({router:".concat(n.$$type || "__unknown__", ", stateMapping:").concat(a.$$type || "__unknown__", "})"),
      $$internal: o,
      onStateChange: function(p) {
        var d = p.uiState, v = a.stateToRoute(d);
        (f === void 0 || !Pr(f, v)) && (n.write(v), f = v);
      },
      subscribe: function() {
        process.env.NODE_ENV === "development" && ie(Object.keys(m).length === 0, "Using `initialUiState` together with routing is not recommended. The `initialUiState` will be overwritten by the URL parameters."), c._initialUiState = ta(ta({}, m), a.routeToState(n.read())), n.onUpdate(function(p) {
          c.mainIndex.getWidgets().length > 0 && c.setUiState(a.routeToState(p));
        });
      },
      started: function() {
        var p;
        (p = n.start) === null || p === void 0 || p.call(n);
      },
      unsubscribe: function() {
        n.dispose();
      }
    };
  };
};
function Q7(t, e) {
  return t.toLocaleString(e);
}
function xi(t) {
  "@babel/helpers - typeof";
  return xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xi(t);
}
function cd(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cd(Object(r), !0).forEach(function(n) {
      J7(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : cd(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function J7(t, e, r) {
  return e = K7(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function K7(t) {
  var e = _7(t, "string");
  return xi(e) == "symbol" ? e : String(e);
}
function _7(t, e) {
  if (xi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (xi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function $7(t) {
  var e = t.numberLocale;
  return {
    formatNumber: function(n, i) {
      return Q7(Number(i(n)), e);
    },
    highlight: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(am(Nt(Nt({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The highlight helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseHighlight: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(sm(Nt(Nt({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseHighlight helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    snippet: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(om(Nt(Nt({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The snippet helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseSnippet: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(lm(Nt(Nt({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseSnippet helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    insights: function(n, i) {
      try {
        var a = JSON.parse(n), s = a.method, o = a.payload;
        return i(Dp(s, Nt({
          objectIDs: [this.objectID]
        }, o)));
      } catch {
        throw new Error(`
The insights helper expects a JSON object of the format:
{ "method": "method-name", "payload": { "eventName": "name of the event" } }`);
      }
    }
  };
}
const ym = "4.77.3";
function Qr(t) {
  "@babel/helpers - typeof";
  return Qr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qr(t);
}
function ud(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zs(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ud(Object(r), !0).forEach(function(n) {
      ye(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ud(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ex(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tx(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wm(n.key), n);
  }
}
function rx(t, e, r) {
  return e && tx(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function nx(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ko(t, e);
}
function ko(t, e) {
  return ko = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, ko(t, e);
}
function ix(t) {
  var e = sx();
  return function() {
    var n = Ta(t), i;
    if (e) {
      var a = Ta(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ax(this, i);
  };
}
function ax(t, e) {
  if (e && (Qr(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ve(t);
}
function ve(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function sx() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ta(t) {
  return Ta = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ta(t);
}
function ye(t, e, r) {
  return e = wm(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function wm(t) {
  var e = ox(t, "string");
  return Qr(e) == "symbol" ? e : String(e);
}
function ox(t, e) {
  if (Qr(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Qr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var yt = Pe({
  name: "instantsearch"
});
function lx() {
  return "#";
}
var Sm = {
  preserveSharedStateOnUnmount: !1,
  persistHierarchicalRootCount: !1
}, cx = /* @__PURE__ */ function(t) {
  nx(r, t);
  var e = ix(r);
  function r(n) {
    var i, a;
    ex(this, r), a = e.call(this), ye(ve(a), "client", void 0), ye(ve(a), "indexName", void 0), ye(ve(a), "compositionID", void 0), ye(ve(a), "insightsClient", void 0), ye(ve(a), "onStateChange", null), ye(ve(a), "future", void 0), ye(ve(a), "helper", void 0), ye(ve(a), "mainHelper", void 0), ye(ve(a), "mainIndex", void 0), ye(ve(a), "started", void 0), ye(ve(a), "templatesConfig", void 0), ye(ve(a), "renderState", {}), ye(ve(a), "_stalledSearchDelay", void 0), ye(ve(a), "_searchStalledTimer", void 0), ye(ve(a), "_initialUiState", void 0), ye(ve(a), "_initialResults", void 0), ye(ve(a), "_createURL", void 0), ye(ve(a), "_searchFunction", void 0), ye(ve(a), "_mainHelperSearch", void 0), ye(ve(a), "_hasSearchWidget", !1), ye(ve(a), "_hasRecommendWidget", !1), ye(ve(a), "_insights", void 0), ye(ve(a), "middleware", []), ye(ve(a), "sendEventToInsights", void 0), ye(ve(a), "status", "idle"), ye(ve(a), "error", void 0), ye(ve(a), "scheduleSearch", an(function() {
      a.started && a.mainHelper.search();
    })), ye(ve(a), "scheduleRender", an(function() {
      var I, L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      (I = a.mainHelper) !== null && I !== void 0 && I.hasPendingRequests() || (clearTimeout(a._searchStalledTimer), a._searchStalledTimer = null, L && (a.status = "idle", a.error = void 0)), a.mainIndex.render({
        instantSearchInstance: ve(a)
      }), a.emit("render");
    })), ye(ve(a), "onInternalStateChange", an(function() {
      var I = a.mainIndex.getWidgetUiState({});
      a.middleware.forEach(function(L) {
        var W = L.instance;
        W.onStateChange({
          uiState: I
        });
      });
    })), a.setMaxListeners(100);
    var s = n.indexName, o = s === void 0 ? "" : s, l = n.compositionID, c = n.numberLocale, u = n.initialUiState, f = u === void 0 ? {} : u, m = n.routing, h = m === void 0 ? null : m, p = n.insights, d = p === void 0 ? void 0 : p, v = n.searchFunction, b = n.stalledSearchDelay, g = b === void 0 ? 200 : b, y = n.searchClient, w = y === void 0 ? null : y, P = n.insightsClient, T = P === void 0 ? null : P, A = n.onStateChange, j = A === void 0 ? null : A, O = n.future, M = O === void 0 ? zs(zs({}, Sm), n.future || {}) : O;
    if (w === null)
      throw new Error(yt("The `searchClient` option is required."));
    if (typeof w.search != "function")
      throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
    if (typeof w.addAlgoliaAgent == "function" && w.addAlgoliaAgent("instantsearch.js (".concat(ym, ")")), process.env.NODE_ENV === "development" && ie(T === null, "`insightsClient` property has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), T && typeof T != "function")
      throw new Error(yt("The `insightsClient` option should be a function."));
    if (process.env.NODE_ENV === "development" && ie(!n.searchParameters, "The `searchParameters` option is deprecated and will not be supported in InstantSearch.js 4.x.\n\nYou can replace it with the `configure` widget:\n\n```\nsearch.addWidgets([\n  configure(".concat(JSON.stringify(n.searchParameters, null, 2), `)
]);
\`\`\`

See `).concat(Nn({
      name: "configure"
    }))), process.env.NODE_ENV === "development" && ((i = n.future) === null || i === void 0 ? void 0 : i.preserveSharedStateOnUnmount) === void 0 && console.info(`Starting from the next major version, InstantSearch will change how widgets state is preserved when they are removed. InstantSearch will keep the state of unmounted widgets to be usable by other widgets with the same attribute.

We recommend setting \`future.preserveSharedStateOnUnmount\` to true to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to false.

See documentation: `.concat(Nn({
      name: "instantsearch"
    }), `#widget-param-future
          `)), a.client = w, a.future = M, a.insightsClient = T, a.indexName = o, a.compositionID = l, a.helper = null, a.mainHelper = null, a.mainIndex = im({
      // we use an index widget to render compositions
      // this only works because there's only one composition index allow for now
      indexName: a.compositionID || a.indexName
    }), a.onStateChange = j, a.started = !1, a.templatesConfig = {
      helpers: $7({
        numberLocale: c
      }),
      compileOptions: {}
    }, a._stalledSearchDelay = g, a._searchStalledTimer = null, a._createURL = lx, a._initialUiState = f, a._initialResults = null, a._insights = d, v && (process.env.NODE_ENV === "development" && ie(!1, "The `searchFunction` option is deprecated. Use `onStateChange` instead."), a._searchFunction = v), a.sendEventToInsights = fe, h) {
      var z = typeof h == "boolean" ? {} : h;
      z.$$internal = !0, a.use(q7(z));
    }
    if (d) {
      var R = typeof d == "boolean" ? {} : d;
      R.$$internal = !0, a.use($u(R));
    }
    return _8() && a.use($8({
      $$internal: !0
    })), a;
  }
  return rx(r, [{
    key: "_isSearchStalled",
    get: (
      /**
       * @deprecated use `status === 'stalled'` instead
       */
      function() {
        return process.env.NODE_ENV === "development" && ie(!1, '`InstantSearch._isSearchStalled` is deprecated and will be removed in InstantSearch.js 5.0.\n\nUse `InstantSearch.status === "stalled"` instead.'), this.status === "stalled";
      }
    )
  }, {
    key: "use",
    value: function() {
      for (var i = this, a = arguments.length, s = new Array(a), o = 0; o < a; o++)
        s[o] = arguments[o];
      var l = s.map(function(c) {
        var u = zs({
          $$type: "__unknown__",
          $$internal: !1,
          subscribe: fe,
          started: fe,
          unsubscribe: fe,
          onStateChange: fe
        }, c({
          instantSearchInstance: i
        }));
        return i.middleware.push({
          creator: c,
          instance: u
        }), u;
      });
      return this.started && l.forEach(function(c) {
        c.subscribe(), c.started();
      }), this;
    }
    /**
     * Removes a middleware from the InstantSearch lifecycle.
     */
  }, {
    key: "unuse",
    value: function() {
      for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
        a[s] = arguments[s];
      return this.middleware.filter(function(o) {
        return a.includes(o.creator);
      }).forEach(function(o) {
        return o.instance.unsubscribe();
      }), this.middleware = this.middleware.filter(function(o) {
        return !a.includes(o.creator);
      }), this;
    }
    // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now
  }, {
    key: "EXPERIMENTAL_use",
    value: function() {
      return process.env.NODE_ENV === "development" && ie(!1, "The middleware API is now considered stable, so we recommend replacing `EXPERIMENTAL_use` with `use` before upgrading to the next major version."), this.use.apply(this, arguments);
    }
    /**
     * Adds a widget to the search instance.
     * A widget can be added either before or after InstantSearch has started.
     * @param widget The widget to add to InstantSearch.
     *
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`.
     */
  }, {
    key: "addWidget",
    value: function(i) {
      return process.env.NODE_ENV === "development" && ie(!1, "addWidget will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`"), this.addWidgets([i]);
    }
    /**
     * Adds multiple widgets to the search instance.
     * Widgets can be added either before or after InstantSearch has started.
     * @param widgets The array of widgets to add to InstantSearch.
     */
  }, {
    key: "addWidgets",
    value: function(i) {
      if (!Array.isArray(i))
        throw new Error(yt("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
      if (i.some(function(a) {
        return typeof a.init != "function" && typeof a.render != "function";
      }))
        throw new Error(yt("The widget definition expects a `render` and/or an `init` method."));
      if (this.compositionID && i.some(at))
        throw new Error(yt("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
      return this.mainIndex.addWidgets(i), this;
    }
    /**
     * Removes a widget from the search instance.
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`
     * @param widget The widget instance to remove from InstantSearch.
     *
     * The widget must implement a `dispose()` method to clear its state.
     */
  }, {
    key: "removeWidget",
    value: function(i) {
      return process.env.NODE_ENV === "development" && ie(!1, "removeWidget will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`"), this.removeWidgets([i]);
    }
    /**
     * Removes multiple widgets from the search instance.
     * @param widgets Array of widgets instances to remove from InstantSearch.
     *
     * The widgets must implement a `dispose()` method to clear their states.
     */
  }, {
    key: "removeWidgets",
    value: function(i) {
      if (!Array.isArray(i))
        throw new Error(yt("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
      if (i.some(function(a) {
        return typeof a.dispose != "function";
      }))
        throw new Error(yt("The widget definition expects a `dispose` method."));
      return this.mainIndex.removeWidgets(i), this;
    }
    /**
     * Ends the initialization of InstantSearch.js and triggers the
     * first search.
     */
  }, {
    key: "start",
    value: function() {
      var i = this;
      if (this.started)
        throw new Error(yt("The `start` method has already been called once."));
      var a = this.mainHelper || qe(this.client, this.indexName, void 0, {
        persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
      });
      if (this.compositionID && (a.searchForFacetValues = a.searchForCompositionFacetValues.bind(a)), a.search = function() {
        return i.status = "loading", i.scheduleRender(!1), process.env.NODE_ENV === "development" && ie(!!i.indexName || !!i.compositionID || i.mainIndex.getWidgets().some(at), "No indexName provided, nor an explicit index widget in the widgets tree. This is required to be able to display results."), i._hasSearchWidget && (i.compositionID ? a.searchWithComposition() : a.searchOnlyWithDerivedHelpers()), i._hasRecommendWidget && a.recommend(), a;
      }, this._searchFunction) {
        var s = {
          search: function() {
            return new Promise(fe);
          }
        };
        this._mainHelperSearch = a.search.bind(a), a.search = function() {
          var l = i.mainIndex.getHelper(), c = qe(s, l.state.index, l.state);
          return c.once("search", function(u) {
            var f = u.state;
            l.overrideStateWithoutTriggeringChangeEvent(f), i._mainHelperSearch();
          }), c.on("change", function(u) {
            var f = u.state;
            l.setState(f);
          }), i._searchFunction(c), a;
        };
      }
      if (a.on("error", function(l) {
        var c = l.error;
        if (!(c instanceof Error)) {
          var u = c;
          c = Object.keys(u).reduce(function(f, m) {
            return f[m] = u[m], f;
          }, new Error(u.message));
        }
        c.error = c, i.error = c, i.status = "error", i.scheduleRender(!1), i.emit("error", c);
      }), this.mainHelper = a, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.subscribe();
      }), this.mainIndex.init({
        instantSearchInstance: this,
        parent: null,
        uiState: this._initialUiState
      }), this._initialResults) {
        A3(this.client, this._initialResults), g3(this.mainHelper, this._initialResults);
        var o = this.scheduleSearch;
        this.scheduleSearch = an(fe), an(function() {
          i.scheduleSearch = o;
        })();
      } else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
      this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.started();
      }), typeof this._insights > "u" && a.derivedHelpers[0].once("result", function() {
        var l = i.mainIndex.getScopedResults().some(function(c) {
          var u = c.results;
          return u == null ? void 0 : u._automaticInsights;
        });
        l && i.use($u({
          $$internal: !0,
          $$automatic: !0
        }));
      });
    }
    /**
     * Removes all widgets without triggering a search afterwards.
     * @return {undefined} This method does not return anything
     */
  }, {
    key: "dispose",
    value: function() {
      var i;
      this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), (i = this.mainHelper) === null || i === void 0 || i.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(a) {
        var s = a.instance;
        s.unsubscribe();
      });
    }
  }, {
    key: "scheduleStalledRender",
    value: function() {
      var i = this;
      this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function() {
        i.status = "stalled", i.scheduleRender();
      }, this._stalledSearchDelay));
    }
    /**
     * Set the UI state and trigger a search.
     * @param uiState The next UI state or a function computing it from the current state
     * @param callOnStateChange private parameter used to know if the method is called from a state change
     */
  }, {
    key: "setUiState",
    value: function(i) {
      var a = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!this.mainHelper)
        throw new Error(yt("The `start` method needs to be called before `setUiState`."));
      this.mainIndex.refreshUiState();
      var o = typeof i == "function" ? i(this.mainIndex.getWidgetUiState({})) : i;
      this.onStateChange && s ? this.onStateChange({
        uiState: o,
        setUiState: function(c) {
          so(typeof c == "function" ? c(o) : c, a.mainIndex), a.scheduleSearch(), a.onInternalStateChange();
        }
      }) : (so(o, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange());
    }
  }, {
    key: "getUiState",
    value: function() {
      return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
    }
  }, {
    key: "createURL",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!this.started)
        throw new Error(yt("The `start` method needs to be called before `createURL`."));
      return this._createURL(i);
    }
  }, {
    key: "refresh",
    value: function() {
      if (!this.mainHelper)
        throw new Error(yt("The `start` method needs to be called before `refresh`."));
      this.mainHelper.clearCache().search();
    }
  }]), r;
}(iw), bt = function(e) {
  return new cx(e);
};
bt.version = ym;
bt.createInfiniteHitsSessionStorageCache = Bt(D8, "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
bt.highlight = Bt(am, "import { highlight } from 'instantsearch.js/es/helpers'");
bt.reverseHighlight = Bt(sm, "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
bt.snippet = Bt(om, "import { snippet } from 'instantsearch.js/es/helpers'");
bt.reverseSnippet = Bt(lm, "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
bt.insights = Dp;
bt.getInsightsAnonymousUserToken = I8;
Object.defineProperty(bt, "widgets", {
  get: function() {
    throw new ReferenceError(`"instantsearch.widgets" are not available from the ES build.

To import the widgets:

import { searchBox } from 'instantsearch.js/es/widgets'`);
  }
});
Object.defineProperty(bt, "connectors", {
  get: function() {
    throw new ReferenceError(`"instantsearch.connectors" are not available from the ES build.

To import the connectors:

import { connectSearchBox } from 'instantsearch.js/es/connectors'`);
  }
});
Object.defineProperty(bt, "templates", {
  get: function() {
    throw new ReferenceError(`"instantsearch.templates" are not available from the ES build.

To import the templates:

import { carousel } from 'instantsearch.js/es/templates'`);
  }
});
var ux = "4.20.4", xm = function(t) {
  var e;
  return Ln(((e = { mixins: [he({ name: "InstantSearch" })], provide: function() {
    return { $_ais_instantSearchInstance: this.instantSearchInstance };
  }, watch: { searchClient: function(r) {
    Fr(!1), this.instantSearchInstance.helper.setClient(r).search();
  }, indexName: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, compositionID: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, stalledSearchDelay: function(r) {
    this.instantSearchInstance._stalledSearchDelay = r;
  }, routing: function() {
    throw new Error(`routing configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, onStateChange: function() {
    throw new Error(`onStateChange configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, searchFunction: function(r) {
    this.instantSearchInstance._searchFunction = r;
  }, middlewares: { immediate: !0, handler: function(r, n) {
    var i = this;
    (n || []).filter(function(a) {
      return (r || []).indexOf(a) === -1;
    }).forEach(function(a) {
      i.instantSearchInstance.unuse(a);
    }), (r || []).filter(function(a) {
      return (n || []).indexOf(a) === -1;
    }).forEach(function(a) {
      i.instantSearchInstance.use(a);
    });
  } }, future: function(r) {
    this.instantSearchInstance.future = Object.assign(Sm, r);
  } }, created: function() {
    var r = this.instantSearchInstance.client;
    typeof r.addAlgoliaAgent == "function" && (r.addAlgoliaAgent("Vue (" + Lm + ")"), r.addAlgoliaAgent("Vue InstantSearch (" + ux + ")"));
  }, mounted: function() {
    var r = this;
    this.$nextTick(function() {
      r.instantSearchInstance.started || r.instantSearchInstance.start();
    });
  } }).beforeUnmount = function() {
    this.instantSearchInstance.started && this.instantSearchInstance.dispose(), this.instantSearchInstance.__initialSearchResults = void 0;
  }, e), t);
}, dd = `Vue InstantSearch: You used the prop api-key or app-id.
These have been replaced by search-client.

See more info here: https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-search-client`;
const dx = xm({ name: "AisInstantSearch", props: { searchClient: { type: Object, required: !0 }, insightsClient: { type: Function, default: void 0 }, indexName: { type: String, required: !1 }, compositionID: { type: String, required: !1 }, routing: { default: void 0, validator: function(t) {
  return !(typeof t == "boolean" || !t.router && !t.stateMapping) || (Fr("The `routing` option expects an object with `router` and/or `stateMapping`.\n\nSee https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-routing"), !1);
} }, insights: { default: void 0, validator: function(t) {
  return t === void 0 || typeof t == "boolean" || typeof t == "object";
} }, stalledSearchDelay: { type: Number, default: void 0 }, searchFunction: { type: Function, default: void 0 }, onStateChange: { type: Function, default: void 0 }, initialUiState: { type: Object, default: void 0 }, apiKey: { type: String, default: void 0, validator: function(t) {
  return t && Fr(dd), !1;
} }, appId: { type: String, default: void 0, validator: function(t) {
  return t && Fr(dd), !1;
} }, middlewares: { type: Array, default: null }, future: { type: Object, default: void 0 } }, data: function() {
  return { instantSearchInstance: bt({ searchClient: this.searchClient, insightsClient: this.insightsClient, insights: this.insights, indexName: this.indexName, compositionID: this.compositionID, routing: this.routing, stalledSearchDelay: this.stalledSearchDelay, searchFunction: this.searchFunction, onStateChange: this.onStateChange, initialUiState: this.initialUiState, future: this.future }) };
}, render: rl(function(t) {
  var e;
  return t("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !1, e) }, nl(this));
}) });
xm({ name: "AisInstantSearchSsr", inject: { $_ais_ssrInstantSearchInstance: { default: function() {
  throw new Error("`createServerRootMixin` is required when using SSR.");
} } }, data: function() {
  return { instantSearchInstance: this.$_ais_ssrInstantSearchInstance };
}, render: rl(function(t) {
  var e;
  return t("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !0, e) }, nl(this));
}) });
const Pm = { name: "AisInfiniteHits", mixins: [Se({ connector: Y6 }, { $$widgetType: "ais.infiniteHits" }), he({ name: "InfiniteHits" })], props: { showBanner: { type: Boolean, default: !0 }, showPrevious: { type: Boolean, default: !1 }, escapeHTML: { type: Boolean, default: !0 }, transformItems: { type: Function, default: void 0 }, cache: { type: Object, default: void 0 } }, computed: { widgetParams: function() {
  return { showBanner: this.showBanner, showPrevious: this.showPrevious, escapeHTML: this.escapeHTML, transformItems: this.transformItems, cache: this.cache };
} }, methods: { refinePrevious: function() {
  this.state.showPrevious();
}, refineNext: function() {
  this.state.showMore();
} } };
var fx = ["disabled"], px = ["href", "target"], mx = ["src", "alt"], hx = ["src", "alt"], gx = ["onClick", "onAuxclick"], vx = ["disabled"];
function bx(t, e, r, n, i, a) {
  return t.state ? (x(), N("div", { key: 0, class: X(t.suit()) }, [r.showPrevious ? H(t.$slots, "loadPrevious", { key: 0, refinePrevious: a.refinePrevious, page: t.state.results.page, isFirstPage: t.state.isFirstPage }, function() {
    return [k("button", { class: X([t.suit("loadPrevious"), t.state.isFirstPage && t.suit("loadPrevious", "disabled")]), disabled: t.state.isFirstPage, onClick: e[0] || (e[0] = function(s) {
      return a.refinePrevious();
    }) }, " Show previous results ", 10, fx)];
  }) : J("", !0), H(t.$slots, "default", { items: t.state.items, results: t.state.results, banner: t.state.banner, isLastPage: t.state.isLastPage, refinePrevious: a.refinePrevious, refineNext: a.refineNext, refine: a.refineNext, insights: t.state.insights, sendEvent: t.state.sendEvent }, function() {
    return [r.showBanner && t.state.banner && t.state.banner.image.urls[0].url ? H(t.$slots, "banner", { key: 0, banner: t.state.banner }, function() {
      return [k("aside", { class: X(t.suit("banner")) }, [t.state.banner.link ? (x(), N("a", { key: 0, href: t.state.banner.link.url, target: t.state.banner.link.target, class: X(t.suit("banner-link")) }, [k("img", { src: t.state.banner.image.urls[0].url, alt: t.state.banner.image.title, class: X(t.suit("banner-image")) }, null, 10, mx)], 10, px)) : (x(), N("img", { key: 1, src: t.state.banner.image.urls[0].url, alt: t.state.banner.image.title, class: X(t.suit("banner-image")) }, null, 10, hx))], 2)];
    }) : J("", !0), k("ol", { class: X(t.suit("list")) }, [(x(!0), N(xe, null, Qe(t.state.items, function(s, o) {
      return x(), N("li", { class: X(t.suit("item")), key: s.objectID, onClick: function(l) {
        return t.state.sendEvent("click:internal", s, "Hit Clicked");
      }, onAuxclick: function(l) {
        return t.state.sendEvent("click:internal", s, "Hit Clicked");
      } }, [H(t.$slots, "item", { item: s, index: o, insights: t.state.insights, sendEvent: t.state.sendEvent }, function() {
        return [le(" objectID: " + _(s.objectID) + ", index: " + _(o), 1)];
      })], 42, gx);
    }), 128))], 2), H(t.$slots, "loadMore", { refineNext: a.refineNext, refine: a.refineNext, page: t.state.results.page, isLastPage: t.state.isLastPage }, function() {
      return [k("button", { class: X([t.suit("loadMore"), t.state.isLastPage && t.suit("loadMore", "disabled")]), disabled: t.state.isLastPage, onClick: e[1] || (e[1] = function(s) {
        return a.refineNext();
      }) }, " Show more results ", 10, vx)];
    })];
  })], 2)) : J("", !0);
}
Pm.render = bx;
he({ name: "Menu" }), Se({ connector: Fp }, { $$widgetType: "ais.menu" }), ot();
he({ name: "MenuSelect" }), Se({ connector: Fp }, { $$widgetType: "ais.menuSelect" }), ot();
Se({ connector: pS }, { $$widgetType: "ais.numericMenu" }), he({ name: "NumericMenu" }), ot();
he({ name: "Pagination" }), Se({ connector: AS }, { $$widgetType: "ais.pagination" }), ot();
he({ name: "Panel" }), o8();
he({ name: "PoweredBy" });
he({ name: "QueryRuleContext" }), Se({ connector: Jp }, { $$widgetType: "ais.queryRuleContext" });
he({ name: "QueryRuleCustomData" }), Se({ connector: Jp }, { $$widgetType: "ais.queryRuleCustomData" });
he({ name: "RangeInput" }), Se({ connector: CS }, { $$widgetType: "ais.rangeInput" }), ot();
he({ name: "RatingMenu" }), Se({ connector: s5 }, { $$widgetType: "ais.ratingMenu" }), ot();
k("symbol", { id: "ais-RatingMenu-starSymbol", viewBox: "0 0 24 24" }, [k("path", { d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" })], -1), k("symbol", { id: "ais-RatingMenu-starEmptySymbol", viewBox: "0 0 24 24" }, [k("path", { d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z" })], -1);
k("use", { "xlink:href": "#ais-RatingMenu-starSymbol" }, null, -1);
k("use", { "xlink:href": "#ais-RatingMenu-starEmptySymbol" }, null, -1);
const Am = { name: "SearchInput", mixins: [he({ name: "SearchBox" })], props: { placeholder: { type: String, default: "Search here…" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !1 }, shouldShowLoadingIndicator: { type: Boolean, default: !1 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Search" }, resetTitle: { type: String, default: "Clear" }, value: { type: String, required: !1, default: void 0 }, modelValue: { type: String, required: !1, default: void 0 } }, emits: ["input", "update:modelValue", "blur", "focus", "reset"], data: function() {
  return { query: "" };
}, methods: { isFocused: function() {
  return document.activeElement === this.$refs.input;
}, onInput: function(t) {
  this.ignoreCompositionEvents && t.isComposing || (this.$emit("input", t.target.value), this.$emit("update:modelValue", t.target.value));
}, onFormSubmit: function() {
  this.$refs.input.blur();
}, onFormReset: function() {
  this.$emit("input", ""), this.$emit("update:modelValue", ""), this.$emit("reset");
} } };
var yx = ["placeholder", "autofocus", "value"], wx = ["title", "hidden"], Sx = [k("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" }, null, -1)], xx = ["title", "hidden"], Px = [k("path", { d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" }, null, -1)], Ax = ["hidden"], Ox = ["aria-hidden"], Tx = [Jr('<g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g></g>', 1)];
function jx(t, e, r, n, i, a) {
  return x(), N("form", { action: "", role: "search", novalidate: "", class: X(t.suit("form")), onSubmit: e[4] || (e[4] = Ds(function() {
    for (var s = [], o = arguments.length; o--; ) s[o] = arguments[o];
    return a.onFormSubmit && a.onFormSubmit.apply(a, s);
  }, ["prevent"])), onReset: e[5] || (e[5] = Ds(function() {
    for (var s = [], o = arguments.length; o--; ) s[o] = arguments[o];
    return a.onFormReset && a.onFormReset.apply(a, s);
  }, ["prevent"])) }, [k("input", { type: "search", autocorrect: "off", autocapitalize: "off", autocomplete: "off", spellcheck: "false", maxlength: "512", "aria-label": "Search", placeholder: r.placeholder, autofocus: r.autofocus, class: X(t.suit("input")), value: r.value || r.modelValue, onFocus: e[0] || (e[0] = function(s) {
    return t.$emit("focus", s);
  }), onBlur: e[1] || (e[1] = function(s) {
    return t.$emit("blur", s);
  }), onInput: e[2] || (e[2] = function(s) {
    return a.onInput(s);
  }), onCompositionend: e[3] || (e[3] = function(s) {
    return a.onInput(s);
  }), ref: "input" }, null, 42, yx), k("button", { type: "submit", title: r.submitTitle, class: X(t.suit("submit")), hidden: r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [H(t.$slots, "submit-icon", {}, function() {
    return [(x(), N("svg", { "aria-hidden": "true", width: "10", height: "10", viewBox: "0 0 40 40", class: X(t.suit("submitIcon")) }, Sx, 2))];
  })], 10, wx), k("button", { type: "reset", title: r.resetTitle, class: X(t.suit("reset")), hidden: !r.value && !r.modelValue || r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [H(t.$slots, "reset-icon", {}, function() {
    return [(x(), N("svg", { "aria-hidden": "true", height: "10", viewBox: "0 0 20 20", class: X(t.suit("resetIcon")), width: "10" }, Px, 2))];
  })], 10, xx), r.showLoadingIndicator ? (x(), N("span", { key: 0, hidden: !r.shouldShowLoadingIndicator, class: X(t.suit("loadingIndicator")) }, [H(t.$slots, "loading-indicator", {}, function() {
    return [(x(), N("svg", { "aria-hidden": !r.shouldShowLoadingIndicator, "aria-label": "Results are loading", width: "16", height: "16", stroke: "#444", viewBox: "0 0 38 38", class: X(t.suit("loadingIcon")) }, Tx, 10, Ox))];
  })], 10, Ax)) : J("", !0)], 34);
}
Am.render = jx;
he({ name: "RefinementList" }), Se({ connector: HS }, { $$widgetType: "ais.refinementList" }), ot();
var ra;
const kx = ((ra = { name: "AisStateResults", mixins: [Se({ connector: !0 }), he({ name: "StateResults" })], props: { catchError: { type: Boolean, default: !1 } }, data: function() {
  var t = this;
  return { renderFn: function() {
    var e = t.instantSearchInstance, r = e.status, n = e.error, i = t.getParentIndex().getResults(), a = t.getParentIndex().getHelper(), s = a ? a.state : null;
    t.state = { results: i, state: s, status: r, error: n };
  } };
}, created: function() {
  this.instantSearchInstance.addListener("render", this.renderFn), this.renderFn();
} }).beforeUnmount = function() {
  this.widget && (this.instantSearchInstance.removeListener("render", this.renderFn), this.errorFn && this.instantSearchInstance.removeListener("error", this.errorFn));
}, ra.watch = { catchError: { immediate: !0, handler: function(t) {
  t ? (this.errorFn = function() {
  }, this.instantSearchInstance.addListener("error", this.errorFn)) : this.errorFn && (this.instantSearchInstance.removeListener("error", this.errorFn), this.errorFn = void 0);
} } }, ra.computed = { stateResults: function() {
  var t = this.state, e = t.results, r = t.state, n = t.status, i = t.error;
  return Ln({}, e, { results: e, state: r, status: n, error: i });
} }, ra);
var Mx = k("p", null, " Use this component to have a different layout based on a certain state. ", -1), zx = k("p", null, "Fill in the slot, and get access to the following things:", -1);
function Ex(t, e, r, n, i, a) {
  return t.state && t.state.state && t.state.results ? (x(), N("div", { key: 0, class: X(t.suit()) }, [H(t.$slots, "default", kd(Md(a.stateResults)), function() {
    return [Mx, zx, k("pre", null, "results: " + _(Object.keys(t.state.results)), 1), k("pre", null, "state: " + _(Object.keys(t.state.state)), 1), k("pre", null, "status: " + _(t.state.status), 1), k("pre", null, "error: " + _(t.state.error), 1)];
  })], 2)) : J("", !0);
}
kx.render = Ex;
const Om = { name: "AisSearchBox", mixins: [Se({ connector: BS }, { $$widgetType: "ais.searchBox" }), he({ name: "SearchBox" })], components: { SearchInput: Am }, props: { placeholder: { type: String, default: "" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !0 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Submit the search query" }, resetTitle: { type: String, default: "Clear the search query" }, value: { type: String, default: void 0 }, modelValue: { type: String, default: void 0 }, queryHook: { type: Function, default: void 0 } }, data: function() {
  return { localValue: "", isVue2: c2, isVue3: u2 };
}, computed: { widgetParams: function() {
  return { queryHook: this.queryHook };
}, isControlled: function() {
  return this.value !== void 0 || this.modelValue !== void 0;
}, model: function() {
  return this.value || this.modelValue;
}, currentRefinement: { get: function() {
  this.isControlled && this.model !== this.localValue && (this.localValue = this.model, this.$emit("input", this.model), this.$emit("update:modelValue", this.model), this.state.refine(this.model));
  var t = this.$refs.searchInput;
  return t && t.isFocused() ? this.localValue : this.model || this.state.query || "";
}, set: function(t) {
  this.localValue = t, this.state.refine(t), this.isControlled && (this.$emit("input", t), this.$emit("update:modelValue", t));
} } } };
function Cx(t, e, r, n, i, a) {
  var s = jd("search-input");
  return t.state ? (x(), N("div", { key: 0, class: X(t.suit()) }, [H(t.$slots, "default", { currentRefinement: a.currentRefinement, isSearchStalled: t.state.isSearchStalled, refine: t.state.refine }, function() {
    return [U(s, { onFocus: e[0] || (e[0] = function(o) {
      return t.$emit("focus", o);
    }), onBlur: e[1] || (e[1] = function(o) {
      return t.$emit("blur", o);
    }), onReset: e[2] || (e[2] = function(o) {
      return t.$emit("reset");
    }), placeholder: r.placeholder, autofocus: r.autofocus, "show-loading-indicator": r.showLoadingIndicator, "should-show-loading-indicator": t.state.isSearchStalled, "ignore-composition-events": r.ignoreCompositionEvents, "submit-title": r.submitTitle, "reset-title": r.resetTitle, "class-names": t.classNames, modelValue: a.currentRefinement, "onUpdate:modelValue": e[3] || (e[3] = function(o) {
      return a.currentRefinement = o;
    }), ref: "searchInput" }, zd({ default: D(function() {
      return [i.isVue2 ? H(t.$slots, "loading-indicator", { key: 0, slot: "loading-indicator" }) : J("", !0), i.isVue2 ? H(t.$slots, "submit-icon", { key: 1, slot: "submit-icon" }) : J("", !0), i.isVue2 ? H(t.$slots, "reset-icon", { key: 2, slot: "reset-icon" }) : J("", !0)];
    }), _: 2 }, [i.isVue3 ? { name: "loading-indicator", fn: D(function() {
      return [H(t.$slots, "loading-indicator")];
    }), key: "0" } : void 0, i.isVue3 ? { name: "submit-icon", fn: D(function() {
      return [H(t.$slots, "submit-icon")];
    }), key: "1" } : void 0, i.isVue3 ? { name: "reset-icon", fn: D(function() {
      return [H(t.$slots, "reset-icon")];
    }), key: "2" } : void 0]), 1032, ["placeholder", "autofocus", "show-loading-indicator", "should-show-loading-indicator", "ignore-composition-events", "submit-title", "reset-title", "class-names", "modelValue"])];
  })], 2)) : J("", !0);
}
Om.render = Cx;
he({ name: "Snippet" });
he({ name: "SortBy" }), Se({ connector: QS }, { $$widgetType: "ais.sortBy" }), ot();
Se({ connector: f5 }, { $$widgetType: "ais.stats" }), he({ name: "Stats" });
he({ name: "ToggleRefinement" }), Se({ connector: S5 }, { $$widgetType: "ais.toggleRefinement" }), ot();
Se({ connector: e8 }, { $$widgetType: "ais.voiceSearch" }), he({ name: "VoiceSearch" });
Jr('<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', 5);
k("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, null, -1);
k("line", { x1: "12", y1: "19", x2: "12", y2: "23" }, null, -1);
k("line", { x1: "8", y1: "23", x2: "16", y2: "23" }, null, -1);
he({ name: "RelevantSort" }), Se({ connector: i8 }, { $$widgetType: "ais.relevantSort" });
const Ix = { name: "AisDynamicWidgets", mixins: [Se({ connector: Cp }, { $$widgetType: "ais.dynamicWidgets" }), he({ name: "DynamicWidgets" })], props: { transformItems: { type: Function, default: void 0 }, facets: { type: Array, default: void 0 }, maxValuesPerFacet: { type: Number, default: void 0 } }, render: rl(function(t) {
  var e = this, r = /* @__PURE__ */ new Map();
  if ((nl(this) || []).forEach(function(i) {
    var a = function s(o) {
      var l, c = o.props;
      if (c) {
        if (c.attribute) return c.attribute;
        if (Array.isArray(c.attributes)) return c.attributes[0];
      }
      if (l = o.children && o.children.default && o.children.default(), Array.isArray(l)) return l.reduce(function(u, f) {
        return u || s(f);
      }, void 0);
    }(i);
    a && r.set(a, t("div", { key: a, class: [e.suit("widget")] }, [i]));
  }), !this.state) {
    var n = [];
    return r.forEach(function(i) {
      return n.push(i);
    }), t("div", Ln({ class: [this.suit()] }, { attrs: { hidden: !0 } }), n);
  }
  return t("div", { class: [this.suit()] }, this.state.attributesToRender.map(function(i) {
    return r.get(i);
  }));
}), computed: { widgetParams: function() {
  return { transformItems: this.transformItems, facets: this.facets, maxValuesPerFacet: this.maxValuesPerFacet, widgets: [] };
} } };
Object.assign({}, Ix, { name: "AisExperimentalDynamicWidgets", mounted: function() {
  Fr("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.");
} });
const Lx = { class: "relative" }, Rx = { class: "-mr-px flex-1" }, Nx = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby", "onInput"], Dx = ["disabled", "tabindex", "aria-disabled"], Hx = { key: 0 }, Wx = ["onClick"], Fx = { class: "block truncate" }, pk = /* @__PURE__ */ V({
  __name: "InputAddressSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, n = e, { searchClient: i } = dh(r.config.hostUrl, r.config.apiKey), a = de(""), [s, o] = jn(!1), l = de(), c = me("field-id");
    ah(l, () => o(!1));
    const u = () => {
      a.value = "", n("update:modelValue", void 0), o(!1);
    }, f = kl((p, d) => {
      o(!0), p(d);
    }, 300), m = kl((p) => {
      p();
    }, 500), h = (p) => {
      n("update:modelValue", p.barcode), a.value = p.single_line_address, o(!1);
    };
    return (p, d) => (x(), N("div", Lx, [
      U(S(dx), {
        "search-client": S(i),
        "index-name": "addresses:building_number:asc",
        future: { preserveSharedStateOnUnmount: !0 }
      }, {
        default: D(() => [
          U(S(Om), { class: "flex" }, {
            default: D(({ refine: v }) => [
              k("div", Rx, [
                dt(k("input", _e({
                  id: S(c),
                  "onUpdate:modelValue": d[0] || (d[0] = (b) => a.value = b),
                  type: "text",
                  class: [
                    "text-base block w-full rounded-l-md border-0 py-1.5 text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
                    "placeholder:text-default-400",
                    "sm:text-sm sm:leading-6",
                    "focus:ring-0 focus:shadow-none focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
                    p.disabled && "disabled:opacity-50 disabled:pointer-events-none"
                  ],
                  disabled: p.disabled,
                  tabindex: p.disabled ? "-1" : 0,
                  "aria-disabled": p.disabled,
                  "aria-invalid": !!p.invalid,
                  "aria-describedby": p.invalid ? `${S(c)}-error` : void 0
                }, p.$attrs, {
                  onInput: (b) => S(f)(v, b.currentTarget.value)
                }), null, 16, Nx), [
                  [ja, a.value]
                ])
              ]),
              k("button", {
                type: "button",
                class: X([
                  "flex-none rounded-r-md bg-default-50 px-3 py-2 text-sm font-mediu text-default-900",
                  "outline outline-1 -outline-offset-1 outline-default-300",
                  "hover:bg-default-100",
                  "focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
                  p.disabled && "disabled:opacity-50 disabled:pointer-events-none"
                ]),
                disabled: p.disabled,
                tabindex: p.disabled ? "-1" : 0,
                "aria-disabled": p.disabled,
                onClick: u
              }, " Clear ", 10, Dx)
            ]),
            _: 1
          }),
          U(S(Pm), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: D(({ items: v, refineNext: b, isLastPage: g }) => [
              U(At, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: D(() => [
                  S(s) ? dt((x(), N("div", {
                    key: 0,
                    ref_key: "dropdown",
                    ref: l,
                    class: X([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    v.length ? (x(), N("ul", Hx, [
                      (x(!0), N(xe, null, Qe(v, (y) => (x(), N("li", {
                        key: y.id,
                        class: X([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none"
                        ]),
                        onClick: (w) => h(y)
                      }, [
                        k("span", Fx, [
                          U(S(_p), {
                            hit: y,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ])
                      ], 8, Wx))), 128))
                    ])) : J("", !0)
                  ])), [
                    [S(Xd), [() => S(m)(b), { distance: 10, canLoadMore: () => !g }]]
                  ]) : J("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["search-client"])
    ]));
  }
}), Vx = { class: "flex" }, Gx = { class: "-mr-px flex-1" }, Zx = ["id", "value"], mk = /* @__PURE__ */ V({
  __name: "InputCopyToClipboard",
  props: {
    value: {}
  },
  emits: ["copy"],
  setup(t, { emit: e }) {
    const r = t, n = e, { copy: i, copied: a } = Vd({
      legacy: !0,
      source: r.value.toString()
    });
    sh(a, () => {
      n("copy");
    });
    const s = me("field-id");
    return (o, l) => (x(), N("div", Vx, [
      k("div", Gx, [
        k("input", _e({
          id: S(s),
          type: "url",
          readonly: "",
          class: [
            "text-base pointer-events-none block w-full rounded-l-md border-0 py-1.5 text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
            "placeholder:text-default-400",
            "sm:text-sm sm:leading-6",
            "focus:ring-0 focus:shadow-none focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
          ],
          value: o.value
        }, o.$attrs), null, 16, Zx)
      ]),
      dt((x(), N("button", {
        "aria-label": "Copy to clipboard",
        type: "button",
        class: X([
          "flex-none rounded-r-md bg-default-50 px-3 py-2 text-sm font-semibold text-default-900",
          "outline outline-1 -outline-offset-1 outline-default-300",
          "hover:bg-default-100",
          "focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
        ]),
        onClick: l[0] || (l[0] = (c) => S(i)(o.value))
      }, [
        S(a) ? (x(), F(S(ae), {
          key: 1,
          icon: S(kf),
          class: "size-4 text-emerald-800",
          "aria-hidden": "true"
        }, null, 8, ["icon"])) : (x(), F(S(ae), {
          key: 0,
          icon: S(Mf),
          class: "size-4",
          "aria-hidden": "true"
        }, null, 8, ["icon"]))
      ])), [
        [S(If), S(a) ? "Copied" : "Copy to clipboard"]
      ])
    ]));
  }
}), hk = /* @__PURE__ */ V({
  __name: "InputFileButton",
  props: {
    options: {}
  },
  emits: ["cancel", "change"],
  setup(t, { emit: e }) {
    const r = t, n = e, { open: i, onChange: a } = Gd(r.options);
    return a((s) => {
      n("change", s);
    }), (s, o) => H(s.$slots, "default", { open: S(i) });
  }
}), Xx = ["disabled", "aria-disabled", "aria-labelledby", "tabindex"], Bx = {
  key: 0,
  class: "flex items-center space-x-base relative"
}, Ux = { class: "flex-1 text-left" }, Yx = { class: "text-sm text-default-500 pt-tiny" }, qx = {
  key: 1,
  class: "relative"
}, Qx = { class: "block pt-sm" }, Jx = { class: "text-sm text-default-500 pt-tiny" }, gk = /* @__PURE__ */ V({
  __name: "InputFileDropZone",
  props: {
    accept: { default: void 0 },
    disabled: { type: Boolean },
    maxFileSize: {},
    multiple: { type: Boolean },
    variant: { default: "horizontal" }
  },
  emits: ["change", "error"],
  setup(t, { emit: e }) {
    const r = t, n = de(), { isOverDropZone: i } = oh(n, {
      dataTypes: r.accept,
      multiple: r.multiple,
      onDrop(m) {
        !m || r.disabled || c(m);
      }
    }), { open: a, onChange: s } = Gd({
      accept: r.accept ? r.accept.join(", ") : "*",
      multiple: r.multiple
    });
    s((m) => {
      m && c(Array.from(m));
    });
    const o = e, l = _a.object({
      ...r.accept && {
        type: _a.string().refine((m) => {
          var h;
          return (h = r.accept) == null ? void 0 : h.includes(m);
        }, {
          message: `The file must have one of the following extensions: ${r.accept.join(", ")}.`
        })
      },
      size: _a.number().max(r.maxFileSize * 1024, {
        message: `The file must not be greater than ${r.maxFileSize} kilobytes.`
      })
    }), c = (m) => {
      const h = [];
      m.forEach((p) => {
        const d = l.safeParse(p);
        d.success ? h.push(p) : o("error", d.error.errors[0].message);
      }), h.length === m.length && o("change", m);
    }, u = () => {
      a();
    }, f = me("field-id");
    return (m, h) => (x(), N("button", {
      ref_key: "dropZone",
      ref: n,
      type: "button",
      disabled: m.disabled,
      "aria-disabled": m.disabled,
      "aria-labelledby": S(f),
      tabindex: m.disabled ? "-1" : 0,
      class: X([
        "w-full group text-center rounded-lg border border-dashed border-primary-600 relative p-base bg-primary-50",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        (S(i) || m.disabled) && "opacity-50",
        m.disabled ? "pointer-events-none" : "cursor-pointer"
      ]),
      onClick: u
    }, [
      m.variant === "horizontal" ? (x(), N("span", Bx, [
        U(S(ae), {
          icon: S(lc),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        k("span", Ux, [
          k("span", {
            class: X([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !m.disabled && "group-hover:text-primary-500"
            ])
          }, h[0] || (h[0] = [
            le(" Click to upload "),
            k("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2),
          k("span", Yx, " Max file size: " + _(m.maxFileSize / 1024) + "mb ", 1)
        ])
      ])) : J("", !0),
      m.variant === "vertical" ? (x(), N("span", qx, [
        U(S(ae), {
          icon: S(lc),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        k("span", Qx, [
          k("span", {
            class: X([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !m.disabled && "group-hover:text-primary-500"
            ])
          }, h[1] || (h[1] = [
            le(" Click to upload "),
            k("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2)
        ]),
        k("span", Jx, " Max file size: " + _(m.maxFileSize / 1024) + "mb ", 1)
      ])) : J("", !0)
    ], 10, Xx));
  }
}), Kx = ["aria-disabled"], vk = /* @__PURE__ */ V({
  __name: "InputGroup",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  setup(t) {
    return Le("disabled", t.disabled), (r, n) => (x(), N("div", _e({
      class: [
        "relative flex shadow-sm items-center rounded-md bg-white outline outline-1 -outline-offset-1 outline-default-300",
        "has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary-600",
        "[&>[data-slot=addon]:first-child]:pl-3",
        "[&>[data-slot=addon]:last-child]:pr-3",
        r.disabled && "opacity-50 pointer-events-none"
      ]
    }, r.$attrs, { "aria-disabled": r.disabled }), [
      H(r.$slots, "default")
    ], 16, Kx));
  }
}), _x = {}, $x = {
  "data-slot": "addon",
  class: /* @__PURE__ */ X([
    "shrink-0 select-none text-base text-default-500",
    "sm:text-sm/6"
  ])
};
function e9(t, e) {
  return x(), N("div", $x, [
    H(t.$slots, "default")
  ]);
}
const bk = /* @__PURE__ */ se(_x, [["render", e9]]), t9 = { class: "flex-1" }, r9 = {
  key: 0,
  class: "left-0 pl-3 pointer-events-none absolute inset-y-0 flex items-center"
}, n9 = ["id", "type", "disabled", "tabindex", "aria-disabled"], yk = /* @__PURE__ */ V({
  __name: "InputGroupInput",
  props: /* @__PURE__ */ sr({
    leadingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = or(t, "modelValue"), r = me("field-id"), n = me("disabled");
    return (i, a) => (x(), N("div", t9, [
      i.leadingIcon ? (x(), N("div", r9, [
        U(S(ae), {
          icon: i.leadingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : J("", !0),
      dt(k("input", _e({
        id: S(r),
        "onUpdate:modelValue": a[0] || (a[0] = (s) => e.value = s),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900",
          "placeholder:text-default-400",
          "focus:ring-0",
          "sm:text-sm sm:leading-6",
          i.leadingIcon && "pl-10"
        ],
        type: i.type,
        disabled: S(n),
        tabindex: S(n) ? "-1" : 0,
        "aria-disabled": S(n)
      }, i.$attrs), null, 16, n9), [
        [Td, e.value]
      ])
    ]));
  }
}), i9 = {
  class: /* @__PURE__ */ X([
    "shrink-0",
    "focus-within:relative"
  ])
}, a9 = ["aria-label", "disabled", "tabindex"], wk = /* @__PURE__ */ V({
  __name: "InputGroupSelect",
  props: /* @__PURE__ */ sr({
    ariaLabel: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = or(t, "modelValue"), r = me("disabled");
    return (n, i) => (x(), N("div", i9, [
      dt(k("select", {
        "onUpdate:modelValue": i[0] || (i[0] = (a) => e.value = a),
        "aria-label": n.ariaLabel,
        class: X([
          "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 text-base text-default-900",
          "sm:text-sm sm:leading-6",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "disabled:opacity-100"
        ]),
        disabled: S(r),
        tabindex: S(r) ? "-1" : 0
      }, [
        H(n.$slots, "default")
      ], 8, a9), [
        [Ed, e.value]
      ])
    ]));
  }
}), s9 = ["id", "min", "max", "step", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], o9 = /* @__PURE__ */ V({
  __name: "InputRange",
  props: /* @__PURE__ */ sr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    min: {},
    max: {},
    step: { default: 1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = or(t, "modelValue"), r = me("field-id");
    return (n, i) => {
      var a;
      return x(), N("div", {
        class: X([
          "inline-flex",
          n.disabled && "opacity-50 pointer-events-none"
        ])
      }, [
        dt(k("input", _e({
          id: S(r),
          "onUpdate:modelValue": i[0] || (i[0] = (s) => e.value = s),
          type: "range",
          min: n.min,
          max: n.max,
          step: n.step,
          class: [
            "rounded-full bg-default-200 w-full appearance-none cursor-grab",
            "focus:outline-none focus:outline-primary-600 focus:outline-2 focus:outline-offset-2",
            "active:enabled:cursor-grabbing"
          ],
          style: {
            "--min": n.min,
            "--max": n.max,
            "--val": (a = e.value) == null ? void 0 : a.toString()
          },
          disabled: n.disabled,
          tabindex: n.disabled ? "-1" : 0,
          "aria-disabled": n.disabled,
          "aria-invalid": !!n.invalid,
          "aria-describedby": n.invalid ? `${S(r)}-error` : void 0
        }, n.$attrs), null, 16, s9), [
          [ja, e.value]
        ])
      ], 2);
    };
  }
}), Sk = /* @__PURE__ */ se(o9, [["__scopeId", "data-v-c3b1b89d"]]), l9 = {}, c9 = { class: "text-xs p-xxs border-default-200 bg-white border rounded" };
function u9(t, e) {
  return x(), N("span", c9, [
    H(t.$slots, "default")
  ]);
}
const xk = /* @__PURE__ */ se(l9, [["render", u9]]), d9 = { class: "isolate flex justify-between items-center" }, f9 = { class: "flex flex-1 justify-between sm:hidden" }, Pk = /* @__PURE__ */ V({
  __name: "LengthAwarePagination",
  props: {
    as: { default: Lt },
    paginator: {}
  },
  setup(t) {
    const e = t, r = de(e.paginator);
    return Le("paginator", r), Le("as", e.as), Pi(() => e.paginator, (n) => {
      r.value = n;
    }), (n, i) => (x(), N("nav", d9, [
      k("div", f9, [
        U(xt, {
          as: r.value.prev_page_url ? n.as : "button",
          href: r.value.prev_page_url,
          color: "secondary",
          disabled: !r.value.prev_page_url
        }, {
          default: D(() => i[0] || (i[0] = [
            le(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        U(xt, {
          as: r.value.next_page_url ? n.as : "button",
          href: r.value.next_page_url,
          color: "secondary",
          disabled: !r.value.next_page_url
        }, {
          default: D(() => i[1] || (i[1] = [
            le(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ]),
      H(n.$slots, "default")
    ]));
  }
}), Ak = /* @__PURE__ */ V({
  __name: "LinkTab",
  props: {
    badge: { default: void 0 },
    current: { type: Boolean, default: !1 },
    leadingIcon: { default: void 0 }
  },
  setup(t) {
    const e = me("link-tab-group-as");
    return (r, n) => (x(), F(be(S(e)), {
      class: X([
        r.current ? "border-primary-500 text-primary-600" : "border-transparent text-default-500 hover:border-default-300 hover:text-default-700",
        "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
      ]),
      "aria-current": r.current ? "page" : void 0
    }, {
      default: D(() => [
        r.leadingIcon ? (x(), F(S(ae), {
          key: 0,
          icon: r.leadingIcon,
          class: X([
            r.current ? "text-primary-500" : "text-default-400 group-hover:text-default-500",
            "-ml-0.5 mr-2 size-4"
          ]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"])) : J("", !0),
        H(r.$slots, "default"),
        r.badge ? (x(), N("span", {
          key: 1,
          class: X([
            r.current ? "bg-primary-100 text-primary-600" : "bg-default-100 text-default-900",
            "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
          ])
        }, _(r.badge), 3)) : J("", !0)
      ]),
      _: 3
    }, 8, ["class", "aria-current"]));
  }
}), p9 = { class: "overflow-x-auto" }, m9 = { class: "border-b border-default-200" }, h9 = { class: "-mb-px flex space-x-8" }, Ok = /* @__PURE__ */ V({
  __name: "LinkTabGroup",
  props: {
    as: { default: Lt }
  },
  setup(t) {
    return Le("link-tab-group-as", t.as), (r, n) => (x(), N("div", p9, [
      k("div", m9, [
        k("nav", h9, [
          H(r.$slots, "default")
        ])
      ])
    ]));
  }
}), Tk = /* @__PURE__ */ V({
  __name: "Listbox",
  props: /* @__PURE__ */ sr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, r = or(t, "modelValue"), n = de(e.disabled);
    return Pi(
      () => e.disabled,
      (i) => {
        n.value = i;
      }
    ), Le("disabled", n), Le("modelValue", r), (i, a) => (x(), F(S(Um), {
      modelValue: r.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => r.value = s),
      disabled: i.disabled,
      multiple: i.multiple,
      by: "id"
    }, {
      default: D(({ open: s, disabled: o }) => [
        H(i.$slots, "default", {
          open: s,
          disabled: o
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), g9 = { class: "flex flex-wrap gap-2 pt-2" }, jk = /* @__PURE__ */ V({
  __name: "ListboxBadges",
  emits: ["remove"],
  setup(t, { emit: e }) {
    const r = me("modelValue"), n = e;
    return (i, a) => (x(), N("ul", g9, [
      (x(!0), N(xe, null, Qe(S(r), (s) => (x(), N("li", {
        key: s.id
      }, [
        U(Tf, {
          color: "blue",
          remove: "",
          onRemove: (o) => n("remove", s)
        }, {
          default: D(() => [
            le(_(s.label), 1)
          ]),
          _: 2
        }, 1032, ["onRemove"])
      ]))), 128))
    ]));
  }
}), v9 = { class: "relative" }, b9 = { class: "col-start-1 row-start-1 truncate pr-6 h-6" }, kk = /* @__PURE__ */ V({
  __name: "ListboxControl",
  props: {
    value: {}
  },
  setup(t) {
    const e = me("modelValue"), r = me("disabled");
    return (n, i) => (x(), N("div", v9, [
      U(S(Ym), {
        class: X([
          "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-3 text-left text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6",
          S(r) && "opacity-50 pointer-events-none"
        ]),
        disabled: S(r)
      }, {
        default: D(() => {
          var a;
          return [
            k("span", b9, [
              n.$slots.value ? H(n.$slots, "value", {
                key: 0,
                selected: S(e)
              }) : n.value ? (x(), N(xe, { key: 1 }, [
                le(_(n.value), 1)
              ], 64)) : (x(), N(xe, { key: 2 }, [
                Array.isArray(S(e)) ? (x(), N(xe, { key: 0 }, [
                  le(_(S(e).map((s) => s.label).join(", ")), 1)
                ], 64)) : (x(), N(xe, { key: 1 }, [
                  le(_((a = S(e)) == null ? void 0 : a.label), 1)
                ], 64))
              ], 64))
            ]),
            U(S(ae), {
              icon: S(_o),
              class: X([
                "col-start-1 row-start-1 size-4 self-center justify-self-end text-default-500",
                "sm:size-3"
              ]),
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ];
        }),
        _: 3
      }, 8, ["class", "disabled"]),
      H(n.$slots, "default")
    ]));
  }
}), Mk = /* @__PURE__ */ V({
  __name: "ListboxLabel",
  setup(t) {
    return (e, r) => (x(), F(Ra, { as: S(qm) }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), zk = /* @__PURE__ */ V({
  __name: "ListboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(t) {
    return (e, r) => (x(), F(S(Qm), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: D(({ active: n, selected: i }) => [
        k("li", {
          class: X([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            n ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          k("span", {
            class: X([
              i ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            H(e.$slots, "default")
          ], 2),
          i ? (x(), N("span", {
            key: 0,
            class: X([
              n ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            U(S(ae), {
              icon: S(La),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : J("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), y9 = { key: 0 }, w9 = { class: "flex justify-center items-center py-2" }, Ek = /* @__PURE__ */ V({
  __name: "ListboxOptions",
  props: {
    endReached: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["loadMore"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => (x(), F(At, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: D(() => [
        dt((x(), F(S(Jm), {
          class: X([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: D(() => [
            H(n.$slots, "default"),
            n.loading ? (x(), N("li", y9, [
              k("span", w9, [
                U($o, { class: "size-4 text-primary-600" })
              ])
            ])) : J("", !0)
          ]),
          _: 3
        })), [
          [S(Xd), [() => r("loadMore"), { distance: 10, canLoadMore: () => !n.loading && !n.endReached }]]
        ])
      ]),
      _: 3
    }));
  }
}), S9 = { class: "fixed inset-0 w-screen overflow-y-auto" }, x9 = {
  class: /* @__PURE__ */ X([
    "flex min-h-full items-end justify-center p-4 text-center",
    "sm:items-center"
  ])
}, P9 = /* @__PURE__ */ V({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    scrollable: { type: Boolean, default: !1 },
    size: { default: "base" }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    Le("scrollable", t.scrollable);
    const n = e, i = {
      sm: "sm:max-w-md",
      base: "sm:max-w-lg",
      lg: "sm:max-w-2xl",
      xl: "sm:max-w-4xl",
      "2xl": "sm:max-w-6xl"
    };
    return (a, s) => (x(), F(S(zo), {
      appear: "",
      show: a.open,
      as: "template"
    }, {
      default: D(() => [
        U(S(Eo), {
          as: "div",
          class: "relative z-[60]",
          onClose: s[1] || (s[1] = (o) => n("close"))
        }, {
          default: D(() => [
            U(S(Vr), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: D(() => s[2] || (s[2] = [
                k("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            k("div", S9, [
              k("div", x9, [
                U(S(Vr), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: D(() => [
                    U(S(Co), _e({
                      class: [
                        "relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all",
                        "sm:my-8 sm:w-full sm:p-6",
                        i[a.size],
                        a.scrollable && "flex flex-col max-h-[calc(100vh-6rem)]"
                      ]
                    }, a.$attrs), {
                      default: D(() => [
                        H(a.$slots, "default"),
                        k("button", {
                          class: X([
                            "absolute right-4 top-4 inline-flex rounded-md",
                            "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                          ]),
                          onClick: s[0] || (s[0] = (o) => n("close"))
                        }, [
                          U(S(ae), {
                            icon: S(A1),
                            class: "size-5 text-default-400",
                            "aria-hidden": "true"
                          }, null, 8, ["icon"]),
                          s[3] || (s[3] = k("span", { class: "sr-only" }, " Close ", -1))
                        ])
                      ]),
                      _: 3
                    }, 16, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), A9 = {
  class: /* @__PURE__ */ X([
    "mt-5",
    "sm:mt-6 flex justify-end gap-3"
  ])
}, O9 = /* @__PURE__ */ V({
  __name: "ModalButtons",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => (x(), N("div", A9, [
      n.hideCancel ? J("", !0) : (x(), F(xt, {
        key: 0,
        color: "secondary",
        type: "button",
        onClick: i[0] || (i[0] = (a) => r("close"))
      }, {
        default: D(() => i[1] || (i[1] = [
          le(" Cancel ")
        ])),
        _: 1
      })),
      H(n.$slots, "default")
    ]));
  }
}), Ck = /* @__PURE__ */ V({
  __name: "ModalContent",
  setup(t) {
    const e = me("scrollable");
    return (r, n) => (x(), N("div", {
      class: X([
        "mt-base",
        S(e) && "flex-1 overflow-y-auto -mx-4 sm:-mx-6 px-4 sm:px-6"
      ])
    }, [
      H(r.$slots, "default")
    ], 2));
  }
}), Ik = /* @__PURE__ */ V({
  __name: "ModalDescription",
  setup(t) {
    return (e, r) => (x(), F(S(Rd), { class: "pt-2 text-sm text-default-500" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Lk = /* @__PURE__ */ V({
  __name: "ModalTitle",
  setup(t) {
    return (e, r) => (x(), F(S(Nd), { class: "text-base font-semibold text-default-900" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), T9 = {
  environmentBadge: null,
  salesLinks: null,
  lettingsLinks: null,
  emailLinks: null,
  socialLinks: null,
  printAdminLinks: null,
  identityAdminLinks: null,
  insightsLinks: null,
  printSalesLinks: null,
  printLettingsLinks: null,
  mobileLinks: null,
  accountLinks: null,
  userLinks: null,
  credits: null,
  fullBranchName: null,
  userName: null,
  csrfToken: null,
  showSalesUpsellBanner: null,
  showLettingsUpsellBanner: null,
  applicationName: null,
  isAdmin: null
}, fd = de("local"), na = de(null), pd = {
  local: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.engineering.local"
  },
  uat: {
    baseUrl: "https://uat.id.",
    topLevelDomain: "spectre.internal.street.engineering"
  },
  production: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.uk.com"
  }
};
function tn() {
  return { getIdsBaseUri: (n) => {
    if (na.value !== null && na.value !== void 0 && n === "local")
      return na.value;
    const { baseUrl: i, topLevelDomain: a } = pd[n];
    return `${i}${a}`;
  }, getTopLevelDomain: (n) => {
    const { topLevelDomain: i } = pd[n];
    return i;
  }, initialiseEnvironment: (n, i) => {
    fd.value = n, na.value = i;
  }, environment: fd };
}
const { getIdsBaseUri: j9 } = tn();
function k9() {
  return { client: async ({ env: e, route: r, method: n }) => {
    const i = j9(e);
    return (await Bd({
      url: i + r,
      method: n
    })).data;
  } };
}
var Dt = /* @__PURE__ */ ((t) => (t.Print = "print", t.Email = "email", t.Insights = "insights", t.Social = "social", t.Identity = "identity", t))(Dt || {});
const M9 = [
  { icon: "faHouse", title: "Dashboard", description: "Sales dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact vendors with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faCalendarStar", title: "Anniversaries", description: "Automatically keep in touch with your past purchasers.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faScaleBalanced", title: "Fee Recovery", description: "Reclaim fees you’re owed with Spectre’s easy-to-use Fee Recovery.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], z9 = [
  { icon: "faHouse", title: "Dashboard", description: "Lettings dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact landlords with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPersonShelter", title: "Landlords", description: "Manage, add, update and nurture landlord relationships.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], E9 = [
  { icon: "faChartLine", title: "Email Dashboard", description: "View the performance of your emails and track overall engagement and delivery", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPaperPlaneTop", title: "Emails", description: "Create new emails and see the performance of sent emails", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faArrowProgress", title: "Automated Journeys", description: "Set up and manage workflows and automate your email marketing", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faUsers", title: "Audience", description: "View, manage and segment your audiences", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faLayerGroup", title: "Templates", description: "Design your own branded templates with lego like blocks", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Manage your email settings for your company and preferences", link: null, subLinks: null, badge: null, isInertia: null }
], C9 = [
  { icon: "faBuildingMagnifyingGlass", title: "Search and Create", description: "Explore, research, and create reports on millions of properties across the UK", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faMemoCircleCheck", title: "Saved Property Reports", description: "View, edit, and share your previously created reports", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faImageUser", title: "Leads", description: "View your leads generated by lead capture reports and landing pages", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBrowsers", title: "Landing Pages", description: "Create and manage your landing pages for instant valuations and more", link: null, subLinks: null, badge: null, isInertia: null }
], I9 = "_SPECTRE_IMPERSONATED_BY", Ga = de(null), Za = de(null), Sl = de(null), xl = de(null), Pl = de(null), L9 = oe(() => Ga.value !== null && Za.value !== null), Mo = () => {
  Ga.value = null, Za.value = null, Sl.value = null, xl.value = null, Pl.value = null;
}, Tm = (t) => {
  if (t === null) {
    Mo();
    return;
  }
  const {
    currentUser: e,
    shadowedUser: r,
    shadowedAccount: n,
    shadowedCompany: i,
    endSessionUrl: a
  } = t;
  typeof e != "object" && typeof r != "object" && Mo(), Ga.value = typeof e == "object" ? e : null, Za.value = typeof r == "object" ? r : null, xl.value = typeof n == "object" ? n : null, Sl.value = typeof i == "object" ? i : null, Pl.value = typeof a == "string" ? new URL(a) : a instanceof URL ? a : null;
}, R9 = () => {
  if (typeof (document == null ? void 0 : document.cookie) != "string")
    return null;
  const t = document.cookie.split("; ").find((r) => r.startsWith(I9));
  if (t === void 0)
    return null;
  const e = window.atob(decodeURIComponent(t.split("=")[1]));
  return JSON.parse(e) ?? null;
}, N9 = (t) => {
  Mo();
  const e = R9();
  Tm({
    ...e,
    ...typeof t == "object" ? t : {}
  });
};
function Xa() {
  return {
    currentUser: Ga,
    shadowedUser: Za,
    shadowedAccount: xl,
    shadowedCompany: Sl,
    endSessionUrl: Pl,
    isShadowing: L9,
    update: Tm,
    initialiseShadowbar: N9
  };
}
const ke = de(T9), Es = de(!1), Cs = de(!1), Is = de(!1), md = de(!1), hd = de(!1), D9 = de(!1), { client: gd } = k9(), { update: H9 } = Xa();
function Rt() {
  const t = (l) => {
    l != null && (window.location.href = l);
  }, e = oe(() => {
    if (ke.value.credits === null)
      return "0";
    const l = parseFloat(ke.value.credits.branchCreditLimit), c = parseFloat(ke.value.credits.branchCreditsUsedThisMonth);
    return (l - c).toFixed(2);
  }), r = oe(() => ke.value.userName === null ? "" : ke.value.userName[0]), n = (l) => {
    ke.value = l, Cs.value = l.showSalesUpsellBanner ?? !1, Is.value = l.showLettingsUpsellBanner ?? !1;
  }, i = (l) => {
    var v, b, g, y, w;
    const {
      print: c,
      insights: u,
      email: f,
      social: m,
      identity: h,
      shadowbarData: p,
      isAdmin: d
    } = l.data;
    return ((c == null ? void 0 : c.links.sales) === void 0 || (v = c == null ? void 0 : c.links.sales) != null && v.is_static) && (Cs.value = !0), ((c == null ? void 0 : c.links.lettings) === void 0 || (b = c == null ? void 0 : c.links.lettings) != null && b.is_static) && (Is.value = !0), (u == null ? void 0 : u.links) === void 0 && (md.value = !0), (f == null ? void 0 : f.links) === void 0 && (hd.value = !0), m == null || m.links, p !== null && typeof p == "object" && H9(p), {
      salesLinks: ((g = c == null ? void 0 : c.links.sales) == null ? void 0 : g.links) ?? M9,
      lettingsLinks: ((y = c == null ? void 0 : c.links.lettings) == null ? void 0 : y.links) ?? z9,
      insightsLinks: (u == null ? void 0 : u.links) ?? C9,
      emailLinks: (f == null ? void 0 : f.links) ?? E9,
      // TODO: add social upsell links when social links are added to AS.
      socialLinks: (m == null ? void 0 : m.links) ?? [],
      mobileLinks: (c == null ? void 0 : c.links.mobile.links) ?? [],
      printAdminLinks: ((w = c == null ? void 0 : c.links.admin) == null ? void 0 : w.links) ?? [],
      identityAdminLinks: (h == null ? void 0 : h.links) ?? [],
      isAdmin: d
    };
  }, a = async (l, c, u, f = 5, m = 1e3) => {
    for (let h = 1; h <= f; h++)
      try {
        const p = u ? `/api/user/navigation/${c}?currentAccountId=${u}` : `/api/user/navigation/${c}`, d = await gd({
          env: l,
          route: p,
          method: "GET"
        }), {
          salesLinks: v,
          lettingsLinks: b,
          insightsLinks: g,
          emailLinks: y,
          socialLinks: w,
          printAdminLinks: P,
          identityAdminLinks: T,
          mobileLinks: A,
          isAdmin: j
        } = i(d);
        ke.value.isAdmin = j, ke.value.applicationName !== Dt.Print && (ke.value.salesLinks = v), ke.value.applicationName !== Dt.Print && (ke.value.lettingsLinks = b), ke.value.applicationName !== Dt.Insights && (ke.value.insightsLinks = g), ke.value.applicationName !== Dt.Email && (ke.value.emailLinks = y), ke.value.applicationName !== Dt.Social && (ke.value.socialLinks = w), ke.value.applicationName !== Dt.Print && (ke.value.mobileLinks = A), ke.value.applicationName !== Dt.Print && (ke.value.printAdminLinks = P), ke.value.applicationName !== Dt.Identity && (ke.value.identityAdminLinks = T);
        return;
      } catch (p) {
        if (console.error(`Attempt ${h} failed. Error fetching links:`, p), h === f) {
          console.error("All retry attempts failed. Exiting function.");
          return;
        }
        await new Promise((d) => setTimeout(d, h * m));
      }
  }, s = async (l, c, u) => await gd({
    env: l,
    route: `/api/request-access/${c}/${u}`,
    method: "POST"
  });
  return {
    initialiseNavigation: n,
    navigation: ke,
    fetchLinks: async ({ env: l, userUUID: c, currentAccountId: u }) => {
      Es.value = !0, await a(l, c, u), Es.value = !1;
    },
    getUsernameAbbreviation: r,
    redirectToTarget: t,
    remainingCredits: e,
    showSalesUpsellBanner: fr(Cs),
    showLettingsUpsellBanner: fr(Is),
    showInsightsUpsellBanner: fr(md),
    showEmailUpsellBanner: fr(hd),
    showSocialUpsellBanner: fr(D9),
    linksLoading: Es,
    requestAccess: s
  };
}
function Ba(t, e) {
  return x(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function W9(t, e) {
  return x(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M3.25 3A2.25 2.25 0 0 0 1 5.25v9.5A2.25 2.25 0 0 0 3.25 17h13.5A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H3.25Zm.943 8.752a.75.75 0 0 1 .055-1.06L6.128 9l-1.88-1.693a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 0 1-1.06-.055ZM9.75 10.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function F9(t, e) {
  return x(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const V9 = ["onClick"], G9 = {
  key: 0,
  class: "block text-black font-semibold px-3 py-2 leading-6 text-sm"
}, Z9 = ["action"], X9 = ["value"], B9 = {
  type: "submit",
  class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left"
}, U9 = ["href", "target"], jm = /* @__PURE__ */ V({
  __name: "BasicPanel",
  props: {
    links: {},
    csrfToken: {}
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => (x(), F(S(ka), { class: "relative" }, {
      default: D(({ open: a }) => [
        U(S(Ti), {
          class: X(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[300px]", a ? "bg-primary-600" : ""])
        }, {
          default: D(() => [
            H(n.$slots, "default"),
            U(S(Ba), {
              class: X(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": a }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        U(At, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: D(() => [
            U(S(Ma), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 w-56 rounded-md bg-white p-2 shadow-lg ring-1 ring-gray-900/5" }, {
              default: D(() => [
                (x(!0), N(xe, null, Qe(n.links, (s) => (x(), N("div", {
                  key: s.name,
                  onClick: (o) => r("selected", s)
                }, [
                  s.isHeading ? (x(), N("span", G9, _(s.name), 1)) : s.isForm ? (x(), N("form", {
                    key: 1,
                    action: s.href,
                    method: "post"
                  }, [
                    k("input", {
                      type: "hidden",
                      name: "_token",
                      value: n.csrfToken
                    }, null, 8, X9),
                    k("button", B9, _(s.name), 1)
                  ], 8, Z9)) : (x(), N("a", {
                    key: 2,
                    href: s.href,
                    target: s.target ? s.target : "",
                    class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm"
                  }, _(s.name), 9, U9))
                ], 8, V9))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), Y9 = { class: "inline-flex items-center px-3 h-9 text-sm rounded-md text-white bg-red-500 mr-3" }, q9 = {
  __name: "EnvironmentBadge",
  setup(t) {
    const { navigation: e } = Rt();
    return (r, n) => (x(), N("div", Y9, [
      U(S(W9), { class: "w-4 h-4 mr-2" }),
      le(" " + _(S(e).environmentBadge), 1)
    ]));
  }
}, vd = /* @__PURE__ */ V({
  __name: "Credits",
  props: {
    credits: {}
  },
  setup(t) {
    return (e, r) => (x(), N("span", null, [
      r[0] || (r[0] = k("span", null, "Company Credits", -1)),
      r[1] || (r[1] = k("span", { class: "mx-2" }, "|", -1)),
      k("span", null, _(e.credits), 1)
    ]));
  }
}), Q9 = {
  key: 0,
  class: "inline-flex place-items-center text-sm font-medium leading-6 text-white gap-x-4"
}, J9 = {
  key: 0,
  class: "text-white"
}, K9 = /* @__PURE__ */ V({
  __name: "PrintCredits",
  setup(t) {
    const { navigation: e, remainingCredits: r } = Rt();
    return (n, i) => S(e).credits ? (x(), N("div", Q9, [
      S(e).credits.branchCreditLimit ? (x(), N("span", J9, [
        i[0] || (i[0] = k("span", null, "Branch Credits", -1)),
        i[1] || (i[1] = k("span", { class: "mx-2" }, "|", -1)),
        k("span", null, _(S(r)) + " / " + _(S(e).credits.branchCreditLimit), 1)
      ])) : J("", !0),
      S(e).credits.canManageCredits ? (x(), F(jm, {
        key: 1,
        links: S(e).credits.links,
        "csrf-token": S(e).csrfToken
      }, {
        default: D(() => [
          U(vd, {
            credits: S(e).credits.credits
          }, null, 8, ["credits"])
        ]),
        _: 1
      }, 8, ["links", "csrf-token"])) : (x(), F(vd, {
        key: 2,
        credits: S(e).credits.credits
      }, null, 8, ["credits"]))
    ])) : J("", !0);
  }
});
function _9(t, e) {
  return x(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const $9 = {
  faBuildingMagnifyingGlass: P1,
  faMemoCircleCheck: L1,
  faImageUser: z1,
  faBrowsers: U1,
  faGears: x1,
  faBolt: O1,
  faCalendarStar: W1,
  faScaleBalanced: S1,
  faPersonShelter: D1,
  faHouse: jf,
  faUsers: Z1,
  faBadgeCheck: E1,
  faCommentsDollar: R1,
  faKey: G1,
  faCalendarDay: w1,
  faScrewdriverWrench: C1,
  faFileChartLine: V1,
  faGear: j1,
  faChartLine: I1,
  faPaperPlaneTop: H1,
  faArrowProgress: B1,
  faLayerGroup: N1,
  faPipe: T1,
  faEyeSlash: zf,
  faInfoCircle: M1
};
function Al() {
  return {
    resolveIcon: (e) => e === null ? null : $9[e]
  };
}
const eP = { class: "relative self-start" }, tP = {
  key: 1,
  class: "w-1.5 h-1.5 rounded-full bg-red-400 absolute -top-1.5 -right-1.5"
}, rP = { class: "block text-left" }, nP = { class: "flex justify-start items-center mb-1" }, iP = { class: "font-medium text-black text-sm block mr-3" }, aP = { class: "text-gray-400 text-xs block" }, sP = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md bg-primary-50 border border-primary-200", oP = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md", lP = /* @__PURE__ */ V({
  __name: "PanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean },
    isVerticalMovement: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(t, { emit: e }) {
    const { resolveIcon: r } = Al(), n = t, i = oe(() => r(n.link.icon)), a = oe(() => n.isVerticalMovement ? sP : oP), s = e, o = (l) => {
      l.link !== null && s("inertiaLinkClick", l);
    };
    return (l, c) => (x(), F(be(l.link.isInertia ? S(Ti) : "button"), {
      class: X(["border border-white w-full flex p-4 items-center gap-x-6 rounded-md", a.value]),
      onClick: c[0] || (c[0] = (u) => o(l.link))
    }, {
      default: D(() => [
        k("span", eP, [
          i.value ? (x(), F(S(ae), {
            key: 0,
            icon: i.value,
            class: "size-8 text-gray-500"
          }, null, 8, ["icon"])) : J("", !0),
          l.link.badge ? (x(), N("span", tP)) : J("", !0)
        ]),
        k("span", rP, [
          k("span", nP, [
            k("span", iP, _(l.link.title), 1)
          ]),
          k("span", aP, _(l.link.description), 1)
        ]),
        l.hasSubLinks ? (x(), F(S(_9), {
          key: 0,
          class: "size-6 text-gray-500 shrink-0"
        })) : J("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function cP() {
  const t = de(0), e = de(0), r = de(!1);
  return {
    handleMouseOver: (i) => {
      const a = i.clientX - t.value, s = i.clientY - e.value;
      return t.value = i.clientX, e.value = i.clientY, r.value = Math.abs(s) > Math.abs(a), r.value;
    }
  };
}
const bd = "data:image/png;base64,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", uP = "data:image/png;base64,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", dP = "data:image/png;base64,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", fP = "data:image/png;base64,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", pP = "data:image/png;base64,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", yd = de(null);
function km() {
  const t = (e) => {
    yd.value = e;
  };
  return {
    userUUID: fr(yd),
    setUserUUID: t
  };
}
const mP = { class: "basis-[230px] bg-gray-50 text-black flex flex-col justify-center items-center" }, hP = {
  key: 0,
  class: "mt-4"
}, gP = ["src"], vP = {
  id: "upgrade-banner-title",
  class: "text-lg font-bold text-black mt-4 px-5 text-center flex justify-center items-center"
}, bP = {
  id: "upgrade-banner-description",
  class: "text-sm font-medium text-gray-400 mt-2 px-5 text-center flex justify-center items-center"
}, yP = { class: "p-5 flex flex-col justify-center items-center" }, wP = ["disabled"], SP = ["href"], xP = /* @__PURE__ */ V({
  __name: "UpgradeBanner",
  props: {
    product: {}
  },
  setup(t) {
    const { requestAccess: e } = Rt(), { environment: r } = tn(), { userUUID: n } = km(), i = de(null), a = t, s = async (u) => {
      n.value !== null && (i.value = await e(r.value, u, n.value));
    }, o = {
      sales: {
        title: "Spectre Sales",
        description: "Direct mail prospecting for property instructions.",
        imagePath: bd,
        buttonText: "Unlock",
        idProductName: "print_sales",
        learnMore: "https://spectre.uk.com/product/sales"
      },
      lettings: {
        title: "Spectre Lettings",
        description: "Identify and target landlord leads to grow your portfolio.",
        imagePath: uP,
        buttonText: "Unlock",
        idProductName: "print_lettings",
        learnMore: "https://spectre.uk.com/product/lettings"
      },
      email: {
        title: "Email Marketing",
        description: "Deliver hyper-targeted emails automatically.",
        imagePath: fP,
        buttonText: "Unlock",
        idProductName: "spectre_email",
        learnMore: "https://spectre.uk.com/product/email-marketing"
      },
      insights: {
        title: "Property Reports",
        description: "Create and share data-driven reports.",
        imagePath: dP,
        buttonText: "Unlock",
        idProductName: "property_reports",
        learnMore: "https://spectre.uk.com/product/property-reports"
      },
      social: {
        title: "Spectre Social",
        description: "Automated social feeds with on-brand content.",
        imagePath: pP,
        buttonText: "Start Free Trial",
        idProductName: "spectre_social",
        learnMore: "https://spectre.uk.com/product/social-media-automation"
      }
    }, l = {
      title: "",
      description: "",
      imagePath: bd,
      buttonText: "",
      idProductName: "",
      learnMore: ""
    }, c = de(o[a.product] ?? l);
    return (u, f) => {
      var m, h, p;
      return x(), N("div", mP, [
        c.value ? (x(), N("div", hP, [
          k("img", {
            src: c.value.imagePath,
            alt: "Lettings Upgrade",
            class: "w-full"
          }, null, 8, gP),
          k("p", vP, _(c.value.title), 1),
          k("p", bP, _(c.value.description), 1)
        ])) : J("", !0),
        k("div", yP, [
          k("button", {
            class: X([{
              "bg-primary-600 hover:bg-primary-700": i.value === null,
              "bg-green-500": ((m = i.value) == null ? void 0 : m.status) === "success",
              "bg-red-500": ((h = i.value) == null ? void 0 : h.status) === "error"
            }, "w-[189px] rounded-md px-4 py-2 text-white inline-block text-center cursor-pointer"]),
            disabled: i.value !== null,
            onClick: f[0] || (f[0] = (d) => s(c.value.idProductName))
          }, _(((p = i.value) == null ? void 0 : p.message) ?? c.value.buttonText), 11, wP),
          f[1] || (f[1] = k("div", { class: "relative my-3 w-full flex justify-center items-center" }, [
            k("div", {
              class: "absolute inset-0 flex items-center",
              "aria-hidden": "true"
            })
          ], -1)),
          k("a", {
            href: c.value.learnMore,
            target: "_blank",
            class: "text-blue-600 hover:text-blue-700 inline-block text-center"
          }, " Learn more ", 8, SP)
        ])
      ]);
    };
  }
});
function PP(t, e) {
  return x(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const AP = {
  class: "border border-white cursor-not-allowed w-full flex p-4 items-center gap-x-6 rounded-md",
  disabled: ""
}, OP = { class: "relative self-start" }, TP = { class: "block text-left" }, jP = { class: "flex justify-start items-center mb-1" }, kP = { class: "font-medium text-gray-300 text-sm block mr-3" }, MP = { class: "text-gray-300 text-xs block" }, zP = /* @__PURE__ */ V({
  __name: "DisabledPanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean }
  },
  setup(t) {
    const { resolveIcon: e } = Al(), r = t, n = oe(() => e(r.link.icon));
    return (i, a) => (x(), N("button", AP, [
      k("span", OP, [
        n.value ? (x(), F(S(ae), {
          key: 0,
          icon: n.value,
          class: "w-8 h-8 text-gray-300"
        }, null, 8, ["icon"])) : J("", !0)
      ]),
      k("span", TP, [
        k("span", jP, [
          k("span", kP, _(i.link.title), 1)
        ]),
        k("span", MP, _(i.link.description), 1)
      ]),
      i.hasSubLinks ? (x(), F(S(PP), {
        key: 0,
        class: "w-4 h-4 text-gray-300"
      })) : J("", !0)
    ]));
  }
});
function Ol(t) {
  const e = de(null), r = de(null), n = de(!1), i = (l, c, u, f) => {
    const m = /* @__PURE__ */ new Date();
    m.setTime(m.getTime() + f * 24 * 60 * 60 * 1e3);
    const h = `; expires=${m.toUTCString()}`;
    document.cookie = `${l}=${encodeURIComponent(c)}; domain=${u}; path=/;${h}`;
  }, a = (l) => {
    const c = `${l}=`, u = document.cookie.split(";");
    for (let f = 0; f < u.length; f++) {
      let m = u[f];
      for (; m.charAt(0) === " "; ) m = m.substring(1, m.length);
      if (m.indexOf(c) === 0) return decodeURIComponent(m.substring(c.length, m.length));
    }
    return null;
  }, s = (l, c, u) => {
    i("storedLink", JSON.stringify({
      clickedLink: l,
      activeVerticalLink: c,
      product: u
    }), t, 7);
  };
  return {
    clickedLink: e,
    activeVerticalLink: r,
    isProductMatch: n,
    saveToCookieStorage: s,
    loadFromCookieStorage: (l) => {
      let c = a("storedLink");
      (c == null || c === "") && (s(null, null, l), c = a("storedLink"));
      try {
        const u = JSON.parse(c), f = (u == null ? void 0 : u.product) ?? null;
        n.value = f !== null && f === l, n.value ? (e.value = u.clickedLink ?? null, r.value = u.activeVerticalLink ?? null) : (e.value = null, r.value = null);
      } catch (u) {
        console.error("Error parsing storedLink:", u);
      }
    }
  };
}
const EP = { class: "basis-[370px] p-4 overflow-y-auto" }, CP = { key: 0 }, IP = { key: 1 }, LP = {
  key: 0,
  class: "basis-[230px] bg-gray-50 text-black px-4 py-8 overflow-y-auto"
}, RP = ["onClick"], NP = /* @__PURE__ */ V({
  __name: "NavigationPanel",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] },
    open: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(t, { expose: e, emit: r }) {
    var P, T;
    const { isShadowing: n } = Xa(), { getTopLevelDomain: i, environment: a } = tn(), s = oe(() => i(a.value)), o = t, l = r, c = de(((T = (P = o.links) == null ? void 0 : P[0]) == null ? void 0 : T.subLinks) ?? null), { clickedLink: u, activeVerticalLink: f, saveToCookieStorage: m, loadFromCookieStorage: h } = Ol(s.value), p = oe(() => c.value), { handleMouseOver: d } = cP(), v = (A, j) => {
      d(A) && j && (w(j.subLinks), f.value = j.title);
    }, b = (A) => {
      if (A.link !== null) {
        if (u.value = A.title, m(u.value, f.value, o.product), A.isInertia === !0) {
          l("inertiaLinkClick", A.link);
          return;
        }
        window.location.href = A.link;
      }
    };
    Kr(() => {
      g(), window.addEventListener("resize", g), h(o.product);
    }), Rm(() => {
      window.removeEventListener("resize", g);
    });
    const g = () => {
      const A = window.innerHeight;
      y.value = A - (n.value ? 144 : 72);
    }, y = de(0), w = (A) => {
      c.value = A;
    };
    return Pi(() => o.open, g), e({ activeLinks: c }), (A, j) => (x(), F(S(Ma), null, {
      default: D(() => [
        k("div", {
          ref: "dropdownPanel",
          class: X(["flex absolute -left-8 top-full z-10 mt-3 w-screen overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5", p.value || A.showUpsellBanner ? "max-w-[600px]" : "max-w-[370px]"]),
          style: Ai({ maxHeight: `${y.value}px` })
        }, [
          k("div", EP, [
            A.showUpsellBanner ? (x(), N("div", IP, [
              (x(!0), N(xe, null, Qe(A.links, (O, M) => (x(), F(zP, {
                key: `${M}-d-link`,
                link: O,
                "has-sub-links": !!O.subLinks
              }, null, 8, ["link", "has-sub-links"]))), 128))
            ])) : (x(), N("div", CP, [
              (x(!0), N(xe, null, Qe(A.links, (O, M) => (x(), F(lP, {
                key: `${M}-link`,
                link: O,
                "has-sub-links": !!O.subLinks,
                "is-vertical-movement": S(f) === O.title,
                onMouseover: (z) => v(z, O),
                onInertiaLinkClick: b
              }, null, 8, ["link", "has-sub-links", "is-vertical-movement", "onMouseover"]))), 128))
            ]))
          ]),
          p.value && !A.showUpsellBanner ? (x(), N("div", LP, [
            (x(!0), N(xe, null, Qe(c.value, (O) => (x(), N("button", {
              key: `${O.title}-link`,
              class: X([{
                "bg-primary-50": S(u) === O.title,
                "hover:bg-primary-50": S(u) !== O.title
              }, "text-sm rounded-md p-2 my-2 flex items-center justify-start gap-x-3 w-full"]),
              onClick: (M) => b(O)
            }, _(O.title), 11, RP))), 128))
          ])) : J("", !0),
          A.showUpsellBanner ? (x(), F(xP, {
            key: 1,
            product: A.product
          }, null, 8, ["product"])) : J("", !0)
        ], 6)
      ]),
      _: 1
    }));
  }
}), ur = /* @__PURE__ */ V({
  __name: "NavigationLink",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] }
  },
  emits: ["inertiaLinkClick"],
  setup(t, { emit: e }) {
    const { getTopLevelDomain: r, environment: n } = tn(), i = oe(() => r(n.value)), a = t, { isProductMatch: s, loadFromCookieStorage: o } = Ol(i.value), l = e, c = (u) => {
      l("inertiaLinkClick", u);
    };
    return Kr(() => {
      o(a.product);
    }), (u, f) => (x(), F(S(ka), { class: "relative" }, {
      default: D(({ open: m }) => [
        U(S(Ti), {
          class: X(["flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500", [m || S(s) && "bg-primary-500", m && "bg-primary-600"]])
        }, {
          default: D(() => [
            H(u.$slots, "default"),
            U(S(Ba), {
              class: X(["h-5 w-5 flex-none", ["text-white", { "rotate-180 transform": m }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        U(At, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: D(() => [
            U(NP, {
              links: u.links,
              product: u.product,
              open: m,
              "show-upsell-banner": u.showUpsellBanner,
              onInertiaLinkClick: c
            }, null, 8, ["links", "product", "open", "show-upsell-banner"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), DP = {};
function HP(t, e) {
  return x(), N("svg", _e(t.$attrs, {
    viewBox: "0 0 260 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    Jr('<g clip-path="url(#clip0_1429_30706)"><path d="M154.672 5.47436H164.481V28.9838H169.955V5.47436H179.765V0.00631714H154.672V5.47436Z"></path><path d="M99.9481 5.78412V0.316071H82.2659L85.272 5.78412H99.9481Z"></path><path d="M85.272 29.0091H100.328V23.541H82.6456L85.272 29.0091Z"></path><path d="M88.1009 17.6684H97.5939V12.1941H85.272L88.1009 17.6684Z"></path><path d="M258.879 5.78412V0.316071H241.197L244.197 5.78412H258.879Z"></path><path d="M244.203 29.0091H259.259V23.541H241.577L244.203 29.0091Z"></path><path d="M247.032 17.6684H256.519V12.1941H244.197L247.032 17.6684Z"></path><path d="M132.8 24.2237C127.623 24.2237 123.415 20.02 123.415 14.8491C123.415 9.67812 127.623 5.47436 132.8 5.47436C134.496 5.47436 136.154 5.9295 137.597 6.78922L140.401 2.09239C138.11 0.726961 135.477 0.00631714 132.8 0.00631714C124.605 0.00631714 117.94 6.66279 117.94 14.8491C117.94 23.0353 124.605 29.6918 132.8 29.6918C135.509 29.6918 138.167 28.9522 140.477 27.5615L137.648 22.8836C136.192 23.756 134.515 24.2237 132.8 24.2237Z"></path><path d="M12.056 12.0234C11.3346 11.8527 10.6448 11.7516 9.98026 11.6504C9.36005 11.5556 8.76516 11.4671 8.23988 11.3343C7.06909 11.0372 5.80969 10.0448 5.80969 8.56555C5.80969 6.85876 7.50576 5.46804 9.59421 5.46804C10.322 5.46804 11.0308 5.63872 11.6384 5.96744C12.7269 6.54901 13.3787 7.52251 13.3787 8.56555H18.853C18.853 5.50597 17.0747 2.66133 14.2141 1.13786C12.8155 0.391929 11.2143 0 9.58788 0C4.48067 0 0.329089 3.84343 0.329089 8.56555C0.329089 12.3331 3.02509 15.6519 6.88556 16.6317C7.68296 16.834 8.43607 16.9478 9.17019 17.0552C9.7461 17.1437 10.2967 17.2196 10.7903 17.3397C12.2079 17.6747 13.7078 18.9074 13.7078 20.5257C13.7078 21.6699 13.0053 22.7382 11.8282 23.3704C11.1637 23.7307 10.3916 23.9203 9.59421 23.9203C7.32223 23.9203 5.47427 22.3969 5.47427 20.5257H0C0 25.4122 4.30347 29.3884 9.59421 29.3884C11.3029 29.3884 12.9737 28.9712 14.4356 28.181C17.3658 26.6006 19.1821 23.6675 19.1821 20.5257C19.1884 16.5811 16.1886 13.0032 12.056 12.0234Z"></path><path d="M216.256 9.76662C216.256 4.55776 212.009 0.316071 206.794 0.316071H201.345V0.347678H196.207V28.8321H201.681V5.78411H206.788C208.984 5.78411 210.775 7.56676 210.775 9.76662C210.775 11.9602 208.99 13.7491 206.788 13.7491H205.143V19.2172L214.661 28.8131H222.382L211.541 17.896C214.345 16.2524 216.256 13.2434 216.256 9.76662Z"></path><path d="M50.9582 13.7491H45.851V5.78411H50.9582C53.1542 5.78411 54.9452 7.56676 54.9452 9.76662C54.9452 11.9602 53.1542 13.7491 50.9582 13.7491ZM50.9582 0.316071H45.1865V0.347678H40.3767V28.8321H45.851V19.2172H50.9582C56.173 19.2172 60.4195 14.9755 60.4195 9.76662C60.4195 4.55776 56.1793 0.316071 50.9582 0.316071Z"></path></g>', 1)
  ]), 16);
}
const WP = /* @__PURE__ */ se(DP, [["render", HP]]), FP = {};
function VP(t, e) {
  return x(), N("svg", _e(t.$attrs, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    k("path", {
      "fill-rule": "evenodd",
      "lip-rule": "evenodd",
      d: "M16.3232 11.5055C16.7293 11.567 17.15 11.6308 17.589 11.7344H17.5849C20.2485 12.3647 22.182 14.6664 22.182 17.2079C22.182 19.2289 21.0113 21.1158 19.1227 22.1324C18.1804 22.6407 17.1036 22.9091 16.0022 22.9091C12.5921 22.9091 9.81836 20.3513 9.81836 17.2079H13.3508C13.3508 18.4116 14.5419 19.3916 16.0063 19.3916C16.5203 19.3916 17.0179 19.2696 17.4462 19.0378C18.2049 18.6312 18.6577 17.9439 18.6577 17.2079C18.6577 16.1669 17.6909 15.3739 16.7772 15.1584C16.5045 15.0922 16.2048 15.0469 15.891 14.9994C15.8387 14.9915 15.786 14.9835 15.733 14.9754C15.2598 14.9063 14.7744 14.8331 14.2605 14.703C11.7722 14.0726 10.0345 11.9378 10.0345 9.51413C10.0345 6.47648 12.7104 4.00407 15.9981 4C17.0465 4 18.0785 4.25212 18.9799 4.73196C20.8237 5.71198 21.9699 7.5419 21.9699 9.51007H18.4415C18.4415 8.8391 18.0214 8.21286 17.3198 7.83875C16.9282 7.62729 16.4713 7.5175 16.0022 7.5175C14.6561 7.5175 13.5629 8.41212 13.5629 9.51007C13.5629 10.4616 14.3747 11.1001 15.1293 11.2912C15.4534 11.3729 15.8185 11.4286 16.1998 11.4867C16.2168 11.4893 16.2339 11.4919 16.251 11.4945C16.2751 11.4982 16.2991 11.5018 16.3232 11.5055ZM21.4547 24.3636V28H12.5433L10.5456 24.3636H21.4547Z"
    }, null, -1)
  ]), 16);
}
const Mm = /* @__PURE__ */ se(FP, [["render", VP]]), GP = {
  id: "account-branch-name",
  class: "font-medium text-ellipsis overflow-hidden text-nowrap"
}, ZP = { class: "flex items-center" }, XP = {
  class: "overflow-y-scroll overflow-x-hidden border-t border-solid border-gray-200 w-[300px]",
  style: { "max-height": "240px" }
}, BP = ["id", "onClick"], UP = /* @__PURE__ */ V({
  __name: "AccountSelector",
  props: {
    branchName: {},
    links: {}
  },
  emits: ["selected"],
  setup(t, { expose: e, emit: r }) {
    const n = r, i = t, a = de(""), s = oe(() => a.value === "" ? i.links : i.links.filter((o) => o.name.toLowerCase().includes(a.value.toLowerCase())));
    return e({ filteredLinks: s }), (o, l) => (x(), F(S(ka), { class: "relative" }, {
      default: D(({ open: c }) => [
        U(S(Ti), {
          class: X(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[400px]", c ? "bg-primary-600" : ""])
        }, {
          default: D(() => [
            k("div", GP, _(o.branchName), 1),
            U(S(Ba), {
              class: X(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": c }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        U(At, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: D(() => [
            U(S(Ma), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 overflow-hidden" }, {
              default: D(() => [
                k("div", ZP, [
                  U(S(F9), { class: "h-5 w-5 text-gray-500 mx-4" }),
                  dt(k("input", {
                    "onUpdate:modelValue": l[0] || (l[0] = (u) => a.value = u),
                    type: "search",
                    class: "w-full border-none h-12 py-2 pr-2 pl-0 text-gray-500 text-sm focus:outline-none focus:ring-0",
                    placeholder: "Search"
                  }, null, 512), [
                    [ja, a.value]
                  ])
                ]),
                k("div", XP, [
                  l[1] || (l[1] = k("span", { class: "block text-gray-600 font-medium px-3 py-2 leading-6 text-sm mx-2 mt-2" }, "All Accounts", -1)),
                  (x(!0), N(xe, null, Qe(s.value, (u) => (x(), N("button", {
                    id: `account-button-${u.id}`,
                    key: u.name,
                    class: "block rounded-lg font-medium text-black hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left mx-2",
                    onClick: (f) => n("selected", u)
                  }, _(u.name), 9, BP))), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), YP = { class: "flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1" }, Ls = /* @__PURE__ */ V({
  __name: "PlaceholderLink",
  setup(t) {
    return (e, r) => (x(), N("span", YP, [
      H(e.$slots, "default"),
      U(S(Ba), { class: "h-5 w-5 flex-none text-white" })
    ]));
  }
}), qP = { class: "flex items-center" }, QP = { class: "flex items-center gap-x-2" }, JP = {
  id: "middle_section",
  class: "grow"
}, KP = { class: "flex items-center gap-x-2" }, _P = /* @__PURE__ */ V({
  __name: "DesktopNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {},
    userLinks: {}
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(t, { emit: e }) {
    const { showSalesUpsellBanner: r, showLettingsUpsellBanner: n, navigation: i, showInsightsUpsellBanner: a, showEmailUpsellBanner: s, showSocialUpsellBanner: o, linksLoading: l } = Rt(), { getTopLevelDomain: c, environment: u } = tn(), f = oe(() => c(u.value)), { saveToCookieStorage: m } = Ol(f.value), h = e, p = (g) => {
      h("selectedAccount", g);
    }, d = (g) => {
      h("inertiaLinkClick", g);
    }, v = t, b = () => {
      m(null, null, null), window.location.href = v.dashboardLink;
    };
    return (g, y) => (x(), N("nav", _e(g.$attrs, { class: "w-full text-white h-16 flex items-center font-inter z-50 bg-spectre-purple" }), [
      U(S(Fd), { class: "flex items-center justify-between w-full mx-8" }, {
        default: D(() => {
          var w, P, T, A, j, O, M, z;
          return [
            k("section", qP, [
              k("button", {
                "aria-label": "Go to dashboard",
                onClick: b
              }, [
                U(WP, { class: "fill-white w-[150px] mr-5 hidden lg:block" }),
                U(Mm, { class: "fill-white w-6 mr-5 block lg:hidden" })
              ]),
              k("div", QP, [
                k("button", {
                  class: "text-sm font-medium leading-6 text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500",
                  onClick: b
                }, " Dashboard "),
                S(i).isAdmin ? J("", !0) : (x(), F(ur, {
                  key: 0,
                  links: S(i).salesLinks,
                  product: "sales",
                  "show-upsell-banner": S(r),
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[0] || (y[0] = [
                    le(" Sales ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                S(i).isAdmin ? J("", !0) : (x(), F(ur, {
                  key: 1,
                  links: S(i).lettingsLinks,
                  product: "lettings",
                  "show-upsell-banner": S(n),
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[1] || (y[1] = [
                    le(" Lettings ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                (w = S(i).emailLinks) != null && w.length ? (x(), F(ur, {
                  key: 2,
                  links: S(i).emailLinks,
                  product: "email",
                  "show-upsell-banner": S(s),
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[2] || (y[2] = [
                    le(" Email Marketing ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : J("", !0),
                !((P = S(i).emailLinks) != null && P.length) && !S(s) && S(l) ? (x(), F(Ls, { key: 3 }, {
                  default: D(() => y[3] || (y[3] = [
                    le(" Email Marketing ")
                  ])),
                  _: 1
                })) : J("", !0),
                (T = S(i).insightsLinks) != null && T.length ? (x(), F(ur, {
                  key: 4,
                  links: S(i).insightsLinks,
                  product: "insights",
                  "show-upsell-banner": S(a),
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[4] || (y[4] = [
                    le(" Property Reports ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : J("", !0),
                !((A = S(i).insightsLinks) != null && A.length) && !S(a) && S(l) ? (x(), F(Ls, { key: 5 }, {
                  default: D(() => y[5] || (y[5] = [
                    le(" Property Reports ")
                  ])),
                  _: 1
                })) : J("", !0),
                (j = S(i).socialLinks) != null && j.length ? (x(), F(ur, {
                  key: 6,
                  links: S(i).socialLinks,
                  product: "social",
                  "show-upsell-banner": S(o),
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[6] || (y[6] = [
                    le(" Social Media ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : J("", !0),
                S(i).isAdmin && ((O = S(i).printAdminLinks) != null && O.length) ? (x(), F(ur, {
                  key: 7,
                  links: S(i).printAdminLinks,
                  product: "print",
                  "show-upsell-banner": S(i).showSalesUpsellBanner,
                  onInertiaLinkClick: d
                }, {
                  default: D(() => y[7] || (y[7] = [
                    le(" Print ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : J("", !0),
                S(i).isAdmin && !((M = S(i).printAdminLinks) != null && M.length) && S(l) ? (x(), F(Ls, { key: 8 }, {
                  default: D(() => y[8] || (y[8] = [
                    le(" Print ")
                  ])),
                  _: 1
                })) : J("", !0)
              ])
            ]),
            k("section", JP, [
              H(g.$slots, "default")
            ]),
            k("section", KP, [
              S(i).environmentBadge ? (x(), F(q9, { key: 0 })) : J("", !0),
              S(i).credits ? (x(), F(K9, { key: 1 })) : J("", !0),
              S(i).accountLinks && S(i).fullBranchName ? (x(), F(UP, {
                key: 2,
                "branch-name": S(i).fullBranchName,
                links: S(i).accountLinks,
                onSelected: p
              }, null, 8, ["branch-name", "links"])) : J("", !0),
              (z = S(i).identityAdminLinks) != null && z.length ? (x(), F(ur, {
                key: 3,
                links: S(i).identityAdminLinks,
                product: "identity",
                "show-upsell-banner": !1,
                onInertiaLinkClick: d
              }, {
                default: D(() => y[9] || (y[9] = [
                  le(" Spectre Admin ")
                ])),
                _: 1
              }, 8, ["links"])) : J("", !0),
              y[10] || (y[10] = k("span", { class: "text-xl text-gray-300" }, "|", -1)),
              S(i).userName && g.userLinks ? (x(), F(jm, {
                key: 4,
                links: g.userLinks,
                "csrf-token": S(i).csrfToken
              }, {
                default: D(() => [
                  le(_(S(i).userName), 1)
                ]),
                _: 1
              }, 8, ["links", "csrf-token"])) : J("", !0)
            ])
          ];
        }),
        _: 3
      })
    ], 16));
  }
}), { navigation: Rs } = Rt(), Lr = Nm({
  label: "",
  links: null
}), wd = de(!1);
function Ua() {
  const t = (a) => {
    wd.value = a;
  }, e = (a, s) => {
    Lr.label = s, Lr.links = a;
  }, r = () => {
    Lr.label = "", Lr.links = null;
  }, n = oe(() => Lr.label !== ""), i = oe(() => {
    if (Rs.value.mobileLinks === void 0 || Rs.value.mobileLinks === null)
      return [];
    const a = Rs.value.mobileLinks.find((s) => s.title === "MobileUserDropdownMenu");
    return a === void 0 ? [] : a.subLinks ?? [];
  });
  return {
    setMobileNavSlideOver: t,
    setMobileNavLinksInFocus: e,
    resetMobileNavLinksInFocus: r,
    isMobileLinksInFocus: n,
    mobileNavLinksInFocus: Lr,
    getMobileDropdownLinks: i,
    isMobileNavSlideoverOpen: fr(wd)
  };
}
const $P = { class: "py-1" }, eA = /* @__PURE__ */ V({
  __name: "MobileMenuDropdown",
  props: {
    dynamicMenuLinks: {}
  },
  setup(t) {
    const { redirectToTarget: e } = Rt();
    return (r, n) => (x(), F(S(Dd), {
      as: "div",
      class: "relative z-50 inline-block text-left"
    }, {
      default: D(() => [
        k("div", null, [
          U(S(Hs), { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md py-2 text-sm font-semibold text-gray-900" }, {
            default: D(() => [
              H(r.$slots, "menu-button")
            ]),
            _: 3
          })
        ]),
        U(At, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: D(() => [
            r.dynamicMenuLinks.length ? (x(), F(S(Hd), {
              key: 0,
              class: "absolute right-0 mr-4 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            }, {
              default: D(() => [
                k("div", $P, [
                  n[0] || (n[0] = k("p", {
                    href: "#",
                    class: "px-4 py-2 text-sm text-black font-semibold"
                  }, " Account ", -1)),
                  (x(!0), N(xe, null, Qe(r.dynamicMenuLinks, (i, a) => (x(), F(S(Wd), {
                    key: a,
                    onClick: (s) => S(e)(i.link)
                  }, {
                    default: D(({ active: s }) => [
                      k("a", {
                        href: "#",
                        class: X([s ? "bg-gray-100 text-gray-900" : "text-gray-700", "block px-4 py-2 text-sm"])
                      }, _(i.title), 3)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ])
              ]),
              _: 1
            })) : J("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), Tn = /* @__PURE__ */ V({
  __name: "NavigationLink",
  props: {
    icon: {},
    iconClasses: {},
    target: {}
  },
  setup(t) {
    const e = t, { redirectToTarget: r } = Rt();
    return (n, i) => (x(), N("aside", {
      class: "flex gap-2 w-full relative items-center",
      onClick: i[0] || (i[0] = (a) => S(r)(e.target))
    }, [
      k("p", null, [
        H(n.$slots, "link-title")
      ]),
      H(n.$slots, "badge"),
      n.icon ? (x(), F(S(ae), {
        key: 0,
        icon: n.icon,
        class: X(["w-6 w-6 text-black absolute right-0 animate duration-500", n.iconClasses])
      }, null, 8, ["icon", "class"])) : J("", !0)
    ]));
  }
}), tA = {}, rA = { class: "bg-red-400 text-xs px-1 py-0.5 flex items-center justify-center rounded text-white" };
function nA(t, e) {
  return x(), N("span", rA, [
    H(t.$slots, "default")
  ]);
}
const zm = /* @__PURE__ */ se(tA, [["render", nA]]), iA = {}, aA = { class: "bg-blue-100 text-xs px-1 py-0.5 flex items-center justify-center rounded text-blue-800" };
function sA(t, e) {
  return x(), N("span", aA, [
    H(t.$slots, "default")
  ]);
}
const Sd = /* @__PURE__ */ se(iA, [["render", sA]]), oA = { class: "flex flex-col gap-4" }, lA = { class: "mt-12 ml-2 text-sm space-y-6" }, cA = { class: "ml-2 text-sm space-y-6" }, uA = /* @__PURE__ */ V({
  __name: "NavigationLinkList",
  props: {
    dashboardLink: {}
  },
  setup(t) {
    const e = t, { navigation: r, redirectToTarget: n, remainingCredits: i } = Rt(), { setMobileNavLinksInFocus: a } = Ua(), s = [
      { name: "Settings", href: "https://spectre.uk.com/portal/account/settings" },
      { name: "Help & Support", href: "https://support.spectre.uk.com/knowledge" }
    ], o = [
      {
        show: !0,
        title: "Dashboard",
        href: e.dashboardLink,
        badge: null,
        dispatchAction: () => {
          n(e.dashboardLink);
        }
      },
      {
        show: !0,
        title: "Sales",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.salesLinks === null) {
            n("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/dashboard&account_type=sales");
            return;
          }
          a(r.value.salesLinks, "Sales");
        }
      },
      {
        show: !0,
        title: "Lettings",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.lettingsLinks === null) {
            n("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/lettings/dashboard&account_type=lettings");
            return;
          }
          a(r.value.lettingsLinks, "Lettings");
        }
      },
      {
        show: r.value.emailLinks,
        title: "Email Marketing",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.emailLinks !== null && a(r.value.emailLinks, "Email Marketing");
        }
      },
      {
        show: r.value.insightsLinks,
        title: "Property Reports",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.insightsLinks !== null && a(r.value.insightsLinks, "Property Reports");
        }
      },
      {
        show: r.value.socialLinks,
        title: "Social Media",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.socialLinks !== null && a(r.value.socialLinks, "Social Media");
        }
      }
    ], l = oe(() => o.filter((c) => c.show));
    return (c, u) => (x(), N("aside", oA, [
      k("nav", lA, [
        (x(!0), N(xe, null, Qe(l.value, (f, m) => (x(), F(Tn, {
          key: m,
          icon: S(nc),
          onClick: f.dispatchAction
        }, zd({
          "link-title": D(() => [
            k("p", null, _(f.title), 1)
          ]),
          _: 2
        }, [
          f != null && f.badge ? {
            name: "badge",
            fn: D(() => [
              U(zm, null, {
                default: D(() => [
                  k("p", null, _(f.badge), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["icon", "onClick"]))), 128))
      ]),
      u[1] || (u[1] = k("div", { class: "h-[1px] bg-gray-200 w-full" }, null, -1)),
      k("nav", cA, [
        S(r).credits ? (x(), F(Tn, { key: 0 }, {
          "link-title": D(() => u[0] || (u[0] = [
            k("p", null, "Branch credits", -1)
          ])),
          badge: D(() => [
            S(r).credits.branchCreditLimit ? (x(), F(Sd, { key: 0 }, {
              default: D(() => [
                k("p", null, _(S(i)) + " / " + _(S(r).credits.branchCreditLimit), 1)
              ]),
              _: 1
            })) : (x(), F(Sd, { key: 1 }, {
              default: D(() => {
                var f;
                return [
                  le(_((f = S(r).credits) == null ? void 0 : f.credits), 1)
                ];
              }),
              _: 1
            }))
          ]),
          _: 1
        })) : J("", !0),
        (x(), N(xe, null, Qe(s, (f, m) => U(Tn, {
          key: m,
          icon: S(nc),
          target: f.href
        }, {
          "link-title": D(() => [
            k("p", null, _(f.name), 1)
          ]),
          _: 2
        }, 1032, ["icon", "target"])), 64))
      ])
    ]));
  }
}), dA = { class: "mt-12 overflow-scroll max-h-[500px] ml-2 text-sm space-y-6" }, fA = { class: "text-base font-semibold" }, pA = { class: "w-full space-y-6" }, mA = /* @__PURE__ */ V({
  __name: "NavigationLinksInFocus",
  setup(t) {
    const { resetMobileNavLinksInFocus: e, mobileNavLinksInFocus: r } = Ua();
    return (n, i) => (x(), N("section", null, [
      k("nav", dA, [
        k("p", fA, _(S(r).label), 1),
        k("aside", {
          class: "flex items-center gap-2",
          onClick: i[0] || (i[0] = //@ts-ignore
          (...a) => S(e) && S(e)(...a))
        }, [
          U(S(ae), {
            icon: S(vv),
            class: "w-6 w-6 text-black"
          }, null, 8, ["icon"]),
          i[1] || (i[1] = le(" Back "))
        ]),
        k("div", pA, [
          (x(!0), N(xe, null, Qe(S(r).links, (a, s) => (x(), F(S(Cd), {
            key: s,
            as: "div"
          }, {
            default: D(({ open: o }) => [
              U(S(Id), { class: "flex w-full" }, {
                default: D(() => {
                  var l;
                  return [
                    U(Tn, {
                      "icon-classes": o ? "rotate-90" : "rotate-0",
                      icon: (l = a == null ? void 0 : a.subLinks) != null && l.length ? S(Pf) : null,
                      target: a.link
                    }, {
                      "link-title": D(() => [
                        k("p", null, _(a.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon-classes", "icon", "target"])
                  ];
                }),
                _: 2
              }, 1024),
              U(At, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "transform opacity-0",
                "enter-to-class": "transform opacity-100",
                "leave-active-class": "transition duration-200 ease-out",
                "leave-from-class": "transform opacity-100",
                "leave-to-class": "transform opacity-0"
              }, {
                default: D(() => {
                  var l;
                  return [
                    (l = a == null ? void 0 : a.subLinks) != null && l.length ? (x(), F(S(Ld), {
                      key: 0,
                      class: "pl-4 py-2 pt-4 space-y-6 text-sm"
                    }, {
                      default: D(() => [
                        (x(!0), N(xe, null, Qe(a.subLinks, (c, u) => (x(), F(Tn, {
                          key: u,
                          target: c.link
                        }, {
                          "link-title": D(() => [
                            k("p", null, _(c.title), 1)
                          ]),
                          badge: D(() => [
                            c != null && c.badge ? (x(), F(zm, {
                              key: 0,
                              class: "absolute right-0"
                            }, {
                              default: D(() => [
                                k("p", null, _(c.badge), 1)
                              ]),
                              _: 2
                            }, 1024)) : J("", !0)
                          ]),
                          _: 2
                        }, 1032, ["target"]))), 128))
                      ]),
                      _: 2
                    }, 1024)) : J("", !0)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ])
      ])
    ]));
  }
}), hA = { class: "fixed inset-0 overflow-hidden" }, gA = { class: "absolute inset-0 overflow-hidden" }, vA = { class: "pointer-events-none fixed inset-y-0 left-0 flex w-10/12" }, bA = { class: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl" }, yA = { class: "px-4 sm:px-6" }, wA = /* @__PURE__ */ V({
  __name: "MobileMenuSlideover",
  props: {
    open: { type: Boolean },
    dashboardLink: {}
  },
  emits: ["close-slide-over"],
  setup(t, { emit: e }) {
    const { isMobileLinksInFocus: r } = Ua(), n = e;
    return (i, a) => (x(), F(S(zo), {
      as: "template",
      show: i.open
    }, {
      default: D(() => [
        U(S(Eo), {
          class: "relative z-50",
          onClose: a[1] || (a[1] = (s) => n("close-slide-over"))
        }, {
          default: D(() => [
            U(S(Vr), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: D(() => a[2] || (a[2] = [
                k("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            k("div", hA, [
              k("div", gA, [
                k("div", vA, [
                  U(S(Vr), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "-translate-x-full"
                  }, {
                    default: D(() => [
                      U(S(Co), { class: "pointer-events-auto relative w-screen max-w-md" }, {
                        default: D(() => [
                          k("div", bA, [
                            k("div", yA, [
                              U(S(ae), {
                                icon: S(Ko),
                                class: "w-8 w-8 text-black",
                                onClick: a[0] || (a[0] = (s) => n("close-slide-over"))
                              }, null, 8, ["icon"]),
                              S(r) ? (x(), F(mA, { key: 0 })) : (x(), F(uA, {
                                key: 1,
                                "dashboard-link": i.dashboardLink
                              }, null, 8, ["dashboard-link"]))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), SA = { class: "fixed w-full z-50 text-white h-16 flex items-center border-b border-gray-200 font-inter z-49 bg-spectre-purple" }, xA = { class: "flex items-center" }, PA = ["href"], AA = { class: "w-4 h-4 text-xs font-semibold flex text-black p-4 items-center justify-center bg-gray-100 rounded-full" }, OA = /* @__PURE__ */ V({
  __name: "MobileNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {}
  },
  setup(t) {
    const { getUsernameAbbreviation: e } = Rt(), { isMobileNavSlideoverOpen: r, setMobileNavSlideOver: n, getMobileDropdownLinks: i } = Ua();
    return (a, s) => (x(), N("nav", SA, [
      U(S(Fd), { class: "flex items-center justify-between w-full mx-4" }, {
        default: D(() => [
          k("section", null, [
            U(S(ae), {
              icon: S(yv),
              class: "w-6 w-6 text-white",
              onClick: s[0] || (s[0] = (o) => S(n)(!0))
            }, null, 8, ["icon"])
          ]),
          k("section", xA, [
            k("a", { href: a.dashboardLink }, [
              U(Mm, { class: "fill-white w-6" })
            ], 8, PA)
          ]),
          k("section", null, [
            U(eA, { "dynamic-menu-links": S(i) }, {
              "menu-button": D(() => [
                k("div", AA, [
                  k("p", null, _(S(e)), 1)
                ])
              ]),
              _: 1
            }, 8, ["dynamic-menu-links"])
          ])
        ]),
        _: 1
      }),
      U(wA, {
        open: S(r),
        "dashboard-link": a.dashboardLink,
        onCloseSlideOver: s[1] || (s[1] = (o) => S(n)(!S(r)))
      }, null, 8, ["open", "dashboard-link"])
    ]));
  }
}), TA = { class: "hidden lg:flex flex-initial items-center divide-x w-full" }, jA = { class: "font-semibold" }, kA = { class: "font-semibold" }, MA = { class: "px-2" }, zA = { class: "font-semibold" }, EA = /* @__PURE__ */ V({
  __name: "ShadowBar",
  setup(t) {
    const { resolveIcon: e } = Al(), r = e("faPipe"), n = e("faEyeSlash"), i = e("faInfoCircle"), {
      currentUser: a,
      shadowedUser: s,
      shadowedAccount: o,
      shadowedCompany: l,
      endSessionUrl: c
    } = Xa(), u = async (m) => {
      await navigator.clipboard.writeText(m);
    }, f = () => {
      if (!(c.value instanceof URL))
        throw new Error("Trying to end shadowing but URL is missing");
      window.location.href = c.value.toString();
    };
    return (m, h) => (x(), N("div", _e(m.$attrs, { class: "w-full text-sm text-indigo-900 h-16 p-4 flex justify-between items-center font-inter z-50 bg-indigo-100" }), [
      k("div", TA, [
        S(n) ? (x(), F(S(ae), {
          key: 0,
          icon: S(n),
          class: "font-semibold"
        }, null, 8, ["icon"])) : J("", !0),
        S(s) && S(a) ? (x(), N("div", {
          key: 1,
          class: "px-2 cursor-copy",
          onClick: h[0] || (h[0] = (p) => u(S(s).id))
        }, [
          k("span", jA, _(S(a).name), 1),
          h[4] || (h[4] = k("span", null, " you are currently shadowing ", -1)),
          k("span", kA, _(S(s).name), 1)
        ])) : J("", !0),
        S(r) && S(l) ? (x(), F(S(ae), {
          key: 2,
          icon: S(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : J("", !0),
        S(l) ? (x(), N("div", {
          key: 3,
          class: "px-2 cursor-copy",
          onClick: h[1] || (h[1] = (p) => u(S(l).id))
        }, [
          h[5] || (h[5] = k("span", { class: "font-semibold" }, "Company: ", -1)),
          k("span", null, _(S(l).name), 1)
        ])) : J("", !0),
        S(r) && S(o) ? (x(), F(S(ae), {
          key: 4,
          icon: S(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : J("", !0),
        S(o) ? (x(), N("div", {
          key: 5,
          class: "pl-2 cursor-copy",
          onClick: h[2] || (h[2] = (p) => u(S(o).id))
        }, [
          h[6] || (h[6] = k("span", { class: "font-semibold" }, "Account: ", -1)),
          k("span", null, _(S(o).name), 1)
        ])) : J("", !0)
      ]),
      S(a) && S(s) ? (x(), N("div", {
        key: 0,
        class: "lg:hidden flex flex-initial items-center divide-x w-full cursor-copy",
        onClick: h[3] || (h[3] = (p) => {
          var d, v;
          return u(`User: ${S(s).id}, Company: ${((d = S(l)) == null ? void 0 : d.id) ?? "N/A"}, Account: ${((v = S(o)) == null ? void 0 : v.id) ?? "N/A"}`);
        })
      }, [
        k("div", MA, [
          k("span", zA, _(S(a).name), 1),
          h[7] || (h[7] = k("span", null, " is shadowing", -1))
        ]),
        S(i) ? (x(), F(S(ae), {
          key: 0,
          icon: S(i)
        }, null, 8, ["icon"])) : J("", !0)
      ])) : J("", !0),
      k("button", {
        class: "bg-indigo-800 rounded text-white text-center text-xs font-normal leading-4 align-middle min-w-24 max-w-28 h-full w-full",
        onClick: f
      }, " End Session ")
    ], 16));
  }
}), CA = "https://spectre.atlassian.net", IA = "/secure/CreateIssueDetails!init.jspa?", LA = "10432", RA = "10103", NA = (t) => `
*Environment*: ${t.environment}
*Url*: ${t.currentURL}
*Previous Url*: ${document.referrer}

*User*: ${t.userName} - ID: ${t.userID}
*Account*: ${t.accountName}
`, DA = (t) => {
  const e = new URLSearchParams({
    pid: LA,
    environment: t.environment,
    issuetype: RA,
    description: NA({
      ...t,
      currentURL: window.location.href
    }),
    reporter: t.userName
  });
  return CA + IA + e.toString();
}, HA = { class: "hidden lg:block" }, Rk = /* @__PURE__ */ V({
  __name: "NavigationBar",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: { default: null },
    environment: { default: "production" },
    userUuid: {},
    accountServiceUrl: {},
    currentAccountId: { default: null }
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(t, { emit: e }) {
    const { setUserUUID: r } = km(), { initialiseNavigation: n, navigation: i, fetchLinks: a } = Rt(), { isShadowing: s, initialiseShadowbar: o } = Xa(), { initialiseEnvironment: l, getIdsBaseUri: c, environment: u } = tn(), f = t, m = e, h = (w) => {
      m("inertiaLinkClick", w);
    }, p = oe(() => f.dashboardLink ?? `${c(u.value)}/dashboard`), d = oe(() => `${c(u.value)}/profile`), v = oe(() => `${c(u.value)}/settings`), b = oe(() => `${c(u.value)}/settings/users`), g = oe(() => {
      const w = i.value.userLinks ?? [
        { name: "Support", isHeading: !0 },
        { name: "Report an Issue", href: "https://info.spectre.uk.com/report-an-issue", target: "_blank" },
        { name: "Make a Suggestion", href: "https://info.spectre.uk.com/feature-request", target: "_blank" },
        { name: "Help Centre", href: "https://support.spectre.uk.com/knowledge", target: "_blank" },
        { name: "Contact Us", href: "https://support.spectre.uk.com/knowledge/contact-us", target: "_blank" },
        { name: "Account", isHeading: !0 },
        { name: "Users", href: b.value },
        { name: "Profile", href: d.value },
        { name: "Settings", href: v.value },
        { name: "Log Out", href: f.logoutLink, isForm: !0 }
      ], P = {
        environment: u.value,
        userID: f.userUuid ?? "Not Known",
        accountName: f.config.fullBranchName ?? "Not Known",
        userName: f.config.userName ?? "Not Known"
      };
      return s.value && (w.push({ name: "Dev Support", isHeading: !0 }), w.push({ name: "ALERT THE DEVS", href: DA(P), target: "_blank" })), w;
    });
    Kr(async () => {
      var w;
      n(f.config), o(((w = f.config) == null ? void 0 : w.shadowbarData) ?? null), l(f.environment, f.accountServiceUrl), f.userUuid !== null && (r(f.userUuid), await a({
        env: f.environment,
        userUUID: f.userUuid,
        currentAccountId: f.currentAccountId
      }));
    });
    const y = (w) => {
      m("selectedAccount", w);
    };
    return (w, P) => (x(), N("div", _e(w.$attrs, { class: "w-full" }), [
      S(s) ? (x(), F(EA, { key: 0 })) : J("", !0),
      U(OA, {
        config: w.config,
        "dashboard-link": p.value,
        "logout-link": f.logoutLink,
        "insights-links": S(i).insightsLinks,
        class: "block lg:hidden"
      }, null, 8, ["config", "dashboard-link", "logout-link", "insights-links"]),
      k("div", HA, [
        U(_P, {
          config: w.config,
          "user-links": g.value,
          "dashboard-link": p.value,
          "logout-link": f.logoutLink,
          "insights-links": S(i).insightsLinks,
          onSelectedAccount: y,
          onInertiaLinkClick: h
        }, {
          default: D(() => [
            H(w.$slots, "default")
          ]),
          _: 3
        }, 8, ["config", "user-links", "dashboard-link", "logout-link", "insights-links"])
      ])
    ], 16));
  }
}), xd = (t) => {
  const e = Dm(t);
  return {
    url: lh(e)
  };
}, Nk = /* @__PURE__ */ V({
  __name: "ObjectUrlPreview",
  props: {
    file: {}
  },
  setup(t) {
    const e = t, r = de();
    return Pi(() => e.file, (n) => {
      if (n) {
        r.value = xd(n).url.value;
        return;
      }
      r.value = void 0;
    }), Kr(() => {
      r.value = xd(e.file).url.value;
    }), (n, i) => r.value ? H(n.$slots, "default", {
      key: 0,
      url: r.value
    }) : J("", !0);
  }
}), WA = {
  class: /* @__PURE__ */ X([
    "py-base border-b border-default-300 bg-white",
    "xl:bg-default-50"
  ])
}, FA = {
  class: /* @__PURE__ */ X([
    "grid grid-cols-1 gap-2",
    "md:grid-cols-12 md:items-center"
  ])
}, Dk = /* @__PURE__ */ V({
  __name: "PageHeading",
  setup(t) {
    return (e, r) => (x(), N("header", WA, [
      U(O0, {
        class: X([
          "px-base",
          "lg:px-large"
        ])
      }, {
        default: D(() => [
          k("div", FA, [
            H(e.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]));
  }
}), VA = {}, GA = {
  class: /* @__PURE__ */ X([
    "pt-3 flex justify-end",
    "md:pt-0 md:col-start-7 md:col-end-13 md:row-start-1 md:row-end-3"
  ])
};
function ZA(t, e) {
  return x(), N("div", GA, [
    k("div", kd(Md(t.$attrs)), [
      H(t.$slots, "default")
    ], 16)
  ]);
}
const Hk = /* @__PURE__ */ se(VA, [["render", ZA]]), XA = {}, BA = {
  class: /* @__PURE__ */ X([
    "md:col-start-1 md:col-end-11 md:row-start-2 md:row-end-3",
    "text-sm font-medium text-black"
  ])
};
function UA(t, e) {
  return x(), N("p", BA, [
    H(t.$slots, "default")
  ]);
}
const Wk = /* @__PURE__ */ se(XA, [["render", UA]]), Fk = /* @__PURE__ */ V({
  __name: "PageHeadingTitle",
  props: {
    as: { default: "h1" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), {
      class: X([
        "text-xl text-default-700 font-gilmer font-bold",
        "md:col-start-1 md:col-end-7 md:row-start-1 md:row-end-2"
      ])
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Pd = /* @__PURE__ */ V({
  __name: "PaginationNextPreviousLink",
  props: {
    disabled: { type: Boolean },
    link: {}
  },
  setup(t) {
    const e = me("as");
    return (r, n) => (x(), F(be(r.disabled ? "button" : S(e)), {
      href: r.link.url,
      class: X([
        "bg-white relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-default-300",
        "focus:z-20",
        r.disabled ? "opacity-50 pointer-events-none" : "hover:bg-default-50"
      ]),
      disabled: r.disabled,
      tabindex: r.disabled ? "-1" : 0,
      "aria-disabled": r.disabled
    }, {
      default: D(() => [
        H(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "class", "disabled", "tabindex", "aria-disabled"]));
  }
}), YA = { class: "sr-only" }, qA = { class: "sr-only" }, QA = /* @__PURE__ */ V({
  __name: "PaginationLink",
  props: {
    current: { type: Boolean },
    link: {}
  },
  setup(t) {
    const e = t, r = me("as"), n = oe(() => !e.link.url);
    return (i, a) => i.link.label === "Previous" ? (x(), F(Pd, {
      key: 0,
      class: "rounded-l-md",
      link: i.link,
      disabled: n.value
    }, {
      default: D(() => [
        U(S(ae), {
          icon: S(fv),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        k("span", YA, _(i.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : i.link.label === "Next" ? (x(), F(Pd, {
      key: 1,
      class: "rounded-r-md",
      link: i.link,
      disabled: n.value
    }, {
      default: D(() => [
        U(S(ae), {
          icon: S(Pf),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        k("span", qA, _(i.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : (x(), F(be(n.value ? "span" : S(r)), {
      key: 2,
      href: i.link.url,
      class: X([
        "relative inline-flex items-center py-2 px-4 text-sm font-medium ring-1 ring-inset",
        "focus:z-20",
        i.current ? "z-10 bg-primary-50 text-primary-600 ring-primary-500" : "text-default-700 bg-white ring-default-300",
        i.current && !n.value && "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        !i.current && !n.value && "hover:bg-default-50 hover:text-primary-600"
      ]),
      "aria-current": i.current
    }, {
      default: D(() => [
        le(_(i.link.label), 1)
      ]),
      _: 1
    }, 8, ["href", "class", "aria-current"]));
  }
}), JA = { class: "-space-x-px hidden sm:flex" }, Vk = /* @__PURE__ */ V({
  __name: "PaginationLinks",
  setup(t) {
    const e = me("paginator");
    return (r, n) => {
      var i;
      return x(), N("div", JA, [
        (x(!0), N(xe, null, Qe((i = S(e)) == null ? void 0 : i.links, (a) => (x(), F(QA, {
          key: a.label,
          link: a,
          current: a.active
        }, null, 8, ["link", "current"]))), 128))
      ]);
    };
  }
}), KA = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], _A = /* @__PURE__ */ V({
  __name: "Select",
  props: /* @__PURE__ */ sr({
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = or(t, "modelValue"), r = me("field-id");
    return (n, i) => dt((x(), N("select", {
      id: S(r),
      "onUpdate:modelValue": i[0] || (i[0] = (a) => e.value = a),
      disabled: n.disabled,
      tabindex: n.disabled ? "-1" : 0,
      "aria-disabled": n.disabled,
      "aria-invalid": !!n.invalid,
      "aria-describedby": n.invalid ? `${S(r)}-error` : void 0,
      class: X([
        "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 shadow-sm text-base text-default-900 ring-1 ring-inset ring-default-300",
        "focus:ring-2 focus:ring-inset focus:ring-primary-600",
        "sm:text-sm sm:leading-6",
        n.disabled && "disabled:opacity-50 disabled:pointer-events-none"
      ])
    }, [
      H(n.$slots, "default")
    ], 10, KA)), [
      [Ed, e.value]
    ]);
  }
}), $A = {
  class: /* @__PURE__ */ X([
    "hidden",
    "sm:flex sm:space-x-3 sm:items-center"
  ])
}, eO = { key: 0 }, tO = { class: "hidden md:block text-sm text-default-700" }, rO = { class: "font-medium" }, nO = { class: "font-medium" }, iO = { class: "font-medium" }, Gk = /* @__PURE__ */ V({
  __name: "PaginationMeta",
  props: {
    perPage: {}
  },
  emits: ["change"],
  setup(t, { emit: e }) {
    const r = me("paginator"), n = e;
    return (i, a) => (x(), N("div", $A, [
      U(I0, null, {
        default: D(() => [
          U(Ra, { class: "sr-only" }, {
            default: D(() => a[1] || (a[1] = [
              le(" Results per page ")
            ])),
            _: 1
          }),
          U(_A, {
            "model-value": i.perPage,
            "onUpdate:modelValue": a[0] || (a[0] = (s) => n("change", s))
          }, {
            default: D(() => a[2] || (a[2] = [
              k("option", { value: 10 }, " 10 ", -1),
              k("option", { value: 25 }, " 25 ", -1),
              k("option", { value: 50 }, " 50 ", -1)
            ])),
            _: 1
          }, 8, ["model-value"])
        ]),
        _: 1
      }),
      S(r) && S(r).from && S(r).to && S(r).total ? (x(), N("div", eO, [
        k("p", tO, [
          a[3] || (a[3] = le(" Showing " + _(" ") + " ")),
          k("span", rO, _(S(r).from), 1),
          a[4] || (a[4] = le(" " + _(" ") + " to " + _(" ") + " ")),
          k("span", nO, _(S(r).to), 1),
          a[5] || (a[5] = le(" " + _(" ") + " of " + _(" ") + " ")),
          k("span", iO, _(S(r).total), 1),
          a[6] || (a[6] = le(" " + _(" ") + " results "))
        ])
      ])) : J("", !0)
    ]));
  }
}), aO = {}, sO = { class: "inline-block cursor-wait bg-current min-h-4 animate-pulse" };
function oO(t, e) {
  return x(), N("span", sO);
}
const Zk = /* @__PURE__ */ se(aO, [["render", oO]]), lO = ["aria-valuenow"], Xk = /* @__PURE__ */ V({
  __name: "Progress",
  props: {
    value: { default: 0 }
  },
  setup(t) {
    return (e, r) => (x(), N("div", {
      class: "overflow-hidden rounded-full bg-default-200 h-2",
      role: "progressbar",
      "aria-valuenow": e.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      k("div", {
        class: "h-full rounded-full bg-gradient-to-r from-primary-800 to-primary-600 transition-all ease-in-out",
        style: Ai({
          width: `${e.value}%`
        })
      }, null, 4)
    ], 8, lO));
  }
}), cO = {
  class: /* @__PURE__ */ X([
    "space-y-base",
    "lg:flex lg:gap-x-base lg:space-y-0"
  ])
}, uO = { "aria-hidden": "true" }, dO = { class: "inline-flex size-12 items-center justify-center rounded-full bg-default-100" }, fO = {
  class: /* @__PURE__ */ X([
    "flex-1 space-y-4",
    "lg:grid lg:space-y-1 lg:grid-cols-4 lg:gap-base lg:[&>div:first-child]:col-span-3 lg:[&>div:last-child]:text-right"
  ])
}, Bk = /* @__PURE__ */ V({
  __name: "ProgressCard",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(t) {
    return (e, r) => (x(), F(Ef, {
      class: X(e.disabled && "opacity-60 pointer-events-none")
    }, {
      default: D(() => [
        U(Cf, null, {
          default: D(() => [
            k("div", cO, [
              k("div", uO, [
                k("span", dO, [
                  k("span", {
                    class: X([
                      "inline-flex size-9 items-center justify-center rounded-full",
                      e.checked ? "bg-primary-600" : "bg-default-300"
                    ])
                  }, [
                    e.checked ? (x(), F(S(ae), {
                      key: 0,
                      icon: S(Xv),
                      class: "size-4 text-white"
                    }, null, 8, ["icon"])) : J("", !0)
                  ], 2)
                ])
              ]),
              k("div", fO, [
                H(e.$slots, "default")
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), pO = {}, mO = { class: "text-sm text-default-500" };
function hO(t, e) {
  return x(), N("p", mO, [
    H(t.$slots, "default")
  ]);
}
const Uk = /* @__PURE__ */ se(pO, [["render", hO]]), gO = {}, vO = { class: "space-y-3 rounded-xl bg-default-100 p-3 shadow" };
function bO(t, e) {
  return x(), N("div", vO, [
    H(t.$slots, "default")
  ]);
}
const Yk = /* @__PURE__ */ se(gO, [["render", bO]]), qk = /* @__PURE__ */ V({
  __name: "ProgressCardTitle",
  props: {
    as: { default: "p" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "text-lg font-semibold text-black" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), yO = ["id", "value", "checked", "disabled", "tabindex", "aria-disabled"], Qk = /* @__PURE__ */ V({
  __name: "Radio",
  props: /* @__PURE__ */ sr({
    checked: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, r = or(t, "modelValue"), n = me("field-id"), i = oe(() => e.checked ? !0 : e.modelValue === e.value);
    return (a, s) => dt((x(), N("input", {
      id: S(n),
      "onUpdate:modelValue": s[0] || (s[0] = (o) => r.value = o),
      type: "radio",
      class: X([
        "h-4 w-4 rounded-full border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: a.value,
      checked: i.value,
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled
    }, null, 8, yO)), [
      [Hm, r.value]
    ]);
  }
}), Jk = /* @__PURE__ */ V({
  __name: "SegmentedButton",
  props: {
    color: { default: "blue" },
    value: {}
  },
  setup(t) {
    const e = /* @__PURE__ */ new Map([
      ["red", "bg-red-100 border-red-600"],
      ["yellow", "bg-yellow-100 border-yellow-600"],
      ["green", "bg-green-100 border-green-600"],
      ["blue", "bg-blue-100 border-blue-600"],
      ["primary", "bg-primary-100 border-primary-600"],
      ["purple", "bg-purple-100 border-purple-600"],
      ["pink", "bg-pink-100 border-pink-600"]
    ]);
    return (r, n) => (x(), F(S(No), {
      as: "template",
      value: r.value
    }, {
      default: D(({ checked: i }) => [
        k("button", {
          type: "button",
          class: X([
            "rounded-full py-1.5 px-4 font-gilmer font-bold text-sm border text-default-700",
            "focus:outline-none",
            i ? S(e).get(r.color) : "border-default-300 bg-white"
          ])
        }, [
          H(r.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), wO = { class: "flex gap-base" }, Kk = /* @__PURE__ */ V({
  __name: "SegmentedButtonGroup",
  props: {
    description: {},
    label: {}
  },
  setup(t) {
    return (e, r) => (x(), F(S(Io), null, {
      default: D(() => [
        U(S(Ro), { class: "sr-only" }, {
          default: D(() => [
            le(_(e.label), 1)
          ]),
          _: 1
        }),
        e.description ? (x(), F(S(Lo), {
          key: 0,
          class: "sr-only"
        }, {
          default: D(() => [
            le(_(e.description), 1)
          ]),
          _: 1
        })) : J("", !0),
        k("div", wO, [
          H(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), SO = /* @__PURE__ */ V({
  __name: "SettingCardButton",
  props: {
    as: { default: "button" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "underline font-medium text-default-700" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), xO = { key: 0 }, PO = {
  key: 1,
  class: "text-default-500 font-medium text-sm"
}, _k = /* @__PURE__ */ V({
  __name: "SettingCard",
  props: {
    showEdit: { type: Boolean }
  },
  emits: ["submit", "cancel", "edit"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => (x(), F(Ef, null, {
      default: D(() => [
        n.showEdit ? J("", !0) : (x(), F(b0, {
          key: 0,
          class: "flex justify-between items-center"
        }, {
          default: D(() => [
            k("div", null, [
              H(n.$slots, "default")
            ]),
            k("div", null, [
              n.$slots.button ? H(n.$slots, "button", { key: 0 }) : (x(), F(SO, {
                key: 1,
                onClick: i[0] || (i[0] = (a) => r("edit"))
              }, {
                default: D(() => i[3] || (i[3] = [
                  le(" Edit ")
                ])),
                _: 1
              }))
            ])
          ]),
          _: 3
        })),
        k("form", {
          onSubmit: i[2] || (i[2] = Ds((a) => r("submit"), ["prevent"]))
        }, [
          U(Cf, null, {
            default: D(() => [
              n.showEdit ? (x(), N("div", xO, [
                H(n.$slots, "edit")
              ])) : (x(), N("div", PO, [
                H(n.$slots, "preview")
              ]))
            ]),
            _: 3
          }),
          n.showEdit ? (x(), F(m0, {
            key: 0,
            class: "flex flex-row-reverse gap-3"
          }, {
            default: D(() => [
              U(xt, { type: "submit" }, {
                default: D(() => i[4] || (i[4] = [
                  le(" Save ")
                ])),
                _: 1
              }),
              U(xt, {
                type: "button",
                color: "secondary",
                onClick: i[1] || (i[1] = (a) => r("cancel"))
              }, {
                default: D(() => i[5] || (i[5] = [
                  le(" Cancel ")
                ])),
                _: 1
              }),
              H(n.$slots, "footer-buttons")
            ]),
            _: 3
          })) : J("", !0)
        ], 32)
      ]),
      _: 3
    }));
  }
}), AO = { class: "grid grid-cols-9 gap-6" }, OO = { class: "col-span-9 lg:col-span-6" }, TO = {
  key: 0,
  class: /* @__PURE__ */ X([
    "col-span-3 hidden",
    "lg:block"
  ])
}, $k = /* @__PURE__ */ V({
  __name: "SettingCardGroup",
  props: {
    help: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", AO, [
      k("div", OO, [
        H(e.$slots, "default")
      ]),
      e.help ? (x(), N("div", TO, [
        U(t2, null, {
          default: D(() => [
            k("p", null, _(e.help), 1)
          ]),
          _: 1
        })
      ])) : J("", !0)
    ]));
  }
}), jO = {}, kO = { class: "bg-default-200 rounded-lg px-4 py-5 sm:p-6 space-y-5" };
function MO(t, e) {
  return x(), N("div", kO, [
    H(t.$slots, "default")
  ]);
}
const eM = /* @__PURE__ */ se(jO, [["render", MO]]), tM = /* @__PURE__ */ V({
  __name: "SettingCardTitle",
  props: {
    as: { default: "h3" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "text-default-700 font-medium" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), zO = {};
function EO(t, e) {
  return x(), N("section", null, [
    H(t.$slots, "default")
  ]);
}
const rM = /* @__PURE__ */ se(zO, [["render", EO]]), CO = {}, IO = { class: "space-y-base" };
function LO(t, e) {
  return x(), N("div", IO, [
    H(t.$slots, "default")
  ]);
}
const nM = /* @__PURE__ */ se(CO, [["render", LO]]), iM = /* @__PURE__ */ V({
  __name: "SettingGroupTitle",
  props: {
    as: { default: "h2" }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), { class: "pb-medium text-black font-gilmer text-xl leading-8 font-semibold" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), RO = { class: "flex items-center justify-between" }, NO = { class: "flex flex-1 justify-between sm:justify-end space-x-3" }, aM = /* @__PURE__ */ V({
  __name: "SimplePagination",
  props: {
    as: { default: Lt },
    paginator: {}
  },
  setup(t) {
    return Le("paginator", t.paginator), (r, n) => (x(), N("nav", RO, [
      H(r.$slots, "default"),
      k("div", NO, [
        U(xt, {
          as: r.paginator.prev_page_url ? r.as : "button",
          href: r.paginator.prev_page_url,
          color: "secondary",
          disabled: !r.paginator.prev_page_url
        }, {
          default: D(() => n[0] || (n[0] = [
            le(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        U(xt, {
          as: r.paginator.next_page_url ? r.as : "button",
          href: r.paginator.next_page_url,
          color: "secondary",
          disabled: !r.paginator.next_page_url
        }, {
          default: D(() => n[1] || (n[1] = [
            le(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ])
    ]));
  }
}), DO = ["fill"], sM = /* @__PURE__ */ V({
  __name: "SpectreLogo",
  props: {
    color: { default: "black" }
  },
  setup(t) {
    return (e, r) => (x(), N("svg", {
      viewBox: "0 0 763 100",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Spectre logo"
    }, r[0] || (r[0] = [
      Jr('<path d="M757.24 19.4393V1.06225H697.727L707.823 19.4393H757.24Z"></path><path d="M707.844 97.4941H758.518V79.117H699.005L707.844 97.4941Z"></path><path d="M717.366 59.3802H749.295V40.9819H707.823L717.366 59.3802Z"></path><path d="M282.62 19.4393V1.06225H223.107L233.224 19.4393H282.62Z"></path><path d="M233.224 97.4939H283.898V79.1168H224.385L233.224 97.4939Z"></path><path d="M242.746 59.3802H274.696V40.9819H233.224L242.746 59.3802Z"></path><path d="M440.73 18.3983H473.746V97.409H492.17V18.3983H525.186V0.021286H440.73V18.3983Z"></path><path d="M376.894 81.4114C359.47 81.4114 345.305 67.2834 345.305 49.9049C345.305 32.5264 359.47 18.3983 376.894 18.3983C382.602 18.3983 388.183 19.928 393.039 22.8173L402.475 7.03218C394.765 2.44323 385.904 0.021286 376.894 0.021286C349.31 0.021286 326.881 22.3924 326.881 49.9049C326.881 77.4173 349.31 99.7885 376.894 99.7885C386.01 99.7885 394.956 97.3028 402.731 92.6289L393.21 76.9075C388.311 79.8393 382.666 81.4114 376.894 81.4114Z"></path><path d="M40.5771 40.4083C38.1488 39.8346 35.8271 39.4947 33.5906 39.1548C31.5031 38.8361 29.5009 38.5387 27.733 38.0925C23.7924 37.094 19.5537 33.7585 19.5537 28.7872C19.5537 23.051 25.2622 18.377 32.2913 18.377C34.7408 18.377 37.1264 18.9507 39.1713 20.0554C42.8349 22.01 45.0288 25.2817 45.0288 28.7872H63.4536C63.4536 18.5045 57.4682 8.94421 47.8405 3.82413C43.1331 1.3172 37.7441 0 32.27 0C15.0806 0 1.10762 12.917 1.10762 28.7872C1.10762 41.4493 10.1815 52.603 23.1747 55.896C25.8586 56.5758 28.3933 56.9582 30.8641 57.3194C32.8025 57.6168 34.6556 57.8718 36.317 58.2754C41.0883 59.4014 46.1365 63.5442 46.1365 68.983C46.1365 72.8284 43.7721 76.4188 39.8103 78.5433C37.5737 79.7543 34.9751 80.3916 32.2913 80.3916C24.6444 80.3916 18.4248 75.2715 18.4248 68.983H0C0 85.4055 14.4842 98.7687 32.2913 98.7687C38.0423 98.7687 43.6656 97.3665 48.586 94.7109C58.448 89.3996 64.5612 79.5418 64.5612 68.983C64.5825 55.726 54.4862 43.7013 40.5771 40.4083Z"></path><path d="M639.855 32.8237C639.855 15.3177 625.563 1.06225 608.012 1.06225H589.672V1.16847H572.376V96.8991H590.801V19.4393H607.99C615.381 19.4393 621.409 25.4304 621.409 32.8237C621.409 40.1958 615.403 46.2082 607.99 46.2082H602.452V64.5852L634.488 96.8354H660.474L623.987 60.145C633.423 54.6213 639.855 44.5086 639.855 32.8237Z"></path><path d="M148.696 46.2082H131.507V19.4393H148.696C156.087 19.4393 162.115 25.4304 162.115 32.8237C162.115 40.1958 156.087 46.2082 148.696 46.2082ZM148.696 1.06225H129.27V1.16847H113.082V96.8991H131.507V64.5852H148.696C166.247 64.5852 180.54 50.3297 180.54 32.8237C180.54 15.3177 166.269 1.06225 148.696 1.06225Z"></path>', 11)
    ]), 8, DO));
  }
});
var Em = {}, Cm = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    return Array.isArray(r) ? r.map((n) => e(n)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([n, i]) => [
      n,
      e(i)
    ])) : r;
  }
})(Cm);
var HO = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: t }) => ({
      ...t("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: t }) => t("blur"),
    backdropBrightness: ({ theme: t }) => t("brightness"),
    backdropContrast: ({ theme: t }) => t("contrast"),
    backdropGrayscale: ({ theme: t }) => t("grayscale"),
    backdropHueRotate: ({ theme: t }) => t("hueRotate"),
    backdropInvert: ({ theme: t }) => t("invert"),
    backdropOpacity: ({ theme: t }) => t("opacity"),
    backdropSaturate: ({ theme: t }) => t("saturate"),
    backdropSepia: ({ theme: t }) => t("sepia"),
    backgroundColor: ({ theme: t }) => t("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: t }) => t("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: t }) => ({
      ...t("colors"),
      DEFAULT: t("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: t }) => t("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: t }) => ({
      ...t("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: t }) => t("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: t }) => t("colors"),
    colors: ({ colors: t }) => ({
      inherit: t.inherit,
      current: t.current,
      transparent: t.transparent,
      black: t.black,
      white: t.white,
      slate: t.slate,
      gray: t.gray,
      zinc: t.zinc,
      neutral: t.neutral,
      stone: t.stone,
      red: t.red,
      orange: t.orange,
      amber: t.amber,
      yellow: t.yellow,
      lime: t.lime,
      green: t.green,
      emerald: t.emerald,
      teal: t.teal,
      cyan: t.cyan,
      sky: t.sky,
      blue: t.blue,
      indigo: t.indigo,
      violet: t.violet,
      purple: t.purple,
      fuchsia: t.fuchsia,
      pink: t.pink,
      rose: t.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: t }) => t("borderColor"),
    divideOpacity: ({ theme: t }) => t("borderOpacity"),
    divideWidth: ({ theme: t }) => t("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: t }) => t("spacing"),
    gradientColorStops: ({ theme: t }) => t("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: t }) => ({
      ...t("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: t, breakpoints: e }) => ({
      ...t("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...e(t("screens"))
    }),
    minHeight: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: t }) => t("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: t }) => t("spacing"),
    placeholderColor: ({ theme: t }) => t("colors"),
    placeholderOpacity: ({ theme: t }) => t("opacity"),
    ringColor: ({ theme: t }) => ({
      DEFAULT: t("colors.blue.500", "#3b82f6"),
      ...t("colors")
    }),
    ringOffsetColor: ({ theme: t }) => t("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: t }) => ({
      DEFAULT: "0.5",
      ...t("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: t }) => ({
      ...t("spacing")
    }),
    scrollPadding: ({ theme: t }) => t("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: t }) => ({
      ...t("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: t }) => t("colors"),
    textDecorationColor: ({ theme: t }) => t("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: t }) => ({
      ...t("spacing")
    }),
    textOpacity: ({ theme: t }) => t("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: t }) => ({
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = Cm, r = /* @__PURE__ */ n(HO);
  function n(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  const i = (0, e.cloneDeep)(r.default.theme);
})(Em);
let Ns = Em;
var WO = (Ns.__esModule ? Ns : { default: Ns }).default;
const Ad = /* @__PURE__ */ Fa(WO), oM = {
  theme: {
    extend: {
      fontFamily: {
        sans: ["Inter", ...Ad.fontFamily.sans],
        gilmer: ["Gilmer", ...Ad.fontFamily.sans]
      },
      spacing: {
        tiny: "var(--spacing-tiny, 2px)",
        xxs: "var(--spacing-xxs, 4px)",
        xs: "var(--spacing-xs, 6px)",
        sm: "var(--spacing-sm, 8px)",
        medium: "var(--spacing-medium, 12px)",
        base: "var(--spacing-base, 16px)",
        large: "var(--spacing-large, 24px)",
        xl: "var(--spacing-xl, 32px)",
        xxl: "var(--spacing-xxl, 40px)",
        huge: "var(--spacing-huge, 48px)"
      },
      colors: {
        "spectre-purple": "rgba(var(--color-spectre-purple), <alpha-value>)",
        default: {
          50: "rgba(var(--color-default-50), <alpha-value>)",
          100: "rgba(var(--color-default-100), <alpha-value>)",
          200: "rgba(var(--color-default-200), <alpha-value>)",
          300: "rgba(var(--color-default-300), <alpha-value>)",
          400: "rgba(var(--color-default-400), <alpha-value>)",
          500: "rgba(var(--color-default-500), <alpha-value>)",
          600: "rgba(var(--color-default-600), <alpha-value>)",
          700: "rgba(var(--color-default-700), <alpha-value>)",
          800: "rgba(var(--color-default-800), <alpha-value>)",
          900: "rgba(var(--color-default-900), <alpha-value>)"
        },
        primary: {
          50: "rgba(var(--color-primary-50), <alpha-value>)",
          100: "rgba(var(--color-primary-100), <alpha-value>)",
          200: "rgba(var(--color-primary-200), <alpha-value>)",
          300: "rgba(var(--color-primary-300), <alpha-value>)",
          400: "rgba(var(--color-primary-400), <alpha-value>)",
          500: "rgba(var(--color-primary-500), <alpha-value>)",
          600: "rgba(var(--color-primary-600), <alpha-value>)",
          700: "rgba(var(--color-primary-700), <alpha-value>)",
          800: "rgba(var(--color-primary-800), <alpha-value>)",
          900: "rgba(var(--color-primary-900), <alpha-value>)"
        },
        dark: {
          50: "rgba(var(--color-dark-50), <alpha-value>)",
          100: "rgba(var(--color-dark-100), <alpha-value>)",
          200: "rgba(var(--color-dark-200), <alpha-value>)",
          300: "rgba(var(--color-dark-300), <alpha-value>)",
          400: "rgba(var(--color-dark-400), <alpha-value>)",
          500: "rgba(var(--color-dark-500), <alpha-value>)",
          600: "rgba(var(--color-dark-600), <alpha-value>)",
          700: "rgba(var(--color-dark-700), <alpha-value>)",
          800: "rgba(var(--color-dark-800), <alpha-value>)",
          900: "rgba(var(--color-dark-900), <alpha-value>)"
        },
        danger: {
          300: "rgba(var(--color-danger-300), <alpha-value>)",
          400: "rgba(var(--color-danger-400), <alpha-value>)",
          500: "rgba(var(--color-danger-500), <alpha-value>)",
          600: "rgba(var(--color-danger-600), <alpha-value>)",
          700: "rgba(var(--color-danger-700), <alpha-value>)",
          900: "rgba(var(--color-danger-900), <alpha-value>)"
        }
      }
    }
  },
  plugins: [fh]
}, FO = {}, VO = {
  class: /* @__PURE__ */ X([
    "px-4 py-5",
    "sm:p-6"
  ])
};
function GO(t, e) {
  return x(), N("div", VO, [
    H(t.$slots, "default")
  ]);
}
const lM = /* @__PURE__ */ se(FO, [["render", GO]]), cM = /* @__PURE__ */ V({
  __name: "StatGroup",
  setup(t) {
    var i, a, s, o, l;
    const e = ((s = (a = (i = jl()).default) == null ? void 0 : a.call(i)[0].children) == null ? void 0 : s.length) ?? ((l = (o = jl()).default) == null ? void 0 : l.call(o).length), r = Math.min(e ?? 1, 5), n = /* @__PURE__ */ new Map([
      [1, "md:grid-cols-1"],
      [2, "md:grid-cols-2"],
      [3, "md:grid-cols-3"],
      [4, "md:grid-cols-4"],
      [5, "md:grid-cols-5"]
    ]);
    return (c, u) => (x(), N("dl", {
      class: X([
        "grid grid-cols-1 divide-y divide-default-200 overflow-hidden rounded-lg bg-white shadow",
        S(n).get(S(r)),
        "md:divide-x md:divide-y-0"
      ])
    }, [
      H(c.$slots, "default")
    ], 2));
  }
}), ZO = {}, XO = { class: "ml-2 text-sm font-medium text-default-500" };
function BO(t, e) {
  return x(), N("span", XO, [
    H(t.$slots, "default")
  ]);
}
const uM = /* @__PURE__ */ se(ZO, [["render", BO]]), UO = {}, YO = { class: "text-base font-normal text-default-900" };
function qO(t, e) {
  return x(), N("dt", YO, [
    H(t.$slots, "default")
  ]);
}
const dM = /* @__PURE__ */ se(UO, [["render", qO]]), QO = {}, JO = {
  class: /* @__PURE__ */ X([
    "mt-1 flex items-baseline justify-between",
    "md:block lg:flex"
  ])
}, KO = { class: "flex items-baseline text-2xl font-semibold text-primary-600" };
function _O(t, e) {
  return x(), N("dd", JO, [
    k("div", KO, [
      H(t.$slots, "default")
    ])
  ]);
}
const fM = /* @__PURE__ */ se(QO, [["render", _O]]), $O = { class: "self-center text-sm text-default-500 font-gilmer" }, eT = { class: "flex gap-3" }, pM = /* @__PURE__ */ V({
  __name: "StepModal",
  props: {
    open: { type: Boolean, default: !1 },
    size: { default: "base" },
    stepper: {}
  },
  emits: ["close", "finish"],
  setup(t, { emit: e }) {
    const r = t, n = e, i = async () => {
      n("close"), await ch(300), zl(r.stepper.steps.value[0]) ? r.stepper.goTo(r.stepper.steps.value[0]) : r.stepper.goTo(Object.keys(r.stepper.steps.value)[0]);
    }, a = async () => {
      await i(), n("finish");
    }, s = (o) => zl(o) ? !0 : o.isValid();
    return (o, l) => (x(), F(P9, {
      open: o.open,
      size: o.size,
      onClose: i
    }, {
      default: D(() => [
        H(o.$slots, "default"),
        U(O9, {
          "hide-cancel": "",
          class: "justify-between"
        }, {
          default: D(() => [
            k("p", $O, _(o.stepper.index.value + 1) + " of " + _(o.stepper.stepNames.value.length), 1),
            k("div", eT, [
              o.stepper.isFirst.value ? J("", !0) : (x(), F(xt, {
                key: 0,
                color: "secondary",
                onClick: o.stepper.goToPrevious
              }, {
                default: D(() => l[0] || (l[0] = [
                  le(" Back ")
                ])),
                _: 1
              }, 8, ["onClick"])),
              o.stepper.isLast.value ? (x(), F(xt, {
                key: 2,
                disabled: !s(o.stepper.current.value),
                onClick: a
              }, {
                default: D(() => l[2] || (l[2] = [
                  le(" Finish ")
                ])),
                _: 1
              }, 8, ["disabled"])) : (x(), F(xt, {
                key: 1,
                disabled: !s(o.stepper.current.value),
                color: "primary",
                onClick: o.stepper.goToNext
              }, {
                default: D(() => l[1] || (l[1] = [
                  le(" Next ")
                ])),
                _: 1
              }, 8, ["disabled", "onClick"]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open", "size"]));
  }
}), tT = ["fill"], mM = /* @__PURE__ */ V({
  __name: "StreetLogo",
  props: {
    color: { default: "black" }
  },
  setup(t) {
    return (e, r) => (x(), N("svg", {
      viewBox: "0 0 780 117",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Street logo"
    }, r[0] || (r[0] = [
      Jr('<path d="M724.075 32.1443C723.658 42.8779 714.651 51.0504 703.141 51.0504C688.839 51.0504 679.602 41.3384 679.602 26.2883C679.602 11.2383 688.839 1.41113 703.141 1.41113C714.507 1.41113 722.852 9.18076 724.147 19.6697C724.234 20.346 723.687 20.9215 722.996 20.9215L711.831 20.8927C711.284 20.8927 710.824 20.5043 710.709 19.9719C710.292 17.9144 708.738 14.231 703.126 14.231C696.781 14.231 693.573 18.2885 693.573 26.2739C693.573 34.2594 696.781 38.2593 703.126 38.2593C708.896 38.2593 710.536 34.5903 710.968 32.1731"></path><path d="M703.083 114.762C690.45 114.762 682.277 106.848 682.277 94.6039V66.8346C682.277 66.2016 682.795 65.6836 683.428 65.6836H694.939C695.572 65.6836 696.09 66.2016 696.09 66.8346V94.4744C696.09 99.7117 698.248 102.043 703.097 102.043C707.946 102.043 710.162 99.7836 710.162 94.4744V66.8346C710.162 66.2016 710.68 65.6836 711.313 65.6836H722.881C723.514 65.6836 724.032 66.2016 724.032 66.8346V94.6039C724.032 106.848 715.816 114.762 703.111 114.762H703.083Z"></path><path d="M755.67 51.0504C741.325 51.0504 732.059 41.3096 732.059 26.2308C732.059 11.1519 741.325 1.41113 755.67 1.41113C770.015 1.41113 779.281 11.1519 779.281 26.2308C779.281 41.3096 770.015 51.0504 755.67 51.0504ZM755.67 14.2454C749.281 14.2454 746.044 18.2741 746.044 26.2308C746.044 34.1874 749.281 38.2161 755.67 38.2161C762.058 38.2161 765.295 34.1874 765.295 26.2308C765.295 18.2741 762.058 14.2454 755.67 14.2454Z"></path><path d="M761.653 113.798L749.884 100.302C749.423 99.7836 748.574 100.1 748.574 100.791V113.035C748.574 113.668 748.056 114.186 747.423 114.186H735.913C735.28 114.186 734.762 113.668 734.762 113.035V66.8346C734.762 66.2016 735.28 65.6836 735.913 65.6836H747.423C748.056 65.6836 748.574 66.2016 748.574 66.8346V77.6977C748.574 78.3884 749.438 78.7337 749.898 78.2157L761.049 66.0577C761.265 65.8275 761.567 65.6836 761.898 65.6836H776.257C777.25 65.6836 777.768 66.8778 777.092 67.6116L757.984 88.3162C757.581 88.7479 757.581 89.4097 757.97 89.8557L777.811 112.301C778.459 113.035 777.941 114.201 776.948 114.201H762.517C762.186 114.201 761.869 114.057 761.653 113.812V113.798Z"></path><path d="M16.5199 79.8257C17.1386 79.8257 17.6278 80.2861 17.7141 80.8904C19.2968 92.4729 28.5772 99.7533 43.3251 99.7533C59.9147 99.7533 67.9864 94.1851 67.9864 82.7465C67.9864 74.315 62.634 69.5813 50.0875 66.9482L34.1598 63.5095C13.2538 59.0203 3.51295 49.0062 3.51295 32.0137C3.51295 11.971 18.4623 0 43.4977 0C66.6483 0 82.4609 12.0429 84.3602 33.1935C84.4177 33.8986 83.8566 34.5029 83.1516 34.5029L67.9433 34.4597C67.3246 34.4597 66.821 33.9705 66.749 33.3518C65.6555 23.2225 56.8356 16.5608 43.1956 16.5608C29.5556 16.5608 21.8147 21.7549 21.8147 32.0137C21.8147 36.546 23.5701 42.9631 38.7784 46.258L53.5982 49.3803C74.9791 53.8262 86.2882 65.3655 86.2882 82.7609C86.2882 103.379 69.8281 116.185 43.3538 116.185C16.8796 116.185 0.606535 103.681 0.00223074 81.1925C-0.0121575 80.5163 0.534594 79.9695 1.21084 79.9552L16.5343 79.8257H16.5199Z"></path><path d="M127.167 68.5752V19.1805C127.167 18.5043 126.62 17.9719 125.958 17.9719H106.074C105.398 17.9719 104.865 17.4252 104.865 16.7633V2.61974C104.865 1.9435 105.412 1.41113 106.074 1.41113H165.972C166.648 1.41113 167.18 1.95788 167.18 2.61974V16.7633C167.18 17.4396 166.634 17.9719 165.972 17.9719H146.203C145.526 17.9719 144.994 18.5187 144.994 19.1805V68.5752C144.994 69.2514 144.447 69.7838 143.785 69.7838H128.404C127.728 69.7838 127.196 69.2371 127.196 68.5752H127.167Z"></path><path d="M159.726 98.1436H113.972C113.288 98.1436 112.734 98.6976 112.734 99.3809V113.481C112.734 114.165 113.288 114.719 113.972 114.719H159.726C160.41 114.719 160.964 114.165 160.964 113.481V99.3809C160.964 98.6976 160.41 98.1436 159.726 98.1436Z"></path><path d="M266.285 114.761C265.867 114.761 265.479 114.56 265.249 114.215L236.89 71.5679L236.803 71.5248H214.689C213.998 71.5248 213.451 72.0859 213.451 72.7622V113.524C213.451 114.215 212.89 114.761 212.214 114.761H197.034C196.344 114.761 195.797 114.2 195.797 113.524V2.64852C195.797 1.95788 196.358 1.41113 197.034 1.41113H241.077C263.364 1.41113 277.766 15.0799 277.766 36.2305C277.766 51.1223 269.982 62.935 256.803 68.3162C256.069 68.6184 255.781 69.496 256.213 70.1579L284.601 112.848C285.148 113.668 284.558 114.776 283.565 114.776H266.27L266.285 114.761ZM240.3 54.9496C252.86 54.9496 259.493 48.5325 259.493 36.3888C259.493 24.2452 252.673 17.9719 240.3 17.9719H214.703C214.012 17.9719 213.466 18.5331 213.466 19.2093V53.7122C213.466 54.4028 214.027 54.9496 214.703 54.9496H240.3Z"></path><path d="M314.028 114.761H312.892C312.201 114.761 311.654 114.2 311.654 113.524V2.64852C311.654 1.95788 312.215 1.41113 312.892 1.41113H384.746C385.437 1.41113 385.984 1.97227 385.984 2.64852V16.7346C385.984 17.4252 385.423 17.9719 384.746 17.9719H330.56C329.87 17.9719 329.323 18.5331 329.323 19.2093V46.8346C329.323 47.5253 329.884 48.072 330.56 48.072H379.912C380.602 48.072 381.149 48.6332 381.149 49.3094V50.4461V62.2588V63.4098C381.149 64.0861 380.588 64.6472 379.897 64.6472H330.56C329.87 64.6472 329.323 65.2084 329.323 65.8846V97.107C329.323 97.7976 329.884 98.3444 330.56 98.3444H384.746C385.437 98.3444 385.984 98.9055 385.984 99.5817V113.51C385.984 114.2 385.423 114.747 384.746 114.747H314.028V114.761Z"></path><path d="M417.704 114.761H416.567C415.877 114.761 415.33 114.2 415.33 113.524V2.64852C415.33 1.95788 415.891 1.41113 416.567 1.41113H488.422C489.113 1.41113 489.659 1.97227 489.659 2.64852V16.7346C489.659 17.4252 489.098 17.9719 488.422 17.9719H434.236C433.545 17.9719 432.999 18.5331 432.999 19.2093V46.8346C432.999 47.5253 433.56 48.072 434.236 48.072H483.588C484.278 48.072 484.825 48.6332 484.825 49.3094V50.4461V62.2588V63.4098C484.825 64.0861 484.264 64.6472 483.573 64.6472H434.236C433.545 64.6472 432.999 65.2084 432.999 65.8846V97.107C432.999 97.7976 433.56 98.3444 434.236 98.3444H488.422C489.113 98.3444 489.659 98.9055 489.659 99.5817V113.51C489.659 114.2 489.098 114.747 488.422 114.747H417.704V114.761Z"></path><path d="M545.877 114.761H544.74C544.049 114.761 543.503 114.2 543.503 113.524V19.2093C543.503 18.5187 542.941 17.9719 542.265 17.9719H510.87C510.18 17.9719 509.633 17.4108 509.633 16.7346V2.64852C509.633 1.95788 510.194 1.41113 510.87 1.41113H593.962C594.653 1.41113 595.199 1.97227 595.199 2.64852V16.7346C595.199 17.4252 594.638 17.9719 593.962 17.9719H562.567C561.876 17.9719 561.33 18.5331 561.33 19.2093V113.524C561.33 114.215 560.768 114.761 560.092 114.761H545.891H545.877Z"></path><path d="M609.245 115.251C608.555 115.251 608.008 114.69 608.008 114.014V99.9278C608.008 99.2372 608.569 98.6904 609.245 98.6904H655C655.69 98.6904 656.237 99.2516 656.237 99.9278V114.014C656.237 114.704 655.676 115.251 655 115.251H609.245Z"></path>', 12)
    ]), 8, tT));
  }
}), hM = /* @__PURE__ */ V({
  __name: "Switch",
  props: {
    checked: { type: Boolean },
    modelValue: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, n = oe(() => r.checked ? !0 : r.modelValue), i = e;
    return Kr(() => {
      const a = Wm();
      a != null && a.id && console.error('Directly passing an "id" attribute to the Switch component is not recommended. Use the HeadlessUI SwitchGroup and SwitchLabel components to manage labels and accessibility instead.');
    }), (a, s) => (x(), F(S(Km), {
      "default-checked": n.value,
      class: X([
        "group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full",
        "focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50"
      ]),
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled,
      "onUpdate:modelValue": s[0] || (s[0] = (o) => i("update:modelValue", o))
    }, {
      default: D(() => [
        s[1] || (s[1] = k("span", {
          "aria-hidden": "true",
          class: "pointer-events-none absolute h-full w-full rounded-md"
        }, null, -1)),
        k("span", {
          "aria-hidden": "true",
          class: X([
            n.value ? "bg-primary-600" : "bg-default-200",
            a.disabled && "bg-default-200",
            "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
          ])
        }, null, 2),
        k("span", {
          "aria-hidden": "true",
          class: X([
            n.value ? "translate-x-5" : "translate-x-0",
            "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-default-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
          ])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["default-checked", "disabled", "tabindex", "aria-disabled"]));
  }
}), rT = {}, nT = { class: "space-y-3" };
function iT(t, e) {
  return x(), N("div", nT, [
    H(t.$slots, "default")
  ]);
}
const gM = /* @__PURE__ */ se(rT, [["render", iT]]), vM = /* @__PURE__ */ V({
  __name: "SwitchGroupField",
  setup(t) {
    return (e, r) => (x(), F(S(_m), {
      as: "div",
      class: "bg-white flex items-center justify-between space-x-3 rounded-xl p-base ring-1 ring-default-200"
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), bM = /* @__PURE__ */ V({
  __name: "SwitchLabel",
  props: {
    disabled: { type: Boolean }
  },
  setup(t) {
    return (e, r) => (x(), F(S($m), {
      class: X([
        "block text-sm font-medium",
        e.disabled ? "text-default-400" : "text-default-900"
      ])
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), aT = { class: "block" }, yM = /* @__PURE__ */ V({
  __name: "Tab",
  props: {
    icon: {}
  },
  setup(t) {
    const e = me("size"), r = /* @__PURE__ */ new Map([
      ["sm", "py-base"],
      ["base", "py-large"]
    ]);
    return (n, i) => (x(), F(S(eh), { as: "template" }, {
      default: D(({ selected: a }) => [
        S(e) ? (x(), N("button", {
          key: 0,
          class: X([
            "flex-1 text-sm font-medium text-default-500 border-b-2 outline-none px-base",
            a ? "border-primary-500" : "border-default-200",
            S(r).get(S(e))
          ])
        }, [
          n.icon ? (x(), F(S(ae), {
            key: 0,
            icon: n.icon,
            class: "size-4 mb-2"
          }, null, 8, ["icon"])) : J("", !0),
          k("span", aT, [
            H(n.$slots, "default")
          ])
        ], 2)) : J("", !0)
      ]),
      _: 3
    }));
  }
}), wM = /* @__PURE__ */ V({
  __name: "TabGroup",
  props: {
    as: { default: "template" },
    defaultIndex: { default: 0 },
    selectedIndex: { default: void 0 },
    size: { default: "base" },
    manual: { type: Boolean }
  },
  emits: ["change"],
  setup(t, { emit: e }) {
    Le("size", t.size);
    const n = e;
    return (i, a) => (x(), N("div", null, [
      U(S(th), {
        as: i.as,
        "default-index": i.defaultIndex,
        "selected-index": i.selectedIndex,
        manual: i.manual,
        onChange: a[0] || (a[0] = (s) => n("change", s))
      }, {
        default: D(() => [
          H(i.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "default-index", "selected-index", "manual"])
    ]));
  }
}), sT = {}, oT = { class: "overflow-x-auto" }, lT = { class: "inline-block min-w-full align-middle p-px" }, cT = { class: "overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg" }, uT = { class: "min-w-full divide-y divide-default-300" };
function dT(t, e) {
  return x(), N("div", oT, [
    k("div", lT, [
      k("div", cT, [
        k("table", uT, [
          H(t.$slots, "default")
        ])
      ])
    ])
  ]);
}
const SM = /* @__PURE__ */ se(sT, [["render", dT]]), fT = {}, pT = { class: "divide-y divide-default-200 bg-white" };
function mT(t, e) {
  return x(), N("tbody", pT, [
    H(t.$slots, "default")
  ]);
}
const xM = /* @__PURE__ */ se(fT, [["render", mT]]), hT = {}, gT = { class: "px-6 py-4 whitespace-nowrap text-sm text-default-900" };
function vT(t, e) {
  return x(), N("td", gT, [
    H(t.$slots, "default")
  ]);
}
const PM = /* @__PURE__ */ se(hT, [["render", vT]]), bT = {}, yT = { class: "bg-default-50" };
function wT(t, e) {
  return x(), N("thead", yT, [
    H(t.$slots, "default")
  ]);
}
const AM = /* @__PURE__ */ se(bT, [["render", wT]]), ST = {}, xT = { class: "px-6 py-3 text-left text-xs font-medium text-default-500 uppercase tracking-wider" };
function PT(t, e) {
  return x(), N("th", xT, [
    H(t.$slots, "default")
  ]);
}
const OM = /* @__PURE__ */ se(ST, [["render", PT]]), AT = {};
function OT(t, e) {
  return x(), N("tr", null, [
    H(t.$slots, "default")
  ]);
}
const TM = /* @__PURE__ */ se(AT, [["render", OT]]), jM = /* @__PURE__ */ V({
  __name: "TabList",
  setup(t) {
    return (e, r) => (x(), F(S(rh), { class: "flex" }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), kM = /* @__PURE__ */ V({
  __name: "TabPanel",
  setup(t) {
    return (e, r) => (x(), F(S(nh), null, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), TT = { class: "p-sm rounded-b-lg" }, MM = /* @__PURE__ */ V({
  __name: "TabPanels",
  props: {
    as: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", TT, [
      U(S(ih), { as: e.as }, {
        default: D(() => [
          H(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["as"])
    ]));
  }
}), jT = {}, kT = { class: "p-large bg-white rounded-md shadow" };
function MT(t, e) {
  return x(), N("section", kT, [
    H(t.$slots, "default")
  ]);
}
const zM = /* @__PURE__ */ se(jT, [["render", MT]]), zT = ["id", "resize", "maxlength", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], ET = {
  key: 0,
  class: "pt-2 text-sm text-default-500"
}, EM = /* @__PURE__ */ V({
  __name: "Textarea",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    resize: { type: Boolean },
    maxLength: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = de(t.modelValue ?? ""), i = e, a = me("field-id");
    return (s, o) => {
      var l;
      return x(), N(xe, null, [
        dt(k("textarea", _e({
          id: S(a),
          "onUpdate:modelValue": o[0] || (o[0] = (c) => n.value = c),
          resize: s.resize,
          maxlength: s.maxLength,
          disabled: s.disabled,
          tabindex: s.disabled ? "-1" : 0,
          "aria-disabled": s.disabled,
          "aria-invalid": !!s.invalid,
          "aria-describedby": s.invalid ? `${S(a)}-error` : void 0,
          class: [
            "text-sm block w-full px-3 py-2 rounded-md border border-default-300 placeholder-default-400 outline-none relative",
            "focus-visible:ring-inset focus-visible:ring-primary-500",
            !s.resize && "resize-none",
            s.disabled && "disabled:opacity-50 disabled:pointer-events-none"
          ]
        }, s.$attrs, {
          onInput: o[1] || (o[1] = (c) => {
            var u;
            return i("update:modelValue", (u = c.target) == null ? void 0 : u.value);
          })
        }), null, 16, zT), [
          [ja, n.value]
        ]),
        s.maxLength ? (x(), N("p", ET, " Characters remaining: " + _(s.maxLength - (((l = n.value) == null ? void 0 : l.length) ?? 0)), 1)) : J("", !0)
      ], 64);
    };
  }
}), CM = /* @__PURE__ */ V({
  __name: "TextLink",
  props: {
    as: { default: Lt }
  },
  setup(t) {
    return (e, r) => (x(), F(be(e.as), {
      class: X([
        "text-primary-600",
        "hover:text-primary-700 hover:underline"
      ])
    }, {
      default: D(() => [
        H(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), CT = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
}, IT = { class: "p-base" }, LT = { class: "flex items-start" }, RT = { class: "shrink-0" }, NT = { class: "ml-3 w-0 flex-1" }, DT = { class: "text-sm font-medium text-default-900" }, HT = { class: "ml-4 flex shrink-0" }, WT = /* @__PURE__ */ V({
  __name: "Toast",
  props: {
    toast: {},
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const r = e;
    return (n, i) => n.show ? (x(), N("div", CT, [
      k("div", IT, [
        k("div", LT, [
          k("div", RT, [
            n.toast.type === "success" ? (x(), F(S(ae), {
              key: 0,
              icon: S(Of),
              class: "size-4 text-emerald-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : J("", !0),
            n.toast.type === "error" ? (x(), F(S(ae), {
              key: 1,
              icon: S(Gv),
              class: "size-4 text-red-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : J("", !0),
            n.toast.type === "warning" ? (x(), F(S(ae), {
              key: 2,
              icon: S(Zv),
              class: "size-4 text-amber-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : J("", !0),
            n.toast.type === "info" ? (x(), F(S(ae), {
              key: 3,
              icon: S(Af),
              class: "size-4 text-blue-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : J("", !0)
          ]),
          k("div", NT, [
            k("p", DT, _(n.toast.label), 1)
          ]),
          k("div", HT, [
            k("button", {
              class: X([
                "inline-flex rounded-md bg-white text-default-400",
                "hover:text-default-500",
                "focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              ]),
              onClick: i[0] || (i[0] = (a) => r("close"))
            }, [
              i[1] || (i[1] = k("span", { class: "sr-only" }, " Close ", -1)),
              U(S(ae), {
                icon: S(Ko),
                class: "size-5",
                "aria-hidden": "true"
              }, null, 8, ["icon"])
            ])
          ])
        ])
      ])
    ])) : J("", !0);
  }
}), ia = de([]);
let FT = 0;
const VT = () => ({
  enqueue: (n, i = "success") => {
    ia.value.push({
      id: `toasts-${FT += 1}`,
      label: n,
      type: i
    });
  },
  dequeue: () => {
    ia.value.length && ia.value.shift();
  },
  duration: 5e3,
  queue: ia
}), Od = 300, GT = /* @__PURE__ */ V({
  __name: "ToastTransition",
  setup(t) {
    const { dequeue: e, duration: r } = VT(), [n] = jn(!1), i = () => {
      n.value = !1, Ml(() => {
        e();
      }, Od);
    }, { start: a, stop: s } = Ml(() => {
      i();
    }, r - Od);
    return Kr(() => {
      n.value = !0, a();
    }), (o, l) => (x(), F(At, {
      "enter-active-class": "transform ease-out duration-300 transition",
      "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
      "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
      "leave-active-class": "transition ease-in duration-300",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      onMouseover: S(s),
      onMouseleave: S(a)
    }, {
      default: D(() => [
        H(o.$slots, "default", {
          show: S(n),
          onClose: i
        })
      ]),
      _: 3
    }, 8, ["onMouseover", "onMouseleave"]));
  }
}), ZT = {
  "aria-live": "assertive",
  class: /* @__PURE__ */ X([
    "z-[70] pointer-events-none fixed inset-0 flex items-end px-4 py-6",
    "sm:items-start sm:p-6"
  ])
}, XT = {
  class: /* @__PURE__ */ X([
    "flex w-full flex-col items-center space-y-4",
    "sm:items-end"
  ])
}, IM = /* @__PURE__ */ V({
  __name: "ToastGroup",
  props: {
    toasts: {}
  },
  setup(t) {
    return (e, r) => (x(), N("div", ZT, [
      k("div", XT, [
        (x(!0), N(xe, null, Qe(e.toasts, (n) => (x(), F(GT, {
          key: n.id
        }, {
          default: D(({ show: i, onClose: a }) => [
            U(WT, {
              toast: n,
              show: i,
              onClose: a
            }, null, 8, ["toast", "show", "onClose"])
          ]),
          _: 2
        }, 1024))), 128))
      ])
    ]));
  }
}), LM = /* @__PURE__ */ V({
  __name: "ToggleButton",
  setup(t) {
    return (e, r) => (x(), F(S(No), { as: "template" }, {
      default: D(({ checked: n }) => [
        k("button", {
          type: "button",
          class: X([
            "rounded outline-none py-2 px-8 border text-sm font-medium text-default-700",
            n ? "bg-white border-default-200" : "border-transparent"
          ])
        }, [
          H(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), BT = { class: "inline-flex bg-default-100 rounded p-tiny space-x-tiny" }, RM = /* @__PURE__ */ V({
  __name: "ToggleButtonGroup",
  props: {
    description: {},
    label: {}
  },
  setup(t) {
    return (e, r) => (x(), F(S(Io), null, {
      default: D(() => [
        U(S(Ro), { class: "sr-only" }, {
          default: D(() => [
            le(_(e.label), 1)
          ]),
          _: 1
        }),
        e.description ? (x(), F(S(Lo), {
          key: 0,
          class: "sr-only"
        }, {
          default: D(() => [
            le(_(e.description), 1)
          ]),
          _: 1
        })) : J("", !0),
        k("div", BT, [
          H(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), UT = { class: "flex-1" }, NM = /* @__PURE__ */ V({
  __name: "VerticalNavigationLink",
  props: {
    as: { default: Lt },
    current: { type: Boolean },
    href: {},
    trailingIcon: { default: void 0 }
  },
  setup(t) {
    return (e, r) => (x(), N("li", null, [
      (x(), F(be(e.as), {
        href: e.href,
        class: X([
          "inline-flex space-x-3 w-full cursor-pointer px-base py-3 text-sm font-medium rounded-md",
          "hover:bg-primary-100 hover:text-primary-600",
          e.current ? "bg-primary-100 text-primary-600" : "text-default-900"
        ])
      }, {
        default: D(() => [
          k("span", UT, [
            H(e.$slots, "default")
          ]),
          e.trailingIcon ? (x(), F(S(ae), {
            key: 0,
            icon: e.trailingIcon,
            class: "size-4",
            "aria-hidden": "true"
          }, null, 8, ["icon"])) : J("", !0)
        ]),
        _: 3
      }, 8, ["href", "class"]))
    ]));
  }
}), YT = {}, qT = { class: "space-y-3" };
function QT(t, e) {
  return x(), N("nav", null, [
    k("ul", qT, [
      H(t.$slots, "default")
    ])
  ]);
}
const DM = /* @__PURE__ */ se(YT, [["render", QT]]), HM = (t) => {
  const e = de(), r = de(), n = () => {
    var a, s;
    if (e.value = new mh({
      broadcaster: "pusher",
      key: t.key,
      wsPort: 443,
      wssPort: 443,
      forceTLS: !0,
      enabledTransports: ["ws", "wss"],
      cluster: "eu",
      Pusher: ph
    }), t.isPrivate) {
      r.value = (a = e.value) == null ? void 0 : a.private(t.channel);
      return;
    }
    r.value = (s = e.value) == null ? void 0 : s.channel(t.channel);
  };
  return {
    echo: e,
    initialise: n,
    leaveChannel: () => {
      var a;
      (a = e.value) == null || a.leaveChannel(t.channel);
    },
    listen: (a, s) => {
      var o;
      (!r.value || !e.value) && n(), (o = r.value) == null || o.listen(`.${a}`, s);
    }
  };
}, WM = (t) => {
  const e = de(0), r = de([]), [n, i] = jn(!1), [a, s] = jn(!1);
  return {
    endReached: a,
    isLoading: n,
    fetch: async () => {
      if (a.value)
        return;
      i(!0);
      const { data: l } = await Bd.get(t.url, {
        params: {
          page: e.value += 1
        }
      }), c = t.transform ? t.transform(l) : l;
      if (!c.length) {
        e.value -= 1, s(!0), i(!1);
        return;
      }
      r.value = [
        ...r.value,
        ...c
      ], i(!1);
    },
    options: r
  };
};
export {
  uj as SpectreAccordion,
  dj as SpectreAccordionButton,
  fj as SpectreAccordionGroup,
  pj as SpectreAccordionPanel,
  mj as SpectreActionBanner,
  hj as SpectreActionBannerActions,
  gj as SpectreActionBannerDescription,
  vj as SpectreActionBannerTitle,
  bj as SpectreActionPanel,
  yj as SpectreActionPanelContent,
  wj as SpectreActionPanelDescription,
  Sj as SpectreActionPanelTitle,
  xj as SpectreAlert,
  Pj as SpectreAlertDescription,
  Aj as SpectreAlertLink,
  Oj as SpectreAlertTitle,
  Tf as SpectreBadge,
  Tj as SpectreBrandPreview,
  jj as SpectreBreadcrumb,
  kj as SpectreBreadcrumbGroup,
  xt as SpectreButton,
  Mj as SpectreButtonGroup,
  sc as SpectreButtonPreview,
  zj as SpectreCalendarMonthView,
  Ej as SpectreCalendarMonthViewDay,
  Cj as SpectreCalendarNavigation,
  Ij as SpectreCalendarNavigationTitle,
  Ef as SpectreCard,
  Cf as SpectreCardContent,
  m0 as SpectreCardFooter,
  b0 as SpectreCardHeader,
  Lj as SpectreCheckbox,
  Rj as SpectreCheckboxGroup,
  Nj as SpectreCheckboxGroupField,
  Dj as SpectreCheckboxGroupFieldLabel,
  oc as SpectreColourPreview,
  Hj as SpectreCombobox,
  Wj as SpectreComboboxBadges,
  Fj as SpectreComboboxControl,
  Vj as SpectreComboboxLabel,
  Gj as SpectreComboboxOption,
  Zj as SpectreComboboxOptions,
  O0 as SpectreContainer,
  Xj as SpectreCopyToClipboard,
  Bj as SpectreDescription,
  Uj as SpectreDivider,
  Yj as SpectreDrawer,
  qj as SpectreDrawerDescription,
  Qj as SpectreDrawerTitle,
  Jj as SpectreDropdown,
  Kj as SpectreDropdownItem,
  _j as SpectreEmojiPicker,
  $j as SpectreErrorMessage,
  I0 as SpectreField,
  R0 as SpectreFieldset,
  ek as SpectreGridCheckboxGroup,
  tk as SpectreGridCheckboxGroupDescription,
  rk as SpectreGridCheckboxGroupLegend,
  nk as SpectreGridCheckboxGroupOption,
  ik as SpectreGridCheckboxGroupOptions,
  ak as SpectreGridRadioGroup,
  sk as SpectreGridRadioGroupDescription,
  ok as SpectreGridRadioGroupLabel,
  lk as SpectreGridRadioGroupOption,
  ck as SpectreGridRadioGroupOptions,
  Lf as SpectreIconButton,
  uk as SpectreImageCarousel,
  dk as SpectreImageCarouselSlide,
  ac as SpectreImagePreview,
  t2 as SpectreInfoBox,
  fk as SpectreInput,
  pk as SpectreInputAddressSearch,
  mk as SpectreInputCopyToClipboard,
  hk as SpectreInputFileButton,
  gk as SpectreInputFileDropZone,
  vk as SpectreInputGroup,
  bk as SpectreInputGroupAddon,
  yk as SpectreInputGroupInput,
  wk as SpectreInputGroupSelect,
  Sk as SpectreInputRange,
  xk as SpectreInputRangeBadge,
  Ra as SpectreLabel,
  D0 as SpectreLegend,
  Pk as SpectreLengthAwarePagination,
  Ak as SpectreLinkTab,
  Ok as SpectreLinkTabGroup,
  Tk as SpectreListbox,
  jk as SpectreListboxBadges,
  kk as SpectreListboxControl,
  Mk as SpectreListboxLabel,
  zk as SpectreListboxOption,
  Ek as SpectreListboxOptions,
  sM as SpectreLogo,
  P9 as SpectreModal,
  O9 as SpectreModalButtons,
  Ck as SpectreModalContent,
  Ik as SpectreModalDescription,
  Lk as SpectreModalTitle,
  Rk as SpectreNavigationBar,
  Nk as SpectreObjectUrlPreview,
  Dk as SpectrePageHeading,
  Hk as SpectrePageHeadingActions,
  Wk as SpectrePageHeadingDescription,
  Fk as SpectrePageHeadingTitle,
  Vk as SpectrePaginationLinks,
  Gk as SpectrePaginationMeta,
  Zk as SpectrePlaceholder,
  oM as SpectrePreset,
  l1 as SpectrePreviewContainer,
  Xk as SpectreProgress,
  Bk as SpectreProgressCard,
  Uk as SpectreProgressCardDescription,
  Yk as SpectreProgressCardGroup,
  qk as SpectreProgressCardTitle,
  Qk as SpectreRadio,
  Jk as SpectreSegmentedButton,
  Kk as SpectreSegmentedButtonGroup,
  _A as SpectreSelect,
  _k as SpectreSettingCard,
  SO as SpectreSettingCardButton,
  $k as SpectreSettingCardGroup,
  eM as SpectreSettingCardPreview,
  tM as SpectreSettingCardTitle,
  rM as SpectreSettingGroup,
  nM as SpectreSettingGroupContent,
  iM as SpectreSettingGroupTitle,
  aM as SpectreSimplePagination,
  $o as SpectreSpinner,
  lM as SpectreStat,
  cM as SpectreStatGroup,
  uM as SpectreStatPreviousValue,
  dM as SpectreStatTitle,
  fM as SpectreStatValue,
  pM as SpectreStepModal,
  mM as SpectreStreetLogo,
  hM as SpectreSwitch,
  gM as SpectreSwitchGroup,
  vM as SpectreSwitchGroupField,
  bM as SpectreSwitchLabel,
  yM as SpectreTab,
  wM as SpectreTabGroup,
  jM as SpectreTabList,
  kM as SpectreTabPanel,
  MM as SpectreTabPanels,
  zM as SpectreTabSection,
  SM as SpectreTable,
  xM as SpectreTableBody,
  PM as SpectreTableData,
  AM as SpectreTableHead,
  OM as SpectreTableHeader,
  TM as SpectreTableRow,
  CM as SpectreTextLink,
  ic as SpectreTextPreview,
  EM as SpectreTextarea,
  IM as SpectreToastGroup,
  LM as SpectreToggleButton,
  RM as SpectreToggleButtonGroup,
  NM as SpectreVerticalNavigationLink,
  DM as SpectreVerticalNavigationLinkGroup,
  HM as useEcho,
  WM as useListbox,
  xd as useObjectUrlPreview,
  VT as useToasts,
  If as vTooltip
};
